let $wc_multi_section_variant_change=($wcpb_bb_ms_variant_this,$wcpb_bb_ms_temp_product_obj)=>{
  let th_pb_cb_p_grid_column=$wcpb_bb_ms_variant_this.closest('.th_pb_cb_p_grid_column');
  let th_bb_variant_option_active=document.querySelector(`.th_bb_variant_option[data-variant_id="${$wcpb_bb_ms_temp_product_obj.selected_variant}"]`);
  if(th_bb_variant_option_active){
    let th_bb_variant_option_qty_selector_cart_icon=th_bb_variant_option_active.querySelector('.th_bb_variant_option_qty_selector_cart_icon');
    if(th_bb_variant_option_qty_selector_cart_icon){
      th_bb_variant_option_qty_selector_cart_icon.click();
      
    }
  }
}

async function fetchAndReplaceHtml() {
    let url = window.location.href + 'cart';
    let response = await fetch(url);
    let responseText = await response.text();
    let newHtml = new DOMParser().parseFromString(responseText, "text/html");
    let cartItems2 = newHtml.querySelector('#CartDrawer .drawer__inner').innerHTML;
    document.querySelector('#CartDrawer .drawer__inner').innerHTML = cartItems2;
    let lineItemsCount = newHtml.querySelectorAll('#CartDrawer .drawer__inner .cart-item');
    if(lineItemsCount.length > 0) {
      document.querySelector('cart-drawer').classList.remove('is-empty');
    }
    let cartItems3 = newHtml.querySelector('#cart-icon-bubble').innerHTML;
    document.querySelector('#cart-icon-bubble').innerHTML = cartItems3;
    document.querySelector('#cart-icon-bubble').click();
    return newHtml;
}
function cartDrawerUpdate() {
  fetchAndReplaceHtml();
}


if (typeof window.th_product_bundle_js_define == 'undefined') {
	window.th_product_bundle_js_define = window.th_product_bundle_js_define || {};
	window.th_bundle_cart_ajax = true;
	window.$th_bundle_cart_active_bundles_value = [], window.$th_bundle_cart_object_value = {};
	const $th_image_resizer = function(t, r) {
		try {
			if ("original" == r) return t;
			let e = t.match(/(.*\/[\w\-\_\.]+)\.(\w{2,4})/);
			return e[1] + "_" + r + "." + e[2]
		} catch (r) {
			return t
		}
	};
	const $th_money_format = function(t, r,no_decimal) {
		function e(t, r) {
			return void 0 === t ? r : t
		}

		function a(t, r, a, o) {
			if (r = e(r, 2), a = e(a, ","), o = e(o, "."), isNaN(t) || null == t) return 0;
			t = (t / 100).toFixed(r);
			let n = t.split(".");
			return n[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + a) + (n[1] ? o + n[1] : "")
		}
		"string" == typeof t && (t = t.replace(".", ""));
		let o = "",
			n = /\{\{\s*(\w+)\s*\}\}/,
			i = r || this.money_format;
		switch (i.match(n)[1]) {
			case "amount":
				o = a(t, 2);
				break;
			case "amount_no_decimals":
				o = a(t, 0);
				break;
			case "amount_with_comma_separator":
				o = a(t, 2, ".", ",");
				break;
			case "amount_with_space_separator":
				o = a(t, 2, " ", ",");
				break;
			case "amount_with_period_and_space_separator":
				o = a(t, 2, " ", ".");
				break;
			case "amount_no_decimals_with_comma_separator":
				o = a(t, 0, ".", ",");
				break;
			case "amount_no_decimals_with_space_separator":
				o = a(t, 0, ".", "");
				break;
			case "amount_with_space_separator":
				o = a(t, 2, ",", "");
				break;
			case "amount_with_apostrophe_separator":
				o = a(t, 2, "'", ".")
		}
        if(no_decimal){
          o = a(t, 0);
        }
		return i.replace(n, o)
	};
	const $th_shop_money = document.querySelector('#th_shop_money').getAttribute('content');
	const $th_shop_conveted_url = Shopify.shop;
	const $th_shop_theme_id = Shopify.theme.theme_store_id;
	const $th_app_ajax_url = 'https://rebolt.webcontrive.com/';
	const $th_bb_app_ajax_url = 'https://rebolt.webcontrive.com/bundle-ci/front-api/'; // bundle box, bundle box products, 
	const $th_app_ajax_new_url = 'https://rebolt.webcontrive.com/rebolt-bundle/public/front/'; // checkout-buildbox, cart-buildbox
	// const $th_app_ajax_url = 'https://csv.rivyo.com/product-bundle-ci/fronted/';
	// const $th_bb_app_ajax_url = 'https://csv.rivyo.com/product-bundle-ci/front-api/';
	// const $th_app_ajax_new_url = 'https://csv.rivyo.com/rebolt-bundle/public/front/';
	const $th_active_currency = Shopify.currency.active;
	const $th_active_country = Shopify.country;
	const $th_loader_image = wc_external_script_layout?.loader_image ? '<img src="' + wc_external_script_layout.loader_image + '" class="wc_custom_loader_design_class">' : '<svg width="60px" height="60px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid" class="uil-ripple"><rect x="0" y="0" width="100" height="100" fill="none" class="bk"></rect><g> <animate attributeName="opacity" dur="2s" repeatCount="indefinite" begin="-1s" keyTimes="0;0.33;1" values="1;1;0"></animate><circle cx="50" cy="50" r="41.2637" stroke="#000" fill="none" stroke-width="6" stroke-linecap="round"><animate attributeName="r" dur="2s" repeatCount="indefinite" begin="-1s" keyTimes="0;0.33;1" values="0;22;44"></animate></circle></g><g><animate attributeName="opacity" dur="2s" repeatCount="indefinite" begin="0s" keyTimes="0;0.33;1" values="1;1;0"></animate><circle cx="50" cy="50" r="24.8458" stroke="#000000" fill="none" stroke-width="6" stroke-linecap="round"><animate attributeName="r" dur="2s" repeatCount="indefinite" begin="0s" keyTimes="0;0.33;1" values="0;22;44"></animate></circle></g></svg>';
	const $th_loader_code = '<figure class="th_bundle_section_loader th_pb_wf">' + $th_loader_image + '</figure>';
	const $th_products_json = Shopify || {},
		$th_bundle_addEventListener = 'addEventListener';
	let $th_bb_scroll_event = true;
	$th_products_json.th_bundle_variantmap = {};
	$th_products_json.th_bundle_products = {};
	$th_products_json.$wcpb_bb_applied_discount = false;
	const $th_inprecise_round = function($th_num) {
		const $th_with2Decimals = $th_num.toString().match(/^-?\d+(?:\.\d{0,2})?/)[0];
		return $th_with2Decimals;
	}
	const $th_active_currency_rate = $th_inprecise_round(Shopify.currency.rate);
	const $th_bundle_addtocart_uniqueid = function() {
		return Date.now().toString(36) + Math.random().toString(36).substr(2);
	}
	const $th_bundle_get_cart_json = async function($th_get_url) {
		const $th_cart_response = await fetch($th_get_url, {
			method: 'GET',
		});
		return $th_cart_response.json();
	}
	const $th_bundle_clear_cart_json = async function($th_get_url) {
		const $th_cart_response = await fetch($th_get_url, {
			method: 'POST',
		});
		return $th_cart_response.json();
	}
	const $th_create_bundle_draft_order = async function($thpb_shop_url, $thpb_cart_items, $thpb_line_items, $thpb_bundle_array, $thpb_quick_array, $thpb_bundle_id, $thpb_direct_checkout, $thpb_active_currency, $thpb_combo_array, $th_quantity_bundle) {
		await fetch($th_app_ajax_new_url + 'create-draft-order', {
			method: 'POST',
			cache: 'no-cache',
			body: JSON.stringify({
				shop: $thpb_shop_url,
				cart_detail: $thpb_cart_items,
				line_items: $thpb_line_items,
				bundle_array: $thpb_bundle_array,
				custom_array: $thpb_quick_array,
				combo_array: $thpb_combo_array,
				bundle_id: $thpb_bundle_id,
				direct_checkout: $thpb_direct_checkout,
				quantity_bundle: $th_quantity_bundle,
				active_currency: $thpb_active_currency,
				active_country: $th_active_country
			})
		}).then(response => response.json()).then($th_bundle_draft_result => {
			let $th_checkout_result_url = '';
			if ($th_bundle_draft_result.discount_code == 'wcpb_draftorder') {
				$th_checkout_result_url = $th_bundle_draft_result.checkout_url + '?locale=' + Shopify.locale;
			} else {
				$th_checkout_result_url = 'https://' + window.location.hostname + '/discount/' + $th_bundle_draft_result.discount_code + '?redirect=/checkout&locale=' + Shopify.locale;
			}
			window.location = $th_checkout_result_url;
		}).catch(($th_bundle_draft_error) => {
			console.error($th_bundle_draft_error);
		});
	}
	const $th_pb_click_analyst = function($th_addtocart_bundle_id) {
		fetch($th_app_ajax_url + 'bundle-ci/front-api/cart_click_analyst', {
			method: 'POST',
			keepalive: true,
			body: JSON.stringify({
				shop: $th_shop_conveted_url,
				bundle_id: $th_addtocart_bundle_id
			})
		}).then(response => response.json()).then($th_click_analyst => {}).catch(($th_click_analyst_error) => {
			console.error($th_click_analyst_error);
		});
	}
	const $th_bundle_cta_ajax_event = async function($th_bundle_formData) {
		const $th_addtocart_result = await fetch('/cart/add.json', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json'
			},
			body: JSON.stringify($th_bundle_formData)
		});
		return $th_addtocart_result.json();
	}
	const $th_bundle_cta_success_method = function($th_button_this, $th_addtocart_result) {
		var route_url = window.Shopify.routes.root;
		if (!route_url) {
			route_url = window.Shopify.routes.root_url;
		}
		const $th_bundle_cta_root_url = (Shopify && Shopify.routes && route_url) ? route_url : '/';
		if ($th_button_this.getAttribute('data-checkout') == '2') {
			window.$th_bundle_addtocart_callback($th_button_this, $th_addtocart_result);
		} else {
			window.location.href = window.location.origin + $th_bundle_cta_root_url + 'cart';
		}
	}
	const $th_bundle_layout_css_event = function($th_layout_setting_val) {
		if (document.querySelectorAll('#th_bundle_layout_css').length === 0) {
			let $th_bundle_css = '<style id="th_bundle_layout_css">';
			$th_bundle_css += '.thpb_combo_inner_start .thpb_combo_title h4{font-size:' + $th_layout_setting_val.product_layout.bundle_title_font_size + 'px !important; color:#' + $th_layout_setting_val.product_layout.bundle_title_font_color + ' !important;}';
			$th_bundle_css += '.th_pb_section .th_pb_title h4, .th_pb_custom_bundle .th_pb_title h4{font-size:' + $th_layout_setting_val.product_layout.bundle_title_font_size + 'px !important; color:#' + $th_layout_setting_val.product_layout.bundle_title_font_color + ' !important;}';
			$th_bundle_css += '.th_pb_custom_bundle .th_pb_cb_main_title h2{font-size:' + $th_layout_setting_val.product_layout.bundle_title_font_size + 'px !important; color:#' + $th_layout_setting_val.product_layout.bundle_title_font_color + ' !important;}';
			$th_bundle_css += '.th_pb_fbt_section .th_pb_title h4{font-size:' + $th_layout_setting_val.product_layout.bundle_title_font_size + 'px !important; color:#' + $th_layout_setting_val.product_layout.bundle_title_font_color + ' !important;}';
			$th_bundle_css += '.thpb_combo_inner_start .thpb_combo_atc_cta_btn{background:#' + $th_layout_setting_val.product_layout.button_background_color + ' !important; background-color:#' + $th_layout_setting_val.product_layout.button_background_color + ' !important; color:#' + $th_layout_setting_val.product_layout.button_font_color + ' !important; font-size:' + $th_layout_setting_val.product_layout.button_font_size + 'px !important;}';
			$th_bundle_css += '.th_pb_section .th_pb_addtocart_section .th_pb_add_to_cart, .th_pb_custom_bundle .th_pb_addtocart_section .th_pb_add_to_cart{background:#' + $th_layout_setting_val.product_layout.button_background_color + ' !important; background-color:#' + $th_layout_setting_val.product_layout.button_background_color + ' !important; color:#' + $th_layout_setting_val.product_layout.button_font_color + ' !important; font-size:' + $th_layout_setting_val.product_layout.button_font_size + 'px !important;}';
			$th_bundle_css += '.th_pb_all_bundles_list_loadmore_div #th_pb_all_bundles_list_loadmore_btn{background:#' + $th_layout_setting_val.product_layout.button_background_color + ' !important; background-color:#' + $th_layout_setting_val.product_layout.button_background_color + ' !important; color:#' + $th_layout_setting_val.product_layout.button_font_color + ' !important; font-size:' + $th_layout_setting_val.product_layout.button_font_size + 'px !important;}';
			$th_bundle_css += '.th_pb_custom_bundle .th_pb_cb_button .th_pb_cb_button_cls{background:#' + $th_layout_setting_val.product_layout.button_background_color + ' !important; background-color:#' + $th_layout_setting_val.product_layout.button_background_color + ' !important; color:#' + $th_layout_setting_val.product_layout.button_font_color + ' !important; font-size:' + $th_layout_setting_val.product_layout.button_font_size + 'px !important;}';
			$th_bundle_css += '.th_pb_fbt_content .th_pb_fbt_product_atc_btn .th_pb_fbt_product_atc_btn_click{background:#' + $th_layout_setting_val.product_layout.button_background_color + ' !important; background-color:#' + $th_layout_setting_val.product_layout.button_background_color + ' !important; color:#' + $th_layout_setting_val.product_layout.button_font_color + ' !important; font-size:' + $th_layout_setting_val.product_layout.button_font_size + 'px !important;}';
			$th_bundle_css += '.th_pb_section ul.th_pb_list_ul li:after, .th_pb_custom_bundle ul.th_pb_list_ul li:after{background:#' + $th_layout_setting_val.product_layout.plus_sign_background_color + ' !important; color:#' + $th_layout_setting_val.product_layout.plus_sign_font_color + ' !important; font-size:' + $th_layout_setting_val.product_layout.plus_sign_font_size + 'px !important;}';
			$th_bundle_css += '.th_pb_section .th_pb_grid_layout_2 .th_pb_list_ul_layout_2 .li_product_list_layout_2::after, .th_pb_custom_bundle .th_pb_grid_layout_2 .th_pb_list_ul_layout_2 .li_product_list_layout_2::after{color:#' + $th_layout_setting_val.product_layout.plus_sign_font_color + ' !important; font-size:' + $th_layout_setting_val.product_layout.plus_sign_font_size + 'px !important;}';
			$th_bundle_css += '.th_pb_section .th_pb_grid_layout_3 .th_pb_list_ul_layout_3 .li_product_list_layout_3::after, .th_pb_custom_bundle .th_pb_grid_layout_3 .th_pb_list_ul_layout_3 .li_product_list_layout_3::after{color:#' + $th_layout_setting_val.product_layout.plus_sign_font_color + ' !important; font-size:' + $th_layout_setting_val.product_layout.plus_sign_font_size + 'px !important;}'
			$th_bundle_css += '.th_pb_fbt_section .th_pb_fbt_content .th_pb_fbt_product_images_li::after{color:#' + $th_layout_setting_val.product_layout.plus_sign_font_color + ' !important; font-size:' + $th_layout_setting_val.product_layout.plus_sign_font_size + 'px !important;}';
			$th_bundle_css += '.th_pb_section .th_pb_list_content, .th_pb_custom_bundle .th_pb_list_content{border:' + $th_layout_setting_val.product_layout.product_box_border_width + 'px ' + $th_layout_setting_val.product_layout.product_box_border_type + ' #' + $th_layout_setting_val.product_layout.product_box_border_color + ' !important;}';
			$th_bundle_css += '.th_pb_section .li_product_list_layout_2 .th_pb_list_content_layout_2 figure.th_product_img_layout_2, .th_pb_custom_bundle .li_product_list_layout_2 .th_pb_list_content_layout_2 figure.th_product_img_layout_2{border-bottom:' + $th_layout_setting_val.product_layout.product_box_border_width + 'px ' + $th_layout_setting_val.product_layout.product_box_border_type + ' #' + $th_layout_setting_val.product_layout.product_box_border_color + ' !important;}';
			$th_bundle_css += '.th_pb_section .th_pb_grid_layout_3 .th_pb_list_ul_layout_3, .th_pb_custom_bundle .th_pb_grid_layout_3 .th_pb_list_ul_layout_3{border:' + $th_layout_setting_val.product_layout.product_box_border_width + 'px ' + $th_layout_setting_val.product_layout.product_box_border_type + ' #' + $th_layout_setting_val.product_layout.product_box_border_color + ' !important;}';
			$th_bundle_css += '.th_pb_section .th_pb_bundle_layout_3 .th_pb_grid_layout_3 .th_pb_list_content_layout_3 .th_pb_addtocart_section_layout_3, .th_pb_custom_bundle .th_pb_bundle_layout_3 .th_pb_grid_layout_3 .th_pb_list_content_layout_3 .th_pb_addtocart_section_layout_3{border:' + $th_layout_setting_val.product_layout.product_box_border_width + 'px ' + $th_layout_setting_val.product_layout.product_box_border_type + ' #' + $th_layout_setting_val.product_layout.product_box_border_color + ' !important; border-top:none !important;}';
			$th_bundle_css += '.th_pb_custom_bundle ul.th_pb_cb_ul li.th_pb_cb_li{border-bottom:' + $th_layout_setting_val.product_layout.product_box_border_width + 'px ' + $th_layout_setting_val.product_layout.product_box_border_type + ' #' + $th_layout_setting_val.product_layout.product_box_border_color + ' !important;}';
			$th_bundle_css += '.th_pb_custom_bundle ul.th_pb_cb_ul li.th_pb_cb_li:first-child{border-top:' + $th_layout_setting_val.product_layout.product_box_border_width + 'px ' + $th_layout_setting_val.product_layout.product_box_border_type + ' #' + $th_layout_setting_val.product_layout.product_box_border_color + ' !important;}';
			$th_bundle_css += '.thpb_combo_inner_start .thpb_combo_p_grid_list{border-bottom:' + $th_layout_setting_val.product_layout.product_box_border_width + 'px ' + $th_layout_setting_val.product_layout.product_box_border_type + ' #' + $th_layout_setting_val.product_layout.product_box_border_color + ' !important;}';
			$th_bundle_css += '.thpb_combo_inner_start .thpb_combo_p_grid_list:last-child{border-bottom:none !important;}';
			$th_bundle_css += '.thpb_combo_inner_start .thpb_combo_p_grid_pprice .thpb_combo_p_grid_main_price, .thpb_combo_inner_start .thpb_combo_p_grid_pprice .thpb_combo_p_grid_old_price{font-size:' + $th_layout_setting_val.product_layout.product_price_font_size + 'px !important; color:#' + $th_layout_setting_val.product_layout.product_price_font_color + ' !important;}';
			$th_bundle_css += '.th_pb_section .th_pb_list_content .th_pb_list_price span.th_pb_main_price, .th_pb_custom_bundle .th_pb_list_content .th_pb_list_price span.th_pb_main_price{font-size:' + $th_layout_setting_val.product_layout.product_price_font_size + 'px !important; color:#' + $th_layout_setting_val.product_layout.product_price_font_color + ' !important;}';
			$th_bundle_css += '.th_pb_section .th_pb_list_content .th_pb_list_price .th_pb_old_price, .th_pb_custom_bundle .th_pb_list_content .th_pb_list_price .th_pb_old_price{font-size:' + $th_layout_setting_val.product_layout.product_price_font_size + 'px !important; color:#' + $th_layout_setting_val.product_layout.product_price_font_color + ' !important;}';
			$th_bundle_css += '.th_pb_fbt_content .th_pb_fbt_product_single_detail .th_pb_fbt_product_price .th_pb_fbt_product_sale_price{font-size:' + $th_layout_setting_val.product_layout.product_price_font_size + 'px !important; color:#' + $th_layout_setting_val.product_layout.product_price_font_color + ' !important;}';
			$th_bundle_css += '.th_pb_fbt_content .th_pb_fbt_product_single_detail .th_pb_fbt_product_price .th_pb_fbt_product_old_price{font-size:' + $th_layout_setting_val.product_layout.product_price_font_size + 'px !important; color:#' + $th_layout_setting_val.product_layout.product_price_font_color + ' !important;}';
			$th_bundle_css += '.thpb_combo_inner_start .thpb_combo_p_grid_ptitle h6{font-size:' + $th_layout_setting_val.product_layout.product_title_font_size + 'px !important; color:#' + $th_layout_setting_val.product_layout.product_title_font_color + ' !important;}';
			$th_bundle_css += '.thpb_combo_inner_start .thpb_combo_p_grid_ptitle h6 a{font-size:' + $th_layout_setting_val.product_layout.product_title_font_size + 'px !important; color:#' + $th_layout_setting_val.product_layout.product_title_font_color + ' !important; text-decoration:none; line-height:normal;}';
			$th_bundle_css += '.th_pb_section .th_pb_list_content .th_pb_pro_title a, .th_pb_custom_bundle .th_pb_list_content .th_pb_pro_title a{font-size:' + $th_layout_setting_val.product_layout.product_title_font_size + 'px !important; color:#' + $th_layout_setting_val.product_layout.product_title_font_color + ' !important;}';
			$th_bundle_css += '.th_pb_custom_bundle ul.th_pb_cb_ul li.th_pb_cb_li .th_pb_cb_title h6{font-size:' + $th_layout_setting_val.product_layout.product_title_font_size + 'px !important; color:#' + $th_layout_setting_val.product_layout.product_title_font_color + ' !important;}';
			$th_bundle_css += '.th_pb_fbt_content .th_pb_fbt_product_single_detail .th_pb_fbt_product_title{font-size:' + $th_layout_setting_val.product_layout.product_title_font_size + 'px !important; color:#' + $th_layout_setting_val.product_layout.product_title_font_color + ' !important;}';
			if ($th_layout_setting_val.product_layout.show_bundle_quantity) {
				$th_bundle_css += '.th_pb_section .th_pb_list_content .th_pb_bd_qty, .th_pb_custom_bundle .th_pb_list_content .th_pb_bd_qty{display:block !important;}';
				$th_bundle_css += '.th_pb_section .li_product_list_layout_2 .th_pb_list_content_layout_2 .th_pb_list_pro_detail_layout_2 .th_pb_bd_qty_layout_2, .th_pb_custom_bundle .li_product_list_layout_2 .th_pb_list_content_layout_2 .th_pb_list_pro_detail_layout_2 .th_pb_bd_qty_layout_2{display:block !important;}';
				$th_bundle_css += '.th_pb_section .li_product_list_layout_3 .th_pb_list_content_layout_3 .th_pb_list_pro_detail_layout_3 .th_pb_bd_qty_layout_3, .th_pb_custom_bundle .li_product_list_layout_3 .th_pb_list_content_layout_3 .th_pb_list_pro_detail_layout_3 .th_pb_bd_qty_layout_3{display:block !important;}';
			} else {
				$th_bundle_css += '.th_pb_section .th_pb_list_content .th_pb_bd_qty, .th_pb_custom_bundle .th_pb_list_content .th_pb_bd_qty{display:none !important;}';
				$th_bundle_css += '.th_pb_section .li_product_list_layout_2 .th_pb_list_content_layout_2 .th_pb_list_pro_detail_layout_2 .th_pb_bd_qty_layout_2, .th_pb_custom_bundle .li_product_list_layout_2 .th_pb_list_content_layout_2 .th_pb_list_pro_detail_layout_2 .th_pb_bd_qty_layout_2{display:none !important;}';
				$th_bundle_css += '.th_pb_section .li_product_list_layout_3 .th_pb_list_content_layout_3 .th_pb_list_pro_detail_layout_3 .th_pb_bd_qty_layout_3, .th_pb_custom_bundle .li_product_list_layout_3 .th_pb_list_content_layout_3 .th_pb_list_pro_detail_layout_3 .th_pb_bd_qty_layout_3{display:none !important;}';
			}
			if (!$th_layout_setting_val.product_layout.show_plus_sign) {
				$th_bundle_css += '.th_pb_section ul.th_pb_list_ul li:after, .th_pb_custom_bundle ul.th_pb_list_ul li:after{content:"" !important; display:none !important;}';
				$th_bundle_css += '.th_pb_section .th_pb_grid_layout_3 .th_pb_list_ul_layout_3 .li_product_list_layout_3::after, .th_pb_custom_bundle .th_pb_grid_layout_3 .th_pb_list_ul_layout_3 .li_product_list_layout_3::after{content:"" !important; display:none !important;}';
				$th_bundle_css += '.th_pb_fbt_content .th_pb_fbt_product_images_li::after{content:"" !important; display:none !important;}';
			}
			if (!$th_layout_setting_val.product_layout.show_regular_price) {
				$th_bundle_css += '.th_pb_section .th_pb_list_content .th_pb_list_price .th_pb_old_price, .th_pb_custom_bundle .th_pb_list_content .th_pb_list_price .th_pb_old_price{display:none !important;}';
				$th_bundle_css += '.th_pb_custom_bundle ul.th_pb_cb_ul li.th_pb_cb_li .th_pb_cb_price .th_pb_cb_old_price{display:none !important;}';
				$th_bundle_css += '.th_pb_fbt_content .th_pb_fbt_product_single_detail .th_pb_fbt_product_price .th_pb_fbt_product_old_price{display:none !important;}';
			}
			if (!$th_layout_setting_val.product_layout.show_total_price) {
				$th_bundle_css += '.th_pb_section .th_pb_addtocart_section .th_pb_total_price, .th_pb_custom_bundle .th_pb_addtocart_section .th_pb_total_price{display:none !important;}';
				$th_bundle_css += '.th_pb_section .th_pb_grid_layout_2 .li_product_list_addtocart_layout_2 .th_pb_list_content_layout_2 .th_product_img_layout_2 .th_pb_total_price_layout_2, .th_pb_custom_bundle .th_pb_grid_layout_2 .li_product_list_addtocart_layout_2 .th_pb_list_content_layout_2 .th_product_img_layout_2 .th_pb_total_price_layout_2{display:none !important;}';
				$th_bundle_css += '.th_pb_section .th_pb_addtocart_section_layout_3 .th_pb_total_price_layout_3 .th_pb_total_price_inner_layout_3, .th_pb_custom_bundle .th_pb_addtocart_section_layout_3 .th_pb_total_price_layout_3 .th_pb_total_price_inner_layout_3{display:none !important;}';
				$th_bundle_css += '.th_pb_custom_bundle .th_pb_cb_inner .th_pb_cb_total_price{display:none !important;}';
				$th_bundle_css += '.th_pb_fbt_content .th_pb_fbt_product_total{display:none !important;}';
				$th_bundle_css += '.thpb_combo_inner_start .thpb_combo_total_price_inner p{display:none !important;}';
			}
			$th_bundle_css += '.thpb_combo_inner_start .thpb_combo_total_price_inner .thpb_combo_total_price_sale, .thpb_combo_inner_start .thpb_combo_total_price_inner .thpb_combo_total_price_old{font-size:' + $th_layout_setting_val.product_layout.total_amount_font_size + 'px !important; color:#' + $th_layout_setting_val.product_layout.total_amount_font_color + ' !important}';
			$th_bundle_css += '.thpb_combo_inner_start .thpb_combo_total_price_inner .thpb_combo_total_price_save_label, .thpb_combo_inner_start .thpb_combo_total_price_inner .thpb_combo_total_price_save_val{font-size:' + $th_layout_setting_val.product_layout.total_amount_font_size + 'px !important; color:#' + $th_layout_setting_val.product_layout.total_amount_font_color + ' !important}';
			$th_bundle_css += '.th_pb_section .th_pb_addtocart_section .th_pb_total_price, .th_pb_section .th_pb_addtocart_section .th_pb_total_price span.th_pb_total_sale_price, .th_pb_custom_bundle .th_pb_addtocart_section .th_pb_total_price, .th_pb_custom_bundle .th_pb_addtocart_section .th_pb_total_price span.th_pb_total_sale_price{font-size:' + $th_layout_setting_val.product_layout.total_amount_font_size + 'px !important; color:#' + $th_layout_setting_val.product_layout.total_amount_font_color + ' !important}';
			$th_bundle_css += '.th_pb_section .li_product_list_addtocart_layout_2 .th_pb_addtocart_section_layout_2 .th_pb_total_price_text, .th_pb_custom_bundle .li_product_list_addtocart_layout_2 .th_pb_addtocart_section_layout_2 .th_pb_total_price_text{font-size:' + $th_layout_setting_val.product_layout.total_amount_font_size + 'px !important; color:#' + $th_layout_setting_val.product_layout.total_amount_font_color + ' !important}';
			$th_bundle_css += '.th_pb_section .th_pb_addtocart_section_layout_3 .th_pb_total_price_layout_3 .th_pb_total_original_price_inner_layout_3 p, .th_pb_custom_bundle .th_pb_addtocart_section_layout_3 .th_pb_total_price_layout_3 .th_pb_total_original_price_inner_layout_3 p{font-size:' + $th_layout_setting_val.product_layout.total_amount_font_size + 'px !important; color:#' + $th_layout_setting_val.product_layout.total_amount_font_color + ' !important}';
			$th_bundle_css += '.th_pb_section .th_pb_list_content_layout_3 .th_pb_addtocart_section_layout_3 .th_pb_total_price_layout_3 p, .th_pb_custom_bundle .th_pb_list_content_layout_3 .th_pb_addtocart_section_layout_3 .th_pb_total_price_layout_3 p{font-size:' + $th_layout_setting_val.product_layout.total_amount_font_size + 'px !important; color:#' + $th_layout_setting_val.product_layout.total_amount_font_color + ' !important}';
			$th_bundle_css += '.th_pb_custom_bundle .th_pb_cb_inner .th_pb_cb_total_price{font-size:' + $th_layout_setting_val.product_layout.total_amount_font_size + 'px !important; color:#' + $th_layout_setting_val.product_layout.total_amount_font_color + ' !important}';
			$th_bundle_css += '.th_pb_fbt_content .th_pb_fbt_product_total{font-size:' + $th_layout_setting_val.product_layout.total_amount_font_size + 'px !important; color:#' + $th_layout_setting_val.product_layout.total_amount_font_color + ' !important}';
			$th_bundle_css += '.thpb_combo_inner_start .thpb_combo_p_grid_variant_swatch_op_title{font-size:' + $th_layout_setting_val.product_layout.variant_label_font_size + 'px !important; color:#' + $th_layout_setting_val.product_layout.variant_label_font_color + ' !important}';
			$th_bundle_css += '.th_pb_section .th_pb_list_content .th_pb_variants_swatches_div_cls .th_pb_variant_option_title, .th_pb_custom_bundle .th_pb_list_content .th_pb_variants_swatches_div_cls .th_pb_variant_option_title{font-size:' + $th_layout_setting_val.product_layout.variant_label_font_size + 'px !important; color:#' + $th_layout_setting_val.product_layout.variant_label_font_color + ' !important}';
			$th_bundle_css += '</style>';
			document.getElementsByTagName('head')[0].insertAdjacentHTML('beforeend', $th_bundle_css);
		}
	}
	const $th_qty_bundle_layout_css_event = function($th_layout_setting_val) {
		if (document.querySelectorAll('#th_qty_bundle_layout_css').length === 0) {
			let $th_qty_bundle_css = '<style id="th_qty_bundle_layout_css">';
			$th_qty_bundle_css += '.th_pb_qty_bundle_cls .th_pb_title h4{font-size:' + $th_layout_setting_val.quantity_layout.bundle_title_font_size + 'px !important; color:#' + $th_layout_setting_val.quantity_layout.bundle_title_font_color + ' !important;}';
			$th_qty_bundle_css += '.th_pb_qty_bundle_cls .th_pb_qty_bundle_l2_content_inner .th_pb_qty_bundle_l2_cta_btn_div .th_pb_qty_layout_grid_btn_cls{background:#' + $th_layout_setting_val.quantity_layout.button_background_color + ' !important; background-color:#' + $th_layout_setting_val.quantity_layout.button_background_color + ' !important; color:#' + $th_layout_setting_val.quantity_layout.button_font_color + ' !important; font-size:' + $th_layout_setting_val.quantity_layout.button_font_size + 'px !important;}';
			$th_qty_bundle_css += '.th_pb_qty_bundle_cls .th_pb_qty_layout .th_pb_qty_layout_qty_btns .th_pb_qty_single_btn_cls{background:#' + $th_layout_setting_val.quantity_layout.button_background_color + ' !important; background-color:#' + $th_layout_setting_val.quantity_layout.button_background_color + ' !important; color:#' + $th_layout_setting_val.quantity_layout.button_font_color + ' !important; font-size:' + $th_layout_setting_val.quantity_layout.button_font_size + 'px !important;}';
			$th_qty_bundle_css += '.th_pb_qty_bundle_cls .th_pb_qty_layout_grid .th_pb_qty_layout_grid_addtocart_btn .th_pb_qty_layout_grid_btn_cls{background:#' + $th_layout_setting_val.quantity_layout.button_background_color + ' !important; background-color:#' + $th_layout_setting_val.quantity_layout.button_background_color + ' !important; color:#' + $th_layout_setting_val.quantity_layout.button_font_color + ' !important; font-size:' + $th_layout_setting_val.quantity_layout.button_font_size + 'px !important;}';
			$th_qty_bundle_css += '.th_pb_qty_bundle_l2_grid_inner .th_pb_qty_bundle_l2_title_text h6 em{background-color:#' + $th_layout_setting_val.quantity_layout.offer_tag_background_color + ' !important; color:#' + $th_layout_setting_val.quantity_layout.offer_tag_font_color + ' !important; font-size:' + $th_layout_setting_val.quantity_layout.offer_tag_font_size + 'px !important;}';
			$th_qty_bundle_css += '.th_pb_qty_bundle_cls .th_pb_qty_layout_grid .th_pb_qty_grid_column .th_pb_qty_grid_content::after{color:#' + $th_layout_setting_val.quantity_layout.plus_sign_font_color + ' !important; font-size:' + $th_layout_setting_val.quantity_layout.plus_sign_font_size + 'px !important;}';
			$th_qty_bundle_css += '.th_pb_qty_bundle_cls .th_pb_qty_layout_detail .th_pb_qty_layout_title_price p, .th_pb_qty_bundle_cls .th_pb_qty_layout_detail .th_pb_qty_layout_title_price p .th_pb_qty_layout_main_price{font-size:' + $th_layout_setting_val.quantity_layout.product_price_font_size + 'px !important; color:#' + $th_layout_setting_val.quantity_layout.product_price_font_color + ' !important;}';
			$th_qty_bundle_css += '.th_pb_qty_bundle_cls .th_pb_qty_layout_grid .th_pb_qty_grid_titprice p{font-size:' + $th_layout_setting_val.quantity_layout.product_price_font_size + 'px !important; color:#' + $th_layout_setting_val.quantity_layout.product_price_font_color + ' !important;}';
			$th_qty_bundle_css += '.th_pb_qty_bundle_cls .th_pb_qty_layout_grid .th_pb_qty_grid_titprice .th_pb_qty_grid_sale_price, .th_pb_qty_bundle_cls .th_pb_qty_layout_grid .th_pb_qty_grid_titprice .th_pb_qty_grid_old_price{font-size:' + $th_layout_setting_val.quantity_layout.product_price_font_size + 'px !important; color:#' + $th_layout_setting_val.quantity_layout.product_price_font_color + ' !important;}';
			$th_qty_bundle_css += '.th_pb_qty_bundle_cls .th_pb_qty_bundle_l2_grid_inner .th_pb_qty_bundle_l2_title_text p{font-size:' + $th_layout_setting_val.quantity_layout.product_price_font_size + 'px !important; color:#' + $th_layout_setting_val.quantity_layout.product_price_font_color + ' !important;}';
			$th_qty_bundle_css += '.th_pb_qty_bundle_cls .th_pb_qty_bundle_l2_grid_inner .th_pb_qty_bundle_l2_total_sale_price .money, .th_pb_qty_bundle_cls .th_pb_qty_bundle_l2_grid_inner .th_pb_qty_bundle_l2_total_old_price .money{font-size:' + $th_layout_setting_val.quantity_layout.product_price_font_size + 'px !important; color:#' + $th_layout_setting_val.quantity_layout.product_price_font_color + ' !important;}';
			$th_qty_bundle_css += '.th_pb_qty_bundle_cls .th_pb_qty_bundle_l2_grid_inner .th_pb_qty_bundle_l2_title_text h6 span{font-size:' + $th_layout_setting_val.quantity_layout.offer_title_font_size + 'px !important; color:#' + $th_layout_setting_val.quantity_layout.offer_title_font_color + ' !important;}';
			$th_qty_bundle_css += '.th_pb_qty_bundle_cls .th_pb_qty_layout_detail .th_pb_qty_layout_title_price h6{font-size:' + $th_layout_setting_val.quantity_layout.product_title_font_size + 'px !important; color:#' + $th_layout_setting_val.quantity_layout.product_title_font_color + ' !important;}';
			$th_qty_bundle_css += '.th_pb_qty_bundle_cls .th_pb_qty_layout_grid .th_pb_qty_grid_titprice h6{font-size:' + $th_layout_setting_val.quantity_layout.product_title_font_size + 'px !important; color:#' + $th_layout_setting_val.quantity_layout.product_title_font_color + ' !important;}';
			$th_qty_bundle_css += '.th_pb_qty_bundle_cls .th_pb_qty_bundle_l2_grid_inner .th_pb_qty_bundle_l2_single_variant label.th_pb_qty_grid_label_cls{font-size:' + $th_layout_setting_val.quantity_layout.variant_label_font_size + 'px !important; color:#' + $th_layout_setting_val.quantity_layout.variant_label_font_color + ' !important;}';
			$th_qty_bundle_css += '.th_pb_qty_bundle_cls .th_pb_qty_layout_grid .th_pb_qty_grid_single_variant .th_pb_qty_variant_option_title{font-size:' + $th_layout_setting_val.quantity_layout.variant_label_font_size + 'px !important; color:#' + $th_layout_setting_val.quantity_layout.variant_label_font_color + ' !important;}';
			$th_qty_bundle_css += '.th_pb_qty_bundle_l2_content_inner .th_pb_qty_bundle_l2_grid_inner{border:' + $th_layout_setting_val.quantity_layout.product_box_border_width + 'px ' + $th_layout_setting_val.quantity_layout.product_box_border_type + ' #' + $th_layout_setting_val.quantity_layout.product_box_border_color + ' !important;}';
			$th_qty_bundle_css += '.th_pb_qty_bundle_l2_grid_inner .th_pb_qty_bundle_l2_grid_discount_section{background-color:#' + $th_layout_setting_val.quantity_layout.discount_bar_background_color + ' !important; color:#' + $th_layout_setting_val.quantity_layout.discount_bar_font_color + ' !important; font-size:' + $th_layout_setting_val.quantity_layout.discount_bar_font_size + 'px !important; border:' + $th_layout_setting_val.quantity_layout.product_box_border_width + 'px ' + $th_layout_setting_val.quantity_layout.product_box_border_type + ' #' + $th_layout_setting_val.quantity_layout.product_box_border_color + ' !important;}';
			$th_qty_bundle_css += '.th_pb_qty_bundle_l2_grid_inner .th_pb_qty_bundle_l2_grid_discount_section .th_pb_qty_bundle_l2_grid_discount_val{color:#' + $th_layout_setting_val.quantity_layout.discount_bar_font_color + ' !important;}';
			$th_qty_bundle_css += '.th_pb_qty_bundle_l2_grid_inner .th_pb_qty_bundle_l2_variants_loop{border-bottom:1px solid #' + $th_layout_setting_val.quantity_layout.product_box_border_color + ' !important;}';
			$th_qty_bundle_css += '.th_pb_qty_bundle_l2_content_inner .th_pb_qty_bundle_l2_grid_inner.th_pb_qty_bundle_l2_selected{background-color:#' + $th_layout_setting_val.quantity_layout.offer_box_background_color + ' !important; border-bottom:1px solid #' + $th_layout_setting_val.quantity_layout.product_box_border_color + ' !important;}';
			$th_qty_bundle_css += '.th_pb_qty_bundle_l2_grid_inner .th_pb_qty_bundle_l2_variants_loop:last-child{border-bottom:none !important;}';
			if (!$th_layout_setting_val.quantity_layout.show_plus_sign) {
				$th_qty_bundle_css += '.th_pb_qty_bundle_cls .th_pb_qty_layout_grid .th_pb_qty_grid_column .th_pb_qty_grid_content::after{content:"" !important; display:none !important;}';
			}
			if (!$th_layout_setting_val.quantity_layout.show_regular_price) {
				$th_qty_bundle_css += '.th_pb_qty_bundle_cls .th_pb_qty_layout_grid .th_pb_qty_grid_titprice .th_pb_qty_grid_old_price{display:none !important;}';
				$th_qty_bundle_css += '.th_pb_qty_bundle_cls .th_pb_qty_bundle_l2_grid_inner .th_pb_qty_bundle_l2_total_old_price{display:none !important;}';
			}
			$th_qty_bundle_css += '</style>';
			document.getElementsByTagName('head')[0].insertAdjacentHTML('beforeend', $th_qty_bundle_css);
		}
	}
	const $th_bundle_close_popup_event = function() {
		document.querySelectorAll('.th_pb_bundle_popup_close_btn').forEach(function($th_close_this, $th_close_idx) {
			$th_close_this[$th_bundle_addEventListener]('click', function(event) {
				event.preventDefault(), event.stopImmediatePropagation();
				const $th_pb_close_loopkey = $th_close_this.getAttribute('data-loopkey');
				if ($th_close_this.closest('.th_pb_bundle_popup_section[data-loopkey="' + $th_pb_close_loopkey + '"]')) {
					$th_close_this.closest('.th_pb_bundle_popup_section[data-loopkey="' + $th_pb_close_loopkey + '"]').style.opacity = 0;
					setTimeout(function() {
						$th_close_this.closest('.th_pb_bundle_popup_section[data-loopkey="' + $th_pb_close_loopkey + '"]').remove();
					}, 1000);
				}
			});
		});
		document.querySelectorAll('.th_pb_bundle_popup_section').forEach(function($th_loop_this, $th_loop_idx) {
			$th_loop_this[$th_bundle_addEventListener]('click', function(event) {
				const $th_pb_close_loopkey = $th_loop_this.getAttribute('data-loopkey');
				if (event.target.classList.contains('th_pb_bundle_popup_section')) {
					event.target.querySelector('.th_pb_bundle_popup_close_btn').dispatchEvent(new Event('click'));
				}
			});
		});
	}
	const $th_bundle_grid_equalizer = function() {
		setTimeout(function() {
			if (document.querySelectorAll('.th_pb_bundle_layout_2').length > 0) {
				document.querySelectorAll('.th_pb_bundle_layout_2').forEach(function($th_bundle_this, $th_layout2_idx) {
					let $th_figure_height = [];
					$th_bundle_this.querySelectorAll('.li_product_list').forEach(function($th_grid_this, $th_grid_idx) {
						const $th_temp_figure_height = parseFloat($th_grid_this.querySelector('.th_product_img').offsetHeight);
						if ($th_temp_figure_height != null && $th_temp_figure_height != '') {
							$th_figure_height.push($th_temp_figure_height);
						}
					});
					const $th_figure_max_height = Math.max.apply(Math, $th_figure_height);
					$th_bundle_this.querySelectorAll('.th_product_img').forEach(function($th_img_this, $th_img_idx) {
						$th_img_this.style.minHeight = $th_figure_max_height + 'px';
					});
				});
			}
		}, 3000);
	}
	const $th_bundle_rivyo_average_rating = async function($th_rating_class) {
		if (document.querySelectorAll($th_rating_class).length > 0) {
			let $th_ajax_product_handle = [];
			document.querySelectorAll($th_rating_class).forEach(function($th_bundle_rating, $th_index) {
				$th_ajax_product_handle.push($th_bundle_rating.getAttribute('data-handle'));
				if ($th_index === document.querySelectorAll($th_rating_class).length - 1) {
					let $th_rivyo_formData = new FormData();
					$th_rivyo_formData.append('shop', $th_shop_conveted_url);
					for (let i = 0; i < $th_ajax_product_handle.length; i++) {
						$th_rivyo_formData.append('product_handles[]', $th_ajax_product_handle[i]);
					}
					fetch('https://app.rivyo.com/product_review/get_review_rating_update.php', {
						method: 'POST',
						body: $th_rivyo_formData,
						cache: 'no-cache'
					}).then(response => response.json()).then($th_rivyo_result => {
						if ($th_rivyo_result.status_code !== 500) {
							document.querySelectorAll($th_rating_class).forEach(function($th_rating_val, $th_rating_index) {
								$th_rating_val.innerHTML = $th_rivyo_result.empty.html;
							});
							Object.keys($th_rivyo_result).forEach(function($th_result_val, $th_result_idx) {
								if (document.querySelectorAll($th_rating_class + '[data-handle="' + $th_result_val + '"]').length > 0) {
									document.querySelectorAll($th_rating_class + '[data-handle="' + $th_result_val + '"]').forEach(function($th_rating_val, $th_rating_index) {
										$th_rating_val.innerHTML = $th_rivyo_result[$th_result_val].html;
									});
								}
								if ($th_result_idx === Object.keys($th_rivyo_result).length - 1) {
									$th_bundle_grid_equalizer();
								}
							});
						}
					}).catch(($th_rivyo_error) => {
						console.error($th_rivyo_error);
					});
				}
			});
		}
	}
	const $th_bundle_cta_loader_class = function($th_btn_this, $th_btn_action, $th_loader_class) {
		if ($th_btn_action == 'add_loader') {
			if (!$th_btn_this.classList.contains($th_loader_class)) {
				$th_btn_this.classList.add($th_loader_class);
			}
		} else {
			if ($th_btn_this.classList.contains($th_loader_class)) {
				$th_btn_this.classList.remove($th_loader_class);
			}
		}
	}
	const $th_bundle_main_title = function($th_pro_value, $th_bundle_type, $th_bundle_div_class, $th_bundle_title_class, $th_bundle_desc_class) {
		let $th_bundle_title = '';
		if ($th_bundle_type == 'th_quick_bundle_title') {
			$th_bundle_title += '<div class="th_pb_cb_main_title th_pb_wf"><h2>' + $th_pro_value.name + '</h2>';
			if ($th_pro_value.short_desc != '' && $th_pro_value.short_desc != null) {
				$th_bundle_title += '<div class="class="th_pb_cb_main_sub_description"">' + $th_pro_value.short_desc + '</div>';
			}
			$th_bundle_title += '</div>';
		} else {
			$th_bundle_title += '<div class="' + $th_bundle_div_class + '">';
			$th_bundle_title += ($th_bundle_title_class) ? '<h4 class="' + $th_bundle_title_class + '">' + $th_pro_value.bundle_detail.bundle_title + '</h4>' : '<h4>' + $th_pro_value.bundle_detail.bundle_title + '</h4>';
			if ($th_pro_value.bundle_detail.short_desc) {
				$th_bundle_title += '<div class="' + $th_bundle_desc_class + '">' + $th_pro_value.bundle_detail.short_desc + '</div>';
			}
			$th_bundle_title += '</div>';
		}
		return $th_bundle_title;
	}
	const $th_variant_instock_status = function($p_grid_val, $p_variant_val) {
		let $th_variant_status = true;
		if ($p_grid_val.status.toLowerCase() == 'draft') {
			$th_variant_status = false;
		} else {
			if ($p_variant_val.inventory_management == 'shopify' || $p_variant_val.inventory_management == 'SHOPIFY') {
				if ($p_variant_val.inventory_policy != 'deny' && $p_variant_val.inventory_policy != 'DENY') {
					$th_variant_status = true;
				} else {
					if ($p_variant_val.inventory_quantity > 0) {
						$th_variant_status = true;
					} else {
						$th_variant_status = false;
					}
				}
			} else {
				$th_variant_status = true;
			}
		}
		return $th_variant_status;
	}
	const $th_pb_p_grid_review = function($grid_val, $th_bundle_type) {
		if ($th_bundle_type == '$th_fbt_bundle') {
			return '<div class="th_pb_fbt_rivyo_average_rating" data-handle="' + $grid_val.handle + '"data-product_id="' + $grid_val.id + '"></div>';
		} else {
			return '<div class="th_pb_rivyo_average_rating th_pb_wf" data-handle="' + $grid_val.handle + '" data-product_id="' + $grid_val.id + '"></div>';
		}
	}
	const $th_pb_bundle_addtocart_btn = function($th_result, $th_bundle_val, $th_bundle_type) {
		var wc_total_product_length = $th_bundle_val.product_list.length;
		var wc_total_available_product_length = $th_bundle_val.product_list.filter(item => item.status.toLowerCase() !== 'draft').length;
		var button_disable_text = (wc_total_product_length == wc_total_available_product_length) ? '' : 'th_pb_draft_product_disable';
		let $th_addtocart_html = '';
		if ($th_bundle_type == 'th_combo_bundle_cta_btn') {
			$th_addtocart_html += '<div class="thpb_combo_wflex thpb_combo_cta_btn_section"><div class="thpb_combo_wflex thpb_combo_cta_btn_inner">';
			$th_addtocart_html += '<div class="btn button thpb_combo_atc_cta_btn ' + button_disable_text + '" data-checkout="' + wc_external_script_layout.direct_checkout + '" data-dismode="' + wc_external_script_layout.discount_mode + '" data-distype="' + $th_bundle_val.bundle_detail.discount_type + '">';
			$th_addtocart_html += '<span class="button_text">' + $th_bundle_val.bundle_detail.button_text + '</span><em class="th_pb_add_to_cart_loader"></em>';
			$th_addtocart_html += '</div>';
			$th_addtocart_html += '</div></div>';
		} else {
			$th_addtocart_html += '<div value="add_to_cart" class="th_pb_add_to_cart btn button ' + button_disable_text + '" data-checkout="' + wc_external_script_layout.direct_checkout + '" data-dismode="' + wc_external_script_layout.discount_mode + '" data-distype="' + $th_bundle_val.bundle_detail.discount_type + '">';
			$th_addtocart_html += '<span class="button_text">' + $th_bundle_val.bundle_detail.button_text + '</span> <em class="th_pb_add_to_cart_loader"></em>';
			$th_addtocart_html += '</div>';
		}
		if ($th_result.wc_bd_number == 7) {
			$th_addtocart_html += '<div class="wc_shopify_preview" style="display: flex !important;width: 100% !important;float: left !important;justify-content: center !important;margin-top: 10px !important; opacity: 1 !important; visibility: visible !important; height: 30px !important;"><img src="https://rebolt.webcontrive.com/rebolt-bundle/public/img/powered_by_rebolt.png" style="display: flex !important;width: 120px !important; opacity: 1 !important; visibility: visible !important; height: 27px !important;"></div>';
		}
		return $th_addtocart_html;
	}
	const $th_pb_p_grid_image = function($grid_val) {
		let $th_product_image = $th_app_ajax_url + 'assets/img/no-product-image.svg';
		if ($grid_val.image && $grid_val.image.hasOwnProperty('src')) {
			$th_product_image = $th_image_resizer($grid_val.image.src, '600x');
		}
		if ($grid_val.featured_image) {
			$th_product_image = $th_image_resizer($grid_val.featured_image, '600x');
		}
		return $th_product_image;
	}
	const $th_pb_product_bundle_price = function($th_bundle_val, $p_grid_price, $th_default_discount) {
		let $th_temp_dc_price = parseFloat($p_grid_price) * 100;
		if ($th_bundle_val.bundle_detail.discount_type == '0') {
			if (parseFloat($th_bundle_val.bundle_detail.discount) > 0) {
				$th_temp_dc_price = ((parseFloat($p_grid_price) * 100) * $th_default_discount) / 100;
			} else {
				$th_temp_dc_price = parseFloat($p_grid_price) * 100;
			}
		}
		return $th_temp_dc_price;
	}
	const $th_pb_product_bundle_original_price = function($th_bundle_val, $p_grid_price, $p_grid_compare_price, $th_default_discount) {
		let $th_temp_dc_cp_price = parseFloat($p_grid_price) * 100;
		return $th_temp_dc_cp_price;
	}
	const $th_bundle_normal_draft_event = async function($th_addtocart_bundle_id, $th_direct_checkout) {
		const $th_cart_json = await $th_bundle_get_cart_json('/cart.js?bundle').then($th_cart_response => {
			return $th_cart_response
		});
		if ($th_cart_json.item_count > 0) {
			let $th_addtocart_bundle_array = new Array();
			$th_addtocart_bundle_array.push({
				bundle_id: $th_addtocart_bundle_id
			});
			await $th_create_bundle_draft_order($th_shop_conveted_url, $th_cart_json.items, null, $th_addtocart_bundle_array, null, null, $th_direct_checkout, $th_active_currency, null, null);
		}
	}
	const $th_bundle_normal_cart_page_addtocart = async function($th_this_button, $th_this_parents, $th_addtocart_bundle_id, $th_redirection, $th_direct_checkout) {
		let $th_id_array = new Array();
		const $th_bundle_normal_uid = $th_bundle_addtocart_uniqueid();
		for (let i = 0; i < $th_this_parents.querySelectorAll('li.li_product_list').length; i++) {
			$th_id_array.push({
				id: $th_this_parents.querySelector('.th_all_bdn_variant_id_' + i).options[$th_this_parents.querySelector('.th_all_bdn_variant_id_' + i).selectedIndex].value,
				quantity: $th_this_parents.querySelector('.th_all_bdn_qty_id_' + i).getAttribute('data-qty'),
				properties: {
					_th_bundle_product: $th_addtocart_bundle_id,
					_th_bundle_type: 'bundle',
					_th_bundle_uid: $th_bundle_normal_uid
				}
			});
		}
		const $th_bundle_formData = {
			items: $th_id_array
		};
		const $th_addtocart_result = await $th_bundle_cta_ajax_event($th_bundle_formData).then($th_addtocart_response => {
			return $th_addtocart_response
		});
		if ($th_addtocart_result.items) {
			if ($th_redirection == '$th_cart_page_redirect') {
				$th_bundle_cta_success_method($th_this_button, $th_addtocart_result);
			} else {
				await $th_bundle_normal_draft_event($th_addtocart_bundle_id, $th_direct_checkout);
			}
		} else {
			$th_bundle_cta_loader_class($th_this_button, 'remove_loader', 'th_pb_btn_loading');
			if ($th_this_parents.querySelector('.th_ajax_error')) {
				if ($th_addtocart_result.description) {
					$th_this_parents.querySelector('.th_ajax_error').innerHTML = '<p class="th_ajax_error_cls">' + $th_addtocart_result.description + '</p>';
				}
				if ($th_addtocart_result.errors) {
					$th_this_parents.querySelector('.th_ajax_error').innerHTML = '<p class="th_ajax_error_cls">' + $th_addtocart_result.errors + '</p>';
				}
			}
			setTimeout(function() {
				$th_this_parents.querySelector('.th_ajax_error').innerHTML = '';
			}, 8000);
		}
	}
	const $th_bundle_normal_addtocart_event = async function($th_button) {
		$th_bundle_cta_loader_class($th_button, 'add_loader', 'th_pb_btn_loading');
		$th_button.closest('.th_pb_innercode').querySelector('.th_ajax_error').innerHTML = '';
		const $th_this_parents = $th_button.closest('.th_pb_innercode');
		const $th_addtocart_bundle_id = $th_this_parents.querySelector('.th_pb_list_ul').getAttribute('data-bundle');
		$th_pb_click_analyst($th_addtocart_bundle_id);
		if ($th_button.getAttribute('data-distype') == '2') {
			const $th_cart_empty_json = await $th_bundle_clear_cart_json('/cart/clear.js').then($th_cart_response => {
				return $th_cart_response
			});
			if ($th_cart_empty_json.items.length === 0) {
				await $th_bundle_normal_cart_page_addtocart($th_button, $th_this_parents, $th_addtocart_bundle_id, '$th_free_shipping', 'direct_checkout');
				$th_bundle_cta_loader_class($th_button, 'remove_loader', 'th_pb_btn_loading');
			}
		} else {
			if ($th_button.getAttribute('data-checkout') == '1') {
				if ($th_button.getAttribute('data-dismode') == '1') {
					await $th_bundle_normal_cart_page_addtocart($th_button, $th_this_parents, $th_addtocart_bundle_id, '', null);
					$th_bundle_cta_loader_class($th_button, 'remove_loader', 'th_pb_btn_loading');
				} else {
					const $th_pb_bundle_items = new Object();
					$th_this_parents.querySelectorAll('li.li_product_list').forEach(async function($th_grid, $th_idx) {
						$th_pb_bundle_items[$th_idx] = {
							product_id: $th_grid.getAttribute('data-id'),
							variant_id: $th_this_parents.querySelector('.th_all_bdn_variant_id_' + $th_idx).options[$th_this_parents.querySelector('.th_all_bdn_variant_id_' + $th_idx).selectedIndex].value,
							quantity: $th_this_parents.querySelector('.th_all_bdn_qty_id_' + $th_idx).getAttribute('data-qty')
						};
						if ($th_idx === ($th_this_parents.querySelectorAll('li.li_product_list').length - 1)) {
							await $th_create_bundle_draft_order($th_shop_conveted_url, null, $th_pb_bundle_items, null, null, $th_addtocart_bundle_id, 'direct_checkout', $th_active_currency, null, null);
							$th_bundle_cta_loader_class($th_button, 'remove_loader', 'th_pb_btn_loading');
						}
					});
				}
			} else {
				await $th_bundle_normal_cart_page_addtocart($th_button, $th_this_parents, $th_addtocart_bundle_id, '$th_cart_page_redirect', null);
				$th_bundle_cta_loader_class($th_button, 'remove_loader', 'th_pb_btn_loading');
			}
		}
	}
	const $th_bundle_normal_addtocart_click_event = async function() {
		document.querySelectorAll('.th_pb_add_to_cart').forEach(function($th_button) {
			$th_button[$th_bundle_addEventListener]('click', function(event) {
				event.preventDefault(), event.stopImmediatePropagation();
				$th_bundle_normal_addtocart_event($th_button);
			});
		});
	}
	const $th_change_bundle_total = function($th_this) {
		const $th_this_parent = $th_this.closest('.th_pb_innercode');
		const $th_this_select = $th_this_parent.querySelectorAll('.th_pb_pro_variants');
		const $th_bundle_discount_type = $th_this_parent.querySelector('ul.th_pb_list_ul').getAttribute('data-bundletype');
		let $th_new_price = 0,
			$th_new_compare_price = 0,
			$th_variant_available = [];
		$th_this_select.forEach(function($th_this_select_single, $th_idx) {
			const $th_this_val = parseFloat($th_this_select_single.options[$th_this_select_single.selectedIndex].getAttribute('data-price'));
			const $th_this_compare_val = (parseFloat($th_this_select_single.options[$th_this_select_single.selectedIndex].getAttribute('data-compare_price'))) ? parseFloat($th_this_select_single.options[$th_this_select_single.selectedIndex].getAttribute('data-compare_price')) : parseFloat($th_this_select_single.options[$th_this_select_single.selectedIndex].getAttribute('data-price'));
			const $th_this_qty = parseInt($th_this_select_single.closest('.th_pb_list_pro_detail').querySelector('.th_pb_bd_qty').getAttribute('data-qty'));
			const $th_this_ptitle = $th_this_select_single.options[$th_this_select_single.selectedIndex].getAttribute('data-ptitle');
			const $th_this_vtitle = $th_this_select_single.options[$th_this_select_single.selectedIndex].getAttribute('data-title');
			const $th_this_available = JSON.parse($th_this_select_single.options[$th_this_select_single.selectedIndex].getAttribute('data-available'));
			if ($th_this_vtitle != 'Default Title') {
				$th_variant_available.push({
					product_title: $th_this_ptitle + ' (' + $th_this_vtitle + ')',
					variant_available: $th_this_available
				});
			} else {
				$th_variant_available.push({
					product_title: $th_this_ptitle,
					variant_available: $th_this_available
				});
			}
			$th_new_price = $th_new_price + (parseFloat($th_this_val) * $th_this_qty);
			$th_new_compare_price = $th_new_compare_price + (parseFloat($th_this_compare_val) * $th_this_qty);
			if ($th_idx === ($th_this_select.length - 1)) {
				if ($th_bundle_discount_type == '1') {
					const $th_bundle_fixed_val = $th_this_parent.querySelector('ul.th_pb_list_ul').getAttribute('data-fixedprice');
					const $th_final_fixed_price = parseFloat($th_new_price) - (parseFloat($th_bundle_fixed_val) * 100);
					$th_new_compare_price = parseFloat($th_new_price);
					$th_this_parent.querySelector('.th_pb_total_price .th_pb_total_sale_price').innerHTML = '<span class="money">' + $th_money_format($th_final_fixed_price, $th_shop_money) + '</span>';
					if ($th_this_parent.querySelector('.th_pb_total_price .th_pb_old_price')) {
						$th_this_parent.querySelector('.th_pb_total_price .th_pb_old_price').innerHTML = '<span class="money th_pb_line_through">' + $th_money_format($th_new_compare_price, $th_shop_money) + '</span>';
					}
					if ($th_this_parent.querySelectorAll('.th_pb_list_layout_1').length > 0) {
						if ($th_this_parent.querySelector('.th_pb_total_price .th_pb_total_save_label')) {
							$th_this_parent.querySelector('.th_pb_total_price .th_pb_total_save_label').setAttribute('style', 'display:inline-block;');
						}
						const $th_bundle_save_price = parseFloat($th_new_compare_price) - parseFloat($th_final_fixed_price);
						if ($th_this_parent.querySelector('.th_pb_total_price .th_pb_total_save_price')) {
							$th_this_parent.querySelector('.th_pb_total_price .th_pb_total_save_price').innerHTML = '<span class="money">' + $th_money_format($th_bundle_save_price, $th_shop_money) + '</span>';
						}
					}
				} else if ($th_bundle_discount_type == '2') {
					$th_this_parent.querySelector('.th_pb_total_price .th_pb_total_sale_price').innerHTML = '<span class="money">' + $th_money_format($th_new_price, $th_shop_money) + '</span>';
					if ($th_this_parent.querySelector('.th_pb_total_price .th_pb_old_price')) {
						$th_this_parent.querySelector('.th_pb_total_price .th_pb_old_price').innerHTML = '';
					}
					if ($th_this_parent.querySelectorAll('.th_pb_list_layout_1').length > 0) {
						if ($th_this_parent.querySelector('.th_pb_total_price .th_pb_total_save_label')) {
							$th_this_parent.querySelector('.th_pb_total_price .th_pb_total_save_label').setAttribute('style', 'display:inline-block;');
						}
						const $th_bundle_save_free_shipping = $th_this_parent.querySelector('.th_pb_total_price').getAttribute('data-freeship');
						if ($th_this_parent.querySelector('.th_pb_total_price .th_pb_total_save_price')) {
							$th_this_parent.querySelector('.th_pb_total_price .th_pb_total_save_price').innerHTML = $th_bundle_save_free_shipping;
						}
					}
				} else {
					if ($th_new_compare_price > $th_new_price) {
						$th_this_parent.querySelector('.th_pb_total_price .th_pb_total_sale_price').innerHTML = '<span class="money">' + $th_money_format($th_new_price, $th_shop_money) + '</span>';
						if ($th_this_parent.querySelector('.th_pb_total_price .th_pb_old_price')) {
							$th_this_parent.querySelector('.th_pb_total_price .th_pb_old_price').innerHTML = '<span class="money th_pb_line_through">' + $th_money_format($th_new_compare_price, $th_shop_money) + '</span>';
						}
						if ($th_this_parent.querySelectorAll('.th_pb_list_layout_1').length > 0) {
							if ($th_this_parent.querySelector('.th_pb_total_price .th_pb_total_save_label')) {
								$th_this_parent.querySelector('.th_pb_total_price .th_pb_total_save_label').setAttribute('style', 'display:inline-block;');
							}
							const $th_bundle_save_price = parseFloat($th_new_compare_price) - parseFloat($th_new_price);
							if ($th_this_parent.querySelector('.th_pb_total_price .th_pb_total_save_price')) {
								$th_this_parent.querySelector('.th_pb_total_price .th_pb_total_save_price').innerHTML = '<span class="money">' + $th_money_format($th_bundle_save_price, $th_shop_money) + '</span>';
							}
						}
					} else {
						$th_this_parent.querySelector('.th_pb_total_price .th_pb_total_sale_price').innerHTML = '<span class="money">' + $th_money_format($th_new_price, $th_shop_money) + '</span>';
						if ($th_this_parent.querySelectorAll('.th_pb_list_layout_1').length > 0) {
							if ($th_this_parent.querySelector('.th_pb_total_price .th_pb_total_save_label')) {
								$th_this_parent.querySelector('.th_pb_total_price .th_pb_total_save_label').setAttribute('style', 'display:none;');
							}
						}
					}
				}
				let $th_enable_btn_click = true;
				let $th_not_available_products = new Array();
				$th_variant_available.forEach(function($th_variant_available_single, $th_array_idx) {
					if (!$th_variant_available_single.variant_available) {
						$th_enable_btn_click = false;
						$th_not_available_products.push($th_variant_available_single.product_title);
					}
					if ($th_array_idx === ($th_variant_available.length - 1)) {
						if ($th_enable_btn_click) {
							$th_this_parent.querySelector('.th_ajax_error').innerHTML = '';
							if (!$th_this_parent.querySelector('.th_pb_add_to_cart').classList.toString().includes('th_pb_draft_product_disable')) {
								$th_this_parent.querySelector('.th_pb_add_to_cart').setAttribute('style', 'pointer-events:auto !important;');
							}
							$th_this_parent.querySelector('.th_pb_add_to_cart').classList.remove('th_pb_add_to_cart_disabled');
						} else {
							$th_not_available_products = [...new Set($th_not_available_products)];
							const $th_pb_error_msg = $th_this_parent.querySelector('.th_ajax_error').getAttribute('data-msg');
							let $th_not_available_text = $th_not_available_products.join(" & ");
							$th_not_available_text = $th_pb_error_msg.replace("{{title}}", $th_not_available_text);
							$th_this_parent.querySelector('.th_ajax_error').innerHTML = '<p class="th_ajax_error_cls">' + $th_not_available_text + '</p>';
							$th_this_parent.querySelector('.th_pb_add_to_cart').setAttribute('style', 'pointer-events:none !important;');
							$th_this_parent.querySelector('.th_pb_add_to_cart').classList.add('th_pb_add_to_cart_disabled');
						}
					}
				});
			}
		});
	}
	const $th_bundle_normal_change_event = function() {
		document.querySelectorAll('.th_pb_pro_variants:not(.wc_main_variants)').forEach(function($th_pb_pro_variants) {
			$th_pb_pro_variants[$th_bundle_addEventListener]('change', function(event) {
				event.preventDefault(), event.stopImmediatePropagation();
				$th_pb_pro_variants.closest('.th_pb_list_content').querySelector('.th_product_img a img').setAttribute('src', $th_pb_pro_variants.options[$th_pb_pro_variants.selectedIndex].getAttribute('data-image'));
				const $th_price = parseFloat($th_pb_pro_variants.options[$th_pb_pro_variants.selectedIndex].getAttribute('data-price'));
				const $th_compare_price = parseFloat($th_pb_pro_variants.options[$th_pb_pro_variants.selectedIndex].getAttribute('data-compare_price'));
				const $th_html_price = $th_pb_pro_variants.closest('.th_pb_list_content').querySelector('.th_pb_main_price');
				$th_html_price.innerHTML = '<span class="money">' + $th_money_format($th_price, $th_shop_money) + '</span>';
				if ($th_compare_price > $th_price) {
					const $th_html_comparre_price = $th_pb_pro_variants.closest('.th_pb_list_content').querySelectorAll('.th_pb_old_price');
					if ($th_html_comparre_price.length > 0) {
						$th_html_comparre_price[0].innerHTML = '<span class="money th_pb_line_through">' + $th_money_format($th_compare_price, $th_shop_money) + '</span>';
					} else {
						$th_pb_pro_variants.closest('.th_pb_list_content').querySelector('.th_pb_list_price').insertAdjacentHTML('beforeend', '<span class="th_pb_old_price"><span class="money th_pb_line_through">' + $th_money_format($th_compare_price, $th_shop_money) + '</span></span>');
					}
				} else {
					if ($th_pb_pro_variants.closest('.th_pb_list_content').querySelector('.th_pb_old_price')) {
						$th_pb_pro_variants.closest('.th_pb_list_content').querySelector('.th_pb_old_price').innerHTML = '';
					}
				}
				$th_change_bundle_total($th_pb_pro_variants);
				if (typeof $th_bundle_variant_change_event == 'function') {
					window.$th_bundle_variant_change_event($th_pb_pro_variants);
				}
			});
			$th_pb_pro_variants.dispatchEvent(new Event('change'));
		});
		const $th_bundle_normal_enable_cta_btn = function($th_option_parents, $th_option_val_array) {
			const $th_final_option_selected = $th_option_val_array.join(" / ");
			$th_option_parents.querySelector('.th_pb_pro_variants').selectedIndex = -1;
			if ($th_option_parents.querySelectorAll('.th_pb_pro_variants option[data-title="' + $th_final_option_selected + '"]').length > 0) {
				$th_option_parents.querySelector('.th_pb_pro_variants option[data-title="' + $th_final_option_selected + '"]').selected = true;
				$th_option_parents.querySelector('.th_pb_pro_variants').dispatchEvent(new Event('change'));
			} else {
				const $th_pb_error_msg = $th_option_parents.closest('.th_pb_innercode').querySelector('.th_ajax_error').getAttribute('data-msg');
				const $th_not_available_text = $th_pb_error_msg.replace("{{title}}", $th_final_option_selected);
				$th_option_parents.closest('.th_pb_innercode').querySelector('.th_ajax_error').innerHTML = '<p class="th_ajax_error_cls">' + $th_not_available_text + '</p>';
				$th_option_parents.closest('.th_pb_innercode').querySelector('.th_pb_add_to_cart').setAttribute('style', 'pointer-events:none !important;');
				$th_option_parents.closest('.th_pb_innercode').querySelector('.th_pb_add_to_cart').classList.add('th_pb_add_to_cart_disabled');
			}
		}
		const $th_update_radio_button = function($th_select_index, $th_select_pid, $th_option_parents) {
			switch ($th_select_index) {
				case 1:
					var $th_key = 'root';
					break;
				case 2:
					var $th_key = $th_option_parents.querySelector('.th_pb_variants_swatches_div_cls[data-index="0"] .th_pb_variant_swatch_btn:checked').value;
					break;
				case 3:
					var $th_key = $th_option_parents.querySelector('.th_pb_variants_swatches_div_cls[data-index="0"] .th_pb_variant_swatch_btn:checked').value;
					$th_key += ' / ' + $th_option_parents.querySelector('.th_pb_variants_swatches_div_cls[data-index="1"] .th_pb_variant_swatch_btn:checked').value;
			}
			let $th_vari_availableOptions = ($th_products_json.th_bundle_variantmap[$th_select_pid + '_' + $th_key]) ? $th_products_json.th_bundle_variantmap[$th_select_pid + '_' + $th_key] : [];
			$th_option_parents.querySelectorAll('.th_pb_variants_swatches_div_cls[data-index="' + ($th_select_index - 1) + '"] .th_pb_variant_swatch_field').forEach(function($th_pb_variants_swatches_div_cls) {
				if ($th_vari_availableOptions.includes($th_pb_variants_swatches_div_cls.querySelector('.th_pb_variant_swatch_btn').value)) {
					$th_pb_variants_swatches_div_cls.classList.remove('th_vari_soldout');
					$th_pb_variants_swatches_div_cls.style.display = 'inline-block';
					$th_pb_variants_swatches_div_cls.querySelector('.th_pb_variant_swatch_btn').removeAttribute('disabled');
				} else {
					$th_pb_variants_swatches_div_cls.classList.add('th_vari_soldout');
					$th_pb_variants_swatches_div_cls.style.display = 'none';
					$th_pb_variants_swatches_div_cls.querySelector('.th_pb_variant_swatch_btn').setAttribute('disabled', 'disabled');
					if ($th_pb_variants_swatches_div_cls.querySelectorAll('.th_pb_variant_swatch_btn:checked').length) {
						$th_pb_variants_swatches_div_cls.querySelector('.th_pb_variant_swatch_btn').removeAttribute('checked');
						if ($th_pb_variants_swatches_div_cls.nextSibling) {
							$th_pb_variants_swatches_div_cls.nextSibling.querySelector('.th_pb_variant_swatch_btn').setAttribute('checked', 'checked');
						}
					}
				}
			});
		}
		if (document.querySelector('.th_pb_variant_swatch_btn:not(.wc_swatch_button)')) {
			document.querySelectorAll('.th_pb_variant_swatch_btn:not(.wc_swatch_button)').forEach(function($th_pb_variant_swatch_btn) {
				$th_pb_variant_swatch_btn[$th_bundle_addEventListener]('change', function(event) {
					event.preventDefault(), event.stopImmediatePropagation();
					const $th_option_parents = $th_pb_variant_swatch_btn.closest('.th_pb_variants_section');
					const $th_option_val_array = new Array();
					$th_option_parents.querySelectorAll('.th_pb_variants_swatches_div_cls').forEach(function($th_pb_variants_swatches_div_cls) {
						if ($th_pb_variants_swatches_div_cls.querySelector('.th_pb_variant_swatch_btn:checked')) {
							let $th_temp_val = $th_pb_variants_swatches_div_cls.querySelector('.th_pb_variant_swatch_btn:checked').value;
							$th_option_val_array.push($th_temp_val);
						}
					});
					const $th_option_pro_id = $th_pb_variant_swatch_btn.closest('.li_product_list').getAttribute('data-id');
					$th_update_radio_button(parseInt($th_products_json.th_bundle_products[$th_option_pro_id][0].options.length), $th_option_pro_id, $th_option_parents);
					$th_bundle_normal_enable_cta_btn($th_option_parents, $th_option_val_array);
				});
				$th_pb_variant_swatch_btn.dispatchEvent(new Event('change'));
			});
		}
		if (document.querySelector('.th_pb_option_select_cls')) {
			document.querySelectorAll('.th_pb_option_select_cls').forEach(function($th_pb_option_select_cls) {
				$th_pb_option_select_cls[$th_bundle_addEventListener]('change', function(event) {
					event.preventDefault(), event.stopImmediatePropagation();
					const $th_option_parents = $th_pb_option_select_cls.closest('.th_pb_variants_section');
					const $th_option_val_array = new Array();
					$th_option_parents.querySelectorAll('.th_pb_option_select_cls').forEach(function($th_pb_option_select) {
						$th_option_val_array.push($th_pb_option_select.options[$th_pb_option_select.selectedIndex].value);
					});
					$th_bundle_normal_enable_cta_btn($th_option_parents, $th_option_val_array);
				});
				$th_pb_option_select_cls.dispatchEvent(new Event('change'));
			});
		}
	}
	const $th_pb_generate_variantmap = function($p_grid_val) {
		$th_products_json.th_bundle_products[$p_grid_val.id] = $th_products_json.th_bundle_products[$p_grid_val.id] || [];
		if ($th_products_json.th_bundle_products[$p_grid_val.id].length === 0) {
			$th_products_json.th_bundle_products[$p_grid_val.id].push($p_grid_val);
		}
		for (let $th_i = 0; $th_i < $p_grid_val.variants.length; $th_i++) {
			let $th_variant = $p_grid_val.variants[$th_i];
			let $th_varaint_available = true;
			if ($p_grid_val.status.toLowerCase() == 'draft') {
				$th_varaint_available = false;
			} else {
				if ($th_variant.inventory_management == 'shopify' || $th_variant.inventory_management == 'SHOPIFY') {
					if ($th_variant.inventory_policy == 'deny' || $th_variant.inventory_policy == 'DENY') {
						if ($th_variant.inventory_quantity <= 0) {
							$th_varaint_available = false;
						}
					}
				}
			}
			if ($th_varaint_available) {
				$th_products_json.th_bundle_variantmap[$p_grid_val.id + '_root'] = $th_products_json.th_bundle_variantmap[$p_grid_val.id + '_root'] || [];
				let $th_variant_split = $th_variant.title.split(' / ');
				const $th_temp_variant_title_0 = $th_variant_split[0].replaceAll('"', "'");
				if (!$th_products_json.th_bundle_variantmap[$p_grid_val.id + '_root'].includes($th_temp_variant_title_0)) {
					$th_products_json.th_bundle_variantmap[$p_grid_val.id + '_root'].push($th_temp_variant_title_0);
				}
				if ($th_variant_split.length > 1) {
					const $th_temp_variant_title_1 = $th_variant_split[1].replaceAll('"', "'");
					let $th_vari_key = $th_temp_variant_title_0;
					$th_products_json.th_bundle_variantmap[$p_grid_val.id + '_' + $th_vari_key] = $th_products_json.th_bundle_variantmap[$p_grid_val.id + '_' + $th_vari_key] || [];
					if (!$th_products_json.th_bundle_variantmap[$p_grid_val.id + '_' + $th_vari_key].includes($th_temp_variant_title_1)) {
						$th_products_json.th_bundle_variantmap[$p_grid_val.id + '_' + $th_vari_key].push($th_temp_variant_title_1);
					}
				}
				if ($th_variant_split.length === 3) {
					const $th_temp_variant_title_2 = $th_variant_split[2].replaceAll('"', "'");
					let $th_vari_key = $th_variant_split[0].replaceAll('"', "'") + ' / ' + $th_variant_split[1].replaceAll('"', "'");
					$th_products_json.th_bundle_variantmap[$p_grid_val.id + '_' + $th_vari_key] = $th_products_json.th_bundle_variantmap[$p_grid_val.id + '_' + $th_vari_key] || [];
					if (!$th_products_json.th_bundle_variantmap[$p_grid_val.id + '_' + $th_vari_key].includes($th_temp_variant_title_2)) {
						$th_products_json.th_bundle_variantmap[$p_grid_val.id + '_' + $th_vari_key].push($th_temp_variant_title_2);
					}
				}
			}
		}
	}
	const $th_pb_p_grid_single_variant = function($th_bundle_val, $p_grid_val, $th_product_default_image, $th_default_discount, $th_pb_show_hide_select, $p_grid_key) {
		let $th_product_single_html = '',
			$th_product_image = $th_product_default_image,
			$th_discount = $th_default_discount;
		let $th_dc_price = $th_pb_product_bundle_price($th_bundle_val, $p_grid_val.variants[0].price, $th_default_discount);
		let $th_dc_cp_price = $th_pb_product_bundle_original_price($th_bundle_val, $p_grid_val.variants[0].price, $p_grid_val.variants[0].compare_at_price, $th_default_discount);
		if (($p_grid_val.variants[0].image !== undefined && $p_grid_val.variants[0].image !== null) || ($p_grid_val.variants[0].featured_image !== undefined && $p_grid_val.variants[0].featured_image !== null)) {
			if ($p_grid_val.variants[0].featured_image !== undefined && $p_grid_val.variants[0].featured_image !== null) {
				$th_product_image = $th_image_resizer($p_grid_val.variants[0].featured_image.src, '600x');
			} else {
				$th_product_image = $th_image_resizer($p_grid_val.variants[0].image.originalSrc, '600x');
			}
		}
		$th_product_single_html += '<div class="th_pb_variants_section th_bundle_main_select_hide_cls th_pb_wf"><select class="th_pb_pro_variants th_pb_wf ' + $th_pb_show_hide_select + ' th_all_bdn_variant_id_' + $p_grid_key + '">';
		const $th_variant_available_status = $th_variant_instock_status($p_grid_val, $p_grid_val.variants[0]);
		$th_product_single_html += '<option value="' + $p_grid_val.variants[0].id + '" data-title="' + $p_grid_val.variants[0].title.replace(/"/g, "'") + '" data-ptitle="' + $p_grid_val.title + '" data-vkey="' + $p_grid_val.variants[0].variant_key + '" data-compare_price="' + $th_dc_cp_price + '" data-price="' + $th_dc_price + '" data-image="' + $th_product_image + '?v=123" data-available="' + $th_variant_available_status + '">' + $p_grid_val.variants[0].title + '</option>';
		$th_product_single_html += '</select></div>';
		if ($p_grid_val.variants[0].title != 'Default Title') {
			$th_product_single_html += '<div class="th_pb_wf th_pb_single_variant_section"><span class="th_pb_wf th_pb_single_variant_title">' + $p_grid_val.variants[0].title + '</span></div>';
		}
		return $th_product_single_html;
	}
	const $th_pb_p_grid_multi_variant = function($th_result, $th_bundle_val, $p_grid_val, $th_product_default_image, $th_default_discount, $th_pb_show_hide_select, $p_grid_key) {
		let $th_product_image = $th_product_default_image,
			$th_discount = $th_default_discount;
		let $th_product_multi_html = '<div class="th_pb_variants_section th_pb_wf th_pb_variants_section_layout_' + $th_bundle_val.bundle_detail.layout_setting_type + '"><select class="th_pb_pro_variants th_pb_wf ' + $th_pb_show_hide_select + ' th_all_bdn_variant_id_' + $p_grid_key + '">';
		$p_grid_val.variants.forEach(function(variant, variant_key) {
			const $th_dc_price = $th_pb_product_bundle_price($th_bundle_val, variant.price, $th_default_discount);
			const $th_dc_cp_price = $th_pb_product_bundle_original_price($th_bundle_val, variant.price, variant.compare_at_price, $th_default_discount);
			if ((variant.featured_image !== undefined && variant.featured_image !== null) || (variant.image !== undefined && variant.image !== null)) {
				if (variant.featured_image !== undefined && variant.featured_image !== null) {
					$th_product_image = $th_image_resizer(variant.featured_image.src, '600x');
				} else {
					$th_product_image = $th_image_resizer(variant.image.originalSrc, '600x');
				}
			}
			const $th_variant_available_status = $th_variant_instock_status($p_grid_val, variant);
			$th_product_multi_html += '<option value="' + variant.id + '" data-title="' + variant.title.replace(/"/g, "'") + '" data-ptitle="' + $p_grid_val.title + '" data-compare_price="' + $th_dc_cp_price + '" data-price="' + $th_dc_price + '" data-image="' + $th_product_image + '?v=123" data-available="' + $th_variant_available_status + '">' + variant.title + '</option>';
		});
		$th_product_multi_html += '</select>';
		if ($p_grid_val.is_all_variants == '1') {
			if (parseInt($th_result.layout_setting.variant_layout) === 1) {
				const $th_pb_current_time = Date.now();
				$p_grid_val.options.forEach(function(option_val, option_key) {
					$th_product_multi_html += '<div class="th_pb_wf th_pb_variants_swatches_div_cls th_pb_variants_swatches_div_layout_' + $th_bundle_val.bundle_detail.layout_setting_type + '" data-index="' + option_key + '" data-option="' + option_val.name.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '') + '">';
					$th_product_multi_html += '<span class="th_pb_wf th_pb_variant_option_title">' + option_val.name + '</span>';
					option_val.values.forEach(function(option_title_val, option_title_key) {
						const $th_pb_option_checked = option_title_key === 0 ? 'checked="checked"' : '';
						if (option_val.name.toLowerCase().indexOf('color') != -1 || option_val.name.toLowerCase().indexOf('colour') != -1) {
							$th_product_multi_html += '<div class="th_pb_variant_swatch_field th_pb_variant_swatch_field_color">';
							$th_product_multi_html += '<input type="radio" name="th_pb_' + $th_bundle_val.bundle_detail.id + '_' + $p_grid_val.handle + '_' + option_key + '_' + $th_pb_current_time + '" id="th_pb_variant_swatch_' + $th_bundle_val.bundle_detail.id + '_' + $p_grid_val.handle + '_' + option_key + '_' + option_title_key + '_' + $th_pb_current_time + '" class="th_pb_variant_swatch_btn" value="' + option_title_val.replace(/"/g, "'") + '" ' + $th_pb_option_checked + ' />';
							$th_product_multi_html += '<label class="th_pb_variant_swatch_label th_pb_variant_swatch_color ' + option_title_val.toLowerCase().replace(/[^\w ]+/g, '').replace(/ +/g, '-') + '" for="th_pb_variant_swatch_' + $th_bundle_val.bundle_detail.id + '_' + $p_grid_val.handle + '_' + option_key + '_' + option_title_key + '_' + $th_pb_current_time + '" style="background-color:' + option_title_val.toLowerCase().replace(/[^\w ]+/g, '').replace(/ +/g, '-') + '"></label>';
							$th_product_multi_html += '</div>';
						} else {
							$th_product_multi_html += '<div class="th_pb_variant_swatch_field">';
							$th_product_multi_html += '<input type="radio" name="th_pb_' + $th_bundle_val.bundle_detail.id + '_' + $p_grid_val.handle + '_' + option_key + '_' + $th_pb_current_time + '" id="th_pb_variant_swatch_' + $th_bundle_val.bundle_detail.id + '_' + $p_grid_val.handle + '_' + option_key + '_' + option_title_key + '_' + $th_pb_current_time + '" class="th_pb_variant_swatch_btn" value="' + option_title_val.replace(/"/g, "'") + '" ' + $th_pb_option_checked + ' />';
							$th_product_multi_html += '<label class="th_pb_variant_swatch_label th_pb_variant_swatch_label_other ' + option_title_val.toLowerCase().replace(/[^\w ]+/g, '').replace(/ +/g, '-') + '" for="th_pb_variant_swatch_' + $th_bundle_val.bundle_detail.id + '_' + $p_grid_val.handle + '_' + option_key + '_' + option_title_key + '_' + $th_pb_current_time + '">' + option_title_val + '</label>';
							$th_product_multi_html += '</div>';
						}
					});
					$th_product_multi_html += '</div>';
				});
			} else {
				$p_grid_val.options.forEach(function(option_val, option_key) {
					$th_product_multi_html += '<div class="th_pb_wf th_pb_variants_select_div_cls th_pb_variants_select_div th_pb_variants_select_div_layout_' + $th_bundle_val.bundle_detail.layout_setting_type + '" data-option="' + option_val.name.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '') + '">';
					$th_product_multi_html += '<label class="th_pb_wf th_pb_option_label_cls" data-name="' + option_val.name + '">' + option_val.name + '</label>';
					$th_product_multi_html += '<select class="th_pb_wf th_pb_option_select_cls" data-name="' + option_val.name + '">';
					option_val.values.forEach(function(option_title_val, option_title_key) {
						$th_product_multi_html += '<option value="' + option_title_val.replace(/"/g, "'") + '">' + option_title_val + '</option>';
					});
					$th_product_multi_html += '</select></div>';
				});
			}
		}
		$th_product_multi_html += '</div>';
		return $th_product_multi_html;
	}
	const $th_bundle_design_layout_1 = function($th_bundle_result, $th_pro_value) {
		if ($th_pro_value.product_list) {
			let $th_discount = 100 - parseFloat($th_pro_value.bundle_detail.discount);
			if ($th_pro_value.bundle_detail.discount_type == '2') {
				$th_discount = 100;
			}
			let $th_product = '',
				$th_total_price_dc = 0,
				$th_total_price = 0;
			$th_product += '<div class="th_pb_innercode th_pb_wf" data-bundle="' + $th_pro_value.bundle_detail.id + '">';
			$th_product += $th_bundle_main_title($th_pro_value, 'th_normal_bundle_title', 'th_pb_title th_pb_wf', '', 'th_pb_title_description');
			$th_product += '<div class="th_pb_list th_pb_list_layout_1 th_pb_wf"><ul class="th_pb_list_ul th_pb_list_ul_index_' + $th_pro_value.product_list.length + '" data-bundle="' + $th_pro_value.bundle_detail.id + '" data-discount="' + $th_discount + '" data-fixedprice="' + ($th_pro_value.bundle_detail.fixed_discount) * $th_active_currency_rate + '" data-bundletype="' + $th_pro_value.bundle_detail.discount_type + '">';
			$th_pro_value.product_list.forEach(function(value, key) {
				if (value.status.toLowerCase() !== 'draft') {
					let $th_product_image = $th_pb_p_grid_image(value);
					$th_product += '<li class="li_product_list" data-id="' + value.id + '"><div class="th_pb_list_content th_pb_wf"><figure class="th_product_img th_pb_wf">';
					$th_product += '<a href="/products/' + value.handle + '"><img src="' + $th_product_image + '?v=123" alt="' + value.handle + '" /></a>';
					$th_product += '</figure>';
					$th_product += '<div class="th_pb_list_pro_detail th_pb_wf"><h6 class="th_pb_pro_title th_pb_wf"><a href="/products/' + value.handle + '">' + value.title + '</a></h6>';
					if (wc_external_script_layout.show_rivyo_widget == '1') {
						$th_product += $th_pb_p_grid_review(value, '$th_normal_bundle');
					}
					const $th_pb_show_hide_select = value.is_all_variants == '1' ? 'th_bundle_main_select_hide_cls' : '';
					if (value.variants.length <= 1) {
						$th_product += $th_pb_p_grid_single_variant($th_pro_value, value, $th_product_image, $th_discount, $th_pb_show_hide_select, key);
					} else {
						$th_product += $th_pb_p_grid_multi_variant($th_bundle_result, $th_pro_value, value, $th_product_image, $th_discount, $th_pb_show_hide_select, key);
					}
					$th_product += '<p class="th_pb_bd_qty th_pb_wf th_all_bdn_qty_id_' + key + '" data-id="' + value.id + '" data-qty="' + value.selected_qty + '">' + wc_external_script_layout.language.quantity + ': <span>' + value.selected_qty + '</span></p>';
					let $th_dc_price = $th_pb_product_bundle_price($th_pro_value, value.variants[0].price, $th_discount);
					let $th_dc_cp_price = $th_pb_product_bundle_original_price($th_pro_value, value.variants[0].price, value.variants[0].compare_at_price, $th_discount);
					if ($th_dc_price > 0) {
						$th_product += '<p class="th_pb_list_price th_pb_wf" data-free="' + wc_external_script_layout.language.free_price + '"><span class="th_pb_main_price"><span class="money transcy-money">' + $th_money_format($th_dc_price, $th_shop_money) + '</span></span>';
					} else {
						$th_product += '<p class="th_pb_list_price th_pb_wf" data-free="' + wc_external_script_layout.language.free_price + '"><span class="th_pb_main_price"><span class="money">' + wc_external_script_layout.language.free_price + '</span></span>';
					}
					if ($th_dc_cp_price > $th_dc_price) {
						$th_product += '<span class="th_pb_old_price"><span class="money transcy-money th_pb_line_through">' + $th_money_format($th_dc_cp_price, $th_shop_money) + '</span></span>';
					}
					$th_product += '</p></div></div></li>';
					$th_pb_generate_variantmap(value);
				} else {
					console.log('Rebolt Bundle--> This product is not available', value);
				}
			});
			$th_product += '</ul>';
			$th_product += '<div class="th_pb_addtocart_section th_pb_wf">';
			if (parseFloat($th_pro_value.bundle_detail.discount) > 0 || parseFloat($th_pro_value.bundle_detail.fixed_discount) > 0) {
				if ($th_pro_value.bundle_detail.discount_type == '1') {
					const $th_fixed_discount_val = (parseFloat($th_pro_value.bundle_detail.fixed_discount) * 100) * $th_active_currency_rate;
					$th_total_price_dc = $th_total_price - $th_fixed_discount_val;
					$th_product += '<p class="th_pb_total_price th_pb_wf" data-freeship="' + wc_external_script_layout.language.free_shipping + '">' + wc_external_script_layout.language.total_price + ' <span class="th_pb_total_sale_price"><span class="money transcy-money">' + $th_money_format($th_total_price_dc, $th_shop_money) + '</span></span><span class="th_pb_old_price"><span class="money th_pb_line_through">' + $th_money_format($th_total_price, $th_shop_money) + '</span></span><span class="th_pb_total_save_label"><span class="th_pb_total_save_text">' + wc_external_script_layout.language.save + '</span><span class="th_pb_total_save_price"></span></span></p>';
				} else {
					$th_product += '<p class="th_pb_total_price th_pb_wf" data-freeship="' + wc_external_script_layout.language.free_shipping + '">' + wc_external_script_layout.language.total_price + ' <span class="th_pb_total_sale_price"><span class="money transcy-money">' + $th_money_format($th_total_price_dc, $th_shop_money) + '</span></span><span class="th_pb_old_price"><span class="money th_pb_line_through">' + $th_money_format($th_total_price, $th_shop_money) + '</span></span><span class="th_pb_total_save_label"><span class="th_pb_total_save_text">' + wc_external_script_layout.language.save + '</span><span class="th_pb_total_save_price"></span></span></p>';
				}
			} else {
				$th_product += '<p class="th_pb_total_price th_pb_wf" data-freeship="' + wc_external_script_layout.language.free_shipping + '">' + wc_external_script_layout.language.total_price + ' <span class="th_pb_total_sale_price"><span class="money transcy-money">' + $th_money_format($th_total_price_dc, $th_shop_money) + '</span></span></p>';
			}
			$th_product += '<div class="th_ajax_error" data-msg="' + $th_bundle_result.layout_setting.language.not_available + '"></div>';
			$th_product += $th_pb_bundle_addtocart_btn($th_bundle_result, $th_pro_value, 'th_normal_bundle_cta_btn');
			$th_product += '</div></div></div>';
			return $th_product;
		}
	}
	const $th_bundle_design_layout_2 = function($th_bundle_result, $th_pro_value) {
		if ($th_pro_value.product_list) {
			let $th_discount = 100 - parseFloat($th_pro_value.bundle_detail.discount);
			if ($th_pro_value.bundle_detail.discount_type == '2') {
				$th_discount = 100;
			}
			let $th_product = '',
				$th_total_price_dc = 0,
				$th_total_price = 0;
			$th_product += '<div class="th_pb_innercode th_pb_wf th_pb_bundle_layout_2" data-bundle="' + $th_pro_value.bundle_detail.id + '">';
			$th_product += $th_bundle_main_title($th_pro_value, 'th_normal_bundle_title', 'th_pb_title th_pb_wf', '', 'th_pb_title_description');
			$th_product += '<div class="th_pb_grid_layout_2 th_pb_wf"><ul class="th_pb_list_ul th_pb_list_ul_layout_2 th_pb_list_ul_index_' + $th_pro_value.product_list.length + '" data-bundle="' + $th_pro_value.bundle_detail.id + '" data-discount="' + $th_discount + '" data-fixedprice="' + ($th_pro_value.bundle_detail.fixed_discount) * $th_active_currency_rate + '" data-bundletype="' + $th_pro_value.bundle_detail.discount_type + '">';
			$th_pro_value.product_list.forEach(function(value, key) {
				if (value.status.toLowerCase() != 'draft') {
					let $th_product_image = $th_pb_p_grid_image(value);
					$th_product += '<li class="li_product_list li_product_list_layout_2" data-id="' + value.id + '"><div class="th_pb_list_content th_pb_wf th_pb_list_content_layout_2"><div class="th_pb_figure_div_layout_2 th_pb_wf"><figure class="th_product_img th_pb_wf th_product_img_layout_2">';
					$th_product += '<a href="/products/' + value.handle + '"><img src="' + $th_product_image + '?v=123" alt="' + value.handle + '" /></a>';
					$th_product += '</figure></div>';
					$th_product += '<div class="th_pb_list_pro_detail th_pb_wf th_pb_list_pro_detail_layout_2"><div class="th_pb_list_title_price_layout_2 th_pb_wf"><h6 class="th_pb_pro_title th_pb_wf"><a href="/products/' + value.handle + '">' + value.title + '</a></h6>';
					if (wc_external_script_layout.show_rivyo_widget == '1') {
						$th_product += $th_pb_p_grid_review(value, '$th_normal_bundle');
					}
					$th_product += '<p class="th_pb_bd_qty th_pb_wf th_pb_bd_qty_layout_2 th_pb_qty_' + key + ' th_all_bdn_qty_id_' + key + '" data-id="' + value.id + '" data-qty="' + value.selected_qty + '">' + wc_external_script_layout.language.quantity + ': <span>' + value.selected_qty + '</span></p>';
					const $th_pb_show_hide_select = value.is_all_variants == '1' ? 'th_bundle_main_select_hide_cls' : '';
					let $th_dc_price = $th_pb_product_bundle_price($th_pro_value, value.variants[0].price, $th_discount);
					let $th_dc_cp_price = $th_pb_product_bundle_original_price($th_pro_value, value.variants[0].price, value.variants[0].compare_at_price, $th_discount);
					if ($th_dc_price > 0) {
						$th_product += '<p class="th_pb_list_price th_pb_wf th_pb_list_price_layout_2" data-free="' + wc_external_script_layout.language.free_price + '"><span class="th_pb_main_price"><span class="money transcy-money">' + $th_money_format($th_dc_price, $th_shop_money) + '</span></span>';
					} else {
						$th_product += '<p class="th_pb_list_price th_pb_wf th_pb_list_price_layout_2" data-free="' + wc_external_script_layout.language.free_price + '"><span class="th_pb_main_price"><span class="money">' + wc_external_script_layout.language.free_price + '</span></span>';
					}
					if ($th_dc_cp_price > $th_dc_price) {
						$th_product += '<span class="th_pb_old_price"><span class="money transcy-money th_pb_line_through">' + $th_money_format($th_dc_cp_price, $th_shop_money) + '</span></span>';
					}
					$th_product += '</p></div>';
					if (value.variants.length <= 1) {
						$th_product += $th_pb_p_grid_single_variant($th_pro_value, value, $th_product_image, $th_discount, $th_pb_show_hide_select, key);
					} else {
						$th_product += $th_pb_p_grid_multi_variant($th_bundle_result, $th_pro_value, value, $th_product_image, $th_discount, $th_pb_show_hide_select, key);
					}
					$th_product += '</div></div></li>';
					$th_pb_generate_variantmap(value);
				} else {
					console.log('Rebolt Bundle--> This product is not available', value);
				}
			});
			$th_product += '</ul>';
			$th_product += '<div class="li_product_list_layout_2 li_product_list_addtocart_layout_2"><div class="th_pb_list_content th_pb_wf th_pb_list_content_layout_2">';
			$th_product += '<div class="th_pb_addtocart_section th_pb_wf th_pb_addtocart_section_layout_2"><div class="th_pb_figure_div_layout_2 th_pb_wf">';
			$th_product += '<figure class="th_product_img th_pb_wf th_product_img_layout_2">';
			$th_product += '<div class="th_pb_total_price th_pb_wf th_pb_total_price_layout_2">';
			if (parseFloat($th_pro_value.bundle_detail.discount) > 0 || parseFloat($th_pro_value.bundle_detail.fixed_discount) > 0) {
				$th_product += '<div class="th_pb_wf th_pb_total_price_inner_layout_2">';
				if ($th_pro_value.bundle_detail.discount_type != '2') {
					$th_product += '<span class="th_pb_wf th_pb_separatly_price_text">' + wc_external_script_layout.language.separate_price + ' <span class="th_pb_old_price"><span class="money transcy-money th_pb_line_through">' + $th_money_format($th_total_price, $th_shop_money) + '</span></span></span>';
				}
				if ($th_pro_value.bundle_detail.discount_type == '1') {
					const $th_fixed_discount_val = (parseFloat($th_pro_value.bundle_detail.fixed_discount) * 100) * $th_active_currency_rate;
					$th_product += '<span class="th_pb_wf th_pb_total_save_text">' + wc_external_script_layout.language.save + ' <span class="th_pb_total_sale_percentage"><span class="money transcy-money">' + $th_money_format($th_fixed_discount_val, $th_shop_money) + '</span></span></span>';
				} else if ($th_pro_value.bundle_detail.discount_type == '2') {
					$th_product += '<span class="th_pb_wf th_pb_total_save_text">' + $th_bundle_result.layout_setting.language.save + ' <span class="th_pb_total_sale_percentage">' + $th_bundle_result.layout_setting.language.free_shipping + '</span></span>';
				} else {
					$th_product += '<span class="th_pb_wf th_pb_total_save_text">' + $th_bundle_result.layout_setting.language.save + ' <span class="th_pb_total_sale_percentage">' + $th_pro_value.bundle_detail.discount + '%</span></span>';
				}
				$th_product += '</div>';
			}
			$th_product += '<div class="th_pb_wf th_pb_total_save_inner_layout_2">';
			$th_product += '<span class="th_pb_wf th_pb_total_price_text"><span class="th_pb_total_price_text_content">' + wc_external_script_layout.language.total_price + '</span> <span class="th_pb_total_sale_price"><span class="money transcy-money">' + $th_money_format($th_total_price_dc, $th_shop_money) + '</span></span></span>';
			$th_product += '</div></figure></div>';
			$th_product += '<div class="th_ajax_error" data-msg="' + wc_external_script_layout.language.not_available + '"></div>';
			$th_product += $th_pb_bundle_addtocart_btn($th_bundle_result, $th_pro_value, 'th_normal_bundle_cta_btn');
			$th_product += '</div></div></div>';
			$th_product += '</div></div>';
			return $th_product;
		}
	}
	const $th_bundle_design_layout_3 = function($th_bundle_result, $th_pro_value) {
		if ($th_pro_value.product_list) {
			let $th_discount = 100 - parseFloat($th_pro_value.bundle_detail.discount);
			if ($th_pro_value.bundle_detail.discount_type == '2') {
				$th_discount = 100;
			}
			let $th_product = '',
				$th_total_price_dc = 0,
				$th_total_price = 0,
				$th_product_length = '';
			if ($th_pro_value.product_list.length > 3) {
				$th_product_length = 'li_product_list_four_grid';
			}
			$th_product += '<div class="th_pb_innercode th_pb_wf th_pb_bundle_layout_3" data-bundle="' + $th_pro_value.bundle_detail.id + '">';
			$th_product += $th_bundle_main_title($th_pro_value, 'th_normal_bundle_title', 'th_pb_title th_pb_wf', '', 'th_pb_title_description');
			$th_product += '<div class="th_pb_grid_layout_3 th_pb_wf"><ul class="th_pb_list_ul th_pb_list_ul_layout_3 th_pb_list_ul_index_' + $th_pro_value.product_list.length + '" data-bundle="' + $th_pro_value.bundle_detail.id + '" data-discount="' + $th_discount + '" data-fixedprice="' + ($th_pro_value.bundle_detail.fixed_discount) * $th_active_currency_rate + '" data-bundletype="' + $th_pro_value.bundle_detail.discount_type + '">';
			$th_pro_value.product_list.forEach(function(value, key) {
				if (value.status.toLowerCase() != 'draft') {
					let $th_product_image = $th_pb_p_grid_image(value);
					$th_product += '<li class="li_product_list li_product_list_layout_3 ' + $th_product_length + '" data-id="' + value.id + '"><div class="th_pb_list_content th_pb_wf th_pb_list_content_layout_3"><div class="th_pb_figure_div_layout_3 th_pb_wf"><figure class="th_product_img th_pb_wf th_product_img_layout_3">';
					$th_product += '<a href="/products/' + value.handle + '"><img src="' + $th_product_image + '?v=123" alt="' + value.handle + '" /></a>';
					$th_product += '</figure></div>';
					$th_product += '<div class="th_pb_list_pro_detail th_pb_wf th_pb_list_pro_detail_layout_3"><div class="th_pb_list_title_price_layout_3 th_pb_wf"><h6 class="th_pb_pro_title th_pb_wf"><a href="/products/' + value.handle + '">' + value.title + '</a></h6>';
					if (wc_external_script_layout.show_rivyo_widget == '1') {
						$th_product += $th_pb_p_grid_review(value, '$th_normal_bundle');
					}
					$th_product += '<p class="th_pb_bd_qty th_pb_wf th_pb_bd_qty_layout_3 th_pb_qty_' + key + ' th_all_bdn_qty_id_' + key + '" data-id="' + value.id + '" data-qty="' + value.selected_qty + '">' + wc_external_script_layout.language.quantity + ': <span>' + value.selected_qty + '</span></p>';
					const $th_pb_show_hide_select = value.is_all_variants == '1' ? 'th_bundle_main_select_hide_cls' : '';
					let $th_dc_price = $th_pb_product_bundle_price($th_pro_value, value.variants[0].price, $th_discount);
					let $th_dc_cp_price = $th_pb_product_bundle_original_price($th_pro_value, value.variants[0].price, value.variants[0].compare_at_price, $th_discount);
					if ($th_dc_price > 0) {
						$th_product += '<p class="th_pb_list_price th_pb_wf th_pb_list_price_layout_3" data-free="' + wc_external_script_layout.language.free_price + '"><span class="th_pb_main_price"><span class="money transcy-money">' + $th_money_format($th_dc_price, $th_shop_money) + '</span></span>';
					} else {
						$th_product += '<p class="th_pb_list_price th_pb_wf th_pb_list_price_layout_3" data-free="' + wc_external_script_layout.language.free_price + '"><span class="th_pb_main_price"><span class="money transcy-money">' + wc_external_script_layout.language.free_price + '</span></span>';
					}
					if ($th_dc_cp_price > $th_dc_price) {
						$th_product += '<span class="th_pb_old_price"><span class="money transcy-money th_pb_line_through">' + $th_money_format($th_dc_cp_price, $th_shop_money) + '</span></span>';
					}
					$th_product += '</p></div>';
					if (value.variants.length <= 1) {
						$th_product += $th_pb_p_grid_single_variant($th_pro_value, value, $th_product_image, $th_discount, $th_pb_show_hide_select, key);
					} else {
						$th_product += $th_pb_p_grid_multi_variant($th_bundle_result, $th_pro_value, value, $th_product_image, $th_discount, $th_pb_show_hide_select, key);
					}
					$th_product += '</div></div></li>';
					$th_pb_generate_variantmap(value);
				} else {
					console.log('Rebolt Bundle--> This product is not available', value);
				}
			});
			$th_product += '</ul>';
			$th_product += '<div class="th_pb_wf th_pb_list_content_layout_3"><div class="th_pb_addtocart_section th_pb_wf th_pb_addtocart_section_layout_3"><div class="th_pb_total_price th_pb_wf th_pb_total_price_layout_3">';
			if (parseFloat($th_pro_value.bundle_detail.discount) > 0 || parseFloat($th_pro_value.bundle_detail.fixed_discount) > 0) {
				if ($th_pro_value.bundle_detail.discount_type != '2') {
					$th_product += '<div class="th_pb_total_original_price_inner_layout_3">';
					$th_product += '<p class="th_pb_wf"><span class="th_pb_separatly_price_text">' + wc_external_script_layout.language.separate_price + ' </span><span class="th_pb_old_price"><span class="money transcy-money">' + $th_money_format($th_total_price, $th_shop_money) + '</span></span></p>';
					$th_product += '</div>';
				}
				if ($th_pro_value.bundle_detail.discount_type == '1') {
					$th_product += '<div class="th_pb_total_save_inner_layout_3">';
					const $th_fixed_discount_val = (parseFloat($th_pro_value.bundle_detail.fixed_discount) * 100) * $th_active_currency_rate;
					$th_product += '<p class="th_pb_wf"><span class="th_pb_wf th_pb_total_save_text">' + wc_external_script_layout.language.save + ' <span class="th_pb_total_sale_percentage"><span class="money transcy-money">' + $th_money_format($th_fixed_discount_val, $th_shop_money) + '</span></span></span></p>';
					$th_product += '</div>';
				} else if ($th_pro_value.bundle_detail.discount_type == '2') {
					$th_product += '<div class="th_pb_total_save_inner_layout_3">';
					$th_product += '<p class="th_pb_wf"><span class="th_pb_wf th_pb_total_save_text">' + $th_bundle_result.layout_setting.language.save + ' <span class="th_pb_total_sale_percentage">' + $th_bundle_result.layout_setting.language.free_shipping + '</span></span></p>';
					$th_product += '</div>';
				} else {
					$th_product += '<div class="th_pb_total_save_inner_layout_3">';
					$th_product += '<p class="th_pb_wf"><span class="th_pb_wf th_pb_total_save_text">' + $th_bundle_result.layout_setting.language.save + ' <span class="th_pb_total_sale_percentage">' + $th_pro_value.bundle_detail.discount + '%</span></span></p>';
					$th_product += '</div>';
				}
			}
			$th_product += '<div class="th_pb_total_price_inner_layout_3">';
			$th_product += '<p class="th_pb_wf"><span class="th_pb_total_price_text"><span class="th_pb_total_price_text_content">' + wc_external_script_layout.language.total_price + '</span> </span><span class="th_pb_total_sale_price"><span class="money transcy-money">' + $th_money_format($th_total_price_dc, $th_shop_money) + '</span></span></p>';
			$th_product += '</div>';
			$th_product += '<div class="th_pb_addtocart_btn_layout_3">';
			$th_product += $th_pb_bundle_addtocart_btn($th_bundle_result, $th_pro_value, 'th_normal_bundle_cta_btn');
			$th_product += '</div>';
			$th_product += '</div><div class="th_ajax_error" data-msg="' + $th_bundle_result.layout_setting.language.not_available + '"></div>';
			$th_product += '</div></div>';
			$th_product += '</div></div>';
			return $th_product;
		}
	}
	const $th_bundle_normal_event = function($th_bundle_result, $th_bundle_class, $th_bundle_code_place, $th_specific_bundle) {
		let $th_bundle_new_html = '';
		$th_bundle_result.bundle_list.forEach(function($th_pro_value, $th_pro_index) {
			if ($th_pro_value.bundle_detail.layout_setting_type == '2') {
				$th_bundle_new_html += $th_bundle_design_layout_2($th_bundle_result, $th_pro_value);
			} else if ($th_pro_value.bundle_detail.layout_setting_type == '3') {
				$th_bundle_new_html += $th_bundle_design_layout_3($th_bundle_result, $th_pro_value);
			} else {
				$th_bundle_new_html += $th_bundle_design_layout_1($th_bundle_result, $th_pro_value);
			}
			if ($th_pro_index === ($th_bundle_result.bundle_list.length - 1)) {
				if ($th_specific_bundle == null) {
					if ($th_bundle_code_place.includes('$th_bundle_after_code')) {
						if (wc_external_script_layout.automatic_show_bundle == '1') {
							document.querySelectorAll($th_bundle_class)[0].insertAdjacentHTML('afterend', '<div class="th_pb_section" id="th_product_bundle">' + $th_bundle_new_html + '</div>');
						}
					} else {
						if ($th_bundle_class) {
							document.querySelector($th_bundle_class).insertAdjacentHTML('beforeend', $th_bundle_new_html);
						}
					}
				} else {
					$th_specific_bundle.insertAdjacentHTML('beforeend', $th_bundle_new_html);
				}
				$th_bundle_normal_change_event();
				$th_bundle_normal_addtocart_click_event();
				$th_bundle_grid_equalizer();
				if (wc_external_script_layout.show_rivyo_widget == '1') {
					$th_bundle_rivyo_average_rating('.th_pb_rivyo_average_rating');
				}
				if (typeof $th_bundle_success_callback === 'function') {
					$th_bundle_success_callback($th_pro_value.bundle_detail.id, $th_bundle_result);
				}
			}
		});
	}
	const $th_bundle_normal_popup_event = function($th_bundle_result) {
		$th_bundle_result.popup_bundle_list.forEach(function($th_pro_value, $th_pro_index) {
			let $th_bundle_popup_html = '<div class="th_pb_bundle_popup_section" data-loopkey="' + $th_pro_value.bundle_detail.id + '"><div class="th_pb_bundle_popup_outer"><div class="th_pb_bundle_popup_inner">';
			$th_bundle_popup_html += '<div class="th_pb_bundle_popup_close">';
			$th_bundle_popup_html += '<span class="th_pb_bundle_popup_close_btn" data-loopkey="' + $th_pro_value.bundle_detail.id + '"><svg fill="#000000" viewBox="0 0 30 30" width="60px" height="60px"><path d="M 7 4 C 6.744125 4 6.4879687 4.0974687 6.2929688 4.2929688 L 4.2929688 6.2929688 C 3.9019687 6.6839688 3.9019687 7.3170313 4.2929688 7.7070312 L 11.585938 15 L 4.2929688 22.292969 C 3.9019687 22.683969 3.9019687 23.317031 4.2929688 23.707031 L 6.2929688 25.707031 C 6.6839688 26.098031 7.3170313 26.098031 7.7070312 25.707031 L 15 18.414062 L 22.292969 25.707031 C 22.682969 26.098031 23.317031 26.098031 23.707031 25.707031 L 25.707031 23.707031 C 26.098031 23.316031 26.098031 22.682969 25.707031 22.292969 L 18.414062 15 L 25.707031 7.7070312 C 26.098031 7.3170312 26.098031 6.6829688 25.707031 6.2929688 L 23.707031 4.2929688 C 23.316031 3.9019687 22.682969 3.9019687 22.292969 4.2929688 L 15 11.585938 L 7.7070312 4.2929688 C 7.5115312 4.0974687 7.255875 4 7 4 z"/></path></svg></span>';
			$th_bundle_popup_html += '</div>';
			$th_bundle_popup_html += '<div class="th_pb_bundle_popup_bundle_details">';
			if ($th_pro_value.bundle_detail.layout_setting_type == '2') {
				$th_bundle_popup_html += $th_bundle_design_layout_2($th_bundle_result, $th_pro_value);
			} else if ($th_pro_value.bundle_detail.layout_setting_type == '3') {
				$th_bundle_popup_html += $th_bundle_design_layout_3($th_bundle_result, $th_pro_value);
			} else {
				$th_bundle_popup_html += $th_bundle_design_layout_1($th_bundle_result, $th_pro_value);
			}
			$th_bundle_popup_html += '</div>';
			$th_bundle_popup_html += '</div></div></div>';
			document.getElementsByTagName('body')[0].insertAdjacentHTML('beforeend', $th_bundle_popup_html);
			if (typeof $th_bundle_success_callback === 'function') {
				$th_bundle_success_callback($th_pro_value.bundle_detail.id, $th_bundle_result);
			}
			let $th_bundle_popup_delay_time = 1;
			if (parseFloat($th_pro_value.bundle_detail.delay_time) != 0) {
				$th_bundle_popup_delay_time = parseFloat($th_pro_value.bundle_detail.delay_time);
			}
			setTimeout(function() {
				setTimeout(function() {
					document.querySelectorAll('.th_pb_bundle_popup_section').forEach(function($th_pb_bundle_popup_val, $th_pb_bundle_popup_idx) {
						$th_pb_bundle_popup_val.style.display = 'block';
					});
					setTimeout(function() {
						document.querySelectorAll('.th_pb_bundle_popup_section').forEach(function($th_pb_bundle_popup_val, $th_pb_bundle_popup_idx) {
							$th_pb_bundle_popup_val.style.opacity = 1;
						});
					}, 100);
				}, 100);
				$th_bundle_normal_change_event();
				$th_bundle_normal_addtocart_click_event();
				$th_bundle_grid_equalizer();
				$th_bundle_close_popup_event();
				if ($th_bundle_result.layout_setting.show_rivyo_widget == '1') {
					$th_bundle_rivyo_average_rating('.th_pb_rivyo_average_rating');
				}
			}, ($th_bundle_popup_delay_time * 1000));
		});
	}
	const $th_bundle_combo_change_event = function() {
		const $th_combo_final_total = function($this_main_parent) {
			let $th_combo_new_sale_price = 0,
				$th_combo_new_compare_price = 0;
			const $th_combo_dtype = $this_main_parent.getAttribute('data-dtype');
			let $th_combo_variant_available = [];
			$this_main_parent.querySelectorAll('.thpb_combo_p_grid_main_variants').forEach(function($thpb_combo_p_grid_main_variants, $th_index) {
				const $th_combo_temp_sale_price = parseFloat($thpb_combo_p_grid_main_variants.options[$thpb_combo_p_grid_main_variants.selectedIndex].getAttribute('data-price'));
				const $th_combo_temp_compare_price = (parseFloat($thpb_combo_p_grid_main_variants.options[$thpb_combo_p_grid_main_variants.selectedIndex].getAttribute('data-compare_price'))) ? parseFloat($thpb_combo_p_grid_main_variants.options[$thpb_combo_p_grid_main_variants.selectedIndex].getAttribute('data-compare_price')) : parseFloat($thpb_combo_p_grid_main_variants.options[$thpb_combo_p_grid_main_variants.selectedIndex].getAttribute('data-price'));
				const $th_combo_temp_ptitle = $thpb_combo_p_grid_main_variants.options[$thpb_combo_p_grid_main_variants.selectedIndex].getAttribute('data-ptitle');
				const $th_combo_temp_vtitle = $thpb_combo_p_grid_main_variants.options[$thpb_combo_p_grid_main_variants.selectedIndex].getAttribute('data-title');
				const $th_combo_temp_available = JSON.parse($thpb_combo_p_grid_main_variants.options[$thpb_combo_p_grid_main_variants.selectedIndex].getAttribute('data-available'));
				const $th_combo_final_title = ($th_combo_temp_vtitle != 'Default Title') ? $th_combo_temp_ptitle + ' (' + $th_combo_temp_vtitle + ')' : $th_combo_temp_ptitle;
				$thpb_combo_p_grid_main_variants.closest('.thpb_combo_p_grid_list').querySelector('.thpb_combo_p_grid_main_price').innerHTML = '<span class="money transcy-money">' + $th_money_format($th_combo_temp_sale_price, $th_shop_money) + '</span>';
				if ($thpb_combo_p_grid_main_variants.closest('.thpb_combo_p_grid_list').querySelector('.thpb_combo_p_grid_old_price')) {
					if ($th_combo_temp_compare_price > $th_combo_temp_sale_price) {
						$thpb_combo_p_grid_main_variants.closest('.thpb_combo_p_grid_list').querySelector('.thpb_combo_p_grid_old_price').innerHTML = '<span class="money transcy-money">' + $th_money_format($th_combo_temp_compare_price, $th_shop_money) + '</span>';
					} else {
						$thpb_combo_p_grid_main_variants.closest('.thpb_combo_p_grid_list').querySelector('.thpb_combo_p_grid_old_price').innerHTML = '';
					}
				}
				$th_combo_variant_available.push({
					product_title: $th_combo_final_title,
					variant_available: $th_combo_temp_available
				});
				$th_combo_new_sale_price = $th_combo_new_sale_price + parseFloat($th_combo_temp_sale_price);
				$th_combo_new_compare_price = $th_combo_new_compare_price + parseFloat($th_combo_temp_compare_price);
				if ($th_index === ($this_main_parent.querySelectorAll('.thpb_combo_p_grid_main_variants').length - 1)) {
					if ($th_combo_dtype == '1') {
						const $th_combo_fixed_price_val = $this_main_parent.getAttribute('data-fixedprice');
						$th_combo_new_compare_price = $th_combo_new_sale_price;
						$th_combo_new_sale_price = $th_combo_new_sale_price - (parseFloat($th_combo_fixed_price_val) * 100);
					}
					$this_main_parent.querySelector('.thpb_combo_total_price_inner .thpb_combo_total_price_sale').innerHTML = '<span class="money transcy-money">' + $th_money_format($th_combo_new_sale_price, $th_shop_money) + '</span>';
					const $th_combo_main_price_class = $this_main_parent.querySelector('.thpb_combo_total_price_inner .thpb_combo_total_price_sale').getAttribute('data-mainprice');
					if ($th_combo_main_price_class) {
						document.querySelectorAll($th_combo_main_price_class).forEach(function($th_combo_main_price_class_cls) {
							$th_combo_main_price_class_cls.innerHTML = '<span class="money transcy-money">' + $th_money_format($th_combo_new_sale_price, $th_shop_money) + '</span>';
						});
					}
					const $th_combo_old_price_class = $this_main_parent.querySelector('.thpb_combo_total_price_inner .thpb_combo_total_price_old').getAttribute('data-mainprice');
					if ($th_combo_new_compare_price > $th_combo_new_sale_price) {
						$this_main_parent.querySelector('.thpb_combo_total_price_inner .thpb_combo_total_price_old').innerHTML = '<span class="money transcy-money th_pb_line_through">' + $th_money_format($th_combo_new_compare_price, $th_shop_money) + '</span>';
						if ($th_combo_old_price_class) {
							document.querySelectorAll($th_combo_old_price_class).forEach(function($th_combo_old_price_class_cls) {
								$th_combo_old_price_class_cls.innerHTML = '<span class="money transcy-money th_pb_line_through">' + $th_money_format($th_combo_new_compare_price, $th_shop_money) + '</span>';
							});
						}
					} else {
						$this_main_parent.querySelector('.thpb_combo_total_price_inner .thpb_combo_total_price_old').innerHTML = '';
						if ($th_combo_old_price_class) {
							document.querySelectorAll($th_combo_old_price_class).forEach(function($th_combo_old_price_class_cls) {
								$th_combo_old_price_class_cls.innerHTML = '';
							});
						}
					}
					let $th_combo_enable_btn_click = true;
					let $th_combo_not_available_products = new Array();
					$th_combo_variant_available.forEach(function($th_array_val, $th_array_index) {
						if (!$th_array_val.variant_available) {
							$th_combo_enable_btn_click = false;
							$th_combo_not_available_products.push($th_array_val.product_title);
						}
						if ($th_array_index === ($th_combo_variant_available.length - 1)) {
							if ($th_combo_enable_btn_click) {
								$this_main_parent.querySelector('.th_ajax_error').innerHTML = '';
								if (!$this_main_parent.querySelector('.thpb_combo_atc_cta_btn').classList.toString().includes('th_pb_draft_product_disable')) {
									$this_main_parent.querySelector('.thpb_combo_atc_cta_btn').setAttribute('style', 'pointer-events:auto !important;');
								}
								$this_main_parent.querySelector('.thpb_combo_atc_cta_btn').classList.remove('th_pb_add_to_cart_disabled');
							} else {
								$th_combo_not_available_products = [...new Set($th_combo_not_available_products)];
								const $th_combo_error_msg = $this_main_parent.querySelector('.th_ajax_error').getAttribute('data-msg');
								const $th_combo_not_available_text = $th_combo_error_msg.replace("{{title}}", $th_combo_not_available_products.join(" & "));
								$this_main_parent.querySelector('.th_ajax_error').innerHTML = '<p class="th_ajax_error_cls">' + $th_combo_not_available_text + '</p>';
								$this_main_parent.querySelector('.thpb_combo_atc_cta_btn').setAttribute('style', 'pointer-events:none !important;');
								$this_main_parent.querySelector('.thpb_combo_atc_cta_btn').classList.add('th_pb_add_to_cart_disabled');
							}
						}
					});
				}
			});
		}
		document.querySelectorAll('.thpb_combo_p_grid_main_variants').forEach(function($thpb_combo_p_grid_main_variants) {
			$thpb_combo_p_grid_main_variants[$th_bundle_addEventListener]('change', function(event) {
				event.preventDefault(), event.stopImmediatePropagation();
				const $this_parent = $thpb_combo_p_grid_main_variants.closest('.thpb_combo_p_grid_list');
				$this_parent.querySelector('.thpb_combo_p_grid_figure img').setAttribute('src', $thpb_combo_p_grid_main_variants.options[$thpb_combo_p_grid_main_variants.selectedIndex].getAttribute('data-image'));
				$th_combo_final_total($this_parent.closest('.thpb_combo_inner_start'));
			});
			$thpb_combo_p_grid_main_variants.dispatchEvent(new Event('change'));
		});
		const $th_bundle_combo_enable_cta_btn = function($th_combo_parent, $th_combo_option_val_array) {
			const $th_combo_final_opt_selected = $th_combo_option_val_array.join(" / ");
			$th_combo_parent.querySelector('.thpb_combo_p_grid_main_variants').selectedIndex = -1;
			if ($th_combo_parent.querySelectorAll('.thpb_combo_p_grid_main_variants option[data-title="' + $th_combo_final_opt_selected + '"]').length > 0) {
				$th_combo_parent.querySelector('.thpb_combo_p_grid_main_variants option[data-title="' + $th_combo_final_opt_selected + '"]').selected = true;
				$th_combo_parent.querySelector('.thpb_combo_p_grid_main_variants').dispatchEvent(new Event('change'));
			} else {
				const $th_combo_error_msg = $th_combo_parent.closest('.thpb_combo_inner_start').querySelector('.th_ajax_error').getAttribute('data-msg');
				const $th_combo_not_available_text = $th_combo_error_msg.replace("{{title}}", $th_combo_final_opt_selected);
				$th_combo_parent.closest('.thpb_combo_inner_start').querySelector('.th_ajax_error').innerHTML = '<p class="th_ajax_error_cls">' + $th_combo_not_available_text + '</p>';
				$th_combo_parent.closest('.thpb_combo_inner_start').querySelector('.thpb_combo_atc_cta_btn').setAttribute('style', 'pointer-events:none !important;');
				$th_combo_parent.closest('.thpb_combo_inner_start').querySelector('.thpb_combo_atc_cta_btn').classList.add('th_pb_add_to_cart_disabled');
			}
		}
		const $th_combo_update_radio_button = function($th_combo_select_index, $th_combo_select_pid, $th_combo_option_parents) {
			switch ($th_combo_select_index) {
				case 1:
					var $th_combo_key = 'root';
					break;
				case 2:
					var $th_combo_key = $th_combo_option_parents.querySelector('.thpb_combo_p_grid_variant_swatch_fieldset[data-index="0"] .thpb_combo_variant_swatch_btn:checked').value;
					break;
				case 3:
					var $th_combo_key = $th_combo_option_parents.querySelector('.thpb_combo_p_grid_variant_swatch_fieldset[data-index="0"] .thpb_combo_variant_swatch_btn:checked').value;
					$th_combo_key += ' / ' + $th_combo_option_parents.querySelector('.thpb_combo_p_grid_variant_swatch_fieldset[data-index="1"] .thpb_combo_variant_swatch_btn:checked').value;
			}
			const $th_combo_vari_availableOptions = ($th_products_json.th_bundle_variantmap[$th_combo_select_pid + '_' + $th_combo_key]) ? $th_products_json.th_bundle_variantmap[$th_combo_select_pid + '_' + $th_combo_key] : [];
			$th_combo_option_parents.querySelectorAll('.thpb_combo_p_grid_variant_swatch_fieldset[data-index="' + ($th_combo_select_index - 1) + '"] .thpb_combo_variant_swatch_field').forEach(function($thpb_combo_variant_swatch_field) {
				if ($th_combo_vari_availableOptions.includes($thpb_combo_variant_swatch_field.querySelector('.thpb_combo_variant_swatch_btn').value)) {
					$thpb_combo_variant_swatch_field.classList.remove('th_combo_vari_soldout');
					$thpb_combo_variant_swatch_field.style.display = 'inline-block';
					if ($thpb_combo_variant_swatch_field.querySelector('.th_combo_vari_soldout')) {
						$thpb_combo_variant_swatch_field.querySelector('.th_combo_vari_soldout').removeAttribute('disabled');
					}
				} else {
					$thpb_combo_variant_swatch_field.classList.add('th_combo_vari_soldout');
					$thpb_combo_variant_swatch_field.style.display = 'none';
					if ($thpb_combo_variant_swatch_field.querySelector('.th_combo_vari_soldout')) {
						$thpb_combo_variant_swatch_field.querySelector('.th_combo_vari_soldout').setAttribute('disabled', 'disabled');
						$thpb_combo_variant_swatch_field.querySelector('.th_combo_vari_soldout').removeAttribute('checked');
					}
				}
			});
		}
		if (document.querySelector('.thpb_combo_variant_swatch_btn')) {
			document.querySelectorAll('.thpb_combo_variant_swatch_btn').forEach(function($thpb_combo_variant_swatch_btn) {
				$thpb_combo_variant_swatch_btn[$th_bundle_addEventListener]('change', function(event) {
					event.preventDefault(), event.stopImmediatePropagation();
					let $th_combo_option_val_array = new Array();
					const $th_combo_parent = $thpb_combo_variant_swatch_btn.closest('.thpb_combo_p_grid_pvariants');
					$th_combo_parent.querySelectorAll('.thpb_combo_p_grid_variant_swatch_section').forEach(function($thpb_combo_p_grid_variant_swatch_section) {
						$th_combo_option_val_array.push($thpb_combo_p_grid_variant_swatch_section.querySelector('.thpb_combo_variant_swatch_btn:checked').value);
					});
					const $th_combo_option_pro_id = $thpb_combo_variant_swatch_btn.closest('.thpb_combo_p_grid_list').getAttribute('data-pid');
					$th_combo_update_radio_button(parseInt($th_products_json.th_bundle_products[$th_combo_option_pro_id][0].options.length), $th_combo_option_pro_id, $th_combo_parent);
					$th_bundle_combo_enable_cta_btn($th_combo_parent, $th_combo_option_val_array);
				});
				$thpb_combo_variant_swatch_btn.dispatchEvent(new Event('change'));
			});
		}
		if (document.querySelector('.thpb_combo_p_grid_variant_select')) {
			document.querySelectorAll('.thpb_combo_p_grid_variant_select').forEach(function($thpb_combo_p_grid_variant_select) {
				$thpb_combo_p_grid_variant_select[$th_bundle_addEventListener]('change', function(event) {
					event.preventDefault(), event.stopImmediatePropagation();
					let $th_combo_option_val_array = new Array();
					const $th_combo_parent = $thpb_combo_p_grid_variant_select.closest('.thpb_combo_p_grid_pvariants');
					$th_combo_parent.querySelectorAll('.thpb_combo_p_grid_variant_select').forEach(function(thpb_combo_p_grid_variant_select) {
						$th_combo_option_val_array.push(thpb_combo_p_grid_variant_select.options[thpb_combo_p_grid_variant_select.selectedIndex].value);
					});
					$th_bundle_combo_enable_cta_btn($th_combo_parent, $th_combo_option_val_array);
				});
				$thpb_combo_p_grid_variant_select.dispatchEvent(new Event('change'));
			});
		}
	}
	const $th_bundle_combo_draft_event = async function($th_combo_bundle_id, $th_direct_checkout) {
		const $th_cart_json = await $th_bundle_get_cart_json('/cart.js?bundle').then($th_cart_response => {
			return $th_cart_response
		});
		if ($th_cart_json.item_count > 0) {
			let $th_combo_addtocart_bundle_array = new Array();
			$th_combo_addtocart_bundle_array.push({
				bundle_id: $th_combo_bundle_id
			});
			await $th_create_bundle_draft_order($th_shop_conveted_url, $th_cart_json.items, null, $th_combo_addtocart_bundle_array, null, null, $th_direct_checkout, $th_active_currency, null, null);
		}
	}
	const $th_combo_cart_page_addtocart = async function($th_combo_button, $th_combo_parent, $th_combo_bundle_id, $th_redirection, $th_direct_checkout) {
		let $th_combo_p_id_array = new Array();
		const $th_bundle_combo_uid = $th_bundle_addtocart_uniqueid();
		$th_combo_parent.querySelectorAll('li.thpb_combo_p_grid_list').forEach(function($thpb_combo_p_grid_list, $th_combo_idx) {
			$th_combo_p_id_array.push({
				id: $thpb_combo_p_grid_list.querySelector('.thpb_combo_p_grid_main_variants').options[$thpb_combo_p_grid_list.querySelector('.thpb_combo_p_grid_main_variants').selectedIndex].value,
				quantity: parseInt($th_combo_parent.querySelector('.thpb_combo_qty_price_section .th_pb_cb_p_grid_add_qty_text').innerText),
				properties: {
					_th_bundle_combo: $th_combo_bundle_id,
					_th_bundle_type: 'combo',
					_th_bundle_uid: $th_bundle_combo_uid
				}
			});
		});
		const $th_combo_addtocart_form_data = {
			items: $th_combo_p_id_array
		};
		const $th_addtocart_result = await $th_bundle_cta_ajax_event($th_combo_addtocart_form_data).then($th_addtocart_response => {
			return $th_addtocart_response
		});
		if ($th_addtocart_result.items) {
			if ($th_redirection == '$th_cart_page_redirect') {
				$th_bundle_cta_success_method($th_combo_button, $th_addtocart_result);
			} else {
				await $th_bundle_combo_draft_event($th_combo_bundle_id, $th_direct_checkout);
			}
		} else {
			$th_bundle_cta_loader_class($th_combo_button, 'remove_loader', 'thpb_combo_atc_cta_btn_loading');
			if ($th_combo_parent.querySelector('.th_ajax_error')) {
				if ($th_addtocart_result.description) {
					$th_combo_parent.querySelector('.th_ajax_error').innerHTML = '<p class="th_ajax_error_cls">' + $th_addtocart_result.description + '</p>';
				}
				if ($th_addtocart_result.errors) {
					$th_combo_parent.querySelector('.th_ajax_error').innerHTML = '<p class="th_ajax_error_cls">' + $th_addtocart_result.errors + '</p>';
				}
			}
			setTimeout(function() {
				$th_combo_parent.querySelector('.th_ajax_error').innerHTML = '';
			}, 8000);
		}
	}
	const $th_bundle_combo_addtocart_event = async function($th_combo_button) {
		$th_bundle_cta_loader_class($th_combo_button, 'add_loader', 'thpb_combo_atc_cta_btn_loading');
		const $th_combo_parent = $th_combo_button.closest('.thpb_combo_inner_start');
		const $th_combo_bundle_id = $th_combo_parent.getAttribute('data-bid');
		$th_combo_parent.querySelector('.th_ajax_error').innerHTML = '';
		await $th_pb_click_analyst($th_combo_bundle_id);
		if ($th_combo_button.getAttribute('data-distype') == '2') {
			const $th_cart_empty_json = await $th_bundle_clear_cart_json('/cart/clear.js').then($th_cart_response => {
				return $th_cart_response
			});
			if ($th_cart_empty_json.items.length === 0) {
				await $th_combo_cart_page_addtocart($th_combo_button, $th_combo_parent, $th_combo_bundle_id, '$th_free_shipping', 'direct_checkout');
				$th_bundle_cta_loader_class($th_combo_button, 'remove_loader', 'th_pb_btn_loading');
			}
		} else {
			if ($th_combo_button.getAttribute('data-checkout') == '1') {
				if ($th_combo_button.getAttribute('data-dismode') == '1') {
					await $th_combo_cart_page_addtocart($th_combo_button, $th_combo_parent, $th_combo_bundle_id, '', null);
				} else {
					let $th_combo_bundle_items = new Object();
					$th_combo_parent.querySelectorAll('li.thpb_combo_p_grid_list').forEach(async function($th_combo_grid, $th_idx) {
						$th_combo_bundle_items[$th_idx] = {
							product_id: $th_combo_grid.getAttribute('data-pid'),
							variant_id: $th_combo_grid.querySelector('.thpb_combo_p_grid_main_variants').options[$th_combo_grid.querySelector('.thpb_combo_p_grid_main_variants').selectedIndex].value,
							quantity: parseInt($th_combo_parent.querySelector('.thpb_combo_qty_price_section .th_pb_cb_p_grid_add_qty_text').innerText)
						};
						if ($th_idx === ($th_combo_parent.querySelectorAll('li.thpb_combo_p_grid_list').length - 1)) {
							await $th_create_bundle_draft_order($th_shop_conveted_url, null, $th_combo_bundle_items, null, null, $th_combo_bundle_id, 'direct_checkout', $th_active_currency, null, null);
						}
					});
				}
			} else {
				await $th_combo_cart_page_addtocart($th_combo_button, $th_combo_parent, $th_combo_bundle_id, '$th_cart_page_redirect', null);
			}
			$th_bundle_cta_loader_class($th_combo_button, 'remove_loader', 'thpb_combo_atc_cta_btn_loading');
		}
	}
	const $th_bundle_combo_cta_click_event = function() {
		document.querySelectorAll('.thpb_combo_atc_cta_btn').forEach(function($th_combo_button) {
			$th_combo_button[$th_bundle_addEventListener]('click', function(event) {
				event.preventDefault(), event.stopImmediatePropagation();
				$th_bundle_combo_addtocart_event($th_combo_button);
			});
		});
	}
	const $th_bundle_combo_qty_event = function() {
		document.querySelectorAll('.thpb_combo_add_qty_btn').forEach(function($thpb_combo_add_qty_btn) {
			$thpb_combo_add_qty_btn[$th_bundle_addEventListener]('click', function(event) {
				event.preventDefault(), event.stopImmediatePropagation();
				let $th_combo_qty_new = 1;
				$thpb_combo_add_qty_btn.closest('.thpb_combo_inner_start').querySelector('.thpb_combo_ajax_error_section .th_ajax_error').innerHTML = '';
				const $th_combo_qty_current = parseInt($thpb_combo_add_qty_btn.closest('.thpb_combo_qty_btn_cls').querySelector('.th_pb_cb_p_grid_add_qty_text').innerText);
				const $th_combo_qty_max = parseInt($thpb_combo_add_qty_btn.closest('.thpb_combo_qty_btn_cls').querySelector('.th_pb_cb_p_grid_add_qty_text').getAttribute('data-maxqty'));
				if ($thpb_combo_add_qty_btn.classList.contains('thpb_combo_add_qty_plus')) {
					if ($th_combo_qty_max > $th_combo_qty_current) {
						$th_combo_qty_new = $th_combo_qty_current + 1;
					} else {
						$th_combo_qty_new = $th_combo_qty_current;
						let $th_combo_qty_limit_msg = $thpb_combo_add_qty_btn.closest('.thpb_combo_inner_start').querySelector('.thpb_combo_ajax_error_section .th_ajax_error').getAttribute('data-limitmsg');
						$th_combo_qty_limit_msg = $th_combo_qty_limit_msg.replace("[[quantity]]", $th_combo_qty_max);
						$thpb_combo_add_qty_btn.closest('.thpb_combo_inner_start').querySelector('.thpb_combo_ajax_error_section .th_ajax_error').innerHTML = '<p class="th_ajax_error_cls">' + $th_combo_qty_limit_msg + '</p>';
					}
				} else {
					if ($th_combo_qty_current > 1) {
						$th_combo_qty_new = $th_combo_qty_current - 1;
					}
				}
				$thpb_combo_add_qty_btn.closest('.thpb_combo_qty_btn_cls').querySelector('.th_pb_cb_p_grid_add_qty_text').innerText = $th_combo_qty_new;
			});
		});
	}
	const $th_combo_variant_html = function($th_combo_result, $th_combo_value, $th_com_por_value, $th_com_por_index, $th_combo_main_product_img) {
		let $th_com_vari_html = '<div class="thpb_combo_wflex thpb_combo_p_grid_pvariants">';
		const $th_com_hide_default_variant = ($th_com_por_value.is_all_variants == '1' || $th_com_por_value.variants.length === 1) ? 'thpb_combo_p_grid_main_variants_hide' : '';
		$th_com_vari_html += '<div class="thpb_combo_wflex thpb_combo_p_grid_div_main_variants ' + $th_com_hide_default_variant + '"><div class="thpb_combo_p_grid_variant_fieldset"><select class="thpb_combo_p_grid_main_variants">';
		const $th_com_discount = 100 - parseFloat($th_combo_value.bundle_detail.discount);
		$th_com_por_value.variants.forEach(function($th_com_variant, $th_com_variant_idx) {
			let $th_com_dc_price = parseFloat($th_com_variant.price) * 100,
				$th_com_dc_cp_price = parseFloat($th_com_variant.compare_at_price) * 100;
			if ($th_combo_value.bundle_detail.discount_type == '0' && parseFloat($th_combo_value.bundle_detail.discount) > 0) {
				$th_com_dc_price = ((parseFloat($th_com_variant.price) * 100) * $th_com_discount) / 100;
				$th_com_dc_cp_price = parseFloat($th_com_variant.price) * 100;
			}
			let $th_combo_variant_image = $th_combo_main_product_img;
			if (($th_com_variant.featured_image !== undefined && $th_com_variant.featured_image !== null) || ($th_com_variant.image !== undefined && $th_com_variant.image !== null)) {
				if ($th_com_variant.featured_image !== undefined && $th_com_variant.featured_image !== null) {
					$th_combo_variant_image = $th_image_resizer($th_com_variant.featured_image.src, '600x');
				} else {
					$th_combo_variant_image = $th_image_resizer($th_com_variant.image.originalSrc, '600x');
				}
			}
			const $th_com_variant_available_status = $th_variant_instock_status($th_com_por_value, $th_com_variant);
			$th_com_vari_html += '<option value="' + $th_com_variant.id + '" data-title="' + $th_com_variant.title.replace(/"/g, "'") + '" data-ptitle="' + $th_com_por_value.title + '" data-compare_price="' + $th_com_dc_cp_price + '" data-price="' + $th_com_dc_price + '" data-image="' + $th_combo_variant_image + '?v=123" data-available="' + $th_com_variant_available_status + '">' + $th_com_variant.title + '</option>';
		});
		$th_com_vari_html += '</select></div></div>';
		if ($th_com_por_value.variants.length === 1 && $th_com_por_value.variants[0].title != 'Default Title') {
			$th_com_vari_html += '<span class="thpb_combo_wflex thpb_combo_single_variant_title">' + $th_com_por_value.variants[0].title + '</span>';
		}
		if ($th_com_por_value.is_all_variants == '1' && $th_com_por_value.variants.length > 1) {
			$th_com_vari_html += '<div class="thpb_combo_wflex thpb_combo_p_grid_separate_variants">';
			if (parseInt(wc_external_script_layout.variant_layout) === 1) {
				$th_com_por_value.options.forEach(function($th_com_op_val, $th_com_op_idx) {
					$th_com_vari_html += '<div class="thpb_combo_wflex thpb_combo_p_grid_variant_swatch_fieldset" data-index="' + $th_com_op_idx + '" data-option="' + $th_com_op_val.name.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '') + '">';
					$th_com_vari_html += '<span class="thpb_combo_wflex thpb_combo_p_grid_variant_swatch_op_title">' + $th_com_op_val.name + '</span>';
					$th_com_vari_html += '<div class="thpb_combo_p_grid_variant_swatch_section">';
					$th_com_op_val.values.forEach(function($th_com_op_title_val, $th_com_op_title_idx) {
						let $thpb_combo_option_checked = $th_com_op_title_idx === 0 ? 'checked="checked"' : '';
						if ($th_com_op_val.name.toLowerCase().indexOf('color') != -1 || $th_com_op_val.name.toLowerCase().indexOf('colour') != -1 || $th_com_op_val.name.toLowerCase().indexOf('shade') != -1) {
							$th_com_vari_html += '<div class="thpb_combo_variant_swatch_field thpb_combo_variant_swatch_field_color">';
							$th_com_vari_html += '<input type="radio" name="thpb_combo_' + $th_combo_value.bundle_detail.id + '_' + $th_com_por_value.handle + '_' + $th_com_op_idx + '" id="thpb_combo_variant_swatch_' + $th_combo_value.bundle_detail.id + '_' + $th_com_por_value.handle + '_' + $th_com_op_idx + '_' + $th_com_op_title_idx + '" class="thpb_combo_variant_swatch_btn" value="' + $th_com_op_title_val.replace(/"/g, "'") + '" ' + $thpb_combo_option_checked + ' />';
							$th_com_vari_html += '<label class="thpb_combo_variant_swatch_label thpb_combo_variant_swatch_color ' + $th_com_op_title_val.toLowerCase().replace(/[^\w ]+/g, '').replace(/ +/g, '-') + '" for="thpb_combo_variant_swatch_' + $th_combo_value.bundle_detail.id + '_' + $th_com_por_value.handle + '_' + $th_com_op_idx + '_' + $th_com_op_title_idx + '" style="background-color:' + $th_com_op_title_val.toLowerCase().replace(/[^\w ]+/g, '').replace(/ +/g, '-') + '" title="' + $th_com_op_title_val + '"></label>';
							$th_com_vari_html += '</div>';
						} else {
							$th_com_vari_html += '<div class="thpb_combo_variant_swatch_field">';
							$th_com_vari_html += '<input type="radio" name="thpb_combo_' + $th_combo_value.bundle_detail.id + '_' + $th_com_por_value.handle + '_' + $th_com_op_idx + '" id="thpb_combo_variant_swatch_' + $th_combo_value.bundle_detail.id + '_' + $th_com_por_value.handle + '_' + $th_com_op_idx + '_' + $th_com_op_title_idx + '" class="thpb_combo_variant_swatch_btn" value="' + $th_com_op_title_val.replace(/"/g, "'") + '" ' + $thpb_combo_option_checked + ' />';
							$th_com_vari_html += '<label class="thpb_combo_variant_swatch_label thpb_combo_variant_swatch_label_other ' + $th_com_op_title_val.toLowerCase().replace(/[^\w ]+/g, '').replace(/ +/g, '-') + '" for="thpb_combo_variant_swatch_' + $th_combo_value.bundle_detail.id + '_' + $th_com_por_value.handle + '_' + $th_com_op_idx + '_' + $th_com_op_title_idx + '">' + $th_com_op_title_val + '</label>';
							$th_com_vari_html += '</div>';
						}
					});
					$th_com_vari_html += '</div></div>';
				});
			} else {
				$th_com_por_value.options.forEach(function($th_com_op_val, $th_com_op_idx) {
					$th_com_vari_html += '<div class="thpb_combo_p_grid_variant_fieldset" data-option="' + $th_com_op_val.name.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '') + '" data-index="' + $th_com_op_idx + '">';
					$th_com_vari_html += '<span class="thpb_combo_p_grid_variant_label">' + $th_com_op_val.name + '</span>';
					$th_com_vari_html += '<select class="thpb_combo_p_grid_variant_select">';
					$th_com_op_val.values.forEach(function($th_com_op_title_val, $th_com_op_title_idx) {
						$th_com_vari_html += '<option value="' + $th_com_op_title_val.replace(/"/g, "'") + '">' + $th_com_op_title_val + '</option>';
					});
					$th_com_vari_html += '</select></div>';
				});
			}
			$th_com_vari_html += '</div>';
		}
		$th_com_vari_html += '</div>';
		return $th_com_vari_html;
	}
	const $th_combo_bundle_layout = function($th_combo_result, $th_combo_value, $th_combo_index) {
		let $th_combo_inner_html = '<div class="thpb_combo_wflex thpb_combo_outer_start"><div class="thpb_combo_wflex thpb_combo_inner_start" data-bid="' + $th_combo_value.bundle_detail.id + '" data-discount="' + $th_combo_value.bundle_detail.discount + '" data-fixedprice="' + ($th_combo_value.bundle_detail.fixed_discount * $th_active_currency_rate) + '" data-dtype="' + $th_combo_value.bundle_detail.discount_type + '">';
		$th_combo_inner_html += $th_bundle_main_title($th_combo_value, 'th_combo_bundle_title', 'thpb_combo_wflex thpb_combo_title', 'thpb_combo_wflex', 'thpb_combo_wflex thpb_combo_title_description');
		$th_combo_inner_html += '<div class="thpb_combo_wflex thpb_combo_product_section">';
		$th_combo_inner_html += '<div class="thpb_combo_wflex thpb_combo_p_grid_inner">';
		$th_combo_inner_html += '<ul class="thpb_combo_wflex thpb_combo_p_grid_ul">';
		$th_combo_value.product_list.forEach(function($th_com_por_value, $th_com_por_index) {
			if ($th_com_por_value.status.toLowerCase() !== 'draft') {
				$th_combo_inner_html += '<li class="thpb_combo_wflex thpb_combo_p_grid_list" data-pid="' + $th_com_por_value.id + '">';
				$th_combo_inner_html += '<div class="thpb_combo_p_grid_figure"><figure class="thpb_combo_wflex">';
				const $th_combo_main_product_img = $th_pb_p_grid_image($th_com_por_value);
				$th_combo_inner_html += '<img src="' + $th_combo_main_product_img + '" alt="' + $th_com_por_value.handle + '" />';
				$th_combo_inner_html += '</figure></div>';
				$th_combo_inner_html += '<div class="thpb_combo_p_grid_detail">';
				$th_combo_inner_html += '<div class="thpb_combo_wflex thpb_combo_p_grid_ptitle"><h6>';
				$th_combo_inner_html += '<a href="/products/' + $th_com_por_value.handle + '" target="_blank">' + $th_com_por_value.title + '</a>';
				$th_combo_inner_html += '</h6></div>';
				$th_combo_inner_html += '<div class="thpb_combo_wflex thpb_combo_p_grid_pprice">';
				$th_combo_inner_html += '<span class="thpb_combo_p_grid_main_price"><span class="money transcy-money">' + $th_money_format($th_com_por_value.variants[0].price, $th_shop_money) + '</span></span>';
				$th_combo_inner_html += '<span class="thpb_combo_p_grid_old_price th_pb_line_through">';
				if ($th_com_por_value.variants[0].compare_at_price > $th_com_por_value.variants[0].price) {
					$th_combo_inner_html += '<span class="money transcy-money">' + $th_money_format($th_com_por_value.variants[0].compare_at_price, $th_shop_money) + '</span>';
				}
				$th_combo_inner_html += '</span>';
				$th_combo_inner_html += '</div>';
				$th_combo_inner_html += $th_combo_variant_html($th_combo_result, $th_combo_value, $th_com_por_value, $th_com_por_index, $th_combo_main_product_img);
				$th_combo_inner_html += '</div>';
				$th_combo_inner_html += '</li>';
				$th_pb_generate_variantmap($th_com_por_value);
			} else {
				console.log('Rebolt Bundle--> This product is not available ', $th_com_por_value);
			}
		});
		$th_combo_inner_html += '</ul>';
		$th_combo_inner_html += '</div>';
		$th_combo_inner_html += '<div class="thpb_combo_wflex thpb_combo_qty_price_section">';
		$th_combo_inner_html += '<div class="thpb_combo_qty_inner"><div class="thpb_combo_wflex thpb_combo_qty_btn_cls">';
		$th_combo_inner_html += '<span class="thpb_combo_add_qty_btn thpb_combo_add_qty_minus"><svg width="25px" height="25px" viewBox="0 -192 469.33333 469"><path d="m437.332031.167969h-405.332031c-17.664062 0-32 14.335937-32 32v21.332031c0 17.664062 14.335938 32 32 32h405.332031c17.664063 0 32-14.335938 32-32v-21.332031c0-17.664063-14.335937-32-32-32zm0 0"></path></svg></span>';
		$th_combo_inner_html += '<span class="th_pb_cb_p_grid_add_qty_text" data-maxqty="' + $th_combo_value.bundle_detail.combo_quantity + '">1</span>'
		$th_combo_inner_html += '<span class="thpb_combo_add_qty_btn thpb_combo_add_qty_plus"><svg width="25px" height="25px" viewBox="0 0 492 492"><path d="M465.064,207.566l0.028,0H284.436V27.25c0-14.84-12.016-27.248-26.856-27.248h-23.116 c-14.836,0-26.904,12.408-26.904,27.248v180.316H26.908c-14.832,0-26.908,12-26.908,26.844v23.248 c0,14.832,12.072,26.78,26.908,26.78h180.656v180.968c0,14.832,12.064,26.592,26.904,26.592h23.116 c14.84,0,26.856-11.764,26.856-26.592V284.438h180.624c14.84,0,26.936-11.952,26.936-26.78V234.41 C492,219.566,479.904,207.566,465.064,207.566z"></path></svg></span>';
		$th_combo_inner_html += '</div></div>';
		$th_combo_inner_html += '<div class="thpb_combo_total_price_inner"><p class="thpb_combo_wflex">';
		$th_combo_inner_html += '<span class="thpb_combo_total_price_sale" data-mainprice="' + wc_external_script_layout.combo_bundle_price_class + '"></span><span class="thpb_combo_total_price_old" data-mainprice="' + wc_external_script_layout.combo_bundle_compare_price_class + '"></span>';
		if ($th_combo_value.bundle_detail.discount_type == '2') {
			$th_combo_inner_html += '<span class="thpb_combo_total_price_save_section">';
			$th_combo_inner_html += '<em class="thpb_combo_total_price_save_label">' + wc_external_script_layout.language.save + '</em>';
			$th_combo_inner_html += '<span class="thpb_combo_total_price_save_val">' + wc_external_script_layout.language.free_shipping + '</span>';
			$th_combo_inner_html += '</span>';
		} else {
			if (parseFloat($th_combo_value.bundle_detail.discount) > 0) {
				$th_combo_inner_html += '<span class="thpb_combo_total_price_save_section">';
				$th_combo_inner_html += '<em class="thpb_combo_total_price_save_label">' + wc_external_script_layout.language.save + '</em>';
				if ($th_combo_value.bundle_detail.discount_type == '1') {
					$th_combo_inner_html += '<span class="thpb_combo_total_price_save_val"><span class="money transcy-money">' + $th_money_format($th_combo_value.bundle_detail.fixed_discount * 100 * $th_active_currency_rate, $th_shop_money) + '</span></span>';
				} else {
					$th_combo_inner_html += '<span class="thpb_combo_total_price_save_val">' + $th_combo_value.bundle_detail.discount + '%</span>';
				}
				$th_combo_inner_html += '</span>';
			}
		}
		$th_combo_inner_html += '</p></div>';
		$th_combo_inner_html += '</div>';
		$th_combo_inner_html += '<div class="thpb_combo_wflex thpb_combo_ajax_error_section">';
		$th_combo_inner_html += '<div class="th_ajax_error" data-msg="' + wc_external_script_layout.language.not_available + '" data-limitmsg="' + wc_external_script_layout.language.combo_max_qtn_message + '"></div>';
		$th_combo_inner_html += '</div>';
		$th_combo_inner_html += $th_pb_bundle_addtocart_btn($th_combo_result, $th_combo_value, 'th_combo_bundle_cta_btn');
		$th_combo_inner_html += '</div>';
		$th_combo_inner_html += '</div></div>';
		return $th_combo_inner_html;
	}
	const $th_bundle_combo_event = function($th_bundle_result) {
		let $th_combo_html = '<div class="th_pb_combo_offer_code">';
		$th_bundle_result.combo_bundle_list.forEach(function($th_combo_value, $th_combo_index) {
			$th_combo_html += $th_combo_bundle_layout($th_bundle_result, $th_combo_value, $th_combo_index);
		});
		$th_combo_html += '</div>';
		if (wc_external_script_layout && wc_external_script_layout.combo_bundle_class) {
			if (document.querySelector(wc_external_script_layout.combo_bundle_class)) {
				document.querySelectorAll(wc_external_script_layout.combo_bundle_class).forEach(function($th_bundle_this_class, $th_class_index) {
					$th_bundle_this_class.innerHTML = $th_combo_html;
				});
			}
		} else {
			document.querySelectorAll('form[action*="/cart/add"]').forEach(function($th_bundle_this_form, $th_form_index) {
				if ($th_form_index === 0) {
					$th_bundle_this_form.innerHTML = $th_combo_html;
				} else {
					$th_bundle_this_form.style.display = 'none';
					document.querySelectorAll('.product-form__quantity').forEach(function($th_combo_qty_selecter, $th_index) {
						$th_combo_qty_selecter.style.display = 'none';
					});
				}
			});
		}
		$th_bundle_combo_change_event();
		$th_bundle_combo_qty_event();
		$th_bundle_combo_cta_click_event();
		if (typeof $th_bundle_success_callback === 'function') {
			$th_bundle_success_callback($th_bundle_result.combo_bundle_list[0].bundle_detail.id, $th_bundle_result);
		}
	}
	const $th_bundle_response_status = function($th_bundle_result, $th_bundle_class, $th_bundle_code_place, $th_specific_bundle, $th_bundle_pageno, $th_bundle_count) {
		if ($th_bundle_result.error != true) {
			document.querySelector('figure.th_bundle_section_loader') ? document.querySelector('figure.th_bundle_section_loader').remove() : '';
			if ($th_bundle_result.bundle_list && $th_bundle_result.bundle_list.length > 0) {
				$th_bundle_normal_event($th_bundle_result, $th_bundle_class, $th_bundle_code_place, $th_specific_bundle);
			}
			if ($th_bundle_result.popup_bundle_list && $th_bundle_result.popup_bundle_list.length > 0) {
				$th_bundle_normal_popup_event($th_bundle_result);
			}
			if ($th_bundle_result.combo_bundle_list && $th_bundle_result.combo_bundle_list.length > 0) {
				$th_bundle_combo_event($th_bundle_result);
			}
		}
	}
	const $th_quick_change_event = function() {
		const $th_quick_update_final_total = function($thpb_cb_this) {
			const $th_this_parents = $thpb_cb_this.closest('.th_pb_cb_inner');
			let $th_pb_cp_discount_total = 0,
				$th_pb_cp_sale_total = 0;
			$th_this_parents.querySelectorAll('.th_pb_cb_li').forEach(function($thpb_cb_li, $th_index) {
				const $th_temp_discount_price = parseFloat($thpb_cb_li.querySelector('.th_pb_cb_main_price').getAttribute('data-price'));
				const $th_temp_sale_price = ($thpb_cb_li.querySelector('.th_pb_cb_old_price')) ? parseFloat($thpb_cb_li.querySelector('.th_pb_cb_old_price').getAttribute('data-price')) : parseFloat($thpb_cb_li.querySelector('.th_pb_cb_main_price').getAttribute('data-price'));
				const $th_temp_qty = parseInt($thpb_cb_li.querySelector('.th_pb_cb_qty').value);
				$th_pb_cp_discount_total = $th_pb_cp_discount_total + ($th_temp_discount_price * $th_temp_qty);
				$th_pb_cp_sale_total = $th_pb_cp_sale_total + ($th_temp_sale_price * $th_temp_qty);
				if ($th_index === ($th_this_parents.querySelectorAll('.th_pb_cb_li').length - 1)) {
					$th_this_parents.querySelector('.th_pb_cb_total_discount_price').innerHTML = '<span class="money transcy-money">' + $th_money_format($th_pb_cp_discount_total, $th_shop_money) + '</span>';
					if ($th_this_parents.querySelector('.th_pb_cb_total_sale_price')) {
						$th_this_parents.querySelector('.th_pb_cb_total_sale_price').innerHTML = '<span class="money transcy-money th_pb_line_through">' + $th_money_format($th_pb_cp_sale_total, $th_shop_money) + '</span>';
					}
				}
			});
		}
		const $th_quick_update_product_price = function($thpb_cb_this, $thpb_cb_parents, $th_cb_price, $th_cb_compare_price, $th_cb_qty, $th_cb_free) {
			const $th_html_price = $thpb_cb_parents.querySelector('.th_pb_cb_main_price');
			$th_html_price.setAttribute('data-price', $th_cb_price);
			if ($th_cb_price > 0) {
				$th_html_price.innerHTML = '<span class="money transcy-money">' + $th_money_format($th_cb_price * $th_cb_qty, $th_shop_money) + '</span>';
			} else {
				$th_html_price.innerHTML = '<span class="money">' + $th_cb_free + '</span>';
			}
			if ($th_cb_compare_price > $th_cb_price) {
				const $th_html_comparre_price = $thpb_cb_parents.querySelector('.th_pb_cb_old_price');
				$th_html_comparre_price.setAttribute('data-price', $th_cb_compare_price);
				$th_html_comparre_price.innerHTML = '<span class="money transcy-money">' + $th_money_format($th_cb_compare_price * $th_cb_qty, $th_shop_money) + '</span>';
			} else {
				if ($thpb_cb_parents.querySelector('.th_pb_cb_old_price')) {
					$thpb_cb_parents.querySelector('.th_pb_cb_old_price').innerHTML = '';
				}
			}
			$th_quick_update_final_total($thpb_cb_this);
		}
		const $th_quick_get_single_price = function($thpb_cb_qty, $thpb_cb_parents) {
			const $th_price = parseFloat($thpb_cb_parents.querySelector('.th_pb_cb_select').options[$thpb_cb_parents.querySelector('.th_pb_cb_select').selectedIndex].getAttribute('data-price'));
			const $th_compare_price = parseFloat($thpb_cb_parents.querySelector('.th_pb_cb_select').options[$thpb_cb_parents.querySelector('.th_pb_cb_select').selectedIndex].getAttribute('data-compare_price'));
			const $th_line_qty = parseInt($thpb_cb_parents.querySelector('.th_pb_cb_qty').value);
			const $th_free_label = $thpb_cb_parents.querySelector('.th_pb_cb_main_price').getAttribute('data-free');
			$th_quick_update_product_price($thpb_cb_qty, $thpb_cb_parents, $th_price, $th_compare_price, $th_line_qty, $th_free_label);
		}
		document.querySelectorAll('.th_pb_cb_select').forEach(function($thpb_cb_select) {
			$thpb_cb_select[$th_bundle_addEventListener]('change', function(event) {
				if ($thpb_cb_select.length > 0) {
					event.preventDefault(), event.stopImmediatePropagation();
					const $th_price = parseFloat($thpb_cb_select.options[$thpb_cb_select.selectedIndex].getAttribute('data-price'));
					const $th_compare_price = parseFloat($thpb_cb_select.options[$thpb_cb_select.selectedIndex].getAttribute('data-compare_price'));
					const $th_line_qty = parseInt($thpb_cb_select.closest('.th_pb_cb_li').querySelector('.th_pb_cb_qty').value);
					const $th_free_label = $thpb_cb_select.closest('.th_pb_cb_li').querySelector('.th_pb_cb_main_price').getAttribute('data-free');
					if ($thpb_cb_select.options[$thpb_cb_select.selectedIndex].getAttribute('data-image')) {
						$thpb_cb_select.closest('.th_pb_cb_li').querySelector('.th_pb_cb_img a img').setAttribute('src', $thpb_cb_select.options[$thpb_cb_select.selectedIndex].getAttribute('data-image'));
					}
					$th_quick_update_product_price($thpb_cb_select, $thpb_cb_select.closest('.th_pb_cb_li'), $th_price, $th_compare_price, $th_line_qty, $th_free_label);
				}
			});
			$thpb_cb_select.dispatchEvent(new Event('change'));
		});
		document.querySelectorAll('.th_pb_cb_qty').forEach(function($thpb_cb_qty) {
			$thpb_cb_qty[$th_bundle_addEventListener]('change', function(event) {
				event.preventDefault(), event.stopImmediatePropagation();
				$th_quick_get_single_price($thpb_cb_qty, $thpb_cb_qty.closest('.th_pb_cb_li'));
			});
		});
		document.querySelectorAll('.th_pb_cb_qty').forEach(function($thpb_cb_qty) {
			$thpb_cb_qty[$th_bundle_addEventListener]('keyup', function(event) {
				event.preventDefault(), event.stopImmediatePropagation();
				$th_quick_get_single_price($thpb_cb_qty, $thpb_cb_qty.closest('.th_pb_cb_li'));
			});
		});
	}
	const $th_bundle_quick_draft_event = async function($th_addtocart_bundle_id) {
		const $th_cart_json = await $th_bundle_get_cart_json('/cart.js?bundle').then($th_cart_response => {
			return $th_cart_response
		});
		if ($th_cart_json.item_count > 0) {
			let $th_addtocart_bundle_array = new Array();
			$th_addtocart_bundle_array.push({
				bundle_id: $th_addtocart_bundle_id
			});
			await $th_create_bundle_draft_order($th_shop_conveted_url, $th_cart_json.items, null, null, $th_addtocart_bundle_array, null, null, $th_active_currency, null, null);
		}
	}
	const $th_quick_cart_page_addtocart = async function($th_this_button, $th_this_parents, $th_addtocart_bundle_id, $th_redirection) {
		let $th_cb_p_id_array = new Array();
		const $th_bundle_quick_uid = $th_bundle_addtocart_uniqueid();
		for (let i = 0; i < $th_this_parents.querySelectorAll('li.th_pb_cb_li').length; i++) {
			if ($th_this_parents.querySelector('.th_pb_cb_qty_id_' + i).value > 0) {
				$th_cb_p_id_array.push({
					id: $th_this_parents.querySelector('.th_pb_cb_variant_id_' + i).options[$th_this_parents.querySelector('.th_pb_cb_variant_id_' + i).selectedIndex].value,
					quantity: $th_this_parents.querySelector('.th_pb_cb_qty_id_' + i).value,
					properties: {
						_th_bundle_custom: $th_addtocart_bundle_id,
						_th_bundle_type: 'custom',
						_th_bundle_uid: $th_bundle_quick_uid
					}
				});
			}
		}
		const $th_quick_order_formData = {
			items: $th_cb_p_id_array
		};
		const $th_addtocart_result = await $th_bundle_cta_ajax_event($th_quick_order_formData).then($th_addtocart_response => {
			return $th_addtocart_response
		});
		if ($th_addtocart_result.items.length > 0) {
			if ($th_redirection == '$th_cart_page_redirect') {
				$th_bundle_cta_success_method($th_this_button, $th_addtocart_result);
			} else {
				await $th_bundle_quick_draft_event($th_addtocart_bundle_id);
			}
		}
	}
	const $th_quick_cta_addtocart_event = async function($th_button) {
		$th_bundle_cta_loader_class($th_button, 'add_loader', 'th_pb_btn_loading');
		const $th_this_parents = $th_button.closest('.th_pb_cb_inner');
		$th_this_parents.querySelector('.th_ajax_error').innerHTML = '';
		const $th_custom_bundle_id = $th_this_parents.closest('.th_pb_custom_bundle').getAttribute('data-id');
		$th_pb_click_analyst($th_custom_bundle_id);
		if ($th_button.getAttribute('data-checkout') == '1') {
			if ($th_button.getAttribute('data-dismode') == '1') {
				await $th_quick_cart_page_addtocart($th_button, $th_this_parents, $th_custom_bundle_id, '');
			} else {
				let $th_cb_bundle_items = new Object();
				$th_this_parents.querySelectorAll('li.th_pb_cb_li').forEach(async function($th_quick_grid, $th_idx) {
					if (parseInt($th_this_parents.querySelector('.th_pb_cb_qty_id_' + $th_idx).value) === 0) {
						$th_this_parents.querySelector('.th_ajax_error').innerHTML = '<p>' + $th_this_parents.querySelector('.th_pb_cb_message').innerText + '</p>';
						return false;
					}
					$th_cb_bundle_items[$th_idx] = {
						product_id: $th_quick_grid.getAttribute('data-id'),
						variant_id: $th_this_parents.querySelector('.th_pb_cb_variant_id_' + $th_idx).options[$th_this_parents.querySelector('.th_pb_cb_variant_id_' + $th_idx).selectedIndex].value,
						quantity: $th_this_parents.querySelector('.th_pb_cb_qty_id_' + $th_idx).value
					};
					if ($th_idx === ($th_this_parents.querySelectorAll('li.th_pb_cb_li').length - 1)) {
						await $th_create_bundle_draft_order($th_shop_conveted_url, null, $th_cb_bundle_items, null, null, $th_custom_bundle_id, 'direct_checkout', $th_active_currency, null, null);
					}
				});
			}
		} else {
			await $th_quick_cart_page_addtocart($th_button, $th_this_parents, $th_custom_bundle_id, '$th_cart_page_redirect');
		}
		$th_bundle_cta_loader_class($th_button, 'remove_loader', 'th_pb_btn_loading');
	}
	const $th_quick_cta_click_event = function() {
		document.querySelectorAll('.th_pb_cb_button_cls').forEach(function($th_button) {
			$th_button[$th_bundle_addEventListener]('click', function(event) {
				event.preventDefault(), event.stopImmediatePropagation();
				$th_quick_cta_addtocart_event($th_button);
			});
		});
	}
	const $th_quick_bundle_grid_view = function($th_quick_result, $th_grid_val, $th_grid_idx, $th_product_image, $th_pb_cb_remain_price, $wc_index) {
		let $th_quick_grid_html = '<li class="th_pb_cb_li" data-id="' + $th_grid_val.id + '"><div class="th_pb_cb_img"><figure class="th_pb_wf">';
		$th_quick_grid_html += '<a href="/products/' + $th_grid_val.handle + '"><img src="' + $th_product_image + '?v=123" alt="' + $th_grid_val.handle + '" /></a>';
		$th_quick_grid_html += '</figure></div>';
		$th_quick_grid_html += '<div class="th_pb_cb_title"><h6 class="th_pb_wf">' + $th_grid_val.title + '</h6>';
		if ($th_grid_val.variants.length <= 1) {
			$th_quick_grid_html += '<select class="th_pb_cb_select th_pb_cb_variant_id_' + $wc_index + '" style="display:none !important">';
			$th_quick_grid_html += '<option value="' + $th_grid_val.variants[0].id + '" data-compare_price="' + $th_grid_val.variants[0].price * 100 + '" data-price="' + ($th_grid_val.variants[0].price * 100 * $th_pb_cb_remain_price) / 100 + '">' + $th_grid_val.variants[0].title + '</option>';
			$th_quick_grid_html += '</select>';
		} else {
			$th_quick_grid_html += '<select class="th_pb_cb_select th_pb_cb_variant_id_' + $wc_index + '">';
			$th_grid_val.variants.forEach(function(variant_value, variant_index) {
				const $th_dc_price = (parseFloat(variant_value.price) * 100 * $th_pb_cb_remain_price) / 100;
				const $th_dc_cp_price = parseFloat(variant_value.price) * 100;
				if (variant_value.image != undefined && variant_value.image != null) {
					$th_product_image = $th_image_resizer(variant_value.image.originalSrc, '600x');
				}
				if (variant_value.inventory_management == 'shopify' || variant_value.inventory_management == 'SHOPIFY') {
					if (variant_value.inventory_policy != 'deny' && variant_value.inventory_policy != 'DENY') {
						$th_quick_grid_html += '<option value="' + variant_value.id + '" data-compare_price="' + $th_dc_cp_price + '" data-price="' + $th_dc_price + '" data-image="' + $th_product_image + '?v=123">' + variant_value.title + '</option>';
					} else {
						if (variant_value.inventory_quantity > 0) {
							$th_quick_grid_html += '<option value="' + variant_value.id + '" data-compare_price="' + $th_dc_cp_price + '" data-price="' + $th_dc_price + '" data-image="' + $th_product_image + '?v=123">' + variant_value.title + '</option>';
						}
					}
				} else {
					$th_quick_grid_html += '<option value="' + variant_value.id + '" data-compare_price="' + $th_dc_cp_price + '" data-price="' + $th_dc_price + '" data-image="' + $th_product_image + '?v=123">' + variant_value.title + '</option>';
				}
			});
			$th_quick_grid_html += '</select>';
		}
		$th_quick_grid_html += '</div>';
		$th_quick_grid_html += '<div class="th_pb_cb_qty_variant">';
		$th_quick_grid_html += '<input type="number" name="quantity" class="th_pb_cb_qty th_pb_cb_qty_id_' + $wc_index + '" value="1" min="1">';
		$th_quick_grid_html += '</div>';
		$th_quick_grid_html += '<div class="th_pb_cb_price"><p class="th_pb_wf">';
		const $th_cb_price = (parseFloat($th_grid_val.variants[0].price) * 100 * $th_pb_cb_remain_price) / 100;
		const $th_cb_compare_price = parseFloat($th_grid_val.variants[0].price) * 100;
		if ($th_cb_price > 0) {
			$th_quick_grid_html += '<span class="th_pb_cb_main_price" data-free="' + $th_quick_result.language.free_price + '" data-price="' + $th_cb_price + '"><span class="money transcy-money">' + $th_money_format($th_cb_price, $th_shop_money) + '</span></span>';
		} else {
			$th_quick_grid_html += '<span class="th_pb_cb_main_price" data-free="' + $th_quick_result.language.free_price + '" data-price="' + $th_cb_price + '"><span class="money transcy-money">' + $th_quick_result.language.free_price + '</span></span>';
		}
		if ($th_cb_compare_price > $th_cb_price) {
			$th_quick_grid_html += '<span class="th_pb_cb_old_price" data-price="' + $th_cb_compare_price + '"><span class="money transcy-money">' + $th_money_format($th_cb_compare_price, $th_shop_money) + '</span></span>';
		}
		$th_quick_grid_html += '</p></div></li>';
		return $th_quick_grid_html;
	}
	const $th_quick_bundle_layout = function($th_quick_result, $th_quick_class, $th_quick_code_place, $th_quick_specific_this, $th_quick_pageno, $th_quick_count) {
		let $th_cb_code = '';
		const $th_pb_cb_remain_price = 100 - parseFloat($th_quick_result.bundle_discount);
		$th_cb_code += '<div class="th_pb_cb_inner th_pb_wf">';
		$th_cb_code += $th_bundle_main_title($th_quick_result, 'th_quick_bundle_title');
		$th_cb_code += '<ul class="th_pb_cb_ul th_pb_wf">';
		var $wc_index = 0;
		$th_quick_result.product_list.forEach(function(value, index) {
			if (value.status.toLowerCase() !== 'draft') {
				let $th_product_image = $th_pb_p_grid_image(value);
				$th_cb_code += $th_quick_bundle_grid_view($th_quick_result, value, index, $th_product_image, $th_pb_cb_remain_price, $wc_index);
				$wc_index++;
			} else {
				console.log('Rebolt Bundle--> This product is not available ', value);
			}
		});
		$th_cb_code += '</ul>';
		$th_cb_code += '<div class="th_pb_cb_button th_pb_wf">';
		if ($th_quick_result.bundle_discount > 0) {
			$th_cb_code += '<div class="th_pb_cb_total_price th_pb_wf">' + $th_quick_result.language.total_price + ' <span class="th_pb_cb_total_discount_price"></span><span class="th_pb_cb_total_sale_price"></span></div>';
		} else {
			$th_cb_code += '<div class="th_pb_cb_total_price th_pb_wf">' + $th_quick_result.language.total_price + ' <span class="th_pb_cb_total_discount_price"></span></div>';
		}
		let $th_cb_discount_requirement = $th_quick_result.language.discount_requirement;
		if ($th_quick_result.bundle_discount > 0) {
			if ($th_quick_result.language.discount_requirement && $th_quick_result.language.discount_requirement) {
				$th_cb_discount_requirement = $th_cb_discount_requirement.replace("{{discount}}", $th_quick_result.bundle_discount + "%");
				$th_cb_code += '<div class="th_pb_cb_message th_pb_wf"><p>' + $th_cb_discount_requirement + '</p></div>';
			}
		}
		var total_smart_products = $th_quick_result.product_list.length;
		var available_items = $th_quick_result.product_list.filter(item => item.status.toLowerCase() !== 'draft').length;
		var class_for_not_available_button = (total_smart_products === available_items) ? '' : 'th_pb_draft_product_disable';
		$th_cb_code += '<div class="th_pb_cb_addtocart_btn_div th_pb_wf"><button type="button" class="th_pb_cb_button_cls btn button ' + class_for_not_available_button + '" data-checkout="' + wc_external_script_layout.direct_checkout + '" data-dismode="' + wc_external_script_layout.discount_mode + '" data-min="null"><span class="button_text">' + $th_quick_result.button_text + '</span><em class="th_pb_add_to_cart_loader"></em></button></div>';
		$th_cb_code += '<div class="th_ajax_error"></div></div>';
		if ($th_quick_result.wc_bd_number == 7) {
			$th_cb_code += '<div class="wc_shopify_preview" style="display: flex !important;width: 100% !important;float: left !important;justify-content: center !important;margin-top: 10px !important; opacity: 1 !important; visibility: visible !important; height: 30px !important;"><img src="https://rebolt.webcontrive.com/rebolt-bundle/public/img/powered_by_rebolt.png" style="display: flex !important;width: 120px !important; opacity: 1 !important; visibility: visible !important; height: 27px !important;"></div>';
		}
		$th_cb_code += '</div>';
		$th_quick_specific_this.innerHTML = $th_cb_code;
		$th_quick_change_event();
		$th_quick_cta_click_event();
		let out_of_stock_pro_title = [];
		let $th_this_parents = document.querySelector(`.th_pb_custom_bundle[data-id='${$th_quick_specific_this.dataset.id}']`);
		$th_this_parents.querySelectorAll('li.th_pb_cb_li').forEach(($th_quick_grid, $th_idx) => {
			if ($th_this_parents.querySelector('.th_pb_cb_variant_id_' + $th_idx).length <= 0) {
				let $th_errorMsgDiv = $th_this_parents.querySelector(".th_ajax_error");
				let $th_product_title = $th_quick_grid.querySelector('.th_pb_cb_title .th_pb_wf');
				out_of_stock_pro_title.push($th_product_title.innerText);
				let $th_out_of_stock_product_titles = '';
				out_of_stock_pro_title.forEach((str) => {
					$th_out_of_stock_product_titles += str + ' ' + '&' + ' '
				})
				$th_out_of_stock_product_titles = $th_out_of_stock_product_titles.slice(0, -2);
				let not_available_language_Setting = '';
				if ($th_quick_result.language.not_available && $th_quick_result.language.not_available != '') {
					not_available_language_Setting = $th_quick_result.language.not_available;
				} else {
					not_available_language_Setting = '{{title}} are not available.'
				}
				$th_errorMsgDiv.innerHTML = `<p class="th_ajax_error_cls"> ${not_available_language_Setting.replace('{{title}}', $th_out_of_stock_product_titles)}</p>`
				let AddCartBtn = $th_this_parents.querySelector('.th_pb_cb_button_cls');
				if (!AddCartBtn.classList.contains('th_pb_add_to_cart_disabled')) {
					AddCartBtn.classList.add('th_pb_add_to_cart_disabled');
					AddCartBtn.style = "pointer-events:none !important;"
				}
			}
		});
		if (typeof $th_bundle_success_callback === 'function') {
			$th_bundle_success_callback($th_quick_specific_this.getAttribute('data-id'), $th_quick_result);
		}
	}
	const $th_bundle_qty_draft_event = async function($this_qty_btn, $th_qty_this_parents, $th_qty_bundle_id) {
		const $th_cart_json = await $th_bundle_get_cart_json('/cart.js?bundle').then($th_cart_response => {
			return $th_cart_response
		});
		if ($th_cart_json.item_count > 0) {
			let $th_qty_line_items = new Object();
			const $th_qty_each_this = ($this_qty_btn.getAttribute('data-layout') == '1') ? $th_qty_this_parents.querySelectorAll('.th_pb_qty_bundle_l2_selected .th_pb_qty_bundle_variants_loop') : $th_qty_this_parents.querySelectorAll('.th_pb_qty_grid_column');
			$th_qty_each_this.forEach(async function($th_grid_this, $th_grid_idx) {
				const $th_qty_selected_pid = ($this_qty_btn.getAttribute('data-layout') == '1') ? $th_qty_this_parents.querySelector('.th_pb_qty_bundle_l2_selected .th_pb_qty_grid_count_' + $th_grid_idx).getAttribute('data-productid') : $th_qty_this_parents.querySelector('.th_pb_qty_grid_count_' + $th_grid_idx).getAttribute('data-productid');
				const $th_qty_selected_vid = ($this_qty_btn.getAttribute('data-layout') == '1') ? $th_qty_this_parents.querySelector('.th_pb_qty_bundle_l2_selected .th_pb_qty_grid_count_' + $th_grid_idx + ' .th_pb_qty_variants_select_hidden').options[$th_qty_this_parents.querySelector('.th_pb_qty_bundle_l2_selected .th_pb_qty_grid_count_' + $th_grid_idx + ' .th_pb_qty_variants_select_hidden').selectedIndex].value : $th_qty_this_parents.querySelector('.th_pb_qty_grid_count_' + $th_grid_idx + ' .th_pb_qty_variants_select_hidden').options[$th_qty_this_parents.querySelector('.th_pb_qty_grid_count_' + $th_grid_idx + ' .th_pb_qty_variants_select_hidden').selectedIndex].value;
				$th_qty_line_items[$th_grid_idx] = {
					product_id: $th_qty_selected_pid,
					variant_id: $th_qty_selected_vid,
					quantity: 1
				};
				if ($th_grid_idx === ($th_qty_each_this.length - 1)) {
					await $th_create_bundle_draft_order($th_shop_conveted_url, null, $th_qty_line_items, null, null, $th_qty_bundle_id, 'direct_checkout', $th_active_currency, null, 'quantity_bundle');
				}
			});
		}
	}
	const $th_qty_cart_page_addtocart = async function($this_qty_btn, $th_qty_this_parents, $th_qty_bundle_id, $th_qty_redirection) {
		let $th_qty_line_items = new Array();
		const $th_bundle_qty_uid = $th_bundle_addtocart_uniqueid();
		const $th_qty_forloop_length = ($this_qty_btn.getAttribute('data-layout') == '1') ? $th_qty_this_parents.querySelectorAll('.th_pb_qty_bundle_l2_selected .th_pb_qty_bundle_variants_loop').length : $th_qty_this_parents.querySelectorAll('.th_pb_qty_grid_column').length;
		for (let i = 0; i < $th_qty_forloop_length; i++) {
			const $th_qty_find_index_this = ($this_qty_btn.getAttribute('data-layout') == '1') ? $th_qty_this_parents.querySelector('.th_pb_qty_bundle_l2_selected .th_pb_qty_grid_count_' + i + ' .th_pb_qty_variants_select_hidden').options[$th_qty_this_parents.querySelector('.th_pb_qty_bundle_l2_selected .th_pb_qty_grid_count_' + i + ' .th_pb_qty_variants_select_hidden').selectedIndex].value : $th_qty_this_parents.querySelector('.th_pb_qty_grid_count_' + i + ' .th_pb_qty_variants_select_hidden').options[$th_qty_this_parents.querySelector('.th_pb_qty_grid_count_' + i + ' .th_pb_qty_variants_select_hidden').selectedIndex].value;
			const $th_qty_selected_id = ($this_qty_btn.getAttribute('data-layout') == '1') ? $th_qty_this_parents.querySelector('.th_pb_qty_bundle_l2_selected .th_pb_qty_grid_count_' + i + ' .th_pb_qty_variants_select_hidden').options[$th_qty_this_parents.querySelector('.th_pb_qty_bundle_l2_selected .th_pb_qty_grid_count_' + i + ' .th_pb_qty_variants_select_hidden').selectedIndex].value : $th_qty_this_parents.querySelector('.th_pb_qty_grid_count_' + i + ' .th_pb_qty_variants_select_hidden').options[$th_qty_this_parents.querySelector('.th_pb_qty_grid_count_' + i + ' .th_pb_qty_variants_select_hidden').selectedIndex].value;
			const $th_qty_find_index = $th_qty_line_items.findIndex((x_val) => x_val.id == $th_qty_find_index_this);
			if ($th_qty_find_index === -1) {
				$th_qty_line_items.push({
					id: $th_qty_selected_id,
					quantity: 1,
					properties: {
						_th_bundle_quantity: $th_qty_bundle_id,
						_th_bundle_type: 'quantity',
						_th_bundle_uid: $th_bundle_qty_uid
					}
				});
			} else {
				$th_qty_line_items[$th_qty_find_index].quantity = $th_qty_line_items[$th_qty_find_index].quantity + 1;
			}
		}
		const $th_qty_bundle_formData = {
			items: $th_qty_line_items
		};
		const $th_addtocart_result = await $th_bundle_cta_ajax_event($th_qty_bundle_formData).then($th_addtocart_response => {
			return $th_addtocart_response
		});
		if ($th_addtocart_result.items) {
			if ($th_qty_redirection == '$th_cart_page_redirect') {
				$th_bundle_cta_success_method($this_qty_btn, $th_addtocart_result);
			} else {
				await $th_bundle_qty_draft_event($this_qty_btn, $th_qty_this_parents, $th_qty_bundle_id);
			}
		} else {
			$th_bundle_cta_loader_class($this_qty_btn, 'remove_loader', 'th_pb_qty_btn_loading');
			if ($th_qty_this_parents.querySelector('.th_qty_ajax_error')) {
				if ($th_addtocart_result.description) {
					$th_qty_this_parents.querySelector('.th_qty_ajax_error').innerHTML = '<p class="th_qty_ajax_error_cls">' + $th_addtocart_result.description + '</p>';
				}
				if ($th_addtocart_result.errors) {
					$th_qty_this_parents.querySelector('.th_qty_ajax_error').innerHTML = '<p class="th_qty_ajax_error_cls">' + $th_addtocart_result.errors + '</p>';
				}
			}
			setTimeout(function() {
				$th_qty_this_parents.querySelector('.th_qty_ajax_error').innerHTML = '';
			}, 8000);
		}
	}
	const $th_pb_qty_cta_addtocart_event = async function($this_qty_btn) {
		$th_bundle_cta_loader_class($this_qty_btn, 'add_loader', 'th_pb_qty_btn_loading');
		const $th_qty_this_parents = $this_qty_btn.closest('.th_pb_qty_innercode');
		const $th_qty_bundle_id = $th_qty_this_parents.getAttribute('data-bundleid');
		if (!$this_qty_btn.classList.contains('th_pb_qty_layout_grid_btn_disabled')) {
			$th_pb_click_analyst($th_qty_bundle_id);
			if ($this_qty_btn.getAttribute('data-checkout') == '1') {
				if ($this_qty_btn.getAttribute('data-dismode') == '1') {
					await $th_qty_cart_page_addtocart($this_qty_btn, $th_qty_this_parents, $th_qty_bundle_id, '');
				} else {
					let $th_qty_line_items = new Object();
					const $th_qty_each_this = ($this_qty_btn.getAttribute('data-layout') == '1') ? $th_qty_this_parents.querySelectorAll('.th_pb_qty_bundle_l2_selected .th_pb_qty_bundle_variants_loop') : $th_qty_this_parents.querySelectorAll('.th_pb_qty_grid_column');
					$th_qty_each_this.forEach(async function($th_grid_this, $th_grid_idx) {
						const $th_qty_selected_pid = ($this_qty_btn.getAttribute('data-layout') == '1') ? $th_qty_this_parents.querySelector('.th_pb_qty_bundle_l2_selected .th_pb_qty_grid_count_' + $th_grid_idx).getAttribute('data-productid') : $th_qty_this_parents.querySelector('.th_pb_qty_grid_count_' + $th_grid_idx).getAttribute('data-productid');
						const $th_qty_selected_vid = ($this_qty_btn.getAttribute('data-layout') == '1') ? $th_qty_this_parents.querySelector('.th_pb_qty_bundle_l2_selected .th_pb_qty_grid_count_' + $th_grid_idx + ' .th_pb_qty_variants_select_hidden').options[$th_qty_this_parents.querySelector('.th_pb_qty_bundle_l2_selected .th_pb_qty_grid_count_' + $th_grid_idx + ' .th_pb_qty_variants_select_hidden').selectedIndex].value : $th_qty_this_parents.querySelector('.th_pb_qty_grid_count_' + $th_grid_idx + ' .th_pb_qty_variants_select_hidden').options[$th_qty_this_parents.querySelector('.th_pb_qty_grid_count_' + $th_grid_idx + ' .th_pb_qty_variants_select_hidden').selectedIndex].value;
						$th_qty_line_items[$th_grid_idx] = {
							product_id: $th_qty_selected_pid,
							variant_id: $th_qty_selected_vid,
							quantity: 1
						};
						if ($th_grid_idx === ($th_qty_each_this.length - 1)) {
							await $th_create_bundle_draft_order($th_shop_conveted_url, null, $th_qty_line_items, null, null, $th_qty_bundle_id, 'direct_checkout', $th_active_currency, null, 'quantity_bundle');
						}
					});
				}
			} else {
				await $th_qty_cart_page_addtocart($this_qty_btn, $th_qty_this_parents, $th_qty_bundle_id, '$th_cart_page_redirect');
			}
		} else {
			return false;
		}
		$th_bundle_cta_loader_class($this_qty_btn, 'remove_loader', 'th_pb_qty_btn_loading');
	}
	const $th_pb_qty_button_click = function($th_pb_qty_details, $th_layout_settings) {
		const $th_pb_qty_activate_change_event = function() {
			const $th_qty_bundle_total = function($this_qty_hide) {
				let $th_qty_sale_total = 0,
					$th_qty_compare_total = 0;
				const $th_pb_qty_parent = $this_qty_hide.closest('.th_pb_qty_bundle_grid_inner');
				const $th_pb_qty_discounttype = $th_pb_qty_parent.closest('.th_pb_qty_innercode').getAttribute('data-discounttype');
				const $th_pb_qty_discountval = $this_qty_hide.closest('.th_pb_qty_bundle_grid_inner').getAttribute('data-discount');
				$th_pb_qty_parent.querySelectorAll('.th_pb_qty_bundle_variants_loop').forEach(function($th_select_this, $th_idx) {
					const $th_qty_temp_sale_price = parseFloat($th_select_this.querySelector('.th_pb_qty_variants_select_hidden').options[$th_select_this.querySelector('.th_pb_qty_variants_select_hidden').selectedIndex].getAttribute('data-price'));
					const $th_qty_temp_compare_price = parseFloat($th_select_this.querySelector('.th_pb_qty_variants_select_hidden').options[$th_select_this.querySelector('.th_pb_qty_variants_select_hidden').selectedIndex].getAttribute('data-compare_price'));
					$th_qty_sale_total = $th_qty_sale_total + $th_qty_temp_sale_price;
					$th_qty_compare_total = $th_qty_compare_total + $th_qty_temp_compare_price;
					if ($th_idx === ($th_pb_qty_parent.querySelectorAll('.th_pb_qty_bundle_variants_loop').length - 1)) {
						if ($th_pb_qty_discounttype == '1') {
							$th_qty_compare_total = $th_qty_sale_total;
							$th_qty_sale_total = $th_qty_sale_total - (parseFloat($th_pb_qty_discountval) * $th_active_currency_rate * 100);
						}
						$th_pb_qty_parent.querySelector('.th_pb_qty_bundle_l2_price_section .th_pb_qty_bundle_l2_total_sale_price').innerHTML = '<span class="money transcy-money">' + $th_money_format($th_qty_sale_total, $th_shop_money) + '</span>';
						if ($th_qty_compare_total > $th_qty_sale_total) {
							$th_pb_qty_parent.querySelector('.th_pb_qty_bundle_l2_price_section .th_pb_qty_bundle_l2_total_old_price').innerHTML = '<span class="money transcy-money">' + $th_money_format($th_qty_compare_total, $th_shop_money) + '</span>';
						} else {
							$th_pb_qty_parent.querySelector('.th_pb_qty_bundle_l2_price_section .th_pb_qty_bundle_l2_total_old_price').innerHTML = '';
						}
					}
				});
			}
			document.querySelectorAll('.th_pb_qty_variants_select_hidden:not(.wc_main_variants)').forEach(function($th_pb_qty_variants_select_hidden) {
				$th_pb_qty_variants_select_hidden[$th_bundle_addEventListener]('change', function(event) {
					event.preventDefault(), event.stopImmediatePropagation();
					const $th_qty_price = parseFloat($th_pb_qty_variants_select_hidden.options[$th_pb_qty_variants_select_hidden.selectedIndex].getAttribute('data-price'));
					const $th_qty_compare_price = parseFloat($th_pb_qty_variants_select_hidden.options[$th_pb_qty_variants_select_hidden.selectedIndex].getAttribute('data-compare_price'));
					if ($th_pb_qty_variants_select_hidden.closest('.th_pb_qty_grid_content').querySelector('.th_pb_qty_grid_sale_price')) {
						const $th_qty_free_label = $th_pb_qty_variants_select_hidden.closest('.th_pb_qty_grid_content').querySelector('.th_pb_qty_grid_sale_price').getAttribute('data-free');
						const $th_qty_html_price = $th_pb_qty_variants_select_hidden.closest('.th_pb_qty_grid_content').querySelector('.th_pb_qty_grid_sale_price');
						if ($th_qty_price > 0) {
							$th_qty_html_price.innerHTML = '<span class="money transcy-money">' + $th_money_format($th_qty_price, $th_shop_money) + '</span>';
						} else {
							$th_qty_html_price.innerHTML = '<span class="money">' + $th_qty_free_label + '</span>';
						}
					}
					if ($th_pb_qty_variants_select_hidden.closest('.th_pb_qty_grid_content').querySelector('.th_pb_qty_grid_figure img')) {
						$th_pb_qty_variants_select_hidden.closest('.th_pb_qty_grid_content').querySelector('.th_pb_qty_grid_figure img').setAttribute('src', $th_pb_qty_variants_select_hidden.options[$th_pb_qty_variants_select_hidden.selectedIndex].getAttribute('data-image'));
					}
					if ($th_pb_qty_variants_select_hidden.closest('.th_pb_qty_grid_content').querySelector('.th_pb_qty_grid_old_price')) {
						if ($th_qty_compare_price > $th_qty_price) {
							if ($th_pb_qty_variants_select_hidden.closest('.th_pb_qty_grid_content').querySelector('.th_pb_qty_grid_old_price')) {
								$th_pb_qty_variants_select_hidden.closest('.th_pb_qty_grid_content').querySelector('.th_pb_qty_grid_old_price').innerHTML = '<span class="money transcy-money">' + $th_money_format($th_qty_compare_price, $th_shop_money) + '</span>';
							} else {
								$th_pb_qty_variants_select_hidden.closest('.th_pb_qty_grid_content').insertAdjacentHTML('beforeend', '<span class="th_pb_qty_grid_old_price"><span class="money transcy-money">' + $th_money_format($th_qty_compare_price, $th_shop_money) + '</span></span>');
							}
						} else {
							$th_pb_qty_variants_select_hidden.closest('.th_pb_qty_grid_content').querySelector('.th_pb_qty_grid_old_price').innerHTML = '';
						}
					}
					let $th_qty_grand_parents = $th_pb_qty_variants_select_hidden.closest('.th_pb_qty_layout_grid_inner');
					let $th_qty_variant_available = [];
					$th_qty_grand_parents.querySelectorAll('.th_pb_qty_variants_select_hidden').forEach(function($th_qty_available_grid, $th_grid_idx) {
						const $th_qty_this_ptitle = $th_qty_available_grid.options[$th_qty_available_grid.selectedIndex].getAttribute('data-ptitle');
						const $th_qty_this_vtitle = $th_qty_available_grid.options[$th_qty_available_grid.selectedIndex].getAttribute('data-title');
						const $th_qty_this_available = JSON.parse($th_qty_available_grid.options[$th_qty_available_grid.selectedIndex].getAttribute('data-available'));
						if ($th_qty_this_vtitle == 'Default Title') {
							$th_qty_variant_available.push({
								product_title: $th_qty_this_ptitle,
								variant_available: $th_qty_this_available
							});
						} else {
							$th_qty_variant_available.push({
								product_title: $th_qty_this_ptitle + ' (' + $th_qty_this_vtitle + ')',
								variant_available: $th_qty_this_available
							});
						}
						if ($th_grid_idx === ($th_qty_grand_parents.querySelectorAll('.th_pb_qty_variants_select_hidden').length - 1)) {
							let $th_qty_enable_btn_click = true;
							let $th_qty_not_available_products = new Array();
							$th_qty_variant_available.forEach(function($th_variant_available_single, $th_array_idx) {
								if (!$th_variant_available_single.variant_available) {
									$th_qty_enable_btn_click = false;
									$th_qty_not_available_products.push($th_variant_available_single.product_title);
								}
								if ($th_array_idx === ($th_qty_variant_available.length - 1)) {
									if ($th_pb_qty_variants_select_hidden.closest('.th_pb_qty_innercode').classList.contains('th_pb_qty_bundle_l2_inner')) {
										$th_qty_grand_parents = $th_pb_qty_variants_select_hidden.closest('.th_pb_qty_bundle_l2_content');
									}
									if ($th_qty_enable_btn_click) {
										$th_qty_grand_parents.querySelector('.th_qty_ajax_error').innerHTML = '';
										$th_qty_grand_parents.querySelector('.th_pb_qty_layout_grid_btn_cls').classList.remove('th_pb_qty_layout_grid_btn_disabled');
									} else {
										$th_qty_not_available_products = [...new Set($th_qty_not_available_products)];
										const $th_qty_pb_error_msg = $th_qty_grand_parents.querySelector('.th_qty_ajax_error').getAttribute('data-msg');
										let $th_qty_not_available_text = $th_qty_not_available_products.join(' & ');
										$th_qty_not_available_text = $th_qty_pb_error_msg.replace('{{title}}', $th_qty_not_available_text);
										$th_qty_grand_parents.querySelector('.th_qty_ajax_error').innerHTML = '<p class="th_qty_ajax_error_cls">' + $th_qty_not_available_text + '</p>';
										$th_qty_grand_parents.querySelector('.th_pb_qty_layout_grid_btn_cls').classList.add('th_pb_qty_layout_grid_btn_disabled');
									}
								}
							});
						}
					});
					if ($th_pb_qty_variants_select_hidden.closest('.th_pb_qty_innercode').classList.contains('th_pb_qty_bundle_l2_inner')) {
						$th_qty_bundle_total($th_pb_qty_variants_select_hidden);
					}
					if (typeof $th_qty_bundle_variant_change_event == 'function') {
						window.$th_qty_bundle_variant_change_event($th_pb_qty_variants_select_hidden);
					}
				});
				$th_pb_qty_variants_select_hidden.dispatchEvent(new Event('change'));
			});
			const $th_qty_bundle_normal_enable_cta_btn = function($th_qty_parents, $th_qty_option_array, $th_pb_qty_grid_select_cls) {
				const $th_qty_final_option_selected = $th_qty_option_array.join(" / ");
				$th_qty_parents.querySelector('.th_pb_qty_variants_select_hidden').selectedIndex = -1;
				if ($th_qty_parents.querySelectorAll('.th_pb_qty_variants_select_hidden option[data-title="' + $th_qty_final_option_selected + '"]').length > 0) {
					$th_qty_parents.querySelector('.th_pb_qty_variants_select_hidden option[data-title="' + $th_qty_final_option_selected + '"]').selected = true;
					$th_qty_parents.querySelector('.th_pb_qty_variants_select_hidden').dispatchEvent(new Event('change'));
				} else {
					if ($th_qty_parents.closest('.th_pb_qty_innercode').classList.contains('th_pb_qty_bundle_l2_inner')) {
						$th_qty_parents = $th_pb_qty_grid_select_cls.closest('.th_pb_qty_bundle_l2_content');
					}
					const $th_qty_error_msg = $th_qty_parents.closest('.th_pb_qty_layout_grid_inner').querySelector('.th_qty_ajax_error').getAttribute('data-msg');
					const $th_qty_not_available_text = $th_qty_error_msg.replace("{{title}}", $th_qty_final_option_selected);
					$th_qty_parents.closest('.th_pb_qty_layout_grid_inner').querySelector('.th_qty_ajax_error').innerHTML = '<p class="th_qty_ajax_error_cls">' + $th_qty_not_available_text + '</p>';
					$th_qty_parents.closest('.th_pb_qty_layout_grid_inner').querySelector('.th_pb_qty_layout_grid_btn_cls').classList.add('th_pb_qty_layout_grid_btn_disabled');
				}
			}
			const $th_qty_update_radio_button = function($th_select_index, $th_select_pid, $th_option_parents) {
				switch ($th_select_index) {
					case 1:
						var $th_key = 'root';
						break;
					case 2:
						var $th_key = $th_option_parents.querySelector('.th_pb_qty_grid_single_variant[data-index="0"] .th_pb_qty_variant_swatch_btn:checked').value;
						break;
					case 3:
						var $th_key = $th_option_parents.querySelector('.th_pb_qty_grid_single_variant[data-index="0"] .th_pb_qty_variant_swatch_btn:checked').value;
						$th_key += ' / ' + $th_option_parents.querySelector('.th_pb_qty_grid_single_variant[data-index="1"] .th_pb_qty_variant_swatch_btn:checked').value;
				}
				const $th_vari_availableOptions = ($th_products_json.th_bundle_variantmap[$th_select_pid + '_' + $th_key]) ? $th_products_json.th_bundle_variantmap[$th_select_pid + '_' + $th_key] : [];
				$th_option_parents.querySelectorAll('.th_pb_qty_grid_single_variant[data-index="' + ($th_select_index - 1) + '"] .th_pb_qty_variant_swatch_field').forEach(function($th_qty_swatch_this) {
					if ($th_vari_availableOptions.includes($th_qty_swatch_this.querySelector('.th_pb_qty_variant_swatch_btn').value)) {
						$th_qty_swatch_this.classList.remove('th_vari_soldout');
						$th_qty_swatch_this.style.display = 'inline-block';
						$th_qty_swatch_this.querySelector('.th_pb_qty_variant_swatch_btn').removeAttribute('disabled');
					} else {
						$th_qty_swatch_this.classList.add('th_vari_soldout');
						$th_qty_swatch_this.style.display = 'none';
						$th_qty_swatch_this.querySelector('.th_pb_qty_variant_swatch_btn').setAttribute('disabled', 'disabled');
						if ($th_qty_swatch_this.querySelectorAll('.th_pb_qty_variant_swatch_btn:checked').length) {
							$th_qty_swatch_this.querySelector('.th_pb_qty_variant_swatch_btn').removeAttribute('checked');
							if ($th_qty_swatch_this.nextSibling) {
								$th_qty_swatch_this.nextSibling.querySelector('.th_pb_qty_variant_swatch_btn').setAttribute('checked', 'checked');
							}
						}
					}
				});
			}
			if (document.querySelector('.th_pb_qty_variant_swatch_btn')) {
				document.querySelectorAll('.th_pb_qty_variant_swatch_btn:not(.wc_swatch_button)').forEach(function($th_pb_qty_variant_swatch_btn) {
					$th_pb_qty_variant_swatch_btn[$th_bundle_addEventListener]('change', function(event) {
						event.preventDefault(), event.stopImmediatePropagation();
						const $th_qty_parents = $th_pb_qty_variant_swatch_btn.closest('.th_pb_qty_grid_content');
						const $th_qty_option_array = new Array();
						$th_qty_parents.querySelectorAll('.th_pb_qty_grid_single_variant').forEach(function($th_pb_qty_grid_single_variant) {
							$th_qty_option_array.push($th_pb_qty_grid_single_variant.querySelector('.th_pb_qty_variant_swatch_field .th_pb_qty_variant_swatch_btn:checked').value);
						});
						const $th_option_pro_id = $th_pb_qty_variant_swatch_btn.closest('.th_pb_qty_grid_column').getAttribute('data-productid');
						$th_qty_update_radio_button(parseInt($th_products_json.th_bundle_products[$th_option_pro_id][0].options.length), $th_option_pro_id, $th_qty_parents);
						$th_qty_bundle_normal_enable_cta_btn($th_qty_parents, $th_qty_option_array, $th_pb_qty_variant_swatch_btn);
					});
					$th_pb_qty_variant_swatch_btn.dispatchEvent(new Event('change'));
				});
			}
			if (document.querySelector('.th_pb_qty_grid_select_cls')) {
				document.querySelectorAll('.th_pb_qty_grid_select_cls').forEach(function($th_pb_qty_grid_select_cls) {
					$th_pb_qty_grid_select_cls[$th_bundle_addEventListener]('change', function(event) {
						event.preventDefault(), event.stopImmediatePropagation();
						const $th_qty_parents = $th_pb_qty_grid_select_cls.closest('.th_pb_qty_grid_content');
						const $th_qty_option_array = new Array();
						$th_qty_parents.querySelectorAll('.th_pb_qty_grid_select_cls').forEach(function($th_th_pb_qty_grid_select_cls) {
							$th_qty_option_array.push($th_th_pb_qty_grid_select_cls.options[$th_th_pb_qty_grid_select_cls.selectedIndex].value);
						});
						$th_qty_bundle_normal_enable_cta_btn($th_qty_parents, $th_qty_option_array, $th_pb_qty_grid_select_cls);
					});
					$th_pb_qty_grid_select_cls.dispatchEvent(new Event('change'));
				});
			}
			if (document.querySelector('.th_pb_qty_bundle_l2_title_label')) {
				document.querySelectorAll('.th_pb_qty_bundle_l2_title_label').forEach(function($th_pb_qty_bundle_l2_title_label) {
					$th_pb_qty_bundle_l2_title_label[$th_bundle_addEventListener]('click', function(event) {
						event.preventDefault(), event.stopImmediatePropagation();
						if (!$th_pb_qty_bundle_l2_title_label.closest('.th_pb_qty_bundle_grid_inner').classList.contains('th_pb_qty_bundle_l2_selected')) {
							$th_pb_qty_bundle_l2_title_label.closest('.th_pb_qty_bundle_l2_content').querySelectorAll('.th_pb_qty_bundle_grid_inner').forEach(function($th_loop_this, $th_loop_idx) {
								$th_loop_this.classList.remove('th_pb_qty_bundle_l2_selected');
								$th_loop_this.querySelector('.th_pb_qty_bundle_l2_title_radio_cls').removeAttribute('checked');
							});
							$th_pb_qty_bundle_l2_title_label.closest('.th_pb_qty_bundle_grid_inner').classList.add('th_pb_qty_bundle_l2_selected');
							$th_pb_qty_bundle_l2_title_label.querySelector('.th_pb_qty_bundle_l2_title_radio_cls').setAttribute('checked', 'checked');
						}
					});
				});
			}
		}
		const $th_pb_qty_activate_addtocart_event = function() {
			document.querySelectorAll('.th_pb_qty_layout_grid_btn_cls').forEach(function($this_qty_btn) {
				$this_qty_btn[$th_bundle_addEventListener]('click', function(event) {
					event.preventDefault(), event.stopImmediatePropagation();
					$th_pb_qty_cta_addtocart_event($this_qty_btn);
				});
			});
		}
		const $th_pb_qty_product_grid_layout = function($this_parents, $th_pb_qty_details, $th_layout_settings, $this_grid_index, $this_discount) {
			$th_pb_qty_details.forEach(function($th_qty_val, $th_qty_idx) {
				if ($th_qty_val.bundle_detail.id == $this_parents.getAttribute('data-bundleid')) {
					let $th_pb_qty_grid_html = '<div class="th_pb_wf th_pb_qty_layout_grid"><div class="th_pb_wf th_pb_qty_layout_grid_inner">';
					$th_pb_qty_grid_html += '<div class="th_pb_qty_layout_grid_column_section th_pb_qty_layout_grid_column_length_' + $this_grid_index + '">';
					for (let $grid_inx = 0; $grid_inx < $this_grid_index; $grid_inx++) {
						$th_pb_qty_grid_html += '<div class="th_pb_qty_grid_column th_pb_qty_grid_count_' + $grid_inx + '" data-productid="' + $th_qty_val.product_list[0].id + '"><div class="th_pb_qty_grid_content">';
						$th_pb_qty_grid_html += '<div class="th_pb_qty_grid_figure"><figure>';
						let $th_pb_qty_product_image = $th_pb_p_grid_image($th_qty_val.product_list[0]);
						$th_pb_qty_grid_html += '<img src="' + $th_pb_qty_product_image + '" alt="' + $th_qty_val.product_list[0].handle + '">';
						$th_pb_qty_grid_html += '</figure></div>';
						$th_pb_qty_grid_html += '<div class="th_pb_qty_grid_detail">';
						$th_pb_qty_grid_html += '<div class="th_pb_wf th_pb_qty_grid_titprice">';
						$th_pb_qty_grid_html += '<h6>' + $th_qty_val.product_list[0].title + '</h6>';
						$th_pb_qty_grid_html += '<p class="th_pb_wf">';
						let $th_qty_sale_price, $th_qty_old_price;
						if ($th_qty_val.bundle_detail.discount_type == '1') {
							$th_qty_sale_price = parseFloat($th_qty_val.product_list[0].variants[0].price) * 100;
							$th_qty_old_price = parseFloat($th_qty_val.product_list[0].variants[0].compare_at_price) * 100;
						} else {
							$th_qty_sale_price = ((parseFloat($th_qty_val.product_list[0].variants[0].price) * 100) * $this_discount) / 100;
							$th_qty_old_price = parseFloat($th_qty_val.product_list[0].variants[0].price) * 100;
						}
						if ($th_qty_sale_price > 0) {
							$th_pb_qty_grid_html += '<span class="th_pb_qty_grid_sale_price" data-free="' + $th_layout_settings.language.free_price + '"><span class="money transcy-money">' + $th_money_format($th_qty_sale_price, $th_shop_money) + '</span></span>';
						} else {
							$th_pb_qty_grid_html += '<span class="th_pb_qty_grid_sale_price" data-free="' + $th_layout_settings.language.free_price + '"><span class="money transcy-money">' + $th_layout_settings.language.free_price + '</span></span>';
						}
						if ($th_qty_old_price > $th_qty_sale_price) {
							$th_pb_qty_grid_html += '<span class="th_pb_qty_grid_old_price"><span class="money transcy-money">' + $th_money_format($th_qty_old_price, $th_shop_money) + '</span></span>';
						}
						$th_pb_qty_grid_html += '</p></div>';
						const $th_pb_qty_select_show = $th_qty_val.product_list[0].variants.length == 1 ? 'display:none !important;' : 'display:block !important;';
						$th_pb_qty_grid_html += '<div class="th_pb_wf th_pb_qty_grid_variants" style="' + $th_pb_qty_select_show + '">';
						if (parseInt($th_layout_settings.variant_layout) === 1) {
							$th_qty_val.product_list[0].options.forEach(function($th_qty_option_val, $th_qty_option_key) {
								$th_pb_qty_grid_html += '<div class="th_pb_qty_grid_single_variant" data-index="' + $th_qty_option_key + '">';
								$th_pb_qty_grid_html += '<span class="th_pb_wf th_pb_qty_variant_option_title">' + $th_qty_option_val.name + '</span>';
								$th_qty_option_val.values.forEach(function($th_qty_value_val, $th_qty_value_key) {
									const $th_pb_qty_option_checked = $th_qty_value_key === 0 ? 'checked="checked"' : '';
									if ($th_qty_option_val.name.toLowerCase().indexOf('color') != -1 || $th_qty_option_val.name.toLowerCase().indexOf('colour') != -1 || $th_qty_option_val.name.toLowerCase().indexOf('shade') != -1) {
										$th_pb_qty_grid_html += '<div class="th_pb_qty_variant_swatch_field th_pb_qty_variant_swatch_field_color">';
										$th_pb_qty_grid_html += '<input type="radio" name="th_pb_qty_' + $th_qty_val.bundle_detail.id + '_' + $th_qty_val.product_list[0].handle + '_' + $grid_inx + '_' + $th_qty_option_key + '" id="th_pb_qty_variant_swatch_' + $th_qty_val.bundle_detail.id + '_' + $th_qty_val.product_list[0].handle + '_' + $grid_inx + '_' + $th_qty_option_key + '_' + $th_qty_value_key + '" class="th_pb_qty_variant_swatch_btn" value="' + $th_qty_value_val.replace(/"/g, "'") + '" ' + $th_pb_qty_option_checked + ' />';
										$th_pb_qty_grid_html += '<label class="th_pb_qty_variant_swatch_label th_pb_qty_variant_swatch_color ' + $th_qty_value_val.toLowerCase().replace(/[^\w ]+/g, '').replace(/ +/g, '-') + '" for="th_pb_qty_variant_swatch_' + $th_qty_val.bundle_detail.id + '_' + $th_qty_val.product_list[0].handle + '_' + $grid_inx + '_' + $th_qty_option_key + '_' + $th_qty_value_key + '" style="background-color:' + $th_qty_value_val.toLowerCase().replace(/[^\w ]+/g, '').replace(/ +/g, '-') + '" title="' + $th_qty_value_val + '"></label>';
										$th_pb_qty_grid_html += '</div>';
									} else {
										$th_pb_qty_grid_html += '<div class="th_pb_qty_variant_swatch_field">';
										$th_pb_qty_grid_html += '<input type="radio" name="th_pb_qty_' + $th_qty_val.bundle_detail.id + '_' + $th_qty_val.product_list[0].handle + '_' + $grid_inx + '_' + $th_qty_option_key + '" id="th_pb_qty_variant_swatch_' + $th_qty_val.bundle_detail.id + '_' + $th_qty_val.product_list[0].handle + '_' + $grid_inx + '_' + $th_qty_option_key + '_' + $th_qty_value_key + '" class="th_pb_qty_variant_swatch_btn" value="' + $th_qty_value_val.replace(/"/g, "'") + '" ' + $th_pb_qty_option_checked + ' />';
										$th_pb_qty_grid_html += '<label class="th_pb_qty_variant_swatch_label ' + $th_qty_value_val.toLowerCase().replace(/[^\w ]+/g, '').replace(/ +/g, '-') + '" for="th_pb_qty_variant_swatch_' + $th_qty_val.bundle_detail.id + '_' + $th_qty_val.product_list[0].handle + '_' + $grid_inx + '_' + $th_qty_option_key + '_' + $th_qty_value_key + '">' + $th_qty_value_val + '</label>';
										$th_pb_qty_grid_html += '</div>';
									}
								});
								$th_pb_qty_grid_html += '</div>';
							});
						} else {
							$th_qty_val.product_list[0].options.forEach(function($th_qty_option_val, $th_qty_option_key) {
								$th_pb_qty_grid_html += '<div class="th_pb_qty_grid_single_variant">';
								$th_pb_qty_grid_html += '<label class="th_pb_wf th_pb_qty_grid_label_cls" data-name="' + $th_qty_option_val.name + '">' + $th_qty_option_val.name + '</label>';
								$th_pb_qty_grid_html += '<select class="th_pb_wf th_pb_qty_grid_select_cls" data-name="' + $th_qty_option_val.name + '">';
								$th_qty_option_val.values.forEach(function($th_qty_value_val, $th_qty_value_key) {
									$th_pb_qty_grid_html += '<option value="' + $th_qty_value_val.replace(/"/g, "'") + '">' + $th_qty_value_val + '</option>';
								});
								$th_pb_qty_grid_html += '</select>';
								$th_pb_qty_grid_html += '</div>';
							});
						}
						$th_pb_qty_grid_html += '<div class="th_pb_qty_variants_section th_pb_wf"><select class="th_pb_qty_variants_select_hidden" style="display:none !important;">';
						$th_qty_val.product_list[0].variants.forEach(function($th_qty_variant, $th_qty_variant_key) {
							if ($th_qty_val.bundle_detail.discount_type == '1') {
								$th_qty_sale_price = parseFloat($th_qty_variant.price) * 100;
								$th_qty_old_price = parseFloat($th_qty_variant.compare_at_price) * 100;
							} else {
								$th_qty_sale_price = ((parseFloat($th_qty_variant.price) * 100) * $this_discount) / 100;
								$th_qty_old_price = parseFloat($th_qty_variant.price) * 100;
							}
							if (($th_qty_variant.image !== undefined || $th_qty_variant?.featured_image?.src !== undefined) && ($th_qty_variant.image !== null || $th_qty_variant?.featured_image?.src !== null)) {
								if ($th_qty_variant?.featured_image?.src) {
									$th_pb_qty_product_image = $th_image_resizer($th_qty_variant.featured_image.src, 'large');
								} else {
									$th_pb_qty_product_image = $th_image_resizer($th_qty_variant.image.originalSrc, 'large');
								}
							}
							const $th_variant_available_status = $th_variant_instock_status($th_qty_val.product_list[0], $th_qty_variant);
							$th_pb_qty_grid_html += '<option value="' + $th_qty_variant.id + '" data-title="' + $th_qty_variant.title.replace(/"/g, "'") + '" data-ptitle="' + $th_qty_val.product_list[0].title + '" data-compare_price="' + $th_qty_old_price + '" data-price="' + $th_qty_sale_price + '" data-image="' + $th_pb_qty_product_image + '" data-available="' + $th_variant_available_status + '">' + $th_qty_variant.title + '</option>';
						});
						$th_pb_qty_grid_html += '</select></div>';
						$th_pb_qty_grid_html += '</div>';
						$th_pb_qty_grid_html += '</div>';
						$th_pb_qty_grid_html += '</div></div>';
					}
					$th_pb_generate_variantmap($th_qty_val.product_list[0]);
					$th_pb_qty_grid_html += '</div>';
					$th_pb_qty_grid_html += '<div class="th_qty_ajax_error" data-msg="' + $th_layout_settings.language.not_available + '"></div>';
					$th_pb_qty_grid_html += '<div class="th_pb_wf th_pb_qty_layout_grid_addtocart_btn"><div class="th_pb_wf th_pb_qty_layout_grid_btn_inner">';
					$th_pb_qty_grid_html += '<div class="btn button th_pb_qty_layout_grid_btn_cls" value="add_to_cart" data-checkout="' + $th_layout_settings.direct_checkout + '" data-dismode="' + $th_layout_settings.discount_mode + '" data-layout="' + $th_qty_val.bundle_detail.layout_setting_type + '">';
					$th_pb_qty_grid_html += '<span class="button_text">' + $th_qty_val.bundle_detail.button_text + '</span>';
					$th_pb_qty_grid_html += '<em class="th_qty_pb_add_to_cart_loader"></em>';
					$th_pb_qty_grid_html += '</div>';
					$th_pb_qty_grid_html += '</div></div>';
					$th_pb_qty_grid_html += '</div></div>';
					$this_parents.insertAdjacentHTML('beforeend', $th_pb_qty_grid_html);
					$th_pb_qty_activate_change_event();
					$th_pb_qty_activate_addtocart_event();
					$this_parents.querySelector('.th_pb_qty_layout_grid').scrollIntoView({
						behavior: 'smooth',
						block: 'nearest',
						inline: 'start'
					});
				}
			});
		}
		document.querySelectorAll('.th_pb_qty_single_btn_cls').forEach(function($this_btn, $th_idx) {
			$this_btn[$th_bundle_addEventListener]('click', function(event) {
				event.preventDefault(), event.stopImmediatePropagation();
				const $this_parents = $this_btn.closest('.th_pb_qty_innercode');
				if ($this_parents.querySelector('.th_pb_qty_layout_grid')) {
					$this_parents.querySelector('.th_pb_qty_layout_grid').remove();
				}
				const $this_grid_index = parseFloat($this_btn.getAttribute('data-val'));
				const $this_discount = 100 - parseFloat($this_btn.getAttribute('data-discount'));
				$th_pb_qty_product_grid_layout($this_parents, $th_pb_qty_details, $th_layout_settings, $this_grid_index, $this_discount);
			});
		});
		$th_pb_qty_activate_change_event();
		$th_pb_qty_activate_addtocart_event();
	}
	const $th_pb_qty_bundle_layout = function($th_qty_result, $th_qty_value) {
		let $th_pb_qty_layout_html = '';
		if ($th_qty_value.product_list !== undefined && $th_qty_value.product_list !== null) {
			$th_pb_qty_layout_html += '<div class="th_pb_wf th_pb_qty_innercode" data-bundleid="' + $th_qty_value.bundle_detail.id + '">';
			$th_pb_qty_layout_html += $th_bundle_main_title($th_qty_value, 'th_qty_bundle_title', 'th_pb_title th_pb_wf', '', 'th_pb_title_description');
			$th_pb_qty_layout_html += '<div class="th_pb_wf th_pb_qty_layout">';
			$th_pb_qty_layout_html += '<div class="th_pb_qty_layout_detail">';
			$th_pb_qty_layout_html += '<div class="th_pb_wf th_pb_qty_layout_figure"><figure class="th_pb_wf">';
			let $th_pb_qty_product_image = $th_pb_p_grid_image($th_qty_value.product_list[0]);
			$th_pb_qty_layout_html += '<img src="' + $th_pb_qty_product_image + '" alt="' + $th_qty_value.product_list[0].handle + '">';
			$th_pb_qty_layout_html += '</figure></div>';
			$th_pb_qty_layout_html += '<div class="th_pb_wf th_pb_qty_layout_title_price">';
			$th_pb_qty_layout_html += '<h6 class="th_pb_wf">' + $th_qty_value.product_list[0].title + '</h6>';
			$th_pb_qty_layout_html += '<p class="th_pb_wf">';
			const $th_pb_qty_price = parseFloat($th_qty_value.product_list[0].variants[0].price) * 100;
			if ($th_pb_qty_price > 0) {
				$th_pb_qty_layout_html += '<span class="th_pb_qty_layout_main_price" data-free="' + wc_external_script_layout.language.free_price + '"><span class="money transcy-money">' + $th_money_format($th_pb_qty_price, $th_shop_money) + '</span></span>';
			} else {
				$th_pb_qty_layout_html += '<span class="th_pb_qty_layout_main_price" data-free="' + wc_external_script_layout.language.free_price + '"><span class="money transcy-money">' + wc_external_script_layout.language.free_price + '</span></span>';
			}
			$th_pb_qty_layout_html += '</p>';
			$th_pb_qty_layout_html += '</div></div>';
			$th_pb_qty_layout_html += '<div class="th_pb_qty_layout_qty_btns"><div class="th_pb_wf th_pb_qty_single_btn">';
			$th_qty_value.bundle_detail.quantity_break.forEach(function($th_break_value, $th_break_idx) {
				$th_pb_qty_layout_html += '<div class="btn button th_pb_qty_single_btn_cls" data-val="' + $th_break_value.quantity + '" data-discount="' + $th_break_value.discount + '" value="open_variant_selection">';
				$th_pb_qty_layout_html += '<span>' + $th_break_value.btn_text + '</span>';
				$th_pb_qty_layout_html += '</div>';
			});
			$th_pb_qty_layout_html += '</div></div>';
			$th_pb_qty_layout_html += '</div>';
			$th_pb_qty_layout_html += '</div>';
			if ($th_qty_result.wc_bd_number == 7) {
				$th_pb_qty_layout_html += '<div class="wc_shopify_preview" style="display: flex !important;width: 100% !important;float: left !important;justify-content: center !important;margin-top: -15px !important; opacity: 1 !important; visibility: visible !important; height: 30px !important;"><img src="https://rebolt.webcontrive.com/rebolt-bundle/public/img/powered_by_rebolt.png" style="display: flex !important;width: 120px !important; opacity: 1 !important; visibility: visible !important; height: 27px !important;"></div>';
			}
		}
		return $th_pb_qty_layout_html;
	}
	const $th_pb_qty_bundle_layout_2 = function($th_qty_result, $th_qty_value) {
		let $th_pb_qty_layout_html = '';
		if ($th_qty_value.product_list !== undefined && $th_qty_value.product_list !== null) {
			$th_pb_qty_layout_html += '<div class="th_pb_wf th_pb_qty_bundle_l2_outer"><div class="th_pb_wf th_pb_qty_innercode th_pb_qty_bundle_l2_inner" data-bundleid="' + $th_qty_value.bundle_detail.id + '" data-discounttype="' + $th_qty_value.bundle_detail.discount_type + '">';
			$th_pb_qty_layout_html += $th_bundle_main_title($th_qty_value, 'th_qty_bundle_title', 'th_pb_title th_pb_wf', '', 'th_pb_title_description');
			$th_pb_qty_layout_html += '<div class="th_pb_wf th_pb_qty_bundle_l2_content"><div class="th_pb_wf th_pb_qty_bundle_l2_content_inner">';
			$th_pb_qty_layout_html += '<div class="th_pb_wf th_pb_qty_bundle_l2_grid_start">';
			$th_qty_value.bundle_detail.quantity_break.forEach(function($th_break_value, $th_break_idx) {
				let th_pb_qty_bundle_l2_selected = '',
					th_pb_qty_bundle_l2_checked = '';
				if ($th_break_value.is_popular == '1') {
					th_pb_qty_bundle_l2_selected = 'th_pb_qty_bundle_l2_selected';
					th_pb_qty_bundle_l2_checked = 'checked';
				}
				const $th_pb_qty_discount_val = ($th_qty_value.bundle_detail.discount_type == '1') ? $th_money_format(($th_break_value.discount * 100) * $th_active_currency_rate, $th_shop_money) : $th_break_value.discount + '%';
				$th_pb_qty_layout_html += '<div class="th_pb_qty_bundle_grid_inner th_pb_qty_bundle_l2_grid_inner ' + th_pb_qty_bundle_l2_selected + '" data-val="' + $th_break_value.quantity + '" data-discount="' + $th_break_value.discount + '">';
				$th_pb_qty_layout_html += '<div class="th_pb_qty_bundle_l2_title_label">';
				$th_pb_qty_layout_html += '<div class="th_pb_qty_bundle_l2_title_radio"><input type="radio" class="th_pb_qty_bundle_l2_title_radio_cls" ' + th_pb_qty_bundle_l2_checked + ' /></div>';
				$th_pb_qty_layout_html += '<div class="th_pb_qty_bundle_l2_title_text"><div class="th_pb_qty_bundle_l2_title_price">';
				$th_pb_qty_layout_html += '<h6><span>' + $th_break_value.btn_text + '</span>';
				if ($th_break_value.tag_text && $th_break_value.is_popular == '1') {
					$th_pb_qty_layout_html += '<em>' + $th_break_value.tag_text + '</em>';
				}
				$th_pb_qty_layout_html += '</h6>';
				$th_pb_qty_layout_html += '<p class="th_pb_qty_bundle_l2_price_section">';
				$th_pb_qty_layout_html += '<span class="th_pb_qty_bundle_l2_total_sale_price"></span>';
				$th_pb_qty_layout_html += '<span class="th_pb_qty_bundle_l2_total_old_price"></span>';
				$th_pb_qty_layout_html += '</p>';
				$th_pb_qty_layout_html += '</div></div>';
				$th_pb_qty_layout_html += '</div>';
				$th_pb_qty_layout_html += '<div class="th_pb_qty_grid_variants th_pb_qty_bundle_l2_grid_variants"><div class="th_pb_qty_layout_grid_inner th_pb_qty_bundle_l2_variants_grid">';
				for (let $grid_inx = 0; $grid_inx < $th_break_value.quantity; $grid_inx++) {
					const $this_discount = 100 - parseFloat($th_break_value.discount);
					const $th_pb_qty_hide_variant = $th_qty_value.product_list[0].variants.length == '1' ? 'style="display:none !important"' : '';
					$th_pb_qty_layout_html += '<div class="th_pb_qty_grid_content th_pb_qty_bundle_variants_loop th_pb_qty_bundle_l2_variants_loop th_pb_qty_grid_column th_pb_qty_grid_count_' + $grid_inx + '" data-productid="' + $th_qty_value.product_list[0].id + '" ' + $th_pb_qty_hide_variant + '>';
					$th_pb_qty_layout_html += '<div class="th_pb_wf th_pb_qty_variants_section"><select class="th_pb_qty_variants_select_hidden" style="display:none !important;">';
					$th_qty_value.product_list[0].variants.forEach(function($th_p_variant, $th_p_idx) {
						let $th_qty_sale_price, $th_qty_old_price;
						if ($th_qty_value.bundle_detail.discount_type == '1') {
							$th_qty_sale_price = parseFloat($th_p_variant.price) * 100;
							$th_qty_old_price = parseFloat($th_p_variant.compare_at_price) * 100;
						} else {
							$th_qty_sale_price = ((parseFloat($th_p_variant.price) * 100) * $this_discount) / 100;
							$th_qty_old_price = parseFloat($th_p_variant.price) * 100;
						}
						const $th_variant_available_status = $th_variant_instock_status($th_qty_value.product_list[0], $th_p_variant);
						$th_pb_qty_layout_html += '<option value="' + $th_p_variant.id + '" data-title="' + $th_p_variant.title.replace(/"/g, "'") + '" data-ptitle="' + $th_qty_value.product_list[0].title + '" data-compare_price="' + $th_qty_old_price + '" data-price="' + $th_qty_sale_price + '" data-available="' + $th_variant_available_status + '">' + $th_p_variant.title + '</option>';
					});
					$th_pb_qty_layout_html += '</select></div>';
					$th_pb_qty_layout_html += '<div class="th_pb_qty_bundle_l2_variants_row">';
					if (parseInt(wc_external_script_layout.variant_layout) === 1) {
						$th_qty_value.product_list[0].options.forEach(function($th_qty_option_val, $th_qty_option_key) {
							$th_pb_qty_layout_html += '<div class="th_pb_qty_grid_single_variant th_pb_qty_bundle_l2_single_variant" data-index="' + $th_qty_option_key + '">';
							$th_pb_qty_layout_html += '<label class="th_pb_wf th_pb_qty_grid_label_cls">' + $th_qty_option_val.name + '</label>';
							$th_qty_option_val.values.forEach(function($th_qty_value_val, $th_qty_value_key) {
								const $th_pb_qty_option_checked = $th_qty_value_key === 0 ? 'checked="checked"' : '';
								if ($th_qty_option_val.name.toLowerCase().indexOf('color') != -1 || $th_qty_option_val.name.toLowerCase().indexOf('colour') != -1 || $th_qty_option_val.name.toLowerCase().indexOf('shade') != -1) {
									$th_pb_qty_layout_html += '<div class="th_pb_qty_variant_swatch_field th_pb_qty_variant_swatch_field_color th_pb_qty_variant_swatch_field_color_l2">';
									$th_pb_qty_layout_html += '<input type="radio" name="th_pb_qty_' + $th_qty_value.bundle_detail.id + '_' + $th_qty_value.product_list[0].handle + '_' + $grid_inx + '_' + $th_qty_option_key + '_' + $th_break_idx + '" id="th_pb_qty_variant_swatch_' + $th_qty_value.bundle_detail.id + '_' + $th_qty_value.product_list[0].handle + '_' + $grid_inx + '_' + $th_qty_option_key + '_' + $th_qty_value_key + '_' + $th_break_idx + '" class="th_pb_qty_variant_swatch_btn" value="' + $th_qty_value_val.replace(/"/g, "'") + '" ' + $th_pb_qty_option_checked + ' />';
									$th_pb_qty_layout_html += '<label class="th_pb_qty_variant_swatch_label th_pb_qty_variant_swatch_color ' + $th_qty_value_val.toLowerCase().replace(/[^\w ]+/g, '').replace(/ +/g, '-') + '" for="th_pb_qty_variant_swatch_' + $th_qty_value.bundle_detail.id + '_' + $th_qty_value.product_list[0].handle + '_' + $grid_inx + '_' + $th_qty_option_key + '_' + $th_qty_value_key + '_' + $th_break_idx + '" style="background-color:' + $th_qty_value_val.toLowerCase().replace(/[^\w ]+/g, '').replace(/ +/g, '-') + '" title="' + $th_qty_value_val + '"></label>';
									$th_pb_qty_layout_html += '</div>';
								} else {
									$th_pb_qty_layout_html += '<div class="th_pb_qty_variant_swatch_field th_pb_qty_variant_swatch_field_l2">';
									$th_pb_qty_layout_html += '<input type="radio" name="th_pb_qty_' + $th_qty_value.bundle_detail.id + '_' + $th_qty_value.product_list[0].handle + '_' + $grid_inx + '_' + $th_qty_option_key + '_' + $th_break_idx + '" id="th_pb_qty_variant_swatch_' + $th_qty_value.bundle_detail.id + '_' + $th_qty_value.product_list[0].handle + '_' + $grid_inx + '_' + $th_qty_option_key + '_' + $th_qty_value_key + '_' + $th_break_idx + '" class="th_pb_qty_variant_swatch_btn" value="' + $th_qty_value_val.replace(/"/g, "'") + '" ' + $th_pb_qty_option_checked + ' />';
									$th_pb_qty_layout_html += '<label class="th_pb_qty_variant_swatch_label ' + $th_qty_value_val.toLowerCase().replace(/[^\w ]+/g, '').replace(/ +/g, '-') + '" for="th_pb_qty_variant_swatch_' + $th_qty_value.bundle_detail.id + '_' + $th_qty_value.product_list[0].handle + '_' + $grid_inx + '_' + $th_qty_option_key + '_' + $th_qty_value_key + '_' + $th_break_idx + '">' + $th_qty_value_val + '</label>';
									$th_pb_qty_layout_html += '</div>';
								}
							});
							$th_pb_qty_layout_html += '</div>';
						});
					} else {
						$th_qty_value.product_list[0].options.forEach(function($th_qty_option_val, $th_qty_option_key) {
							$th_pb_qty_layout_html += '<div class="th_pb_qty_grid_single_variant th_pb_qty_bundle_l2_single_variant">';
							$th_pb_qty_layout_html += '<label class="th_pb_wf th_pb_qty_grid_label_cls">' + $th_qty_option_val.name + '</label>';
							$th_pb_qty_layout_html += '<select class="th_pb_wf th_pb_qty_grid_select_cls" data-name="' + $th_qty_option_val.name + '">';
							$th_qty_option_val.values.forEach(function($th_qty_value_val, $th_qty_value_key) {
								$th_pb_qty_layout_html += '<option value="' + $th_qty_value_val.replace(/"/g, "'") + '">' + $th_qty_value_val + '</option>';
							});
							$th_pb_qty_layout_html += '</select>';
							$th_pb_qty_layout_html += '</div>';
						});
					}
					$th_pb_qty_layout_html += '</div>';
					$th_pb_qty_layout_html += '</div>';
				}
				$th_pb_generate_variantmap($th_qty_value.product_list[0]);
				$th_pb_qty_layout_html += '</div></div>';
				if (wc_external_script_layout.language.quantity_offer_text) {
					$th_pb_qty_layout_html += '<div class="th_pb_qty_bundle_l2_grid_discount_section"><div class="th_pb_qty_bundle_l2_grid_discount_text">';
					$th_pb_qty_layout_html += '<span class="th_pb_qty_bundle_l2_grid_discount_val">' + wc_external_script_layout.language.quantity_offer_text.replace('[[discount]]', $th_pb_qty_discount_val) + '</span>';
					$th_pb_qty_layout_html += '</div></div>';
				}
				$th_pb_qty_layout_html += '</div>';
			});
			$th_pb_qty_layout_html += '</div>';
			$th_pb_qty_layout_html += '<div class="th_pb_qty_bundle_l2_cta_btn_section"><div class="th_pb_qty_layout_grid_addtocart_btn th_pb_qty_bundle_l2_cta_btn_div">';
			$th_pb_qty_layout_html += '<div class="th_qty_ajax_error" data-msg="' + wc_external_script_layout.language.not_available + '"></div>';
			$th_pb_qty_layout_html += '<div class="btn button th_pb_qty_layout_grid_btn_cls" value="add_to_cart" data-checkout="' + wc_external_script_layout.direct_checkout + '" data-dismode="' + wc_external_script_layout.discount_mode + '" data-layout="' + $th_qty_value.bundle_detail.layout_setting_type + '">';
			$th_pb_qty_layout_html += '<span class="button_text">' + $th_qty_value.bundle_detail.button_text + '</span><em class="th_qty_pb_add_to_cart_loader"></em>';
			$th_pb_qty_layout_html += '</div>';
			$th_pb_qty_layout_html += '</div></div>';
			$th_pb_qty_layout_html += '</div></div>';
			$th_pb_qty_layout_html += '</div>';
			if ($th_qty_result.wc_bd_number == 7) {
				$th_pb_qty_layout_html += '<div class="wc_shopify_preview" style="display: flex !important;width: 100% !important;float: left !important;justify-content: center !important;margin-top: -15px !important; opacity: 1 !important; visibility: visible !important; height: 30px !important;"><img src="https://rebolt.webcontrive.com/rebolt-bundle/public/img/powered_by_rebolt.png" style="display: flex !important;width: 120px !important; opacity: 1 !important; visibility: visible !important; height: 27px !important;"></div>';
			}
			$th_pb_qty_layout_html += '</div>';
			return $th_pb_qty_layout_html;
		}
		return $th_pb_qty_layout_html;
	}
	const $th_qty_bundle_response_status = function($th_qty_result, $th_qty_class, $th_qty_code_place, $th_qty_specific_this, $th_qty_pageno, $th_qty_count) {
		if ($th_qty_result.error != true) {
			if ($th_qty_result && $th_qty_result.quantity_bundle_list) {
				$th_qty_result.quantity_bundle_list.forEach(function($th_qty_value, $th_qty_idx) {
					$th_qty_result.bundle_list = $th_qty_result.quantity_bundle_list
					let $th_pb_qty_html = '';
					if ($th_qty_value.bundle_detail.layout_setting_type == '1') {
						$th_pb_qty_html += $th_pb_qty_bundle_layout_2($th_qty_result, $th_qty_value);
					} else {
						$th_pb_qty_html += $th_pb_qty_bundle_layout($th_qty_result, $th_qty_value);
					}
					if ($th_qty_code_place.includes('$th_qty_after_code')) {
						if (wc_external_script_layout.automatic_show_bundle == '1') {
							$th_qty_specific_this.insertAdjacentHTML('afterend', '<div id="th_pb_qty_bundle" class="th_pb_qty_bundle_cls">' + $th_pb_qty_html + '</div>');
						}
					} else {
						$th_qty_specific_this.insertAdjacentHTML('beforeend', $th_pb_qty_html);
					}
					if ($th_qty_idx === ($th_qty_result.quantity_bundle_list.length - 1)) {
						$th_pb_qty_button_click($th_qty_result.quantity_bundle_list, wc_external_script_layout);
					}
					if (typeof $th_bundle_success_callback === 'function') {
						$th_bundle_success_callback($th_qty_value.bundle_detail.id, $th_qty_result);
					}
				});
			}
			if ($th_qty_result && $th_qty_result.bundle_list && !$th_qty_result.quantity_bundle_list) {
				$th_qty_result.bundle_list.forEach(function($th_qty_value, $th_qty_idx) {
					let $th_pb_qty_html = '';
					if ($th_qty_value.bundle_detail.layout_setting_type == '1') {
						$th_pb_qty_html += $th_pb_qty_bundle_layout_2($th_qty_result, $th_qty_value);
					} else {
						$th_pb_qty_html += $th_pb_qty_bundle_layout($th_qty_result, $th_qty_value);
					}
					if ($th_qty_code_place.includes('$th_qty_after_code')) {
						if (wc_external_script_layout.automatic_show_bundle == '1') {
							$th_qty_specific_this.insertAdjacentHTML('afterend', '<div id="th_pb_qty_bundle" class="th_pb_qty_bundle_cls">' + $th_pb_qty_html + '</div>');
						}
					} else {
						$th_qty_specific_this.insertAdjacentHTML('beforeend', $th_pb_qty_html);
					}
					if ($th_qty_idx === ($th_qty_result.bundle_list.length - 1)) {
						$th_pb_qty_button_click($th_qty_result.bundle_list, wc_external_script_layout);
					}
					if (typeof $th_bundle_success_callback === 'function') {
						$th_bundle_success_callback($th_qty_value.bundle_detail.id, $th_qty_result);
					}
				});
			}
		}
	}
	const $wc_recurssive_internal = function($bundle_list, wc_product_data) {
		for (var index in $bundle_list) {
			var single_bundle = $bundle_list[index];
			var single_bundle_products = single_bundle.product_list;
			for (var prd_index in single_bundle_products) {
				var single_product = single_bundle_products[prd_index];
				if (wc_product_data[single_product.handle]) {
					if (single_product?.is_all_variants == '1') {
						single_product.variants = JSON.parse(JSON.stringify(wc_product_data[single_product.handle].variants));
					}
					for (var key in wc_product_data[single_product.handle]) {
						if (wc_product_data[single_product.handle].hasOwnProperty(key)) {
							if (key === "variants") {
								for (var var_index in single_product.variants) {
									var single_variant_id = parseInt(single_product.variants[var_index].id);
									var findVairantIndexInProduct = wc_product_data[single_product.handle].variants.findIndex(item => item.id === single_variant_id);
									for (var var_key in wc_product_data[single_product.handle].variants[var_index]) {
										if (var_key == 'available') {
											var key_result = wc_product_data[single_product.handle].variants[findVairantIndexInProduct][var_key];
											if (key_result) {
												single_product.variants[var_index].inventory_policy = 'allow';
												single_product.variants[var_index].inventory_quantity = 10;
											} else {
												single_product.variants[var_index].inventory_policy = 'deny';
												single_product.variants[var_index].inventory_quantity = -10;
											}
										} else if (var_key == 'price' || var_key == 'compare_at_price') {
											single_product.variants[var_index][var_key] = Number(wc_product_data[single_product.handle].variants[findVairantIndexInProduct][var_key] / 100);
										} else {
											if (wc_product_data[single_product.handle].variants[findVairantIndexInProduct] && wc_product_data[single_product.handle].variants[findVairantIndexInProduct].hasOwnProperty(var_key)) {
												single_product.variants[var_index][var_key] = wc_product_data[single_product.handle].variants[findVairantIndexInProduct][var_key];
											}
										}
									}
								}
							} else if (key == 'price' || key == 'compare_at_price' || key == 'price_min' || key == 'compare_at_price_min' || key == 'price_max' || key == 'compare_at_price_max') {
								single_product[key] = wc_product_data[single_product.handle][key] / 100;
							} else {
								single_product[key] = wc_product_data[single_product.handle][key];
							}
						}
					}
					single_product.status = 'active';
					$bundle_list[index].product_list[prd_index] = single_product;
				} else {
					single_product.status = 'draft';
					$bundle_list[index].product_list[prd_index] = single_product;
				}
			}
		}
		return $bundle_list;
	}
	const $th_bundle_new_ajax_request = function($th_get_bundle_ajax_data, $th_callback_event, $th_bundle_class, $th_bundle_code_place, $th_specific_bundle, $th_bundle_pageno, $th_bundle_count) {
		if (document.querySelectorAll('.th_pb_qty_bundle_cls').length > 0 || document.querySelectorAll('.th_pb_fbt_section').length > 0) {
			var page_type = document.querySelector('#th_shop_money').getAttribute('data-page-type');
			if (page_type != 'product') {
				$th_get_bundle_ajax_data['custom_shortcode'] = true;
			}
		}
		fetch($th_app_ajax_url + 'frontendv2/get_bundle_details_single_v3.php', {
			method: 'POST',
			body: JSON.stringify($th_get_bundle_ajax_data),
			cache: 'no-cache'
		}).then(response => response.json()).then($th_bundle_result => {
			if ($th_bundle_result.error != true) {
				var wc_products_handle_array = [];
				/* Get Product Details code start*/
				const recursiveFunc = (length, starting_length, wc_product_data) => {
					if (length == starting_length) {
						if ($th_bundle_result?.bundle_list?.length) {
							$th_bundle_result.bundle_list = $wc_recurssive_internal($th_bundle_result?.bundle_list, wc_product_data);
						}
						if ($th_bundle_result?.addon_bundle_list?.length) {
							$th_bundle_result.addon_bundle_list = $wc_recurssive_internal($th_bundle_result.addon_bundle_list, wc_product_data);
						}
						if ($th_bundle_result?.fbt_bundle_list?.length) {
							$th_bundle_result.fbt_bundle_list = $wc_recurssive_internal($th_bundle_result.fbt_bundle_list, wc_product_data);
						}
						if ($th_bundle_result?.quantity_bundle_list?.length) {
							$th_bundle_result.quantity_bundle_list = $wc_recurssive_internal($th_bundle_result.quantity_bundle_list, wc_product_data);
						}
						if ($th_bundle_result?.popup_bundle_list?.length) {
							$th_bundle_result.popup_bundle_list = $wc_recurssive_internal($th_bundle_result.popup_bundle_list, wc_product_data);
						}
						if ($th_bundle_result?.combo_bundle_list?.length) {
							$th_bundle_result.combo_bundle_list = $wc_recurssive_internal($th_bundle_result.combo_bundle_list, wc_product_data);
						}
						if ($th_bundle_result?.exitIntent_bundle_list?.length) {
							$th_bundle_result.exitIntent_bundle_list = $wc_recurssive_internal($th_bundle_result.exitIntent_bundle_list, wc_product_data);
						}
						if ($th_bundle_result?.product_list?.length) {
							var single_bundle_products = $th_bundle_result.product_list;
							for (var prd_index in single_bundle_products) {
								var single_product = single_bundle_products[prd_index];
								if (wc_product_data[single_product.handle]) {
									if (single_product.is_all_variants == 1) {
										single_product.variants = JSON.parse(JSON.stringify(wc_product_data[single_product.handle].variants));
									}
									for (var key in wc_product_data[single_product.handle]) {
										if (wc_product_data[single_product.handle].hasOwnProperty(key)) {
											if (key === "variants") {
												for (var var_index in single_product.variants) {
													var single_variant_id = parseInt(single_product.variants[var_index].id);
													var findVairantIndexInProduct = wc_product_data[single_product.handle].variants.findIndex(item => item.id === single_variant_id);
													for (var var_key in wc_product_data[single_product.handle].variants[var_index]) {
														if (var_key == 'available') {
															var key_result = wc_product_data[single_product.handle].variants[findVairantIndexInProduct][var_key];
															if (key_result) {
																single_product.variants[var_index].inventory_policy = 'allow';
																single_product.variants[var_index].inventory_quantity = 10;
															} else {
																single_product.variants[var_index].inventory_policy = 'deny';
																single_product.variants[var_index].inventory_quantity = -10;
															}
														} else if (var_key == 'price' || var_key == 'compare_at_price') {
															single_product.variants[var_index][var_key] = Number(wc_product_data[single_product.handle].variants[findVairantIndexInProduct][var_key] / 100);
														} else {
															if (wc_product_data[single_product.handle].variants[findVairantIndexInProduct].hasOwnProperty(var_key)) {
																single_product.variants[var_index][var_key] = wc_product_data[single_product.handle].variants[findVairantIndexInProduct][var_key];
															}
														}
													}
												}
											} else if (key == 'price' || key == 'compare_at_price' || key == 'price_min' || key == 'compare_at_price_min' || key == 'price_max' || key == 'compare_at_price_max') {
												single_product[key] = wc_product_data[single_product.handle][key] / 100;
											} else {
												single_product[key] = wc_product_data[single_product.handle][key];
											}
										}
									}
									single_product.status = 'active';
									$th_bundle_result.product_list[prd_index] = single_product;
								} else {
									single_product.status = 'draft';
									$th_bundle_result.product_list[prd_index] = single_product;
								}
							}
						}
						var $wcpb_ao_bundle_this = document.querySelector('.wcpb_ao_section');
						if ($wcpb_ao_bundle_this) {
							if ($th_bundle_result && $th_bundle_result.addon_bundle_list) {
								$wcpb_ao_design_layout($th_bundle_result, $wcpb_ao_bundle_this);
							}
						}
						if (document.querySelector('.th_pb_fbt_section[data-thpid]') && $th_bundle_result?.fbt_bundle_list?.length) {
							$th_fbt_bundle_class = document.querySelector('.th_pb_fbt_section[data-thpid]');
							$th_fbt_bundle_code_place = '$th_fbt_append_code'
							$th_fbt_bundle_response_status($th_bundle_result, null, $th_fbt_bundle_code_place, $th_fbt_bundle_class);
						}
						if ($th_bundle_response_status && (typeof $th_bundle_response_status == "function")) {
							if ($th_callback_event == $th_quick_bundle_layout) {
								$th_quick_bundle_layout($th_bundle_result, $th_bundle_class, $th_bundle_code_place, $th_specific_bundle, $th_bundle_pageno, $th_bundle_count);
							} else {
								if (document.querySelector('#th_product_bundle')) {
									$th_bundle_class = '#th_product_bundle';
								} else if (document.querySelector('.th_pb_cart_bundles')) {
									$th_bundle_class = '.th_pb_cart_bundles';
								} else {
									var wc_older_bundle = $th_bundle_class;
									if ($th_bundle_result && $th_bundle_result.bundle_list && $th_bundle_result.bundle_list.length && wc_external_script_layout.automatic_show_bundle == '1') {
										$th_bundle_class = 'form[action="/cart/add"]';
										$th_bundle_code_place += ', $th_bundle_after_code'
									} else {
										$th_bundle_class = '';
									}
								}
								$th_bundle_response_status($th_bundle_result, $th_bundle_class, $th_bundle_code_place, $th_specific_bundle, $th_bundle_pageno, $th_bundle_count);
							}
							$th_bundle_class = wc_older_bundle;
						}
						if ($th_bundle_result.quantity_bundle_list) {
							$th_specific_bundle = document.querySelector('#th_pb_qty_bundle');
							if (!$th_specific_bundle) {
								$th_bundle_code_place = '$th_qty_after_code';
								$th_specific_bundle = document.querySelectorAll('form[action="/cart/add"]')[0];
							}
							$th_qty_bundle_response_status($th_bundle_result, $th_bundle_class, $th_bundle_code_place, $th_specific_bundle, $th_bundle_pageno, $th_bundle_count);
						}
					}
				}
				if ($th_bundle_result?.bundle_list?.length) {
					for (var index in $th_bundle_result.bundle_list) {
						var single_bundle = $th_bundle_result.bundle_list[index];
						var single_bundle_products = single_bundle.product_list;
						for (var prd_index in single_bundle_products) {
							var single_product = single_bundle_products[prd_index];
							if (single_product.handle) {
								wc_products_handle_array.push(single_product.handle);
							}
						}
					}
				}
				if ($th_bundle_result?.addon_bundle_list?.length) {
					for (var index in $th_bundle_result.addon_bundle_list) {
						var single_bundle = $th_bundle_result.addon_bundle_list[index];
						var single_bundle_products = single_bundle.product_list;
						for (var prd_index in single_bundle_products) {
							var single_product = single_bundle_products[prd_index];
							if (single_product.handle) {
								wc_products_handle_array.push(single_product.handle);
							}
						}
					}
				}
				if ($th_bundle_result?.fbt_bundle_list?.length) {
					for (var index in $th_bundle_result.fbt_bundle_list) {
						var single_bundle = $th_bundle_result.fbt_bundle_list[index];
						var single_bundle_products = single_bundle.product_list;
						for (var prd_index in single_bundle_products) {
							var single_product = single_bundle_products[prd_index];
							if (single_product.handle) {
								wc_products_handle_array.push(single_product.handle);
							}
						}
					}
				}
				if ($th_bundle_result?.quantity_bundle_list?.length) {
					for (var index in $th_bundle_result.quantity_bundle_list) {
						var single_bundle = $th_bundle_result.quantity_bundle_list[index];
						var single_bundle_products = single_bundle.product_list;
						for (var prd_index in single_bundle_products) {
							var single_product = single_bundle_products[prd_index];
							if (single_product.handle) {
								wc_products_handle_array.push(single_product.handle);
							}
						}
					}
				}
				if ($th_bundle_result?.popup_bundle_list?.length) {
					for (var index in $th_bundle_result.popup_bundle_list) {
						var single_bundle = $th_bundle_result.popup_bundle_list[index];
						var single_bundle_products = single_bundle.product_list;
						for (var prd_index in single_bundle_products) {
							var single_product = single_bundle_products[prd_index];
							if (single_product.handle) {
								wc_products_handle_array.push(single_product.handle);
							}
						}
					}
				}
				if ($th_bundle_result?.combo_bundle_list?.length) {
					for (var index in $th_bundle_result.combo_bundle_list) {
						var single_bundle = $th_bundle_result.combo_bundle_list[index];
						var single_bundle_products = single_bundle.product_list;
						for (var prd_index in single_bundle_products) {
							var single_product = single_bundle_products[prd_index];
							if (single_product.handle) {
								wc_products_handle_array.push(single_product.handle);
							}
						}
					}
				}
				if ($th_bundle_result?.exitIntent_bundle_list?.length) {
					for (var index in $th_bundle_result.exitIntent_bundle_list) {
						var single_bundle = $th_bundle_result.exitIntent_bundle_list[index];
						var single_bundle_products = single_bundle.product_list;
						for (var prd_index in single_bundle_products) {
							var single_product = single_bundle_products[prd_index];
							if (single_product.handle) {
								wc_products_handle_array.push(single_product.handle);
							}
						}
					}
				}
				if ($th_bundle_result?.product_list?.length) {
					var single_bundle_products = $th_bundle_result.product_list;
					for (var prd_index in single_bundle_products) {
						var single_product = single_bundle_products[prd_index];
						if (single_product.handle) {
							wc_products_handle_array.push(single_product.handle);
						}
					}
				}
				var cleanedArray = wc_products_handle_array.filter(function(item, index, self) {
					return item !== undefined && self.indexOf(item) === index;
				});
				var wc_currency_change = false;
				if (sessionStorage.getItem('wc_session_storage_currency') == null) {
					sessionStorage.setItem('wc_session_storage_currency', Shopify.currency.active);
				} else {
					if (sessionStorage.getItem('wc_session_storage_currency') == $th_active_currency) {
						wc_currency_change = false;
					} else {
						wc_currency_change = true;
						sessionStorage.setItem('wc_session_storage_currency', Shopify.currency.active);
					}
				}
				var total_products_list = cleanedArray.length;
				var wc_starting_length = 0;
				var wc_product_data = [];
				for (var single_handle_index = 0; single_handle_index < cleanedArray.length; single_handle_index++) {
					var single_handle = cleanedArray[single_handle_index];
					var product_available = false;
					var selected_product_data = sessionStorage.getItem('wc_' + single_handle);
					if (wc_currency_change) {
						product_available = false;
					} else if (selected_product_data) {
						var selected_product_json = JSON.parse(selected_product_data);
						var selected_product_time_stamp = selected_product_json.timestamp;
						var current_time = Date.now();
						var timedifference = current_time - selected_product_time_stamp;
						if (timedifference <= 120000) {
							product_available = true;
							wc_product_data[single_handle] = selected_product_json;
							wc_starting_length++;
							recursiveFunc(total_products_list, wc_starting_length, wc_product_data);
						}
					}
					if (!product_available) {
						var route_url = window.Shopify.routes.root;
						if (!route_url) {
							route_url = window.Shopify.routes.root_url;
						}
						fetch(route_url + 'products/' + single_handle + '.js').then(response => response.json()).then(data => {
							data.timestamp = Date.now();
							wc_product_data[data.handle] = data;
							sessionStorage.setItem('wc_' + data.handle, JSON.stringify(data));
							wc_starting_length++;
							recursiveFunc(total_products_list, wc_starting_length, wc_product_data);
						}).catch(error => {
							wc_starting_length++;
							recursiveFunc(total_products_list, wc_starting_length, wc_product_data);
							// console.log(error);
						});
					}
				}
			} else {
				if (document.querySelectorAll('figure.th_bundle_section_loader').length > 0) {
					document.querySelectorAll('figure.th_bundle_section_loader').forEach(function($th_grid, $th_idx) {
						$th_grid.remove();
					});
				}
			}
		}).catch(($th_bundle_error) => {
			console.error($th_bundle_error);
			if (document.querySelectorAll('figure.th_bundle_section_loader').length > 0) {
				document.querySelectorAll('figure.th_bundle_section_loader').forEach(function($th_grid, $th_idx) {
					$th_grid.remove();
				});
			}
		});
	}
	const $th_get_cart_values = async function($th_bundle_product_id, $th_page_id, $th_page_type, $th_bundle_class, $th_bundle_code_place, $th_specific_bundle) {
		let $th_get_bundle_ajax_data = {
			shop: $th_shop_conveted_url,
			product_id: $th_bundle_product_id,
			active_currency: $th_active_currency,
			active_country: $th_active_country,
			page_id: $th_page_id,
			page_type: $th_page_type,
			cart_bids: null
		};
		var $wc_bundle_ids = [];
		if ($th_cart_json.item_count > 0) {
			let $th_cart_item_data = [];
			$th_cart_json.items.forEach(function($th_cart_value, $th_cart_idx) {
				if ($th_cart_value['properties'] && $th_cart_value['properties']['_th_bundle_addon']) {
					if (!String($wc_bundle_ids).includes($th_cart_value['properties']['_th_bundle_addon'])) {
						$wc_bundle_ids.push($th_cart_value['properties']['_th_bundle_addon']);
					}
				}
				if ($th_cart_value['properties'] && $th_cart_value['properties']['_th_bundle_quantity']) {
					if (!String($wc_bundle_ids).includes($th_cart_value['properties']['_th_bundle_quantity'])) {
						$wc_bundle_ids.push($th_cart_value['properties']['_th_bundle_quantity']);
					}
				}
				if ($th_cart_value['properties'] && $th_cart_value['properties']['_th_bundle_custom']) {
					if (!String($wc_bundle_ids).includes($th_cart_value['properties']['_th_bundle_custom'])) {
						$wc_bundle_ids.push($th_cart_value['properties']['_th_bundle_custom']);
					}
				}
				if ($th_cart_value['properties'] && $th_cart_value['properties']['_th_bundle_fbt']) {
					if (!String($wc_bundle_ids).includes($th_cart_value['properties']['_th_bundle_fbt'])) {
						$wc_bundle_ids.push($th_cart_value['properties']['_th_bundle_fbt']);
					}
				}
				if ($th_cart_value['properties'] && $th_cart_value['properties']['_th_bundle_product']) {
					if (!String($wc_bundle_ids).includes($th_cart_value['properties']['_th_bundle_product'])) {
						$wc_bundle_ids.push($th_cart_value['properties']['_th_bundle_product']);
					}
				}
				$th_cart_item_data.push({
					variant_id: $th_cart_value.id,
					product_id: $th_cart_value.product_id,
					quantity: $th_cart_value.quantity,
					price: $th_cart_value.price
				});
				if ($th_cart_idx === ($th_cart_json.items.length - 1)) {
					const $th_cart_post_data = {
						items: $th_cart_item_data,
						total_price: $th_cart_json.total_price
					};
					$th_get_bundle_ajax_data['cart'] = $th_cart_post_data;
					$th_get_bundle_ajax_data['cart_bids'] = $wc_bundle_ids;
					$th_bundle_new_ajax_request($th_get_bundle_ajax_data, $th_bundle_response_status, $th_bundle_class, $th_bundle_code_place, $th_specific_bundle, null, null);
				}
			});
		} else {
			let $th_cart_post_data = {
				items: null
			};
			$th_get_bundle_ajax_data['cart'] = $th_cart_post_data;
			$th_bundle_new_ajax_request($th_get_bundle_ajax_data, $th_bundle_response_status, $th_bundle_class, $th_bundle_code_place, $th_specific_bundle, null, null);
		}
	}
	var wc_product_type = document.querySelector('#th_shop_money')?.getAttribute('data-page-type') ? document.querySelector('#th_shop_money')?.getAttribute('data-page-type') : ShopifyAnalytics ? ShopifyAnalytics.meta.page.pageType : '';
	var wc_product_id = document.querySelector('#th_shop_money')?.getAttribute('data-product-id') ? document.querySelector('#th_shop_money')?.getAttribute('data-product-id') : ShopifyAnalytics?.meta?.product?.id ? ShopifyAnalytics.meta.product.id : '';
	if (wc_product_type == 'product') {
		if (document.querySelector('.wc_total_product_ids').getAttribute('data-product-ids').includes(String(wc_product_id))) {
			if (document.querySelector('#th_product_bundle')) {
				document.querySelector('#th_product_bundle').insertAdjacentHTML('beforeend', $th_loader_code);
				const $th_product_id = document.querySelector('#th_product_bundle').getAttribute('data-id'),
					$th_page_id = (__st.rid) ? __st.rid : null,
					$th_page_type = (__st.p) ? __st.p : null;
				const $th_bundle_class = '#th_product_bundle',
					$th_specific_bundle = null;
				var $th_bundle_code_place = '$th_bundle_append_code';
				if (document.querySelector('#th_pb_qty_bundle')) {
					$th_bundle_code_place += ', quantity_bundle';
				}
				$th_get_cart_values($th_product_id, $th_page_id, $th_page_type, $th_bundle_class, $th_bundle_code_place, $th_specific_bundle);
			} else if (document.querySelector('.wcpb_ao_section')) {
				document.querySelector('.wcpb_ao_section').insertAdjacentHTML('beforeend', $th_loader_code);
				$wcpb_ao_bundle_this = document.querySelector('.wcpb_ao_section');
				const $th_product_id = $wcpb_ao_bundle_this.getAttribute('data-wcpid'),
					$th_page_id = (__st.rid) ? __st.rid : null,
					$th_page_type = (__st.p) ? __st.p : null;
				const $th_bundle_class = '.wcpb_ao_section',
					$th_bundle_code_place = '',
					$th_specific_bundle = null;
				$th_get_cart_values($th_product_id, $th_page_id, $th_page_type, $wcpb_ao_bundle_this, $th_bundle_code_place, $th_specific_bundle);
			} else if (document.querySelector('#th_pb_qty_bundle')) {
				document.querySelector('#th_pb_qty_bundle').insertAdjacentHTML('beforeend', $th_loader_code);
				const $th_product_id = document.querySelector('#th_pb_qty_bundle').getAttribute('data-pid'),
					$th_page_id = (__st.rid) ? __st.rid : null,
					$th_page_type = (__st.p) ? __st.p : null;
				const $th_bundle_class = 'form[action="/cart/add"]',
					$th_bundle_code_place = 'quantity_bundle',
					$th_specific_bundle = null;
				$th_get_cart_values($th_product_id, $th_page_id, $th_page_type, $th_bundle_class, $th_bundle_code_place, $th_specific_bundle);
			} else if (document.querySelector('.th_pb_fbt_section[data-thpid]')) {
				$th_fbt_bundle = document.querySelector('.th_pb_fbt_section[data-thpid]');
				const $th_product_id = $th_fbt_bundle.getAttribute('data-thpid'),
					$th_page_id = (__st.rid) ? __st.rid : null,
					$th_page_type = (__st.p) ? __st.p : null;
				const $th_bundle_code_place = '$th_fbt_append_code',
					$th_specific_bundle = null;
				$th_get_cart_values($th_product_id, $th_page_id, $th_page_type, $th_fbt_bundle, $th_bundle_code_place, $th_specific_bundle);
			} else if (typeof __st !== 'undefined' && window.location.href.indexOf('/cart') == -1 && window.location.href.indexOf('/apps/') == -1 && window.location.href.indexOf('/a/') == -1 && window.location.href.indexOf('/community/') == -1 && window.location.href.indexOf('/tools/') == -1) {
				const $th_product_id = (__st.rid) ? __st.rid : null,
					$th_page_id = (__st.rid) ? __st.rid : null,
					$th_page_type = (__st.p) ? __st.p : null;
				const $th_bundle_class = 'form[action="/cart/add"]',
					$th_bundle_code_place = '$th_bundle_after_code',
					$th_specific_bundle = null;
				$th_get_cart_values($th_product_id, $th_page_id, $th_page_type, $th_bundle_class, $th_bundle_code_place, $th_specific_bundle);
			}
		}
	} else {
		if (document.querySelector('#th_product_bundle')) {
			document.querySelector('#th_product_bundle').insertAdjacentHTML('beforeend', $th_loader_code);
			const $th_product_id = document.querySelector('#th_product_bundle').getAttribute('data-id'),
				$th_page_id = (__st.rid) ? __st.rid : null,
				$th_page_type = (__st.p) ? __st.p : null;
			const $th_bundle_class = '#th_product_bundle',
				$th_specific_bundle = null;
			var $th_bundle_code_place = '$th_bundle_append_code';
			if (document.querySelector('#th_pb_qty_bundle')) {
				$th_bundle_code_place += ', quantity_bundle';
			}
			$th_get_cart_values($th_product_id, $th_page_id, $th_page_type, $th_bundle_class, $th_bundle_code_place, $th_specific_bundle);
		} else if (document.querySelector('.wcpb_ao_section')) {
			document.querySelector('.wcpb_ao_section').insertAdjacentHTML('beforeend', $th_loader_code);
			$wcpb_ao_bundle_this = document.querySelector('.wcpb_ao_section');
			const $th_product_id = $wcpb_ao_bundle_this.getAttribute('data-wcpid'),
				$th_page_id = (__st.rid) ? __st.rid : null,
				$th_page_type = (__st.p) ? __st.p : null;
			const $th_bundle_class = '.wcpb_ao_section',
				$th_bundle_code_place = '',
				$th_specific_bundle = null;
			$th_get_cart_values($th_product_id, $th_page_id, $th_page_type, $wcpb_ao_bundle_this, $th_bundle_code_place, $th_specific_bundle);
		} else if (document.querySelector('#th_pb_qty_bundle')) {
			document.querySelector('#th_pb_qty_bundle').insertAdjacentHTML('beforeend', $th_loader_code);
			const $th_product_id = document.querySelector('#th_pb_qty_bundle').getAttribute('data-pid'),
				$th_page_id = (__st.rid) ? __st.rid : null,
				$th_page_type = (__st.p) ? __st.p : null;
			var route_url = window.Shopify.routes.root;
			if (!route_url) {
				route_url = window.Shopify.routes.root_url;
			}
			const $th_bundle_class = 'form[action="' + route_url + 'cart/add"]',
				$th_bundle_code_place = 'quantity_bundle',
				$th_specific_bundle = null;
			$th_get_cart_values($th_product_id, $th_page_id, $th_page_type, $th_bundle_class, $th_bundle_code_place, $th_specific_bundle);
		} else if (document.querySelector('.th_pb_fbt_section[data-thpid]')) {
			$th_fbt_bundle = document.querySelector('.th_pb_fbt_section[data-thpid]');
			const $th_product_id = $th_fbt_bundle.getAttribute('data-thpid'),
				$th_page_id = (__st.rid) ? __st.rid : null,
				$th_page_type = (__st.p) ? __st.p : null;
			const $th_bundle_code_place = '$th_fbt_append_code',
				$th_specific_bundle = null;
			$th_get_cart_values($th_product_id, $th_page_id, $th_page_type, $th_fbt_bundle, $th_bundle_code_place, $th_specific_bundle);
		} else if (typeof __st !== 'undefined' && window.location.href.indexOf('/cart') == -1 && window.location.href.indexOf('/apps/') == -1 && window.location.href.indexOf('/a/') == -1 && window.location.href.indexOf('/community/') == -1 && window.location.href.indexOf('/tools/') == -1) {
			const $th_product_id = (__st.rid) ? __st.rid : null,
				$th_page_id = (__st.rid) ? __st.rid : null,
				$th_page_type = (__st.p) ? __st.p : null;
			var route_url = window.Shopify.routes.root;
			if (!route_url) {
				route_url = window.Shopify.routes.root_url;
			}
			const $th_bundle_class = 'form[action="' + route_url + 'cart/add"]',
				$th_bundle_code_place = '$th_bundle_after_code',
				$th_specific_bundle = null;
			$th_get_cart_values($th_product_id, $th_page_id, $th_page_type, $th_bundle_class, $th_bundle_code_place, $th_specific_bundle);
		}
	}
	const $th_all_bundle_new_ajax_request = async function($th_get_bundle_ajax_data, $th_callback_event, $th_bundle_class, $th_bundle_code_place, $th_specific_bundle, $th_bundle_pageno, $th_bundle_count) {
		fetch($th_app_ajax_url + 'frontendv2/get_all_bundle_by_shop.php', {
			method: 'POST',
			body: JSON.stringify($th_get_bundle_ajax_data),
			cache: 'no-cache'
		}).then(response => response.json()).then($th_bundle_result => {
			if ($th_bundle_result.error != true) {
				if ($th_callback_event && (typeof $th_callback_event == "function")) {
					$th_callback_event($th_bundle_result, $th_bundle_class, $th_bundle_code_place, $th_specific_bundle, $th_bundle_pageno, $th_bundle_count);
				}
			} else {
				if (document.querySelectorAll('figure.th_bundle_section_loader').length > 0) {
					document.querySelectorAll('figure.th_bundle_section_loader').forEach(function($th_grid, $th_idx) {
						$th_grid.remove();
					});
				}
			}
		}).catch(($th_bundle_error) => {
			console.error($th_bundle_error);
			if (document.querySelectorAll('figure.th_bundle_section_loader').length > 0) {
				document.querySelectorAll('figure.th_bundle_section_loader').forEach(function($th_grid, $th_idx) {
					$th_grid.remove();
				});
			}
		});
	}
	if (document.querySelector('.th_pb_specific_bundles')) {
		document.querySelectorAll('.th_pb_specific_bundles').forEach(function($th_specific_bundles_this, $th_idx) {
			const $th_specific_bundles_id = $th_specific_bundles_this.getAttribute('data-bundleid');
			$th_specific_bundles_this.innerHTML = $th_loader_code;
			const $th_get_bundle_ajax_data = {
				shop: $th_shop_conveted_url,
				all_bundles: '',
				bundle_id: $th_specific_bundles_id,
				active_currency: $th_active_currency,
				active_country: $th_active_country
			};
			const $th_bundle_class = '#th_pb_all_bundles_list',
				$th_bundle_code_place = '$th_bundle_append_code',
				$th_specific_bundle = $th_specific_bundles_this;
			$th_all_bundle_new_ajax_request($th_get_bundle_ajax_data, $th_bundle_response_status, $th_bundle_class, $th_bundle_code_place, $th_specific_bundle, null, null);
		});
	}
	const $th_get_all_bundles = function($th_pageno, $th_bundle_count) {
		function $th_all_bundles_loadmore_function($th_bundle_result, $th_bundle_class, $th_bundle_code_place, $th_specific_bundle, $th_bundle_pageno, $th_bundle_count) {
			if (document.querySelectorAll('figure.th_bundle_section_loader').length > 0) {
				document.querySelector('figure.th_bundle_section_loader').remove();
			}
			$th_bundle_response_status($th_bundle_result, $th_bundle_class, $th_bundle_code_place, $th_specific_bundle, $th_bundle_pageno, $th_bundle_count);
			const $th_bundle_count_update = $th_bundle_result.bundle_count;
			let $th_loaded = 0;
			if ($th_bundle_result.nextpage > $th_pageno) {
				if (wc_external_script_layout.btn_load_more == '1') {
					document[$th_bundle_addEventListener]('scroll', function(event) {
						const $th_bundle_section_height = document.querySelector('#th_pb_all_bundles_list').offsetTop + document.querySelector('#th_pb_all_bundles_list').offsetHeight - window.innerHeight;
						if (window.scrollY >= $th_bundle_section_height) {
							if ($th_loaded === 0) {
								$th_get_all_bundles($th_pageno, $th_bundle_count_update);
								$th_loaded = 1;
							}
						}
					});
					$th_pageno++;
				} else {
					if (document.querySelectorAll('.th_pb_all_bundles_list_loadmore_div').length > 0) {
						document.querySelector('.th_pb_all_bundles_list_loadmore_div').remove();
					}
					let $th_load_more_button = '<div class="th_pb_wf th_pb_all_bundles_list_loadmore_div">';
					$th_load_more_button += '<div id="th_pb_all_bundles_list_loadmore_btn" class="btn button th_pb_all_bundles_list_loadmore_btn" data-nextpage="' + $th_bundle_result.nextpage + '" data-bundlecount="' + $th_bundle_result.bundle_count + '"><span class="button_text">' + wc_external_script_layout.language.btn_load_more + '</span> <em class="th_pb_add_to_cart_loader"></em></div>';
					$th_load_more_button += '</div>';
					document.querySelector('#th_pb_all_bundles_list').insertAdjacentHTML('beforeend', $th_load_more_button);
					document.querySelectorAll('#th_pb_all_bundles_list_loadmore_btn').forEach(function($th_button) {
						$th_button[$th_bundle_addEventListener]('click', function(event) {
							event.preventDefault(), event.stopImmediatePropagation();
							if (document.querySelectorAll('.th_pb_all_bundles_list_loadmore_div').length > 0) {
								document.querySelector('.th_pb_all_bundles_list_loadmore_div').remove();
							}
							$th_get_all_bundles($th_button.getAttribute('data-nextpage'), $th_button.getAttribute('data-bundlecount'));
						});
					});
				}
			} else {
				if (document.querySelectorAll('.th_pb_all_bundles_list_loadmore_div').length > 0) {
					document.querySelector('.th_pb_all_bundles_list_loadmore_div').remove();
				}
			}
		}
		document.querySelector('#th_pb_all_bundles_list').insertAdjacentHTML('beforeend', $th_loader_code);
		const $th_get_bundle_ajax_data = {
			shop: $th_shop_conveted_url,
			all_bundles: '',
			currentpage: $th_pageno,
			bundle_count: $th_bundle_count,
			active_currency: $th_active_currency,
			active_country: $th_active_country
		};
		const $th_bundle_class = '#th_pb_all_bundles_list',
			$th_bundle_code_place = '$th_bundle_append_code',
			$th_specific_bundle = null;
		$th_all_bundle_new_ajax_request($th_get_bundle_ajax_data, $th_all_bundles_loadmore_function, $th_bundle_class, $th_bundle_code_place, $th_specific_bundle, $th_pageno, $th_bundle_count);
	}
	if (document.querySelector('#th_pb_all_bundles_list')) {
		$th_get_all_bundles(1, 0);
	}
	if (document.querySelector('.th_pb_custom_bundle[data-id]')) {
		document.querySelectorAll('.th_pb_custom_bundle').forEach(function($th_custom_bundle_this, $th_idx) {
			const $th_cb_bundle_id = $th_custom_bundle_this.getAttribute('data-id');
			$th_custom_bundle_this.innerHTML = $th_loader_code;
			const $th_get_quick_ajax_data = {
				shop: $th_shop_conveted_url,
				custom_bundle_page: $th_cb_bundle_id,
				active_currency: $th_active_currency,
				active_country: $th_active_country,
				cart_bids: null
			};
			const $th_quick_class = null,
				$th_quick_code_place = null,
				$th_quick_specific_this = $th_custom_bundle_this;
			$th_bundle_new_ajax_request($th_get_quick_ajax_data, $th_quick_bundle_layout, $th_quick_class, $th_quick_code_place, $th_quick_specific_this, null, null);
		});
	}
	const $th_get_all_qty_bundles = function($th_qty_pageno, $th_qty_bundle_count) {
		function $th_qty_all_bundles_loadmore_function($th_qty_result, $th_qty_bundle_class, $th_qty_bundle_code_place, $th_qty_specific_bundle) {
			if (document.querySelectorAll('figure.th_bundle_section_loader').length > 0) {
				document.querySelector('figure.th_bundle_section_loader').remove();
			}
			$th_qty_bundle_response_status($th_qty_result, $th_qty_bundle_class, $th_qty_bundle_code_place, $th_qty_specific_bundle, $th_qty_pageno, $th_qty_bundle_count);
			const $th_qty_bundle_count_updated = $th_qty_result.bundle_count;
			let $th_qty_loaded = 0;
			if ($th_qty_result.nextpage > $th_qty_pageno) {
				if (wc_external_script_layout.btn_load_more == '1') {
					document[$th_bundle_addEventListener]('scroll', function(event) {
						const $th_qty_bundle_section_height = document.querySelector('#th_pb_all_qty_bundle').offsetTop + document.querySelector('#th_pb_all_qty_bundle').offsetHeight - window.innerHeight;
						if (window.scrollY >= $th_qty_bundle_section_height) {
							if ($th_qty_loaded === 0) {
								$th_get_all_qty_bundles($th_qty_pageno, $th_qty_bundle_count_updated);
								$th_qty_loaded = 1;
							}
						}
					});
					$th_qty_pageno++;
				} else {
					if (document.querySelectorAll('.th_pb_qty_all_bundles_list_loadmore_div').length > 0) {
						document.querySelector('.th_pb_qty_all_bundles_list_loadmore_div').remove();
					}
					let $th_load_more_button = '<div class="th_pb_wf th_pb_qty_all_bundles_list_loadmore_div">';
					$th_load_more_button += '<button type="button" id="th_pb_qty_all_bundles_list_loadmore_btn" class="btn button th_pb_qty_all_bundles_list_loadmore_btn" data-nextpage="' + $th_data.nextpage + '" data-bundlecount="' + $th_data.bundle_count + '"><span class="button_text">' + wc_external_script_layout.language.btn_load_more + '</span> <em class="th_pb_add_to_cart_loader"></em></button>';
					$th_load_more_button += '</div>';
					document.querySelector('#th_pb_all_qty_bundle').insertAdjacentHTML('beforeend', $th_load_more_button);
					document.querySelectorAll('#th_pb_qty_all_bundles_list_loadmore_btn').forEach(function($th_button) {
						$th_button[$th_bundle_addEventListener]('click', function(event) {
							event.preventDefault(), event.stopImmediatePropagation();
							if (document.querySelectorAll('.th_pb_qty_all_bundles_list_loadmore_div').length > 0) {
								document.querySelector('.th_pb_qty_all_bundles_list_loadmore_div').remove();
							}
							$th_get_all_qty_bundles($th_button.getAttribute('data-nextpage'), $th_button.getAttribute('data-bundlecount'));
						});
					});
				}
			} else {
				if (document.querySelectorAll('.th_pb_qty_all_bundles_list_loadmore_div').length > 0) {
					document.querySelector('.th_pb_qty_all_bundles_list_loadmore_div').remove();
				}
			}
		}
		document.querySelector('#th_pb_all_qty_bundle').insertAdjacentHTML('beforeend', $th_loader_code);
		const $th_qty_get_bundle_ajax_data = {
			shop: $th_shop_conveted_url,
			all_quantity_bundles: 'all_quantity_bundles',
			currentpage: $th_qty_pageno,
			bundle_count: $th_qty_bundle_count,
			active_currency: $th_active_currency,
			active_country: $th_active_country
		};
		const $th_qty_bundle_class = '#th_pb_all_qty_bundle',
			$th_qty_bundle_code_place = '$th_bundle_append_code',
			$th_qty_specific_bundle = document.querySelector('#th_pb_all_qty_bundle');
		$th_all_bundle_new_ajax_request($th_qty_get_bundle_ajax_data, $th_qty_all_bundles_loadmore_function, $th_qty_bundle_class, $th_qty_bundle_code_place, $th_qty_specific_bundle, $th_qty_pageno, $th_qty_bundle_count);
	}
	if (document.querySelector('#th_pb_all_qty_bundle')) {
		$th_get_all_qty_bundles(1, 0);
	}
	const $th_fbt_bundle_total = function($th_fbt_this) {
		let $th_fbt_new_price = 0,
			$th_fbt_new_compare_price = 0,
			$th_fbt_check_count = 0,
			$th_fbt_variant_available = [];
		$th_fbt_this.querySelector('.th_pb_fbt_product_details_ul').querySelectorAll('.th_pb_fbt_product_details_li').forEach(function($th_fbt_grid, $th_fbt_idx) {
			if ($th_fbt_grid.querySelector('.th_pb_fbt_product_checkbox').checked) {
				$th_fbt_check_count++;
			}
		});
		$th_fbt_this.querySelectorAll('.th_pb_fbt_product_variant').forEach(function($th_fbt_product_variant, $th_fbt_idx) {
			const $th_this_fbt_enable = $th_fbt_product_variant.closest('.th_pb_fbt_product_details_li').querySelector('.th_pb_fbt_product_checkbox').checked ? true : false;
			const $th_this_fbt_discount = parseFloat($th_fbt_this.getAttribute('data-discount'));
			const $th_this_fbt_distype = parseFloat($th_fbt_this.getAttribute('data-distype'));
			const $th_this_fbt_minpro = parseFloat($th_fbt_this.getAttribute('data-minpro'));
			const $th_this_fbt_fixdiscount = parseFloat($th_fbt_this.getAttribute('data-fixdiscount'));
			if ($th_this_fbt_enable) {
				const $th_this_fbt_price = parseFloat($th_fbt_product_variant.options[$th_fbt_product_variant.selectedIndex].getAttribute('data-price'));
				const $th_this_fbt_compare_price = ($th_fbt_product_variant.options[$th_fbt_product_variant.selectedIndex].getAttribute('data-compare_price') && parseFloat($th_fbt_product_variant.options[$th_fbt_product_variant.selectedIndex].getAttribute('data-compare_price')) > 0) ? parseFloat($th_fbt_product_variant.options[$th_fbt_product_variant.selectedIndex].getAttribute('data-compare_price')) : parseFloat($th_fbt_product_variant.options[$th_fbt_product_variant.selectedIndex].getAttribute('data-price'));
				const $th_this_fbt_qty = parseInt($th_fbt_product_variant.options[$th_fbt_product_variant.selectedIndex].getAttribute('data-qty'));
				const $th_this_fbt_ptitle = $th_fbt_product_variant.options[$th_fbt_product_variant.selectedIndex].getAttribute('data-ptitle');
				const $th_this_fbt_vtitle = $th_fbt_product_variant.options[$th_fbt_product_variant.selectedIndex].getAttribute('data-title');
				const $th_this_fbt_available = JSON.parse($th_fbt_product_variant.options[$th_fbt_product_variant.selectedIndex].getAttribute('data-available'));
				if ($th_this_fbt_vtitle != 'Default Title' && $th_this_fbt_vtitle != 'Default') {
					$th_fbt_variant_available.push({
						product_title: $th_this_fbt_ptitle + ' (' + $th_this_fbt_vtitle + ')',
						variant_available: $th_this_fbt_available
					});
				} else {
					$th_fbt_variant_available.push({
						product_title: $th_this_fbt_ptitle,
						variant_available: $th_this_fbt_available
					});
				}
				$th_fbt_new_price = $th_fbt_new_price + ($th_this_fbt_price * $th_this_fbt_qty);
				$th_fbt_new_compare_price = $th_fbt_new_compare_price + ($th_this_fbt_compare_price * $th_this_fbt_qty);
			}
			if ($th_fbt_idx === ($th_fbt_this.querySelectorAll('.th_pb_fbt_product_variant').length - 1)) {
				if (($th_fbt_check_count >= $th_this_fbt_minpro) && ($th_this_fbt_discount > 0)) {
					if ($th_this_fbt_distype === 1) {
						$th_fbt_new_compare_price = $th_fbt_new_price;
						$th_fbt_new_price = $th_fbt_new_price - ($th_this_fbt_fixdiscount * 100);
					} else {
						$th_fbt_new_compare_price = $th_fbt_new_price;
						$th_fbt_new_price = ($th_fbt_new_price * $th_this_fbt_discount) / 100;
					}
				} else {
					$th_fbt_new_compare_price = 0;
				}
				if ($th_fbt_new_compare_price > $th_fbt_new_price) {
					$th_fbt_this.querySelector('.th_pb_fbt_product_total .th_pb_fbt_product_total_sale_price').innerHTML = '<span class="money transcy-money">' + $th_money_format($th_fbt_new_price, $th_shop_money) + '</span>';
					$th_fbt_this.querySelector('.th_pb_fbt_product_total .th_pb_fbt_product_total_old_price').innerHTML = '<span class="money transcy-money th_pb_line_through">' + $th_money_format($th_fbt_new_compare_price, $th_shop_money) + '</span>';
				} else {
					$th_fbt_this.querySelector('.th_pb_fbt_product_total .th_pb_fbt_product_total_sale_price').innerHTML = '<span class="money transcy-money">' + $th_money_format($th_fbt_new_price, $th_shop_money) + '</span>';
					$th_fbt_this.querySelector('.th_pb_fbt_product_total .th_pb_fbt_product_total_old_price').innerHTML = '';
				}
				let $th_fbt_enable_btn_click = true;
				let $th_fbt_not_available_products = new Array();
				$th_fbt_variant_available.forEach(function($th_variant_available_single, $th_array_idx) {
					if (!$th_variant_available_single.variant_available) {
						$th_fbt_enable_btn_click = false;
						$th_fbt_not_available_products.push($th_variant_available_single.product_title);
					}
					if ($th_array_idx === ($th_fbt_variant_available.length - 1)) {
						if ($th_fbt_enable_btn_click) {
							$th_fbt_this.querySelector('.th_fbt_ajax_error').innerHTML = '';
							$th_fbt_this.querySelector('.th_pb_fbt_product_atc_btn_click').classList.remove('th_pb_add_to_cart_disabled');
							if (!$th_fbt_this.querySelector('.th_pb_fbt_product_atc_btn_click').classList.toString().includes('th_pb_draft_product_disable')) {
								$th_fbt_this.querySelector('.th_pb_fbt_product_atc_btn_click').setAttribute('style', 'pointer-events:auto !important;');
							}
						} else {
							$th_fbt_not_available_products = [...new Set($th_fbt_not_available_products)];
							const $th_pb_error_msg = $th_fbt_this.querySelector('.th_fbt_ajax_error').getAttribute('data-msg');
							const $th_not_available_text = $th_fbt_not_available_products.join(' & ');
							$th_fbt_this.querySelector('.th_fbt_ajax_error').innerHTML = '<p class="th_ajax_error_cls">' + $th_pb_error_msg.replace('{{title}}', $th_not_available_text) + '</p>';
							$th_fbt_this.querySelector('.th_pb_fbt_product_atc_btn_click').classList.add('th_pb_add_to_cart_disabled');
							$th_fbt_this.querySelector('.th_pb_fbt_product_atc_btn_click').setAttribute('style', 'pointer-events:none !important;');
						}
					}
				});
			}
		});
	}
	const $th_fbt_bundle_change_event = function() {
		if (document.querySelector('.th_pb_fbt_product_variant')) {
			document.querySelectorAll('.th_pb_fbt_product_variant').forEach(function($th_pb_fbt_product_variant) {
				$th_pb_fbt_product_variant[$th_bundle_addEventListener]('change', function(event) {
					event.preventDefault(), event.stopImmediatePropagation();
					const $th_fbt_select_price = parseFloat($th_pb_fbt_product_variant.options[$th_pb_fbt_product_variant.selectedIndex].getAttribute('data-price'));
					const $th_fbt_select_compare_price = parseFloat($th_pb_fbt_product_variant.options[$th_pb_fbt_product_variant.selectedIndex].getAttribute('data-compare_price'));
					const $th_fbt_grid_index = $th_pb_fbt_product_variant.closest('.th_pb_fbt_product_details_li').getAttribute('data-index');
					$th_pb_fbt_product_variant.closest('.th_pb_fbt_content').querySelector('.th_pb_fbt_product_images_li[data-index="' + $th_fbt_grid_index + '"] img').setAttribute('src', $th_pb_fbt_product_variant.options[$th_pb_fbt_product_variant.selectedIndex].getAttribute('data-image'));
					const $th_fbt_html_price = $th_pb_fbt_product_variant.closest('.th_pb_fbt_product_details_li').querySelector('.th_pb_fbt_product_sale_price');
					const $th_fbt_html_compare_price = $th_pb_fbt_product_variant.closest('.th_pb_fbt_product_details_li').querySelector('.th_pb_fbt_product_old_price');
					const $th_fbt_free_label = $th_pb_fbt_product_variant.closest('.th_pb_fbt_product_details_li').querySelector('.th_pb_fbt_product_sale_price').getAttribute('data-free');
					if ($th_fbt_select_price > 0) {
						$th_fbt_html_price.innerHTML = '<span class="money transcy-money">' + $th_money_format($th_fbt_select_price, $th_shop_money) + '</span>';
					} else {
						$th_fbt_html_price.innerHTML = '<span class="money">' + $th_fbt_free_label + '</span>';
					}
					if ($th_fbt_select_compare_price > $th_fbt_select_price) {
						if ($th_fbt_html_compare_price) {
							$th_fbt_html_compare_price.innerHTML = '<span class="money transcy-money th_pb_line_through">' + $th_money_format($th_fbt_select_compare_price, $th_shop_money) + '</span>';
						} else {
							$th_fbt_html_price.insertAdjacentHTML('afterend', '<span class="th_pb_fbt_product_old_price"><span class="money transcy-money th_pb_line_through">' + $th_money_format($th_fbt_select_compare_price, $th_shop_money) + '</span></span>');
						}
					} else {
						if ($th_fbt_html_compare_price) {
							$th_fbt_html_compare_price.innerHTML = '';
						}
					}
					$th_fbt_bundle_total($th_pb_fbt_product_variant.closest('.th_pb_fbt_innercode'));
				});
			});
		}
		if (document.querySelector('.th_pb_fbt_product_checkbox')) {
			document.querySelectorAll('.th_pb_fbt_product_checkbox').forEach(function($th_pb_fbt_product_checkbox) {
				$th_pb_fbt_product_checkbox[$th_bundle_addEventListener]('change', function(event) {
					event.preventDefault(), event.stopImmediatePropagation();
					const $th_this_index = $th_pb_fbt_product_checkbox.closest('.th_pb_fbt_product_details_li').getAttribute('data-index');
					if ($th_pb_fbt_product_checkbox.checked) {
						$th_pb_fbt_product_checkbox.closest('.th_pb_fbt_innercode').querySelector('.th_pb_fbt_product_images_li[data-index="' + $th_this_index + '"]').setAttribute('style', 'display:inline-block !important;');
						$th_pb_fbt_product_checkbox.closest('.th_pb_fbt_innercode').querySelector('.th_pb_fbt_product_details_li[data-index="' + $th_this_index + '"]').setAttribute('style', 'opacity:1 !important;');
					} else {
						$th_pb_fbt_product_checkbox.closest('.th_pb_fbt_innercode').querySelector('.th_pb_fbt_product_images_li[data-index="' + $th_this_index + '"]').setAttribute('style', 'display:none !important;');
						$th_pb_fbt_product_checkbox.closest('.th_pb_fbt_innercode').querySelector('.th_pb_fbt_product_details_li[data-index="' + $th_this_index + '"]').setAttribute('style', 'opacity:0.5 !important;');
					}
					let $th_fbt_check_count = 0;
					$th_pb_fbt_product_checkbox.closest('.th_pb_fbt_product_details_ul').querySelectorAll('.th_pb_fbt_product_details_li').forEach(function($th_fbt_grid, $th_fbt_idx) {
						if ($th_fbt_grid.querySelector('.th_pb_fbt_product_checkbox').checked) {
							$th_fbt_check_count++;
						}
						if ($th_fbt_idx === ($th_pb_fbt_product_checkbox.closest('.th_pb_fbt_product_details_ul').querySelectorAll('.th_pb_fbt_product_details_li').length - 1)) {
							if ($th_fbt_check_count === 0) {
								$th_pb_fbt_product_checkbox.closest('.th_pb_fbt_innercode').querySelector('.th_pb_fbt_product_atc_btn_click').classList.add('th_pb_add_to_cart_disabled');
								$th_pb_fbt_product_checkbox.closest('.th_pb_fbt_innercode').querySelector('.th_pb_fbt_product_atc_btn_click').setAttribute('style', 'pointer-events:none !important;');
							}
						}
					});
					$th_fbt_bundle_total($th_pb_fbt_product_checkbox.closest('.th_pb_fbt_innercode'));
				});
			});
		}
	}
	const $th_fbt_addtocart_event = async function($th_fbt_button, $th_fbt_this_parents, $th_pb_fbt_bundle_id) {
		let $th_pb_fbt_id_array = new Array();
		const $th_bundle_fbt_uid = $th_bundle_addtocart_uniqueid();
		$th_fbt_this_parents.querySelectorAll('li.th_pb_fbt_product_details_li').forEach(function($th_grid_val, $th_grid_idx) {
			if ($th_grid_val.querySelector('.th_pb_fbt_product_checkbox').checked) {
				$th_pb_fbt_id_array.push({
					id: $th_fbt_this_parents.querySelector('.th_pb_fbt_product_select_' + $th_grid_idx).options[$th_fbt_this_parents.querySelector('.th_pb_fbt_product_select_' + $th_grid_idx).selectedIndex].value,
					quantity: parseInt($th_fbt_this_parents.querySelector('.th_pb_fbt_product_select_' + $th_grid_idx).options[$th_fbt_this_parents.querySelector('.th_pb_fbt_product_select_' + $th_grid_idx).selectedIndex].getAttribute('data-qty')),
					properties: {
						_th_bundle_fbt: $th_pb_fbt_bundle_id,
						_th_bundle_type: 'fbt',
						_th_bundle_uid: $th_bundle_fbt_uid
					}
				});
			}
		});
		const $th_pb_fbt_formData = {
			items: $th_pb_fbt_id_array
		};
		const $th_addtocart_result = await $th_bundle_cta_ajax_event($th_pb_fbt_formData).then($th_addtocart_response => {
			return $th_addtocart_response
		});
		if ($th_addtocart_result.items) {
			$th_bundle_cta_success_method($th_fbt_button, $th_addtocart_result);
		} else {
			$th_fbt_this_parents.querySelector('.th_fbt_ajax_error').innerHTML = '<p class="th_ajax_error_cls">' + $th_addtocart_result.errors + '</p>';
			$th_bundle_cta_loader_class($th_fbt_button, 'remove_loader', 'th_pb_btn_loading');
		}
	}
	const $th_fbt_cta_addtocart_event = async function($th_fbt_button) {
		$th_bundle_cta_loader_class($th_fbt_button, 'add_loader', 'th_pb_btn_loading');
		const $th_fbt_this_parents = $th_fbt_button.closest('.th_pb_fbt_innercode');
		const $th_pb_fbt_bundle_id = $th_fbt_this_parents.getAttribute('data-bundleid');
		$th_fbt_this_parents.querySelector('.th_fbt_ajax_error').innerHTML = '';
		$th_pb_click_analyst($th_pb_fbt_bundle_id);
		if ($th_fbt_button.getAttribute('data-checkout') == '1') {
			if ($th_fbt_button.getAttribute('data-dismode') == '1') {
				await $th_fbt_addtocart_event($th_fbt_button, $th_fbt_this_parents, $th_pb_fbt_bundle_id, '');
				$th_bundle_cta_loader_class($th_fbt_button, 'remove_loader', 'th_pb_btn_loading');
			} else {
				const $th_pb_fbt_bundle_items = new Object();
				let $th_pb_fbt_product_idx = 0;
				$th_fbt_this_parents.querySelectorAll('li.th_pb_fbt_product_details_li').forEach(async ($th_grid_val, $th_grid_idx) => {
					if ($th_grid_val.querySelector('.th_pb_fbt_product_checkbox').checked) {
						$th_pb_fbt_bundle_items[$th_pb_fbt_product_idx] = {
							product_id: $th_grid_val.getAttribute('data-pid'),
							variant_id: $th_fbt_this_parents.querySelector('.th_pb_fbt_product_select_' + $th_grid_idx).options[$th_fbt_this_parents.querySelector('.th_pb_fbt_product_select_' + $th_grid_idx).selectedIndex].value,
							quantity: parseInt($th_fbt_this_parents.querySelector('.th_pb_fbt_product_select_' + $th_grid_idx).options[$th_fbt_this_parents.querySelector('.th_pb_fbt_product_select_' + $th_grid_idx).selectedIndex].getAttribute('data-qty')),
							variant_key: $th_fbt_this_parents.querySelector('.th_pb_fbt_product_select_' + $th_grid_idx).options[$th_fbt_this_parents.querySelector('.th_pb_fbt_product_select_' + $th_grid_idx).selectedIndex].getAttribute('data-vkey'),
						};
						$th_pb_fbt_product_idx++;
						if ($th_grid_idx === ($th_fbt_this_parents.querySelectorAll('li.th_pb_fbt_product_details_li').length - 1)) {
							await $th_create_bundle_draft_order($th_shop_conveted_url, null, $th_pb_fbt_bundle_items, null, null, $th_pb_fbt_bundle_id, 'direct_checkout', $th_active_currency, null, null);
							$th_bundle_cta_loader_class($th_fbt_button, 'remove_loader', 'th_pb_btn_loading');
						}
					}
				});
			}
		} else {
			await $th_fbt_addtocart_event($th_fbt_button, $th_fbt_this_parents, $th_pb_fbt_bundle_id, '$th_cart_page_redirect');
			$th_bundle_cta_loader_class($th_fbt_button, 'remove_loader', 'th_pb_btn_loading');
		}
	}
	const $th_fbt_bundle_cta_event = function() {
		document.querySelectorAll('.th_pb_fbt_product_atc_btn_click').forEach(function($th_fbt_button) {
			$th_fbt_button[$th_bundle_addEventListener]('click', function(event) {
				event.preventDefault(), event.stopImmediatePropagation();
				$th_fbt_cta_addtocart_event($th_fbt_button);
			});
		});
	}
	const $th_fbt_product_img_html = function($th_fbt_result, $th_fbt_value) {
		let $th_fbt_pro_img_html = '';
		$th_fbt_value.product_list.forEach(function($th_fbt_pro_val, $th_fbt_pro_idx) {
			if ($th_fbt_pro_val.status.toLowerCase() !== 'draft') {
				const $th_fbt_product_image = $th_pb_p_grid_image($th_fbt_pro_val);
				$th_fbt_pro_img_html += '<li class="th_pb_fbt_product_images_li" data-index="' + $th_fbt_pro_idx + '"><figure class="th_pb_wf"><span>';
				$th_fbt_pro_img_html += '<img src="' + $th_fbt_product_image + '" class="th_pb_fbt_product_image_cls" alt="' + $th_fbt_pro_val.handle + '" />';
				$th_fbt_pro_img_html += '</span></figure></li>';
			}
		});
		return $th_fbt_pro_img_html;
	}
	const $th_fbt_product_listing_html = function($th_fbt_result, $th_fbt_value, $th_fbt_specific_bundle, $th_fbt_discount) {
		let $th_fbt_pro_listing_html = '';
		var $wc_index = 0;
		$th_fbt_value.product_list.forEach(function($th_fbt_pro_val, $th_fbt_pro_idx) {
			if ($th_fbt_pro_val.status.toLowerCase() !== 'draft') {
				let $th_fbt_product_product_image = $th_pb_p_grid_image($th_fbt_pro_val);
				let $th_fbt_product_sale_price = parseFloat($th_fbt_pro_val.variants[0].price) * 100;
				let $th_fbt_product_original_price = parseFloat($th_fbt_pro_val.variants[0].compare_at_price) * 100;
				$th_fbt_pro_listing_html += '<li class="th_pb_fbt_product_details_li" data-index="' + $wc_index + '" data-pid="' + $th_fbt_pro_val.id + '"><div class="th_pb_fbt_product_single_detail">';
				$th_fbt_pro_listing_html += '';
				$th_fbt_pro_listing_html += (parseInt($th_fbt_specific_bundle.getAttribute('data-thpid')) === parseInt($th_fbt_pro_val.id)) ? '<h6 class="th_pb_fbt_product_title th_pb_fbt_current_product_title"><label><input type="checkbox" class="th_pb_fbt_product_checkbox" value="' + $th_fbt_pro_val.id + '" checked="checked" /></label><span class="th_pb_fbt_this_product">' + wc_external_script_layout.language.fbt_this_item + ' </span><span class="th_pb_fbt_product_title_text">' + $th_fbt_pro_val.title + '</span></h6>' : '<h6 class="th_pb_fbt_product_title"><label><input type="checkbox" class="th_pb_fbt_product_checkbox" value="' + $th_fbt_pro_val.id + '" checked="checked" /></label><span class="th_pb_fbt_product_title_text"><a href="/products/' + $th_fbt_pro_val.handle + '" target="_blank">' + $th_fbt_pro_val.title + '</a></span></h6>';
				if ($th_fbt_pro_val.variants.length <= 1) {
					$th_fbt_pro_listing_html += '<select class="th_pb_fbt_product_variant th_pb_fbt_product_select_' + $wc_index + ' th_pb_fbt_product_select_hide" style="display:none !important;">';
					const $th_variant_available_status = $th_variant_instock_status($th_fbt_pro_val, $th_fbt_pro_val.variants[0]);
					$th_fbt_pro_listing_html += '<option value="' + $th_fbt_pro_val.variants[0].id + '" data-title="' + $th_fbt_pro_val.variants[0].title.replace(/"/g, "'") + '" data-ptitle="' + $th_fbt_pro_val.title + '" data-compare_price="' + $th_fbt_product_original_price + '" data-price="' + $th_fbt_product_sale_price + '" data-qty="' + $th_fbt_pro_val.selected_qty + '" data-image="' + $th_fbt_product_product_image + '" data-available="' + $th_variant_available_status + '">' + $th_fbt_pro_val.variants[0].title + '</option>';
					$th_fbt_pro_listing_html += '</select>';
				} else {
					$th_fbt_pro_listing_html += '<select class="th_pb_fbt_product_variant th_pb_fbt_product_select_' + $wc_index + '">';
					$th_fbt_pro_val.variants.forEach(function($th_fbt_variant_val, $th_fbt_variant_idx) {
						let $th_fbt_variant_sale_price = parseFloat($th_fbt_variant_val.price) * 100;
						let $th_fbt_variant_original_price = parseFloat($th_fbt_variant_val.compare_at_price) * 100;
						if ($th_fbt_variant_val.image !== undefined && $th_fbt_variant_val.image !== null) {
							$th_fbt_product_product_image = $th_image_resizer($th_fbt_variant_val.image.originalSrc, '600x');
						}
						const $th_variant_available_status = $th_variant_instock_status($th_fbt_pro_val, $th_fbt_variant_val);
						$th_fbt_pro_listing_html += '<option value="' + $th_fbt_variant_val.id + '" data-title="' + $th_fbt_variant_val.title.replace(/"/g, "'") + '" data-ptitle="' + $th_fbt_pro_val.title + '" data-compare_price="' + $th_fbt_variant_original_price + '" data-price="' + $th_fbt_variant_sale_price + '" data-qty="' + $th_fbt_pro_val.selected_qty + '" data-image="' + $th_fbt_product_product_image + '" data-available="' + $th_variant_available_status + '">' + $th_fbt_variant_val.title + '</option>';
					});
					$th_fbt_pro_listing_html += '</select>';
				}
				$th_fbt_pro_listing_html += '<span class="th_pb_fbt_product_price">';
				if ($th_fbt_product_sale_price > 0) {
					$th_fbt_pro_listing_html += '<span class="th_pb_fbt_product_sale_price" data-free="' + wc_external_script_layout.language.free_price + '"><span class="money transcy-money">' + $th_money_format($th_fbt_product_sale_price, $th_shop_money) + '</span></span>';
				} else {
					$th_fbt_pro_listing_html += '<span class="th_pb_fbt_product_sale_price" data-free="' + wc_external_script_layout.language.free_price + '"><span class="money">' + wc_external_script_layout.language.free_price + '</span></span>';
				}
				if ($th_fbt_product_original_price > $th_fbt_product_sale_price) {
					$th_fbt_pro_listing_html += '<span class="th_pb_fbt_product_old_price"><span class="money transcy-money th_pb_line_through">' + $th_money_format($th_fbt_product_original_price, $th_shop_money) + '</span></span>';
				}
				$th_fbt_pro_listing_html += '</span>';
				if (wc_external_script_layout.show_rivyo_widget == '1') {
					$th_fbt_pro_listing_html += $th_pb_p_grid_review($th_fbt_pro_val, '$th_fbt_bundle');
				}
				$th_fbt_pro_listing_html += '</div></li>';
				$wc_index++;
			} else {
				console.log('Rebolt Bundle--> This product is not available ', $th_fbt_pro_val);
			}
		});
		return $th_fbt_pro_listing_html;
	}
	const $th_fbt_layout_one = function($th_fbt_result, $th_fbt_value, $th_fbt_idx, $th_fbt_bundle_class, $th_fbt_bundle_code_place, $th_fbt_specific_bundle) {
		let $th_fbt_discount = 100 - parseFloat($th_fbt_value.bundle_detail.discount),
			$th_fbt_fixed_discount = $th_fbt_value.bundle_detail.fixed_discount;
		if ($th_fbt_value.bundle_detail.fbt_apply_discount == '0') {
			$th_fbt_discount = 100;
			$th_fbt_fixed_discount = 0;
		}
		let $th_fbt_bundle_html = '<div class="th_pb_wf th_pb_fbt_innercode" data-bundleid="' + $th_fbt_value.bundle_detail.id + '" data-discount="' + $th_fbt_discount + '" data-fixdiscount="' + $th_fbt_fixed_discount + '" data-distype="' + $th_fbt_value.bundle_detail.discount_type + '" data-minpro="' + $th_fbt_value.bundle_detail.min_product + '">';
		$th_fbt_bundle_html += $th_bundle_main_title($th_fbt_value, 'th_fbt_bundle_title', 'th_pb_wf th_pb_title', '', 'th_pb_title_description');
		$th_fbt_bundle_html += '<div class="th_pb_wf th_pb_fbt_content" data-plength="' + $th_fbt_value.product_list.length + '">';
		$th_fbt_bundle_html += '<div class="th_pb_wf th_pb_fbt_product_grid">';
		$th_fbt_bundle_html += '<div class="th_pb_fbt_product_grid_images"><ul class="th_pb_fbt_product_images_ul">';
		$th_fbt_bundle_html += $th_fbt_product_img_html($th_fbt_result, $th_fbt_value);
		$th_fbt_bundle_html += '</ul></div>';
		$th_fbt_bundle_html += '<div class="th_pb_fbt_product_atc">';
		$th_fbt_bundle_html += '<p class="th_pb_wf th_pb_fbt_product_total">';
		$th_fbt_bundle_html += '<span class="th_pb_fbt_product_total_text">' + wc_external_script_layout.language.total_price + '</span>';
		$th_fbt_bundle_html += '<span class="th_pb_fbt_product_total_sale_price"><span class="money transcy-money">' + $th_money_format(0, $th_shop_money) + '</span></span>';
		$th_fbt_bundle_html += '<span class="th_pb_fbt_product_total_old_price"><span class="money transcy-money th_pb_line_through">' + $th_money_format(0, $th_shop_money) + '</span></span>';
		$th_fbt_bundle_html += '</p>';
		var wc_fbt_total_available_products = $th_fbt_value.product_list.filter(item => item.status.toLowerCase() !== 'draft').length;
		var disable_button = '';
		if (wc_fbt_total_available_products < $th_fbt_value.bundle_detail.min_product) {
			disable_button = 'th_pb_draft_product_disable'
		}
		$th_fbt_bundle_html += '<p class="th_pb_wf th_pb_fbt_product_atc_btn">';
		$th_fbt_bundle_html += '<span class="btn button th_pb_fbt_product_atc_btn_click ' + disable_button + '" data-checkout="' + wc_external_script_layout.direct_checkout + '" data-dismode="' + wc_external_script_layout.discount_mode + '">';
		$th_fbt_bundle_html += '<span class="th_pb_fbt_product_atc_btn_text">' + $th_fbt_value.bundle_detail.button_text + '</span><em class="th_pb_add_to_cart_loader"></em>';
		$th_fbt_bundle_html += '</span>';
		$th_fbt_bundle_html += '</p>';
		$th_fbt_bundle_html += '<div class="th_pb_wf th_fbt_ajax_error" data-msg="' + wc_external_script_layout.language.not_available + '"></div>';
		$th_fbt_bundle_html += '</div>';
		$th_fbt_bundle_html += '</div>';
		$th_fbt_bundle_html += '<div class="th_pb_wf th_pb_fbt_product_details"><ul class="th_pb_wf th_pb_fbt_product_details_ul">';
		$th_fbt_bundle_html += $th_fbt_product_listing_html($th_fbt_result, $th_fbt_value, $th_fbt_specific_bundle, $th_fbt_discount);
		$th_fbt_bundle_html += '</ul></div>';
		$th_fbt_bundle_html += '</div>';
		$th_fbt_bundle_html += '</div>';
		return $th_fbt_bundle_html;
	}
	const $th_fbt_bundle_response_status = function($th_fbt_result, $th_fbt_bundle_class, $th_fbt_bundle_code_place, $th_fbt_specific_bundle) {
		if ($th_fbt_result.error != true) {
			$th_fbt_result.bundle_list.forEach(function($th_fbt_value, $th_fbt_idx) {
				let $th_pb_fbt_html = '';
				$th_pb_fbt_html += $th_fbt_layout_one($th_fbt_result, $th_fbt_value, $th_fbt_idx, $th_fbt_bundle_class, $th_fbt_bundle_code_place, $th_fbt_specific_bundle);
				if ($th_fbt_bundle_code_place == '$th_fbt_after_code') {
					if (wc_external_script_layout.automatic_show_bundle == '1') {
						$th_fbt_specific_bundle.insertAdjacentHTML('afterend', '<div class="th_pb_fbt_section" data-thpid="' + __st.rid + '">' + $th_pb_fbt_html + '</div>');
						const $th_fbt_apppend_this = document.querySelector('.th_pb_fbt_section[data-thpid="' + __st.rid + '"] .th_pb_fbt_innercode');
						$th_fbt_bundle_total($th_fbt_apppend_this);
					}
				} else {
					$th_fbt_specific_bundle.insertAdjacentHTML('beforeend', $th_pb_fbt_html);
					$th_fbt_bundle_total($th_fbt_specific_bundle.querySelector('.th_pb_fbt_innercode[data-bundleid="' + $th_fbt_value.bundle_detail.id + '"]'));
				}
				if (wc_external_script_layout.show_rivyo_widget == '1') {
					$th_bundle_rivyo_average_rating('.th_pb_fbt_rivyo_average_rating');
				}
				if ($th_fbt_idx === ($th_fbt_result.fbt_bundle_list.length - 1)) {
					$th_fbt_bundle_change_event();
					$th_fbt_bundle_cta_event();
				}
				if (typeof $th_bundle_success_callback === 'function') {
					$th_bundle_success_callback($th_fbt_value.bundle_detail.id, $th_fbt_result);
				}
			});
		}
	}
	class $wcpb_bb_section_class_function {
		constructor($wcpb_bb_json, $wcpb_bb_bundle_this, $wcpb_bb_bundle_layouts) {
			this.$wcpb_bb_api_json = $wcpb_bb_json;
			this.$wcpb_bb_section_this = $wcpb_bb_bundle_this;
			this.$wcpb_bb_layout_htmls = $wcpb_bb_bundle_layouts;
			if (this.$wcpb_bb_api_json.data) {
				this.$wcpb_bb_api_json.data.wc_bd_number = this.$wcpb_bb_api_json.wc_bd_number;
			}
		}
		$wcpb_bb_product_grid_price($wcpb_bb_pgrid_customized_temp_html, $wcpb_bb_pro_val) {
			const $wcpb_bb_grid_sale_price = '<span class="th_pb_main_price"><span class="money">' + $th_money_format($wcpb_bb_pro_val.v_price * 100, $th_shop_money) + "</span></span>";
			const $wcpb_bb_grid_compare_price = '<span class="th_pb_old_price"><span class="money th_pb_line_through">' + $th_money_format($wcpb_bb_pro_val.v_compare_price * 100, $th_shop_money) + "</span></span>";
			for (let i = 1; i <= ($wcpb_bb_pgrid_customized_temp_html.match(/[[wcpb_bb_pgrid_psaleprice]]/g) || []).length; i++) {
				$wcpb_bb_pgrid_customized_temp_html = $wcpb_bb_pgrid_customized_temp_html.replace("[[wcpb_bb_pgrid_psaleprice]]", $wcpb_bb_grid_sale_price);
			}
			for (let i = 1; i <= ($wcpb_bb_pgrid_customized_temp_html.match(/[[wcpb_bb_pgrid_pcompareprice]]/g) || []).length; i++) {
				$wcpb_bb_pgrid_customized_temp_html = $wcpb_bb_pgrid_customized_temp_html.replace("[[wcpb_bb_pgrid_pcompareprice]]", $wcpb_bb_pro_val && $wcpb_bb_pro_val.v_compare_price > $wcpb_bb_pro_val.v_price ? $wcpb_bb_grid_compare_price : "");
			}
			return $wcpb_bb_pgrid_customized_temp_html;
		}
		$wcpb_bb_product_grid_variants_html($wcpb_bb_pgrid_customized_temp_html, $wcpb_bb_pro_val) {
			const $wcpb_bb_variant_length_cls = $wcpb_bb_pro_val.variants && $wcpb_bb_pro_val.variants.length <= 1 ? "th_pb_cb_p_grid_variant_single" : "";
			let $wcpb_bb_variant_html = '<select class="th_pb_wf th_pb_cb_p_grid_main_variant ' + $wcpb_bb_variant_length_cls + '" aria-label="Select a variant for ' + $wcpb_bb_pro_val.title + '" value="' + $wcpb_bb_pro_val.selected_variant + '">';
			($wcpb_bb_pro_val.variants || []).map(($wcpb_bb_v_val, $wcpb_bb_v_idx) => {
				const $wcpb_bb_v_selected_true = $wcpb_bb_v_val.id == $wcpb_bb_pro_val.selected_variant ? 'selected="selected"' : "";
				if ($wcpb_bb_v_val && $wcpb_bb_v_val.inventory_management && $wcpb_bb_v_val.inventory_management.toLowerCase() == "shopify") {
					if ($wcpb_bb_v_val && $wcpb_bb_v_val.inventory_policy && $wcpb_bb_v_val.inventory_policy.toLowerCase() != "deny") {
						$wcpb_bb_variant_html += '<option value="' + $wcpb_bb_v_val.id + '" key="' + $wcpb_bb_v_idx + '" ' + $wcpb_bb_v_selected_true + ">" + $wcpb_bb_v_val.title + "</option>";
					} else {
						if ($wcpb_bb_v_val && $wcpb_bb_v_val.inventory_quantity > 0) {
							$wcpb_bb_variant_html += '<option value="' + $wcpb_bb_v_val.id + '" key="' + $wcpb_bb_v_idx + '" ' + $wcpb_bb_v_selected_true + ">" + $wcpb_bb_v_val.title + "</option>";
						}
					}
				} else {
					$wcpb_bb_variant_html += '<option value="' + $wcpb_bb_v_val.id + '" key="' + $wcpb_bb_v_idx + '" ' + $wcpb_bb_v_selected_true + ">" + $wcpb_bb_v_val.title + "</option>";
				}
			});
			$wcpb_bb_variant_html += "</select>";
			for (let i = 1; i <= ($wcpb_bb_pgrid_customized_temp_html.match(/[[wcpb_bb_pgrid_pvariants]]/g) || []).length; i++) {
				$wcpb_bb_pgrid_customized_temp_html = $wcpb_bb_pgrid_customized_temp_html.replace("[[wcpb_bb_pgrid_pvariants]]", $wcpb_bb_variant_html);
			}
			return $wcpb_bb_pgrid_customized_temp_html;
		}
		$wcpb_bb_product_grid_add_cta_html($wcpb_bb_pgrid_customized_temp_html, $wcpb_bb_pro_val, $wcpb_bb_variant_disable_btn, $wcpb_bb_disable_add_btn, $wcpb_bb_variant_sum) {
			const $wcpb_bb_pgrid_added_cls = (this.$wcpb_bb_api_json.wcpb_bb_single_section || []).some((y) => y.p_id === $wcpb_bb_pro_val.id) ? "th_pb_cb_added_grid" : "";
			let $wcpb_is_preselected_class = $wcpb_bb_pro_val.is_preselected ? "is_preselected" : "";
			const $wcpb_bb_variant_disable_btn_temp = $wcpb_bb_pro_val.selected_variant ? "" : "th_pb_cb_p_grid_add_disabled";
			let $wcpb_bb_product_grid_add_html = '<div class="th_pb_wf th_pb_cb_p_grid_add ' + $wcpb_bb_pgrid_added_cls + '">';
			$wcpb_bb_product_grid_add_html += '<button type="button" class="th_pb_wf btn  th_pb_cb_p_grid_add_btn ' + $wcpb_is_preselected_class + " " + $wcpb_bb_disable_add_btn + " " + $wcpb_bb_variant_disable_btn_temp + '">' + this.$wcpb_bb_api_json.grid_add_label + "</button>";
			$wcpb_bb_product_grid_add_html += '<div class="th_pb_wf btn  th_pb_cb_p_grid_add_qty">';
			$wcpb_bb_product_grid_add_html += '<button type="button" aria-label="minus" class="th_pb_cb_p_grid_add_qty_btn th_pb_cb_p_grid_add_qty_minus">';
			$wcpb_bb_product_grid_add_html += '<svg width="25px" height="25px" viewBox="0 -192 469.33333 469"><path d="m437.332031.167969h-405.332031c-17.664062 0-32 14.335937-32 32v21.332031c0 17.664062 14.335938 32 32 32h405.332031c17.664063 0 32-14.335938 32-32v-21.332031c0-17.664063-14.335937-32-32-32zm0 0" /></svg>';
			$wcpb_bb_product_grid_add_html += "</button>";
			$wcpb_bb_product_grid_add_html += '<span class="th_pb_cb_p_grid_add_qty_text">';
			$wcpb_bb_product_grid_add_html += "<em>" + $wcpb_bb_variant_sum + "</em>";
			$wcpb_bb_product_grid_add_html += "</span>";
			$wcpb_bb_product_grid_add_html += '<button type="button" aria-label="plus" class="th_pb_cb_p_grid_add_qty_btn th_pb_cb_p_grid_add_qty_plus ' + $wcpb_bb_disable_add_btn + " " + $wcpb_bb_variant_disable_btn_temp + '">';
			$wcpb_bb_product_grid_add_html += '<svg width="25px" height="25px" viewBox="0 0 492 492"><path d="M465.064,207.566l0.028,0H284.436V27.25c0-14.84-12.016-27.248-26.856-27.248h-23.116 c-14.836,0-26.904,12.408-26.904,27.248v180.316H26.908c-14.832,0-26.908,12-26.908,26.844v23.248 c0,14.832,12.072,26.78,26.908,26.78h180.656v180.968c0,14.832,12.064,26.592,26.904,26.592h23.116 c14.84,0,26.856-11.764,26.856-26.592V284.438h180.624c14.84,0,26.936-11.952,26.936-26.78V234.41 C492,219.566,479.904,207.566,465.064,207.566z" /></svg>';
			$wcpb_bb_product_grid_add_html += "</button>";
			$wcpb_bb_product_grid_add_html += "</div>";
			$wcpb_bb_product_grid_add_html += "</div>";
			for (let i = 1; i <= ($wcpb_bb_pgrid_customized_temp_html.match(/[[wcpb_bb_pgrid_paddbtn]]/g) || []).length; i++) {
				$wcpb_bb_pgrid_customized_temp_html = $wcpb_bb_pgrid_customized_temp_html.replace("[[wcpb_bb_pgrid_paddbtn]]", $wcpb_bb_product_grid_add_html);
			}
			return $wcpb_bb_pgrid_customized_temp_html;
		}
		$wcpb_bb_product_grid_html() {
			let $wcpb_bb_product_total_qty = (this.$wcpb_bb_api_json.wcpb_bb_single_section || []).reduce((a, b) => +a + b.added_qty, 0);
			const $wcpb_bb_disable_add_btn = parseInt(this.$wcpb_bb_api_json.max_product) && parseInt(this.$wcpb_bb_api_json.max_product) > 0 && parseInt(this.$wcpb_bb_api_json.max_product) === $wcpb_bb_product_total_qty ? "th_pb_cb_p_grid_add_disabled" : "";
			let $wcpb_bb_pgrid_html = "";
			(this.$wcpb_bb_api_json.products || []).map(
				($wcpb_bb_pro_val, $wcpb_bb_pro_idx) => {
					let $wcpb_bb_pgrid_customized_html = this.$wcpb_bb_layout_htmls.bb_p_grid_html;
					let $wcpb_bb_variant_disable_btn = true;
					let $wcpb_bb_product_img = "https://bundle.thimatic-apps.com/assets/img/no-product-image.svg";
					if (Object.keys($wcpb_bb_pro_val.image).length) {
						$wcpb_bb_product_img = $wcpb_bb_pro_val.image.src;
					}
					if (Object.keys($wcpb_bb_pro_val.images).length) {
						Object.keys($wcpb_bb_pro_val.images).map((key) => {
							let $wcpb_bb_selected_found = false;
							if (Object.keys($wcpb_bb_pro_val.images[key].variant_ids).length) {
								Object.keys($wcpb_bb_pro_val.images[key].variant_ids).map(
									(v_key) => {
										if ($wcpb_bb_pro_val.images[key].variant_ids[v_key] == $wcpb_bb_pro_val.selected_variant) {
											$wcpb_bb_selected_found = true;
										}
									});
							}
							if ($wcpb_bb_selected_found) {
								$wcpb_bb_product_img = $wcpb_bb_pro_val.images[key].src;
							}
						});
					}
					let $wcpb_bb_variant_sum = 0;
					(this.$wcpb_bb_api_json.wcpb_bb_single_section || []).map(
						(added_val) => {
							if (added_val.p_id == $wcpb_bb_pro_val.id) {
								$wcpb_bb_variant_sum = $wcpb_bb_variant_sum + added_val.added_qty;
							}
						});
					if ($wcpb_bb_pro_val.variants && $wcpb_bb_pro_val.variants.length <= 1) {
						if (
							($wcpb_bb_pro_val.status && $wcpb_bb_pro_val.status.toLowerCase() != "draft") || this.$wcpb_bb_api_json.disable_click == false) {
							if ($wcpb_bb_pro_val.variants[0] && $wcpb_bb_pro_val.variants[0].inventory_management && $wcpb_bb_pro_val.variants[0].inventory_management.toLowerCase() == "shopify") {
								if ($wcpb_bb_pro_val.variants[0] && $wcpb_bb_pro_val.variants[0].inventory_policy && $wcpb_bb_pro_val.variants[0].inventory_policy.toLowerCase() != "deny") {
									$wcpb_bb_variant_disable_btn = false;
								} else if ($wcpb_bb_pro_val.variants[0] && $wcpb_bb_pro_val.variants[0].inventory_quantity > 0) {
									$wcpb_bb_variant_disable_btn = false;
								}
							} else {
								$wcpb_bb_variant_disable_btn = false;
							}
						}
					} else {
						$wcpb_bb_variant_disable_btn = false;
					}
					let $wcpb_bb_pro_disabled = "";
					if ($wcpb_bb_pro_val.status == "DRAFT") {
						$wcpb_bb_pro_disabled = 'data-draft="true"';
					}
					for (let i = 1; i <= ($wcpb_bb_pgrid_customized_html.match(/[[wcpb_bb_pgrid_disabled]]/g) || []).length; i++) {
						$wcpb_bb_pgrid_customized_html = $wcpb_bb_pgrid_customized_html.replace("[[wcpb_bb_pgrid_disabled]]", $wcpb_bb_pro_disabled);
					}
					for (let i = 1; i <= ($wcpb_bb_pgrid_customized_html.match(/[[wcpb_bb_pgrid_url]]/g) || []).length; i++) {
						$wcpb_bb_pgrid_customized_html = $wcpb_bb_pgrid_customized_html.replace("[[wcpb_bb_pgrid_url]]", "/products/" + $wcpb_bb_pro_val.handle);
					}
					for (let i = 1; i <= ($wcpb_bb_pgrid_customized_html.match(/[[wcpb_bb_pgrid_img_url]]/g) || []).length; i++) {
						$wcpb_bb_pgrid_customized_html = $wcpb_bb_pgrid_customized_html.replace("[[wcpb_bb_pgrid_img_url]]", '<img src="' + $th_image_resizer($wcpb_bb_product_img, "400x") + '" alt="' + $wcpb_bb_pro_val.title + '" />');
					}
					for (let i = 1; i <= ($wcpb_bb_pgrid_customized_html.match(/[[wcpb_bb_pgrid_ptitle]]/g) || []).length; i++) {
						$wcpb_bb_pgrid_customized_html = $wcpb_bb_pgrid_customized_html.replace("[[wcpb_bb_pgrid_ptitle]]", $wcpb_bb_pro_val.title);
					}
					$wcpb_bb_pgrid_customized_html = this.$wcpb_bb_product_grid_price($wcpb_bb_pgrid_customized_html, $wcpb_bb_pro_val);
					$wcpb_bb_pgrid_customized_html = this.$wcpb_bb_product_grid_variants_html($wcpb_bb_pgrid_customized_html, $wcpb_bb_pro_val);
					$wcpb_bb_pgrid_customized_html = this.$wcpb_bb_product_grid_add_cta_html($wcpb_bb_pgrid_customized_html, $wcpb_bb_pro_val, $wcpb_bb_variant_disable_btn, $wcpb_bb_disable_add_btn, $wcpb_bb_variant_sum);
					$wcpb_bb_pgrid_html += $wcpb_bb_pgrid_customized_html;
				});
			return $wcpb_bb_pgrid_html;
		}
		$wcpb_bb_build_loadmore_btn() {
			let $wcpb_bb_build_loadmore_html = "";
			if (this.$wcpb_bb_api_json.next_product_page) {
				$wcpb_bb_build_loadmore_html += '<button type="button" aria-label="' + this.$wcpb_bb_api_json.language.buildbox_load_more + '" class="btn button th_pb_cb_p_grid_loadmore_btn" data-scroll="' + this.$wcpb_bb_api_json.btn_load_more + '">';
				$wcpb_bb_build_loadmore_html += '<span class="button_text">' + this.$wcpb_bb_api_json.language.buildbox_load_more + "</span>";
				$wcpb_bb_build_loadmore_html += '<em class="th_pb_add_to_cart_loader"></em>';
				$wcpb_bb_build_loadmore_html += "</button>";
			}
			return $wcpb_bb_build_loadmore_html;
		}
		$th_handle_multitier_min_max_msg(multitier_upcoming_discount, $wcpb_bb_final_total_or_$wcpb_bb_total_qty, th_temp_$wcpb_bb_section_this) {
			let th_multitier_min_max_message_text = th_temp_$wcpb_bb_section_this.querySelector(".th_multitier_min_max_message_text_wc");
			if (multitier_upcoming_discount != undefined) {
				//managing_multitier_min_max_msg
				let upcoming_discount_title = multitier_upcoming_discount.discount_title;
				if (this.$wcpb_bb_api_json.discount_type == "1") {
					//fixed_box_discount
					var th_upcoming_box_discount = $th_money_format(parseFloat(multitier_upcoming_discount.box_discount) * parseFloat(Shopify.currency.rate) * 100, $th_shop_money);
				} else {
					var th_upcoming_box_discount = `${multitier_upcoming_discount.box_discount}%`;
				}
				if (this.$wcpb_bb_api_json.discount_trigger == 0) {
					//discount_after_price_multitier
					let upcoming_discount_trigger_value = parseFloat(multitier_upcoming_discount.discount_trigger_value) * parseFloat(Shopify.currency.rate);
					let require_amount_to_trigger_upcoming_discount = upcoming_discount_trigger_value - $wcpb_bb_final_total_or_$wcpb_bb_total_qty;
					if (upcoming_discount_title != "") {
						upcoming_discount_title = upcoming_discount_title.replace("{{ threshold }}", `<span class="th_multitier_min_max_limit_msg_red_highlight_text_wc wc_glow_pricing">${$th_money_format(
                require_amount_to_trigger_upcoming_discount * 100,
                $th_shop_money
              )}</span>`);
						upcoming_discount_title = upcoming_discount_title.replace("{{ discount }}", `<span class="th_multitier_min_max_limit_msg_red_highlight_text_wc wc_glow_pricing">${th_upcoming_box_discount}</span>`);
						th_multitier_min_max_message_text.innerHTML = `<div>${upcoming_discount_title}<div>`;
						th_multitier_min_max_message_text.classList.remove("hide_th_multitier_min_max_message_text_wc");
					} else {
						th_multitier_min_max_message_text.classList.add("hide_th_multitier_min_max_message_text_wc");
					}
				} else {
					//discount_after_quanitity_multitier
					let upcoming_discount_trigger_value = parseFloat(multitier_upcoming_discount.discount_trigger_value);
					let require_quantity_to_trigger_upcoming_discount = upcoming_discount_trigger_value - $wcpb_bb_final_total_or_$wcpb_bb_total_qty;
					upcoming_discount_title = upcoming_discount_title.replace("{{ threshold }}", `<span class="th_multitier_min_max_limit_msg_red_highlight_text_wc wc_glow_pricing">${require_quantity_to_trigger_upcoming_discount}</span>`);
					upcoming_discount_title = upcoming_discount_title.replace("{{ discount }}", `<span class="th_multitier_min_max_limit_msg_red_highlight_text_wc wc_glow_pricing">${th_upcoming_box_discount}</span>`);
					th_multitier_min_max_message_text.innerHTML = `<div>${upcoming_discount_title}<div>`;
					th_multitier_min_max_message_text.classList.remove("hide_th_multitier_min_max_message_text_wc");
				}
			} else {
				//appending_text_msg_when_all_the_discounts_are_fulfilled
				th_multitier_min_max_message_text.innerHTML = `<div class="th_multitier_success_msg_wc">${this.$wcpb_bb_api_json.language.buildbox_tier_success_msg}</div>`;
			}
			return th_temp_$wcpb_bb_section_this.innerHTML;
		}
		$th_handle_multitier_discount_round_circles_highlight(which_circle_has_to_hightlight, $wcpb_bb_final_total_or_$wcpb_bb_total_qty, $wcpb_bb_main_temp_html) {
			let th_temp_$wcpb_bb_section_this = document.createElement("div");
			th_temp_$wcpb_bb_section_this.innerHTML = $wcpb_bb_main_temp_html;
			let th_multitier_round_circles = th_temp_$wcpb_bb_section_this.querySelectorAll(".th_round_circle_multitier_discount_wc");
			let th_multitier_min_max_message_text_wc = th_temp_$wcpb_bb_section_this.querySelector(".th_multitier_min_max_message_text_wc");
			if (which_circle_has_to_hightlight != undefined) {
				if (th_multitier_round_circles.length > 0) {
					th_multitier_round_circles.forEach((th_circle, th_circle_index) => {
						th_circle.classList.remove("th_round_circle_highlight_wc");
						th_circle.classList.remove("th_bb_previous_highlight_multitier_discount_circle");
						let th_multitier_straight_lines = th_circle.closest(".th_multitier_discount_round_cricle_step_containor_wc").querySelectorAll(".th_multitier_straight_line_wc");
						if (th_multitier_straight_lines.length > 0) th_multitier_straight_lines.forEach(th_multitier_straight_line => th_multitier_straight_line.classList.remove("th_multitier_straight_line_highlight_wc"));
						if (th_circle_index <= which_circle_has_to_hightlight && th_multitier_straight_lines.length > 0) {
							if (th_circle_index < which_circle_has_to_hightlight || which_circle_has_to_hightlight == this.$wcpb_bb_api_json.multi_tiered_discounts.length - 1) {
								th_multitier_straight_lines.forEach(th_multitier_straight_line => th_multitier_straight_line.classList.add("th_multitier_straight_line_highlight_wc"));
							} else {
								th_multitier_straight_lines[0].classList.add("th_multitier_straight_line_highlight_wc");
							}
						}
					});
					th_multitier_round_circles.forEach((circle, circle_index) => {
						if (circle_index < which_circle_has_to_hightlight) {
							circle.classList.add("th_bb_previous_highlight_multitier_discount_circle")
						}
					})
					th_multitier_round_circles[which_circle_has_to_hightlight].classList.add("th_round_circle_highlight_wc");
				}
				if (th_multitier_min_max_message_text_wc) {
					let multitier_upcoming_discount = this.$wcpb_bb_api_json.multi_tiered_discounts[parseFloat(which_circle_has_to_hightlight) + 1];
					return this.$th_handle_multitier_min_max_msg(multitier_upcoming_discount, $wcpb_bb_final_total_or_$wcpb_bb_total_qty, th_temp_$wcpb_bb_section_this);
				}
			} else {
				if (th_multitier_round_circles.length > 0) {
					th_multitier_round_circles.forEach(th_circle => {
						th_circle.classList.remove("th_round_circle_highlight_wc");
						let th_multitier_straight_lines = th_circle.closest(".th_multitier_discount_round_cricle_step_containor_wc").querySelectorAll(".th_multitier_straight_line_wc");
						if (th_multitier_straight_lines.length > 0) th_multitier_straight_lines.forEach(th_multitier_straight_line => th_multitier_straight_line.classList.remove("th_multitier_straight_line_highlight_wc"));
					});
				}
				if (th_multitier_min_max_message_text_wc) {
					return this.$th_handle_multitier_min_max_msg(this.$wcpb_bb_api_json.multi_tiered_discounts[0], $wcpb_bb_final_total_or_$wcpb_bb_total_qty, th_temp_$wcpb_bb_section_this);
				}
			}
		}
		$wcpb_bb_box_final_total_price($wcpb_bb_main_temp_html) {
			let $wcpb_bb_final_total = 0,
				$wcpb_bb_total_qty = 0,
				$wcpb_bb_older_total_price = 0;
			if (this.$wcpb_bb_api_json.bundle_structure_type == "1") {
				(this.$wcpb_bb_api_json.wcpb_bb_multi_section || []).map(
					($wcpb_bb_selected_items) => {
						let $wcpb_bb_temp_ms_total = ($wcpb_bb_selected_items.added_products || []).reduce((a, b) => +a + b.v_price * (b.added_qty || 0), 0);
						let $wcpb_bb_temp_ms_qty_total = ($wcpb_bb_selected_items.added_products || []).reduce((a, b) => +a + b.added_qty, 0);
						$wcpb_bb_final_total = $wcpb_bb_final_total + $wcpb_bb_temp_ms_total;
						$wcpb_bb_total_qty = $wcpb_bb_total_qty + $wcpb_bb_temp_ms_qty_total;
					});
			} else {
				$wcpb_bb_final_total = (this.$wcpb_bb_api_json.wcpb_bb_single_section || []).reduce((a, b) => +a + b.v_price * (b.added_qty || 0), 0);
				$wcpb_bb_total_qty = (this.$wcpb_bb_api_json.wcpb_bb_single_section || []).reduce((a, b) => +a + b.added_qty, 0);
			}
			if (this.$wcpb_bb_api_json.box_price && this.$wcpb_bb_api_json.use_fixed_price && parseInt(this.$wcpb_bb_api_json.use_fixed_price) === 1) {
				let current_currency_rate = parseFloat(Shopify.currency.rate);
				let box_price = parseFloat(this.$wcpb_bb_api_json.box_price);
				$wcpb_bb_final_total = box_price * current_currency_rate;
			}
			if (this.$wcpb_bb_api_json.use_discount && parseInt(this.$wcpb_bb_api_json.use_discount) === 1) {
				if (this.$wcpb_bb_api_json.use_discount_type && parseInt(this.$wcpb_bb_api_json.use_discount_type) === 0) {
					if (this.$wcpb_bb_api_json.flat_discount_type && parseInt(this.$wcpb_bb_api_json.flat_discount_type) == 0) {
						$wcpb_bb_older_total_price = $wcpb_bb_final_total;
						$wcpb_bb_final_total = ((100 - parseFloat(this.$wcpb_bb_api_json.flat_discount_value)) * parseFloat($wcpb_bb_final_total)) / 100;
					} else {
						$wcpb_bb_older_total_price = $wcpb_bb_final_total;
						$wcpb_bb_final_total = $wcpb_bb_final_total - parseFloat(this.$wcpb_bb_api_json.flat_discount_value) * parseFloat(Shopify.currency.rate);
					}
				} else if (this.$wcpb_bb_api_json.use_discount_type && parseInt(this.$wcpb_bb_api_json.use_discount_type) === 1) {
					if (this.$wcpb_bb_api_json.discount_trigger && parseInt(this.$wcpb_bb_api_json.discount_trigger) === 1) {
						if (this.$wcpb_bb_api_json.discount_trigger_value && parseInt($wcpb_bb_total_qty) >= parseInt(this.$wcpb_bb_api_json.discount_trigger_value)) {
							if (this.$wcpb_bb_api_json.discount_type && parseInt(this.$wcpb_bb_api_json.discount_type) === 0) {
								$wcpb_bb_older_total_price = $wcpb_bb_final_total;
								$wcpb_bb_final_total = ((100 - parseFloat(this.$wcpb_bb_api_json.box_discount)) * parseFloat($wcpb_bb_final_total)) / 100;
							} else {
								$wcpb_bb_older_total_price = $wcpb_bb_final_total;
								$wcpb_bb_final_total = $wcpb_bb_final_total - parseFloat(this.$wcpb_bb_api_json.box_discount) * parseFloat(Shopify.currency.rate);
							}
						}
					}
					if (this.$wcpb_bb_api_json.discount_trigger && parseInt(this.$wcpb_bb_api_json.discount_trigger) === 0) {
						if ($wcpb_bb_final_total && parseFloat($wcpb_bb_final_total) >= parseFloat(this.$wcpb_bb_api_json.discount_trigger_value) * parseFloat(Shopify.currency.rate)) {
							if (this.$wcpb_bb_api_json.discount_type && parseInt(this.$wcpb_bb_api_json.discount_type) === 0) {
								$wcpb_bb_older_total_price = $wcpb_bb_final_total;
								$wcpb_bb_final_total = ((100 - parseFloat(this.$wcpb_bb_api_json.box_discount)) * parseFloat($wcpb_bb_final_total)) / 100;
							} else {
								$wcpb_bb_older_total_price = $wcpb_bb_final_total;
								$wcpb_bb_final_total = $wcpb_bb_final_total - parseFloat(this.$wcpb_bb_api_json.box_discount) * parseFloat(Shopify.currency.rate);
							}
						}
					}
				} else {
					//multitier_discount
					let multi_tiered_discounts = this.$wcpb_bb_api_json.multi_tiered_discounts;
					let from_which_tier_section_need_to_apply_discount;
					multi_tiered_discounts.forEach((tier, index) => {
						if (this.$wcpb_bb_api_json.discount_trigger == 0) {
							//discount_after_price
							let discount_trigger_value = parseFloat(tier.discount_trigger_value) * parseFloat(Shopify.currency.rate);
							if (discount_trigger_value <= $wcpb_bb_final_total) {
								from_which_tier_section_need_to_apply_discount = index;
							}
						} else {
							//discount_after_quantity
							let discount_trigger_value = parseFloat(tier.discount_trigger_value);
							if (discount_trigger_value <= $wcpb_bb_total_qty) {
								from_which_tier_section_need_to_apply_discount = index;
							}
						}
					});
					if (this.$wcpb_bb_api_json.discount_trigger == 0) {
						//discount_after_price_multitier
						$wcpb_bb_main_temp_html = this.$th_handle_multitier_discount_round_circles_highlight(from_which_tier_section_need_to_apply_discount, $wcpb_bb_final_total, $wcpb_bb_main_temp_html);
						if (from_which_tier_section_need_to_apply_discount != undefined) {
							if ($wcpb_bb_final_total && parseFloat($wcpb_bb_final_total) >= parseFloat(multi_tiered_discounts[from_which_tier_section_need_to_apply_discount].discount_trigger_value) * parseFloat(Shopify.currency.rate)) {
								if (this.$wcpb_bb_api_json.discount_type && parseInt(this.$wcpb_bb_api_json.discount_type) === 0) {
									$wcpb_bb_older_total_price = $wcpb_bb_final_total;
									$wcpb_bb_final_total = ((100 - parseFloat(multi_tiered_discounts[from_which_tier_section_need_to_apply_discount].box_discount)) * parseFloat($wcpb_bb_final_total)) / 100;
								} else {
									$wcpb_bb_older_total_price = $wcpb_bb_final_total;
									$wcpb_bb_final_total = $wcpb_bb_final_total - parseFloat(multi_tiered_discounts[from_which_tier_section_need_to_apply_discount].box_discount) * parseFloat(Shopify.currency.rate);
								}
							}
						}
					} else {
						$wcpb_bb_main_temp_html = this.$th_handle_multitier_discount_round_circles_highlight(from_which_tier_section_need_to_apply_discount, $wcpb_bb_total_qty, $wcpb_bb_main_temp_html);
						if (from_which_tier_section_need_to_apply_discount != undefined) {
							if (parseInt($wcpb_bb_total_qty) >= parseInt(multi_tiered_discounts[from_which_tier_section_need_to_apply_discount].discount_trigger_value)) {
								if (this.$wcpb_bb_api_json.discount_type && parseInt(this.$wcpb_bb_api_json.discount_type) === 0) {
									$wcpb_bb_older_total_price = $wcpb_bb_final_total;
									$wcpb_bb_final_total = ((100 - parseFloat(multi_tiered_discounts[from_which_tier_section_need_to_apply_discount].box_discount)) * parseFloat($wcpb_bb_final_total)) / 100;
								} else {
									$wcpb_bb_older_total_price = $wcpb_bb_final_total;
									$wcpb_bb_final_total = $wcpb_bb_final_total - parseFloat(multi_tiered_discounts[from_which_tier_section_need_to_apply_discount].box_discount) * parseFloat(Shopify.currency.rate);
								}
							}
						}
					}
				}
			}
			if (this.$wcpb_bb_api_json.base_price && this.$wcpb_bb_api_json.use_base_price && parseInt(this.$wcpb_bb_api_json.use_base_price) === 1) {
				let wc_base_price = parseFloat(this.$wcpb_bb_api_json.base_price) * parseFloat(Shopify.currency.rate);
				$wcpb_bb_older_total_price = $wcpb_bb_older_total_price + wc_base_price;
				$wcpb_bb_final_total = parseFloat($wcpb_bb_final_total) + wc_base_price;
			}
			$wcpb_bb_final_total = $th_inprecise_round($wcpb_bb_final_total) * 1;
			$wcpb_bb_older_total_price = $th_inprecise_round($wcpb_bb_older_total_price) * 1;
			if ($wcpb_bb_older_total_price > $wcpb_bb_final_total) {
				$th_products_json.$wcpb_bb_applied_discount = true;
			}
			if ($wcpb_bb_final_total < 0) {
				$wcpb_bb_final_total = 0;
			}
			const $wcpb_bb_final_sale_price = '<span class="th_pb_main_price"><span class="money">' + $th_money_format($wcpb_bb_final_total.toFixed(2), $th_shop_money) + "</span></span>";
			const $wcpb_bb_final_compare_price = '<span class="th_pb_old_price"><span class="money th_pb_line_through">' + $th_money_format($wcpb_bb_older_total_price.toFixed(2), $th_shop_money) + "</span></span>";
			for (let i = 1; i <= ($wcpb_bb_main_temp_html.match(/[[wcpb_bb_box_final_sale_price]]/g) || []).length; i++) {
				$wcpb_bb_main_temp_html = $wcpb_bb_main_temp_html.replace("[[wcpb_bb_box_final_sale_price]]", $wcpb_bb_final_sale_price);
			}
			for (let i = 1; i <= ($wcpb_bb_main_temp_html.match(/[[wcpb_bb_box_final_compare_price]]/g) || []).length; i++) {
				$wcpb_bb_main_temp_html = $wcpb_bb_main_temp_html.replace("[[wcpb_bb_box_final_compare_price]]", $wcpb_bb_older_total_price > $wcpb_bb_final_total ? $wcpb_bb_final_compare_price : "");
			}
			if (typeof wcpb_total_price_update == "function") {
				wcpb_total_price_update($wcpb_bb_final_sale_price, $wcpb_bb_final_compare_price);
			}
			return $wcpb_bb_main_temp_html;
		}
		$wcpb_bb_limit_msg_html() {
			let $wcpb_bb_limit_msg_temp = "";
			if (this.$wcpb_bb_api_json.box_fixed_limit_msg && this.$wcpb_bb_api_json.min_product && this.$wcpb_bb_api_json.max_product) {
				$wcpb_bb_limit_msg_temp = this.$wcpb_bb_api_json.box_fixed_limit_msg.replaceAll("[[min]]", this.$wcpb_bb_api_json.min_product).replaceAll("[[max]]", this.$wcpb_bb_api_json.max_product);
			}
			return $wcpb_bb_limit_msg_temp;
		}
        $wcpb_bb_box_selected_grid_html() {
            let $wcpb_bb_sidecart_added_html = '';
            if (this.$wcpb_bb_api_json.bundle_structure_type == '1') {
                (this.$wcpb_bb_api_json.wcpb_bb_multi_section || []).map(($wcpb_bb_selected_items, $wcpb_bb_sidx) => {
                    ($wcpb_bb_selected_items.added_products || []).map(($wcpb_bb_added_val, $wcpb_bb_added_idx) => {
                        let $wcpb_bbms_sidecart_grid_temp_html = this.$wcpb_bb_layout_htmls.bb_selected_p_grid_html;
                        for (let i = 1; i <= ($wcpb_bbms_sidecart_grid_temp_html.match(/[[wcpb_bb_box_selected_pimg]]/g) || []).length; i++) {
                            $wcpb_bbms_sidecart_grid_temp_html = $wcpb_bbms_sidecart_grid_temp_html.replace('[[wcpb_bb_box_selected_pimg]]', '<img src="' + $th_image_resizer($wcpb_bb_added_val.variant_img, '200x') + '" alt="' + $wcpb_bb_added_val.p_title + '" />');
                        }
                        for (let i = 1; i <= ($wcpb_bbms_sidecart_grid_temp_html.match(/[[wcpb_bb_box_selected_ptitle]]/g) || []).length; i++) {
                            var prd_variant_title = $wcpb_bb_added_val.p_title;
                            if ($wcpb_bb_added_val.v_title != 'Default Title') {
                                prd_variant_title += '&nbsp;<span>(' + $wcpb_bb_added_val.v_title + ')</span>';
                            }
                            $wcpb_bbms_sidecart_grid_temp_html = $wcpb_bbms_sidecart_grid_temp_html.replace('[[wcpb_bb_box_selected_ptitle]]', prd_variant_title);
                        }
                        for (let i = 1; i <= ($wcpb_bbms_sidecart_grid_temp_html.match(/[[wcpb_bb_box_selected_pprice]]/g) || []).length; i++) {
                            $wcpb_bbms_sidecart_grid_temp_html = $wcpb_bbms_sidecart_grid_temp_html.replace('[[wcpb_bb_box_selected_pprice]]', '<span class="money">' + $th_money_format($wcpb_bb_added_val.v_price * 100, $th_shop_money) + '</span>');
                        }
                        for (let i = 1; i <= ($wcpb_bbms_sidecart_grid_temp_html.match(/[[wcpb_bb_box_selected_pqty]]/g) || []).length; i++) {
                            $wcpb_bbms_sidecart_grid_temp_html = $wcpb_bbms_sidecart_grid_temp_html.replace('[[wcpb_bb_box_selected_pqty]]', $wcpb_bb_added_val.added_qty);
                        }
                        const $wcpb_bb_box_selected_remove_btn = '<button type="button" class="th_pb_cb_sidecart_p_grid_remove_product" data-sid="' + $wcpb_bb_sidx + '" data-pid="' + $wcpb_bb_added_idx + '" aria-label="Remove ' + $wcpb_bb_added_val.p_title + '"><svg id="Capa_1" x="0px" y="0px" width="18px" height="18px" viewBox="0 0 468.067 468.067"><g><path d="M431.38,0.225H36.685C16.458,0.225,0,16.668,0,36.898v394.274c0,20.215,16.458,36.671,36.685,36.671H431.38 c20.232,0,36.688-16.456,36.688-36.671V36.898C468.062,16.668,451.612,0.225,431.38,0.225z M381.256,326.924 c14.233,14.239,14.233,37.321,0,51.53c-7.116,7.11-16.455,10.681-25.771,10.681c-9.327,0-18.643-3.57-25.747-10.681l-95.708-95.695 l-95.71,95.689c-7.105,7.11-16.42,10.681-25.742,10.681c-9.327,0-18.648-3.57-25.765-10.681c-14.236-14.215-14.236-37.291,0-51.524 l95.678-95.689l-95.678-95.704c-14.236-14.236-14.236-37.303,0-51.521c14.227-14.233,37.271-14.233,51.506,0l95.71,95.692 l95.708-95.692c14.232-14.233,37.285-14.233,51.518,0c14.233,14.218,14.233,37.285,0,51.521l-95.683,95.704L381.256,326.924z"/></g></svg></button>';
                        for (let i = 1; i <= ($wcpb_bbms_sidecart_grid_temp_html.match(/[[wcpb_bb_box_selected_remove_btn]]/g) || []).length; i++) {
                            $wcpb_bbms_sidecart_grid_temp_html = $wcpb_bbms_sidecart_grid_temp_html.replace('[[wcpb_bb_box_selected_remove_btn]]', $wcpb_bb_box_selected_remove_btn);
                        }
                        $wcpb_bb_sidecart_added_html += $wcpb_bbms_sidecart_grid_temp_html;
                    });
                });
            } else {
                (this.$wcpb_bb_api_json.wcpb_bb_single_section || []).map(($wcpb_bb_added_val, $wcpb_bb_added_idx) => {
                    let $wcpb_bb_sidecart_grid_temp_html = this.$wcpb_bb_layout_htmls.bb_selected_p_grid_html;
                    for (let i = 1; i <= ($wcpb_bb_sidecart_grid_temp_html.match(/[[wcpb_bb_box_selected_pimg]]/g) || []).length; i++) {
                        $wcpb_bb_sidecart_grid_temp_html = $wcpb_bb_sidecart_grid_temp_html.replace('[[wcpb_bb_box_selected_pimg]]', '<img src="' + $th_image_resizer($wcpb_bb_added_val.variant_img, '200x') + '" alt="' + $wcpb_bb_added_val.p_title + '" />');
                    }
                    for (let i = 1; i <= ($wcpb_bb_sidecart_grid_temp_html.match(/[[wcpb_bb_box_selected_ptitle]]/g) || []).length; i++) {
                        var prd_variant_title = $wcpb_bb_added_val.p_title;
                        if ($wcpb_bb_added_val.v_title != 'Default Title') {
                            prd_variant_title += '&nbsp;<span>' + $wcpb_bb_added_val.v_title + '</span>';
                        }
                        $wcpb_bb_sidecart_grid_temp_html = $wcpb_bb_sidecart_grid_temp_html.replace('[[wcpb_bb_box_selected_ptitle]]', prd_variant_title);
                    }
                    for (let i = 1; i <= ($wcpb_bb_sidecart_grid_temp_html.match(/[[wcpb_bb_box_selected_pprice]]/g) || []).length; i++) {
                        $wcpb_bb_sidecart_grid_temp_html = $wcpb_bb_sidecart_grid_temp_html.replace('[[wcpb_bb_box_selected_pprice]]', '<span class="money">' + $th_money_format($wcpb_bb_added_val.v_price * 100, $th_shop_money) + '</span>');
                    }
                    for (let i = 1; i <= ($wcpb_bb_sidecart_grid_temp_html.match(/[[wcpb_bb_box_selected_pqty]]/g) || []).length; i++) {
                        $wcpb_bb_sidecart_grid_temp_html = $wcpb_bb_sidecart_grid_temp_html.replace('[[wcpb_bb_box_selected_pqty]]', $wcpb_bb_added_val.added_qty);
                    }
                    const $wcpb_bb_box_selected_remove_btn = '<button type="button" class="th_pb_cb_sidecart_p_grid_remove_product" aria-label="Remove ' + $wcpb_bb_added_val.p_title + '"><svg id="Capa_1" x="0px" y="0px" width="18px" height="18px" viewBox="0 0 468.067 468.067"><g><path d="M431.38,0.225H36.685C16.458,0.225,0,16.668,0,36.898v394.274c0,20.215,16.458,36.671,36.685,36.671H431.38 c20.232,0,36.688-16.456,36.688-36.671V36.898C468.062,16.668,451.612,0.225,431.38,0.225z M381.256,326.924 c14.233,14.239,14.233,37.321,0,51.53c-7.116,7.11-16.455,10.681-25.771,10.681c-9.327,0-18.643-3.57-25.747-10.681l-95.708-95.695 l-95.71,95.689c-7.105,7.11-16.42,10.681-25.742,10.681c-9.327,0-18.648-3.57-25.765-10.681c-14.236-14.215-14.236-37.291,0-51.524 l95.678-95.689l-95.678-95.704c-14.236-14.236-14.236-37.303,0-51.521c14.227-14.233,37.271-14.233,51.506,0l95.71,95.692 l95.708-95.692c14.232-14.233,37.285-14.233,51.518,0c14.233,14.218,14.233,37.285,0,51.521l-95.683,95.704L381.256,326.924z"/></g></svg></button>';
                    for (let i = 1; i <= ($wcpb_bb_sidecart_grid_temp_html.match(/[[wcpb_bb_box_selected_remove_btn]]/g) || []).length; i++) {
                        $wcpb_bb_sidecart_grid_temp_html = $wcpb_bb_sidecart_grid_temp_html.replace('[[wcpb_bb_box_selected_remove_btn]]', $wcpb_bb_box_selected_remove_btn);
                    }
                    $wcpb_bb_sidecart_added_html += $wcpb_bb_sidecart_grid_temp_html;
                });
            }
            return $wcpb_bb_sidecart_added_html;
        }
		$wcpb_bb_final_atc_cta_btn() {
			let $wcpb_bb_total_qty = 0,
				$wcpb_bb_atc_cta_disable_cls = "th_pb_cb_sidecart_btn_disabled",
				$wcpb_bb_multisection_limit_array = [];
			if (this.$wcpb_bb_api_json.bundle_structure_type == "1") {
				(this.$wcpb_bb_api_json.wcpb_bb_multi_section || []).map(
					($wcpb_bb_selected_items) => {
						let $wcpb_bb_temp_ms_qty_total = ($wcpb_bb_selected_items.added_products || []).reduce((a, b) => +a + b.added_qty, 0);
						$wcpb_bb_total_qty = $wcpb_bb_total_qty + $wcpb_bb_temp_ms_qty_total;
						(this.$wcpb_bb_api_json.sections || []).map(
							($wcpb_bb_section_val) => {
								if ($wcpb_bb_section_val.section_id == $wcpb_bb_selected_items.section_id) {
									let $wcpb_bb_temp_section_qty_total = ($wcpb_bb_selected_items.added_products || []).reduce((a, b) => +a + b.added_qty, 0);
									if ($wcpb_bb_temp_section_qty_total >= $wcpb_bb_section_val.min_product) {
										$wcpb_bb_multisection_limit_array.push("1");
									} else {
										$wcpb_bb_multisection_limit_array.push("0");
									}
								}
							});
					});
				let $wcpb_bb_enable_ms_addtocart_btn = $wcpb_bb_multisection_limit_array.every(
					(val, i, arr) => val === arr[0] && val > 0);
				if ($wcpb_bb_multisection_limit_array && $wcpb_bb_multisection_limit_array.length > 0 && $wcpb_bb_multisection_limit_array.length === this.$wcpb_bb_api_json.sections.length && $wcpb_bb_enable_ms_addtocart_btn) {
					$wcpb_bb_atc_cta_disable_cls = "";
				}
			} else {
				$wcpb_bb_total_qty = (this.$wcpb_bb_api_json.wcpb_bb_single_section || []).reduce((a, b) => +a + b.added_qty, 0);
				$wcpb_bb_atc_cta_disable_cls = $wcpb_bb_total_qty < this.$wcpb_bb_api_json.min_product ? "th_pb_cb_sidecart_btn_disabled" : "";
			}
			let $wcpb_bb_atc_cta_cls = "wcpb_bb_atc_ss_cta_event";
			if (this.$wcpb_bb_api_json.bundle_sku_type == "1") {
				if (this.$wcpb_bb_api_json.bundle_structure_type == "1") {
					$wcpb_bb_atc_cta_cls = "wcpb_bb_atc_mm_cta_event";
				} else {
					$wcpb_bb_atc_cta_cls = "wcpb_bb_atc_sm_cta_event";
				}
			} else {
				if (this.$wcpb_bb_api_json.bundle_structure_type == "1") {
					$wcpb_bb_atc_cta_cls = "wcpb_bb_atc_ms_cta_event";
				}
			}
			let $wcpb_bb_atc_cta_html = '<button type="button" aria-label="' + this.$wcpb_bb_api_json.button_text + '" class="th_pb_wf btn button th_pb_cb_sidecart_btn_cls ' + $wcpb_bb_atc_cta_cls + " " + $wcpb_bb_atc_cta_disable_cls + '">';
			$wcpb_bb_atc_cta_html += '<span class="button_text">' + this.$wcpb_bb_api_json.button_text + "</span>";
			$wcpb_bb_atc_cta_html += '<em class="th_pb_add_to_cart_loader"></em>';
			$wcpb_bb_atc_cta_html += "</button>";
			return $wcpb_bb_atc_cta_html;
		}
		$wcpb_bb_single_variant_change() {
			if (document.querySelector(".th_pb_cb_p_grid_main_variant")) {
				document.querySelectorAll(".th_pb_cb_p_grid_main_variant").forEach(($wcpb_bb_variant_this, $wcpb_bb_variant_idx) => {
					$wcpb_bb_variant_this[$th_bundle_addEventListener]("change",
						(event) => {
							event.preventDefault(), event.stopImmediatePropagation();
							const $wcpb_bb_api_json_clone = [...this.$wcpb_bb_api_json.products, ];
							const $wcpb_bb_temp_obj = $wcpb_bb_api_json_clone[$wcpb_bb_variant_idx].variants.find(
								(variant_val) => variant_val.id == event.target.value);
							const $wcpb_bb_temp_product_obj = $wcpb_bb_api_json_clone[$wcpb_bb_variant_idx];
							$wcpb_bb_api_json_clone[$wcpb_bb_variant_idx].selected_variant = $wcpb_bb_temp_obj.id;
							$wcpb_bb_api_json_clone[$wcpb_bb_variant_idx].selected_variant_title = $wcpb_bb_temp_obj.title;
							$wcpb_bb_api_json_clone[$wcpb_bb_variant_idx].v_price = parseFloat($wcpb_bb_temp_obj.price);
							$wcpb_bb_api_json_clone[$wcpb_bb_variant_idx].v_orignal_price = parseFloat($wcpb_bb_temp_obj.orignal_price);
							$wcpb_bb_api_json_clone[$wcpb_bb_variant_idx].v_compare_price = parseFloat($wcpb_bb_temp_obj.compare_at_price);
							$wcpb_bb_api_json_clone[$wcpb_bb_variant_idx].variant_key = $wcpb_bb_temp_obj.variant_key;
							$wcpb_bb_api_json_clone[$wcpb_bb_variant_idx].variant_img = $wcpb_bb_temp_obj.image && $wcpb_bb_temp_obj.image.originalSrc ? $wcpb_bb_temp_obj.image.originalSrc : $wcpb_bb_temp_product_obj.variant_img;
							this.$wcpb_bb_api_json = {
								...this.$wcpb_bb_api_json,
								products: $wcpb_bb_api_json_clone,
							};
							const $wcpb_bb_bundle_parent_this = $wcpb_bb_variant_this.closest(".wc_pb_bb_section_id");
							let $wcpb_bb_build_init_json = new $wcpb_bb_section_class_function(this.$wcpb_bb_api_json, $wcpb_bb_bundle_parent_this, this.$wcpb_bb_layout_htmls);
							$wcpb_bb_build_init_json.$wcpb_bb_build_html_init();
							if (typeof $wc_single_section_variant_change == "function") {
								$wc_single_section_variant_change();
							}
						});
				});
			}
		}
        $wcpb_bb_ms_single_variant_change() {
            if (document.querySelector('.th_pb_cb_p_grid_main_variant')) {
                document.querySelectorAll('.th_pb_cb_p_grid_main_variant').forEach(($wcpb_bb_ms_variant_this, $wcpb_bb_ms_variant_idx) => {
                    $wcpb_bb_ms_variant_this[$th_bundle_addEventListener]('change', (event) => {
                        event.preventDefault(), event.stopImmediatePropagation();
                        const $wcpb_bb_ms_api_json_clone = [...this.$wcpb_bb_api_json.sections];
                        const $wcpb_bb_ms_temp_obj = $wcpb_bb_ms_api_json_clone[this.$wcpb_bb_api_json.wcpb_bb_selected_section_count].products[$wcpb_bb_ms_variant_idx].variants.find(($wcpb_bb_ms_variant_val) => $wcpb_bb_ms_variant_val.id == event.target.value);
                        const $wcpb_bb_ms_temp_product_obj = $wcpb_bb_ms_api_json_clone[this.$wcpb_bb_api_json.wcpb_bb_selected_section_count].products[$wcpb_bb_ms_variant_idx];
                        $wcpb_bb_ms_api_json_clone[this.$wcpb_bb_api_json.wcpb_bb_selected_section_count].products[$wcpb_bb_ms_variant_idx].selected_variant = event.target.value;
                        $wcpb_bb_ms_api_json_clone[this.$wcpb_bb_api_json.wcpb_bb_selected_section_count].products[$wcpb_bb_ms_variant_idx].selected_variant_title = $wcpb_bb_ms_temp_obj.title;
                        $wcpb_bb_ms_api_json_clone[this.$wcpb_bb_api_json.wcpb_bb_selected_section_count].products[$wcpb_bb_ms_variant_idx].v_price = parseFloat($wcpb_bb_ms_temp_obj.price);
                        $wcpb_bb_ms_api_json_clone[this.$wcpb_bb_api_json.wcpb_bb_selected_section_count].products[$wcpb_bb_ms_variant_idx].v_orignal_price = parseFloat($wcpb_bb_ms_temp_obj.orignal_price);
                        $wcpb_bb_ms_api_json_clone[this.$wcpb_bb_api_json.wcpb_bb_selected_section_count].products[$wcpb_bb_ms_variant_idx].v_compare_price = parseFloat($wcpb_bb_ms_temp_obj.compare_at_price);
                        $wcpb_bb_ms_api_json_clone[this.$wcpb_bb_api_json.wcpb_bb_selected_section_count].products[$wcpb_bb_ms_variant_idx].variant_key = $wcpb_bb_ms_temp_obj.variant_key;
                        $wcpb_bb_ms_api_json_clone[this.$wcpb_bb_api_json.wcpb_bb_selected_section_count].products[$wcpb_bb_ms_variant_idx].variant_img = ($wcpb_bb_ms_temp_obj.image && $wcpb_bb_ms_temp_obj.image.originalSrc) ? $wcpb_bb_ms_temp_obj.image.originalSrc : $wcpb_bb_ms_temp_product_obj.variant_img;
                        this.$wcpb_bb_api_json = { ...this.$wcpb_bb_api_json, sections: $wcpb_bb_ms_api_json_clone };
                        const $wcpb_bb_ms_bundle_parent_this = $wcpb_bb_ms_variant_this.closest('.wc_pb_bb_section_id');
                        let $wcpb_bb_ms_build_init_json = new $wcpb_bb_section_class_function(this.$wcpb_bb_api_json, $wcpb_bb_ms_bundle_parent_this, this.$wcpb_bb_layout_htmls);
                        $wcpb_bb_ms_build_init_json.$wcpb_bb_ms_build_html_init();

                        if (typeof $wc_multi_section_variant_change == 'function') {
                            $wc_multi_section_variant_change($wcpb_bb_ms_variant_this,$wcpb_bb_ms_temp_product_obj);
                        }
                    });
                });
            }
        }
		$wcpb_bb_single_add_event() {
			if (document.querySelector(".th_pb_cb_p_grid_add_btn")) {
				document.querySelectorAll(".th_pb_cb_p_grid_add_btn").forEach(($wcpb_bb_add_this, $wcpb_bb_add_idx) => {
					$wcpb_bb_add_this[$th_bundle_addEventListener]("click", (event) => {
						event.preventDefault(), event.stopImmediatePropagation();
						const $wcpb_bb_api_json_clone = [...this.$wcpb_bb_api_json.wcpb_bb_single_section, ];
						let $wcpb_bb_temp_obj = {
							p_id: this.$wcpb_bb_api_json.products[$wcpb_bb_add_idx].id,
							v_id: this.$wcpb_bb_api_json.products[$wcpb_bb_add_idx].selected_variant,
							p_title: this.$wcpb_bb_api_json.products[$wcpb_bb_add_idx].title,
							p_handle: this.$wcpb_bb_api_json.products[$wcpb_bb_add_idx].handle,
							v_title: this.$wcpb_bb_api_json.products[$wcpb_bb_add_idx].selected_variant_title === "Default Title" ? "" : this.$wcpb_bb_api_json.products[$wcpb_bb_add_idx].selected_variant_title,
							added_qty: 1,
							v_price: parseFloat(this.$wcpb_bb_api_json.products[$wcpb_bb_add_idx].v_price),
							v_orignal_price: parseFloat(this.$wcpb_bb_api_json.products[$wcpb_bb_add_idx].v_orignal_price),
							v_compare_price: parseFloat(this.$wcpb_bb_api_json.products[$wcpb_bb_add_idx].v_compare_price),
							variant_key: this.$wcpb_bb_api_json.products[$wcpb_bb_add_idx].variant_key,
							variant_img: this.$wcpb_bb_api_json.products[$wcpb_bb_add_idx].variant_img,
						};
						$wcpb_bb_api_json_clone.push($wcpb_bb_temp_obj);
						this.$wcpb_bb_api_json = {
							...this.$wcpb_bb_api_json,
							wcpb_bb_single_section: $wcpb_bb_api_json_clone,
						};
						const $wcpb_bb_bundle_parent_this = $wcpb_bb_add_this.closest(".wc_pb_bb_section_id");
						let $wcpb_bb_build_init_json = new $wcpb_bb_section_class_function(this.$wcpb_bb_api_json, $wcpb_bb_bundle_parent_this, this.$wcpb_bb_layout_htmls);
						$wcpb_bb_build_init_json.$wcpb_bb_build_html_init();
						if (typeof $th_add_item_to_box_single_section == "function") {
							$th_add_item_to_box_single_section();
						}
					});
				});
			}
			if (document.querySelector(".th_pb_cb_p_grid_add_qty_plus")) {
				document.querySelectorAll(".th_pb_cb_p_grid_add_qty_plus").forEach(($wcpb_bb_add_plus_this, $wcpb_bb_add_plus_idx) => {
					$wcpb_bb_add_plus_this[$th_bundle_addEventListener]("click",
						(event) => {
							event.preventDefault(), event.stopImmediatePropagation();
							const $wcpb_bb_api_json_clone = [...this.$wcpb_bb_api_json.wcpb_bb_single_section, ];
							const $wcpb_bb_temp_idx = $wcpb_bb_api_json_clone.findIndex(
								(x_val) => x_val.v_id === this.$wcpb_bb_api_json.products[$wcpb_bb_add_plus_idx].selected_variant);
							if ($wcpb_bb_temp_idx != -1) {
								$wcpb_bb_api_json_clone[$wcpb_bb_temp_idx].added_qty = $wcpb_bb_api_json_clone[$wcpb_bb_temp_idx].added_qty + 1;
							} else {
								let $wcpb_bb_temp_obj = {
									p_id: this.$wcpb_bb_api_json.products[$wcpb_bb_add_plus_idx].id,
									v_id: this.$wcpb_bb_api_json.products[$wcpb_bb_add_plus_idx].selected_variant,
									p_title: this.$wcpb_bb_api_json.products[$wcpb_bb_add_plus_idx].title,
									p_handle: this.$wcpb_bb_api_json.products[$wcpb_bb_add_plus_idx].handle,
									v_title: this.$wcpb_bb_api_json.products[$wcpb_bb_add_plus_idx].selected_variant_title === "Default Title" ? "" : this.$wcpb_bb_api_json.products[$wcpb_bb_add_plus_idx].selected_variant_title,
									added_qty: 1,
									v_price: parseFloat(this.$wcpb_bb_api_json.products[$wcpb_bb_add_plus_idx].v_price),
									v_orignal_price: parseFloat(this.$wcpb_bb_api_json.products[$wcpb_bb_add_plus_idx].v_orignal_price),
									v_compare_price: parseFloat(this.$wcpb_bb_api_json.products[$wcpb_bb_add_plus_idx].v_compare_price),
									variant_key: this.$wcpb_bb_api_json.products[$wcpb_bb_add_plus_idx].variant_key,
									variant_img: this.$wcpb_bb_api_json.products[$wcpb_bb_add_plus_idx].variant_img,
								};
								$wcpb_bb_api_json_clone.push($wcpb_bb_temp_obj);
							}
							this.$wcpb_bb_api_json = {
								...this.$wcpb_bb_api_json,
								wcpb_bb_single_section: $wcpb_bb_api_json_clone,
							};
							const $wcpb_bb_bundle_parent_this = $wcpb_bb_add_plus_this.closest(".wc_pb_bb_section_id");
							let $wcpb_bb_build_init_json = new $wcpb_bb_section_class_function(this.$wcpb_bb_api_json, $wcpb_bb_bundle_parent_this, this.$wcpb_bb_layout_htmls);
							$wcpb_bb_build_init_json.$wcpb_bb_build_html_init();
							if (typeof $th_plus_item_to_box_single_section == "function") {
								$th_plus_item_to_box_single_section();
							}
						});
				});
			}
			if (document.querySelector(".th_pb_cb_p_grid_add_qty_minus")) {
				document.querySelectorAll(".th_pb_cb_p_grid_add_qty_minus").forEach(($wcpb_bb_add_minus_this, $wcpb_bb_add_minus_idx) => {
					$wcpb_bb_add_minus_this[$th_bundle_addEventListener]("click",
						(event) => {
							event.preventDefault(), event.stopImmediatePropagation();
							let $wcpb_bb_api_json_clone = [...this.$wcpb_bb_api_json.wcpb_bb_single_section, ];
							const $wcpb_bb_temp_idx = $wcpb_bb_api_json_clone.findIndex(
								(x_val) => x_val.v_id === this.$wcpb_bb_api_json.products[$wcpb_bb_add_minus_idx].selected_variant);
							if ($wcpb_bb_temp_idx != -1) {
								$wcpb_bb_api_json_clone[$wcpb_bb_temp_idx].added_qty = $wcpb_bb_api_json_clone[$wcpb_bb_temp_idx].added_qty != 0 ? $wcpb_bb_api_json_clone[$wcpb_bb_temp_idx].added_qty - 1 : 0;
								$wcpb_bb_api_json_clone = $wcpb_bb_api_json_clone.filter(
									(val) => val.added_qty != 0);
								this.$wcpb_bb_api_json = {
									...this.$wcpb_bb_api_json,
									wcpb_bb_single_section: $wcpb_bb_api_json_clone,
								};
								const $wcpb_bb_bundle_parent_this = $wcpb_bb_add_minus_this.closest(".wc_pb_bb_section_id");
								let $wcpb_bb_build_init_json = new $wcpb_bb_section_class_function(this.$wcpb_bb_api_json, $wcpb_bb_bundle_parent_this, this.$wcpb_bb_layout_htmls);
								$wcpb_bb_build_init_json.$wcpb_bb_build_html_init();
							}
							if (typeof $th_minus_item_to_box_single_section == "function") {
								$th_minus_item_to_box_single_section();
							}
						});
				});
			}
			if (document.querySelector(".th_pb_cb_sidecart_p_grid_remove_product")) {
				document.querySelectorAll(".th_pb_cb_sidecart_p_grid_remove_product").forEach(($wcpb_bb_add_remove_this, $wcpb_bb_add_remove_idx) => {
					$wcpb_bb_add_remove_this[$th_bundle_addEventListener]("click",
						(event) => {
							event.preventDefault(), event.stopImmediatePropagation();
							let $wcpb_bb_api_json_clone = [...this.$wcpb_bb_api_json.wcpb_bb_single_section, ];
							const $wcpb_bb_temp_idx = $wcpb_bb_api_json_clone.findIndex(
								(x_val) => x_val.v_id === $wcpb_bb_api_json_clone[$wcpb_bb_add_remove_idx].v_id);
							if ($wcpb_bb_temp_idx != -1) {
								$wcpb_bb_api_json_clone[$wcpb_bb_temp_idx].added_qty = 0;
							}
							$wcpb_bb_api_json_clone = $wcpb_bb_api_json_clone.filter(
								(val) => val.added_qty != 0);
							this.$wcpb_bb_api_json = {
								...this.$wcpb_bb_api_json,
								wcpb_bb_single_section: $wcpb_bb_api_json_clone,
							};
							const $wcpb_bb_bundle_parent_this = $wcpb_bb_add_remove_this.closest(".wc_pb_bb_section_id");
							let $wcpb_bb_build_init_json = new $wcpb_bb_section_class_function(this.$wcpb_bb_api_json, $wcpb_bb_bundle_parent_this, this.$wcpb_bb_layout_htmls);
							$wcpb_bb_build_init_json.$wcpb_bb_build_html_init();
							if (typeof $th_remove_item_to_box_single_section == "function") {
								$th_remove_item_to_box_single_section();
							}
						});
				});
			}
		}
		$wcpb_bb_ms_single_add_event() {
			if (document.querySelector(".th_pb_cb_ms_p_grid_add_btn")) {
				document.querySelectorAll(".th_pb_cb_ms_p_grid_add_btn").forEach(($wcpb_bb_ms_add_this, $wcpb_bb_ms_add_idx) => {
					$wcpb_bb_ms_add_this[$th_bundle_addEventListener]("click",
						(event) => {
                            let th_pb_cb_p_grid_column=$wcpb_bb_ms_add_this.closest('.th_pb_cb_p_grid_column');
                            let th_bb_variant_option_containor=th_pb_cb_p_grid_column.querySelector(".th_bb_variant_option_containor");
                            localStorage.setItem('th_remember_last_variant_id',th_bb_variant_option_containor.dataset.prod_id);
                          
							event.preventDefault(), event.stopImmediatePropagation();
							let $wcpb_bb_ms_api_json_clone = [...this.$wcpb_bb_api_json.wcpb_bb_multi_section, ];
							let $wcpb_bb_ms_index = $wcpb_bb_ms_api_json_clone.findIndex(
								(x_val) => x_val.section_id === this.$wcpb_bb_api_json.sections[this.$wcpb_bb_api_json.wcpb_bb_selected_section_count].section_id);
							if ($wcpb_bb_ms_index != -1) {
								let $wcpb_bb_ms_product_obj = {
									p_id: this.$wcpb_bb_api_json.sections[this.$wcpb_bb_api_json.wcpb_bb_selected_section_count].products[$wcpb_bb_ms_add_idx].id,
									v_id: this.$wcpb_bb_api_json.sections[this.$wcpb_bb_api_json.wcpb_bb_selected_section_count].products[$wcpb_bb_ms_add_idx].selected_variant,
									p_title: this.$wcpb_bb_api_json.sections[this.$wcpb_bb_api_json.wcpb_bb_selected_section_count].products[$wcpb_bb_ms_add_idx].title,
									p_handle: this.$wcpb_bb_api_json.sections[this.$wcpb_bb_api_json.wcpb_bb_selected_section_count].products[$wcpb_bb_ms_add_idx].handle,
									v_title: this.$wcpb_bb_api_json.sections[this.$wcpb_bb_api_json.wcpb_bb_selected_section_count].products[$wcpb_bb_ms_add_idx].selected_variant_title === "Default Title" ? "" : this.$wcpb_bb_api_json.sections[this.$wcpb_bb_api_json.wcpb_bb_selected_section_count].products[$wcpb_bb_ms_add_idx].selected_variant_title,
									added_qty: 1,
									v_price: parseFloat(this.$wcpb_bb_api_json.sections[this.$wcpb_bb_api_json.wcpb_bb_selected_section_count].products[$wcpb_bb_ms_add_idx].v_price),
									v_orignal_price: parseFloat(this.$wcpb_bb_api_json.sections[this.$wcpb_bb_api_json.wcpb_bb_selected_section_count].products[$wcpb_bb_ms_add_idx].v_orignal_price),
									v_compare_price: parseFloat(this.$wcpb_bb_api_json.sections[this.$wcpb_bb_api_json.wcpb_bb_selected_section_count].products[$wcpb_bb_ms_add_idx].v_compare_price),
									variant_key: this.$wcpb_bb_api_json.sections[this.$wcpb_bb_api_json.wcpb_bb_selected_section_count].products[$wcpb_bb_ms_add_idx].variant_key,
									variant_img: this.$wcpb_bb_api_json.sections[this.$wcpb_bb_api_json.wcpb_bb_selected_section_count].products[$wcpb_bb_ms_add_idx].variant_img,
								};
								$wcpb_bb_ms_api_json_clone[$wcpb_bb_ms_index].added_products.push($wcpb_bb_ms_product_obj);
							} else {
								let $wcpb_bb_ms_added_product_array = [];
								let $wcpb_bb_ms_product_obj = {
									p_id: this.$wcpb_bb_api_json.sections[this.$wcpb_bb_api_json.wcpb_bb_selected_section_count].products[$wcpb_bb_ms_add_idx].id,
									v_id: this.$wcpb_bb_api_json.sections[this.$wcpb_bb_api_json.wcpb_bb_selected_section_count].products[$wcpb_bb_ms_add_idx].selected_variant,
									p_title: this.$wcpb_bb_api_json.sections[this.$wcpb_bb_api_json.wcpb_bb_selected_section_count].products[$wcpb_bb_ms_add_idx].title,
									p_handle: this.$wcpb_bb_api_json.sections[this.$wcpb_bb_api_json.wcpb_bb_selected_section_count].products[$wcpb_bb_ms_add_idx].handle,
									v_title: this.$wcpb_bb_api_json.sections[this.$wcpb_bb_api_json.wcpb_bb_selected_section_count].products[$wcpb_bb_ms_add_idx].selected_variant_title === "Default Title" ? "" : this.$wcpb_bb_api_json.sections[this.$wcpb_bb_api_json.wcpb_bb_selected_section_count].products[$wcpb_bb_ms_add_idx].selected_variant_title,
									added_qty: 1,
									v_price: parseFloat(this.$wcpb_bb_api_json.sections[this.$wcpb_bb_api_json.wcpb_bb_selected_section_count].products[$wcpb_bb_ms_add_idx].v_price),
									v_orignal_price: parseFloat(this.$wcpb_bb_api_json.sections[this.$wcpb_bb_api_json.wcpb_bb_selected_section_count].products[$wcpb_bb_ms_add_idx].v_orignal_price),
									v_compare_price: parseFloat(this.$wcpb_bb_api_json.sections[this.$wcpb_bb_api_json.wcpb_bb_selected_section_count].products[$wcpb_bb_ms_add_idx].v_compare_price),
									variant_key: this.$wcpb_bb_api_json.sections[this.$wcpb_bb_api_json.wcpb_bb_selected_section_count].products[$wcpb_bb_ms_add_idx].variant_key,
									variant_img: this.$wcpb_bb_api_json.sections[this.$wcpb_bb_api_json.wcpb_bb_selected_section_count].products[$wcpb_bb_ms_add_idx].variant_img,
								};
								$wcpb_bb_ms_added_product_array.push($wcpb_bb_ms_product_obj);
								let $wcpb_bb_ms_obj = {
									section_id: this.$wcpb_bb_api_json.sections[this.$wcpb_bb_api_json.wcpb_bb_selected_section_count].section_id,
									added_products: $wcpb_bb_ms_added_product_array,
								};
								$wcpb_bb_ms_api_json_clone.push($wcpb_bb_ms_obj);
							}
							this.$wcpb_bb_api_json = {
								...this.$wcpb_bb_api_json,
								wcpb_bb_multi_section: $wcpb_bb_ms_api_json_clone,
							};
							const $wcpb_bb_ms_bundle_parent_this = $wcpb_bb_ms_add_this.closest(".wc_pb_bb_section_id");
							let $wcpb_bb_ms_build_init_json = new $wcpb_bb_section_class_function(this.$wcpb_bb_api_json, $wcpb_bb_ms_bundle_parent_this, this.$wcpb_bb_layout_htmls);
							$wcpb_bb_ms_build_init_json.$wcpb_bb_ms_build_html_init();
							if (typeof $th_addtocart_button_click == "function") {
								$th_addtocart_button_click();
							}
						});
				});
			}
			if (document.querySelector(".th_pb_cb_ms_p_grid_add_qty_plus")) {
				document.querySelectorAll(".th_pb_cb_ms_p_grid_add_qty_plus").forEach(($wcpb_bb_ms_add_plus_this, $wcpb_bb_ms_add_plus_idx) => {
					$wcpb_bb_ms_add_plus_this[$th_bundle_addEventListener]("click",
						(event) => {
                            let th_pb_cb_p_grid_column=$wcpb_bb_ms_add_plus_this.closest('.th_pb_cb_p_grid_column');
                            let th_bb_variant_option_containor=th_pb_cb_p_grid_column.querySelector(".th_bb_variant_option_containor");
                            localStorage.setItem('th_remember_last_variant_id',th_bb_variant_option_containor.dataset.prod_id);
                          
							let $wcpb_bb_ms_total_qty = 0;
							let $wcpb_bb_ms_api_json_clone = [...this.$wcpb_bb_api_json.wcpb_bb_multi_section, ];
							let $wcpb_bb_ms_index = $wcpb_bb_ms_api_json_clone.findIndex(
								(x_val) => x_val.section_id === this.$wcpb_bb_api_json.sections[this.$wcpb_bb_api_json.wcpb_bb_selected_section_count].section_id);
							if ($wcpb_bb_ms_index != -1) {
								$wcpb_bb_ms_total_qty = (this.$wcpb_bb_api_json.wcpb_bb_multi_section[$wcpb_bb_ms_index].added_products || []).reduce((a, b) => +a + b.added_qty, 0);
								const $wcpb_bb_ms_disable_add_btn = parseInt(this.$wcpb_bb_api_json.sections[$wcpb_bb_ms_index].max_product) === $wcpb_bb_ms_total_qty && parseInt(this.$wcpb_bb_api_json.sections[$wcpb_bb_ms_index].max_product) && parseInt(this.$wcpb_bb_api_json.sections[$wcpb_bb_ms_index].max_product) > 0 ? true : false;
								if (!$wcpb_bb_ms_disable_add_btn) {
									let $wcpb_bb_ms_product_index = $wcpb_bb_ms_api_json_clone[$wcpb_bb_ms_index].added_products.findIndex(
										(y_val) => y_val.v_id === this.$wcpb_bb_api_json.sections[$wcpb_bb_ms_index].products[$wcpb_bb_ms_add_plus_idx].selected_variant);
									if ($wcpb_bb_ms_product_index != -1) {
										$wcpb_bb_ms_api_json_clone[$wcpb_bb_ms_index].added_products[$wcpb_bb_ms_product_index].added_qty = $wcpb_bb_ms_api_json_clone[$wcpb_bb_ms_index].added_products[$wcpb_bb_ms_product_index].added_qty + 1;
									} else {
										let $wcpb_bb_ms_product_obj = {
											p_id: this.$wcpb_bb_api_json.sections[this.$wcpb_bb_api_json.wcpb_bb_selected_section_count].products[$wcpb_bb_ms_add_plus_idx].id,
											v_id: this.$wcpb_bb_api_json.sections[this.$wcpb_bb_api_json.wcpb_bb_selected_section_count].products[$wcpb_bb_ms_add_plus_idx].selected_variant,
											p_title: this.$wcpb_bb_api_json.sections[this.$wcpb_bb_api_json.wcpb_bb_selected_section_count].products[$wcpb_bb_ms_add_plus_idx].title,
											p_handle: this.$wcpb_bb_api_json.sections[this.$wcpb_bb_api_json.wcpb_bb_selected_section_count].products[$wcpb_bb_ms_add_plus_idx].handle,
											v_title: this.$wcpb_bb_api_json.sections[this.$wcpb_bb_api_json.wcpb_bb_selected_section_count].products[$wcpb_bb_ms_add_plus_idx].selected_variant_title === "Default Title" ? "" : this.$wcpb_bb_api_json.sections[this.$wcpb_bb_api_json.wcpb_bb_selected_section_count].products[$wcpb_bb_ms_add_plus_idx].selected_variant_title,
											added_qty: 1,
											v_price: parseFloat(this.$wcpb_bb_api_json.sections[this.$wcpb_bb_api_json.wcpb_bb_selected_section_count].products[$wcpb_bb_ms_add_plus_idx].v_price),
											v_orignal_price: parseFloat(this.$wcpb_bb_api_json.sections[this.$wcpb_bb_api_json.wcpb_bb_selected_section_count].products[$wcpb_bb_ms_add_plus_idx].v_orignal_price),
											v_compare_price: parseFloat(this.$wcpb_bb_api_json.sections[this.$wcpb_bb_api_json.wcpb_bb_selected_section_count].products[$wcpb_bb_ms_add_plus_idx].v_compare_price),
											variant_key: this.$wcpb_bb_api_json.sections[this.$wcpb_bb_api_json.wcpb_bb_selected_section_count].products[$wcpb_bb_ms_add_plus_idx].variant_key,
											variant_img: this.$wcpb_bb_api_json.sections[this.$wcpb_bb_api_json.wcpb_bb_selected_section_count].products[$wcpb_bb_ms_add_plus_idx].variant_img,
										};
										$wcpb_bb_ms_api_json_clone[$wcpb_bb_ms_index].added_products.push($wcpb_bb_ms_product_obj);
									}
								}
							}
							this.$wcpb_bb_api_json = {
								...this.$wcpb_bb_api_json,
								wcpb_bb_multi_section: $wcpb_bb_ms_api_json_clone,
							};
							const $wcpb_bb_ms_bundle_parent_this = $wcpb_bb_ms_add_plus_this.closest(".wc_pb_bb_section_id");
							let $wcpb_bb_ms_build_init_json = new $wcpb_bb_section_class_function(this.$wcpb_bb_api_json, $wcpb_bb_ms_bundle_parent_this, this.$wcpb_bb_layout_htmls);
							$wcpb_bb_ms_build_init_json.$wcpb_bb_ms_build_html_init();
							if (typeof $th_add_plus_button_click == "function") {
								$th_add_plus_button_click();
							}
						});
				});
			}
			if (document.querySelector(".th_pb_cb_ms_p_grid_add_qty_minus")) {
				document.querySelectorAll(".th_pb_cb_ms_p_grid_add_qty_minus").forEach(($wcpb_bb_ms_add_minus_this, $wcpb_bb_ms_add_minus_idx) => {
					$wcpb_bb_ms_add_minus_this[$th_bundle_addEventListener]("click",
						(event) => {
                            let th_pb_cb_p_grid_column=$wcpb_bb_ms_add_minus_this.closest('.th_pb_cb_p_grid_column');
                            let th_bb_variant_option_containor=th_pb_cb_p_grid_column.querySelector(".th_bb_variant_option_containor");
                            localStorage.setItem('th_remember_last_variant_id',th_bb_variant_option_containor.dataset.prod_id);
							let $wcpb_bb_ms_api_json_clone = [...this.$wcpb_bb_api_json.wcpb_bb_multi_section, ];
							let $wcpb_bb_ms_index = $wcpb_bb_ms_api_json_clone.findIndex(
								(x_val) => x_val.section_id === this.$wcpb_bb_api_json.sections[this.$wcpb_bb_api_json.wcpb_bb_selected_section_count].section_id);
							if ($wcpb_bb_ms_index != -1) {
								let $wcpb_bb_ms_product_index = $wcpb_bb_ms_api_json_clone[$wcpb_bb_ms_index].added_products.findIndex(
									(y_val) => y_val.v_id === this.$wcpb_bb_api_json.sections[$wcpb_bb_ms_index].products[$wcpb_bb_ms_add_minus_idx].selected_variant);
								if ($wcpb_bb_ms_product_index != -1) {
									$wcpb_bb_ms_api_json_clone[$wcpb_bb_ms_index].added_products[$wcpb_bb_ms_product_index].added_qty = $wcpb_bb_ms_api_json_clone[$wcpb_bb_ms_index].added_products[$wcpb_bb_ms_product_index].added_qty != 0 ? $wcpb_bb_ms_api_json_clone[$wcpb_bb_ms_index].added_products[$wcpb_bb_ms_product_index].added_qty - 1 : 0;
									let $wcpb_bb_ms_temp_array = [...$wcpb_bb_ms_api_json_clone[$wcpb_bb_ms_index].added_products, ];
									$wcpb_bb_ms_temp_array = $wcpb_bb_ms_temp_array.filter(
										(val) => val.added_qty != 0);
									$wcpb_bb_ms_api_json_clone[$wcpb_bb_ms_index].added_products = $wcpb_bb_ms_temp_array;
								}
							}
							this.$wcpb_bb_api_json = {
								...this.$wcpb_bb_api_json,
								wcpb_bb_multi_section: $wcpb_bb_ms_api_json_clone,
							};
							const $wcpb_bb_ms_bundle_parent_this = $wcpb_bb_ms_add_minus_this.closest(".wc_pb_bb_section_id");
							let $wcpb_bb_ms_build_init_json = new $wcpb_bb_section_class_function(this.$wcpb_bb_api_json, $wcpb_bb_ms_bundle_parent_this, this.$wcpb_bb_layout_htmls);
							$wcpb_bb_ms_build_init_json.$wcpb_bb_ms_build_html_init();
						});
				});
			}
			if (document.querySelector(".th_pb_cb_ms_next_btn")) {
				document.querySelectorAll(".th_pb_cb_ms_next_btn").forEach(($wcpb_bb_ms_add_next_this, $wcpb_bb_ms_add_next_idx) => {
					$wcpb_bb_ms_add_next_this[$th_bundle_addEventListener]("click", async (event) => {
						event.preventDefault(), event.stopImmediatePropagation();
                        localStorage.setItem('th_remember_last_variant_id','');
						if (!$wcpb_bb_ms_add_next_this.classList.contains("th_pb_btn_loading")) {
							$wcpb_bb_ms_add_next_this.classList.add("th_pb_btn_loading");
						}
						if ($wcpb_bb_ms_add_next_this.classList.contains("th_pb_cb_ms_next_buy_btn")) {
							const $wcpb_this_parent = $wcpb_bb_ms_add_next_this.closest(".wc_pb_bb_section_id");
							if ($wcpb_this_parent.querySelector(".th_pb_cb_sidecart_btn_cls").classList.contains("wcpb_bb_atc_ms_cta_event")) {
								document.querySelector(".wcpb_bb_atc_ms_cta_event").dispatchEvent(new Event("click"));
							} else {
								document.querySelector(".wcpb_bb_atc_mm_cta_event").dispatchEvent(new Event("click"));
							}
						} else {
							let $wcpb_bb_ms_count = this.$wcpb_bb_api_json.sections.length - 1 > this.$wcpb_bb_api_json.wcpb_bb_selected_section_count ? this.$wcpb_bb_api_json.wcpb_bb_selected_section_count + 1 : this.$wcpb_bb_api_json.wcpb_bb_selected_section_count;
							if ($wcpb_bb_ms_count > this.$wcpb_bb_api_json.wcpb_bb_selected_section_count) {
								const $wcpb_bb_ms_section_id = this.$wcpb_bb_api_json.sections[$wcpb_bb_ms_count].section_id;
								let $wcpb_bb_ms_api_json_clone = [...this.$wcpb_bb_api_json.wcpb_bb_multi_section, ];
								if (this.$wcpb_bb_api_json.sections[$wcpb_bb_ms_count].products == 0) {
									this.$wcpb_bb_api_json = {
										...this.$wcpb_bb_api_json,
										wcpb_bb_selected_section_count: $wcpb_bb_ms_count,
									};
									await this.$wcpb_bb_loadmore_fetch_event($wcpb_bb_ms_add_next_this, this.$wcpb_bb_api_json.sections[$wcpb_bb_ms_count].section_id, true, 0, this.$wcpb_bb_api_json.wcpb_bb_selected_section_count);
								} else {
									this.$wcpb_bb_api_json = {
										...this.$wcpb_bb_api_json,
										wcpb_bb_selected_section_count: $wcpb_bb_ms_count,
									};
									const $wcpb_bb_bundle_parent_this = $wcpb_bb_ms_add_next_this.closest(".wc_pb_bb_section_id");
									let $wcpb_bb_build_init_json = new $wcpb_bb_section_class_function(this.$wcpb_bb_api_json, $wcpb_bb_bundle_parent_this, this.$wcpb_bb_layout_htmls);
									$wcpb_bb_build_init_json.$wcpb_bb_ms_build_html_init();
								}
							}
						}
					});
				});
			}
			if (document.querySelector(".th_pb_cb_ms_previous_btn")) {
				document.querySelectorAll(".th_pb_cb_ms_previous_btn").forEach(
					($wcpb_bb_ms_add_previous_this, $wcpb_bb_ms_add_previous_idx) => {
						$wcpb_bb_ms_add_previous_this[$th_bundle_addEventListener]("click",
							(event) => {
								event.preventDefault(), event.stopImmediatePropagation();
								if (!$wcpb_bb_ms_add_previous_this.classList.contains("th_pb_btn_loading")) {
									$wcpb_bb_ms_add_previous_this.classList.add("th_pb_btn_loading");
								}
								let $wcpb_bb_ms_count = this.$wcpb_bb_api_json.wcpb_bb_selected_section_count != 0 ? this.$wcpb_bb_api_json.wcpb_bb_selected_section_count - 1 : 0;
								this.$wcpb_bb_api_json = {
									...this.$wcpb_bb_api_json,
									wcpb_bb_selected_section_count: $wcpb_bb_ms_count,
								};
								const $wcpb_bb_ms_bundle_parent_this = $wcpb_bb_ms_add_previous_this.closest(".wc_pb_bb_section_id");
								let $wcpb_bb_ms_build_init_json = new $wcpb_bb_section_class_function(this.$wcpb_bb_api_json, $wcpb_bb_ms_bundle_parent_this, this.$wcpb_bb_layout_htmls);
								$wcpb_bb_ms_build_init_json.$wcpb_bb_ms_build_html_init();
							});
					});
			}
			if (document.querySelector(".th_pb_cb_sidecart_p_grid_remove_product")) {
				document.querySelectorAll(".th_pb_cb_sidecart_p_grid_remove_product").forEach(($wcpb_bb_ms_add_remove_this, $wcpb_bb_ms_add_remove_idx) => {
					$wcpb_bb_ms_add_remove_this[$th_bundle_addEventListener]("click",
						(event) => {
							event.preventDefault(), event.stopImmediatePropagation();
							let $wcpb_bb_ms_api_json_clone = [...this.$wcpb_bb_api_json.wcpb_bb_multi_section, ];
							$wcpb_bb_ms_api_json_clone[$wcpb_bb_ms_add_remove_this.getAttribute("data-sid")].added_products[$wcpb_bb_ms_add_remove_this.getAttribute("data-pid")].added_qty = 0;
							let $wcpb_bb_ms_remove_temp_array = [...$wcpb_bb_ms_api_json_clone[$wcpb_bb_ms_add_remove_this.getAttribute("data-sid")].added_products, ];
							$wcpb_bb_ms_remove_temp_array = $wcpb_bb_ms_remove_temp_array.filter(
								(val) => val.added_qty != 0);
							$wcpb_bb_ms_api_json_clone[$wcpb_bb_ms_add_remove_this.getAttribute("data-sid")].added_products = $wcpb_bb_ms_remove_temp_array;
							this.$wcpb_bb_api_json = {
								...this.$wcpb_bb_api_json,
								wcpb_bb_multi_section: $wcpb_bb_ms_api_json_clone,
							};
							const $wcpb_bb_ms_bundle_parent_this = $wcpb_bb_ms_add_remove_this.closest(".wc_pb_bb_section_id");
							let $wcpb_bb_ms_build_init_json = new $wcpb_bb_section_class_function(this.$wcpb_bb_api_json, $wcpb_bb_ms_bundle_parent_this, this.$wcpb_bb_layout_htmls);
							$wcpb_bb_ms_build_init_json.$wcpb_bb_ms_build_html_init();
						});
				});
			}
		}
		async $wcpb_bb_multiSKU_tracking_event($wcpb_bb_atc_this) {
			let $wcpb_bb_update_attributes = {
				attributes: {
					"BPBT-order-BB": this.$wcpb_bb_api_json.bundle_key,
					"BPBT-order": {
						order: "anyalytics"
					},
				},
			};
			const $wcpb_bb_update_cart_response = await fetch("/cart/update.js", {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
				},
				body: JSON.stringify($wcpb_bb_update_attributes),
			});
			const $wcpb_bb_updated_cart_response = await $wcpb_bb_update_cart_response.json();
			if ($wcpb_bb_updated_cart_response.items.length > 0) {
				if ($wcpb_bb_atc_this.classList.contains("th_pb_btn_loading")) {
					$wcpb_bb_atc_this.classList.remove("th_pb_btn_loading");
				}
				// window.location = window.location.origin + Shopify.routes.root + "checkout?locale=" + Shopify.locale;
                // location.reload();
                // monster_refresh();
                cartDrawerUpdate();
			} else {
				console.error($wcpb_bb_updated_cart_response);
				if ($wcpb_bb_atc_this.classList.contains("th_pb_btn_loading")) {
					$wcpb_bb_atc_this.classList.remove("th_pb_btn_loading");
				}
			}
		}
		async $wcpb_bb_multiSKU_sm_discount_event($wcpb_bb_cart_items, $wcpb_bb_atc_this) {
			let $wcpb_bb_multiSKU_dd_json = {
				shop: $th_shop_conveted_url,
				box_id: this.$wcpb_bb_api_json.bundle_key,
				active_currency: $th_active_currency,
				active_country: $th_active_country,
				cart_items: $wcpb_bb_cart_items,
				currency_rate: Shopify.currency.rate,
			};
			const rawResponse = await fetch($th_app_ajax_new_url + "checkout-buildbox", {
				method: "POST",
				cache: "no-cache",
				body: JSON.stringify($wcpb_bb_multiSKU_dd_json),
			});
			const $wcpb_bb_multiSKU_dd_response = await rawResponse.json();
			if (!$wcpb_bb_multiSKU_dd_response.error) {
				let $wcpb_bb_page_redirection = "";
				if ($wcpb_bb_multiSKU_dd_response.discount_code == "wcpb_draftorder") {
					$wcpb_bb_page_redirection = $wcpb_bb_multiSKU_dd_response.checkout_url + "?locale=" + Shopify.locale;
				} else {
					$wcpb_bb_page_redirection = "https://" + window.location.hostname + "/discount/" + $wcpb_bb_multiSKU_dd_response.discount_code + "?redirect=/checkout&locale=" + Shopify.locale;
				}
                console.log("$wcpb_bb_page_redirection",$wcpb_bb_page_redirection)
                fetch(`${$wcpb_bb_page_redirection}`)
                .then(response => {
                  if ($wcpb_bb_atc_this.classList.contains("th_pb_btn_loading")) {
					$wcpb_bb_atc_this.classList.remove("th_pb_btn_loading");
				  }
                  if (document.querySelector(".th_pb_cb_ms_next_buy_btn") && document.querySelector(".th_pb_cb_ms_next_buy_btn").classList.contains("th_pb_btn_loading")) {
					document.querySelector(".th_pb_cb_ms_next_buy_btn").classList.remove("th_pb_btn_loading");
				  }
                  // location.reload();
                  // monster_refresh();
                  cartDrawerUpdate()
                })
                .catch(error => {
                  if ($wcpb_bb_atc_this.classList.contains("th_pb_btn_loading")) {
					$wcpb_bb_atc_this.classList.remove("th_pb_btn_loading");
				  }
                  if (document.querySelector(".th_pb_cb_ms_next_buy_btn") && document.querySelector(".th_pb_cb_ms_next_buy_btn").classList.contains("th_pb_btn_loading")) {
					document.querySelector(".th_pb_cb_ms_next_buy_btn").classList.remove("th_pb_btn_loading");
				  }
                  // location.reload();
                  // monster_refresh();
                  cartDrawerUpdate()
                  console.error('Error applying discount:', error)
                });
			} else {
				console.error($wcpb_bb_multiSKU_dd_response);
				if ($wcpb_bb_atc_this.classList.contains("th_pb_btn_loading")) {
					$wcpb_bb_atc_this.classList.remove("th_pb_btn_loading");
				}
				if (document.querySelector(".th_pb_cb_ms_next_buy_btn") && document.querySelector(".th_pb_cb_ms_next_buy_btn").classList.contains("th_pb_btn_loading")) {
					document.querySelector(".th_pb_cb_ms_next_buy_btn").classList.remove("th_pb_btn_loading");
				}
			}
		}
		async $wcpb_bb_products_atc_cta_event($wcpb_bb_atc_variant_formData, $wcpb_bb_atc_this) {
			const rawResponse = await fetch("/cart/add.js", {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
				},
				body: JSON.stringify($wcpb_bb_atc_variant_formData),
			});
			const $wcpb_bb_cart_response = await rawResponse.json();
			if ($wcpb_bb_cart_response.items) {
				if (this.$wcpb_bb_api_json.bundle_sku_type == "1") {
					if (this.$wcpb_bb_api_json.use_discount == "0" || $th_products_json.$wcpb_bb_applied_discount == false) {
						this.$wcpb_bb_multiSKU_tracking_event($wcpb_bb_atc_this);
                         // location.reload();
						// monster_refresh(open);
                      cartDrawerUpdate()
					} else {
						// monster_refresh(open);
						this.$wcpb_bb_multiSKU_sm_discount_event($wcpb_bb_cart_response.items, $wcpb_bb_atc_this);
					}
				}
				if (this.$wcpb_bb_api_json.bundle_sku_type == "0") {
					setTimeout(() => {
						if ($wcpb_bb_atc_this.classList.contains("th_pb_btn_loading")) {
							$wcpb_bb_atc_this.classList.remove("th_pb_btn_loading");
						}
						if (document.querySelector(".th_pb_cb_ms_next_buy_btn") && document.querySelector(".th_pb_cb_ms_next_buy_btn").classList.contains("th_pb_btn_loading")) {
							document.querySelector(".th_pb_cb_ms_next_buy_btn").classList.remove("th_pb_btn_loading");
						}
						window.location.href = window.location.origin + Shopify.routes.root + "cart";
					}, 15000);
				}
			} else {
				console.error($wcpb_bb_cart_response);
				if ($wcpb_bb_atc_this.classList.contains("th_pb_btn_loading")) {
					$wcpb_bb_atc_this.classList.remove("th_pb_btn_loading");
				}
				if (document.querySelector(".th_pb_cb_ms_next_buy_btn") && document.querySelector(".th_pb_cb_ms_next_buy_btn").classList.contains("th_pb_btn_loading")) {
					document.querySelector(".th_pb_cb_ms_next_buy_btn").classList.remove("th_pb_btn_loading");
				}
				let $wcpb_bb_cart_error_message = '<p class="th_pb_cb_sidecart_error_msg">' + $wcpb_bb_cart_response.description + "</p>";
				document.querySelector(".th_pb_cb_sidecart_btn_cls").insertAdjacentHTML("afterend", '<div class="th_pb_wf th_pb_cb_sidecart_error_msg_section">' + $wcpb_bb_cart_error_message + "</div>");
				setTimeout(function() {
					if (document.querySelector(".th_pb_cb_sidecart_error_msg_section")) {
						document.querySelector(".th_pb_cb_sidecart_error_msg_section").remove();
					}
				}, 8000);
			}
		}
		async $wcpb_bb_created_variant_atc_event($wcpb_bb_created_variant, $wcpb_bb_atc_ss_this) {
			let $wcpb_bb_product_properties = {};
			$wcpb_bb_product_properties._th_bundle_box = this.$wcpb_bb_api_json.bundle_key;
			$wcpb_bb_product_properties._th_bundle_type = "Build_box";
			(this.$wcpb_bb_api_json.wcpb_bb_single_section || []).map(
				($wcpb_bb_variant, $wcpb_bb_idx) => {
					const $wcpb_bb_temp_vtitle = $wcpb_bb_variant.v_title != "" ? "(" + $wcpb_bb_variant.v_title + ")" : "";
					$wcpb_bb_product_properties[$wcpb_bb_idx + 1] = $wcpb_bb_variant.added_qty + " x " + $wcpb_bb_variant.p_title + " " + $wcpb_bb_temp_vtitle;
				});
			let $wcpb_bb_atc_variant_array = new Array();
			$wcpb_bb_atc_variant_array.push({
				id: parseInt($wcpb_bb_created_variant.data.variant_id),
				quantity: 1,
				properties: $wcpb_bb_product_properties,
			});
			let $wcpb_bb_atc_variant_formData = {
				items: $wcpb_bb_atc_variant_array
			};
			this.$wcpb_bb_products_atc_cta_event($wcpb_bb_atc_variant_formData, $wcpb_bb_atc_ss_this);
		}
		async $wcpb_bb_ms_created_variant_atc_event($wcpb_bb_ms_created_variant, $wcpb_bb_ms_atc_ss_this) {
			let $wcpb_bb_ms_product_properties = {};
			$wcpb_bb_ms_product_properties._th_bundle_box = this.$wcpb_bb_api_json.bundle_key;
			$wcpb_bb_ms_product_properties._th_bundle_type = "Build_box";
			let $wcpb_bb_ms_added_index = 1;
			(this.$wcpb_bb_api_json.wcpb_bb_multi_section || []).map(
				($wcpb_bb_ms_section_value) => {
					($wcpb_bb_ms_section_value.added_products || []).map(
						($wcpb_bb_ms_added_val) => {
							const $wcpb_bb_ms_temp_vtitle = $wcpb_bb_ms_added_val.v_title != "" ? "(" + $wcpb_bb_ms_added_val.v_title + ")" : "";
							$wcpb_bb_ms_product_properties[$wcpb_bb_ms_added_index] = $wcpb_bb_ms_added_val.added_qty + " x " + $wcpb_bb_ms_added_val.p_title + " " + $wcpb_bb_ms_temp_vtitle;
							$wcpb_bb_ms_added_index = $wcpb_bb_ms_added_index + 1;
						});
				});
			let $wcpb_bb_ms_act_variant_array = [];
			$wcpb_bb_ms_act_variant_array.push({
				id: parseInt($wcpb_bb_ms_created_variant.data.variant_id),
				quantity: 1,
				properties: $wcpb_bb_ms_product_properties,
			});
			let $wcpb_bb_ms_act_variant_formData = {
				items: $wcpb_bb_ms_act_variant_array,
			};
			this.$wcpb_bb_products_atc_cta_event($wcpb_bb_ms_act_variant_formData, $wcpb_bb_ms_atc_ss_this);
		}
		async $wcpb_bb_generate_s_sku_variant($wcpb_bb_atc_ss_this, $wcpb_bb_json_data) {
			const rawResponse = await fetch($th_app_ajax_new_url + "cart-buildbox", {
				method: "POST",
				cache: "no-cache",
				body: JSON.stringify($wcpb_bb_json_data),
			});
			const $wcpb_bb_created_variant = await rawResponse.json();
			if (!$wcpb_bb_created_variant.error) {
				if (this.$wcpb_bb_api_json.bundle_structure_type == "1") {
					this.$wcpb_bb_ms_created_variant_atc_event($wcpb_bb_created_variant, $wcpb_bb_atc_ss_this);
				} else {
					this.$wcpb_bb_created_variant_atc_event($wcpb_bb_created_variant, $wcpb_bb_atc_ss_this);
				}
			} else {
				console.error($wcpb_bb_created_variant);
				if ($wcpb_bb_atc_ss_this.classList.contains("th_pb_btn_loading")) {
					$wcpb_bb_atc_ss_this.classList.remove("th_pb_btn_loading");
				}
			}
		}
		$wcpb_bb_single_addtocart_cta_event() {
			if (document.querySelector(".wcpb_bb_atc_ss_cta_event")) {
				document.querySelectorAll(".wcpb_bb_atc_ss_cta_event").forEach(($wcpb_bb_atc_ss_this, $wcpb_bb_atc_ss_idx) => {
					$wcpb_bb_atc_ss_this[$th_bundle_addEventListener]("click",
						(event) => {
							event.preventDefault(), event.stopImmediatePropagation();
							if (!$wcpb_bb_atc_ss_this.classList.contains("th_pb_btn_loading")) {
								$wcpb_bb_atc_ss_this.classList.add("th_pb_btn_loading");
							}
							const $wcpb_bb_json_data = {
								shop: $th_shop_conveted_url,
								box_id: this.$wcpb_bb_api_json.bundle_key,
								items: this.$wcpb_bb_api_json.wcpb_bb_single_section,
								created_product: this.$wcpb_bb_api_json.created_product,
								active_currency: $th_active_currency,
								active_country: $th_active_country,
								currency_rate: Shopify.currency.rate,
							};
							this.$wcpb_bb_generate_s_sku_variant($wcpb_bb_atc_ss_this, $wcpb_bb_json_data);
						});
				});
			}
			if (document.querySelector(".wcpb_bb_atc_sm_cta_event")) {
				document.querySelectorAll(".wcpb_bb_atc_sm_cta_event").forEach(($wcpb_bb_atc_sm_this, $wcpb_bb_atc_sm_idx) => {
					$wcpb_bb_atc_sm_this[$th_bundle_addEventListener]("click", async (event) => {
						event.preventDefault(), event.stopImmediatePropagation();
						if (!$wcpb_bb_atc_sm_this.classList.contains("th_pb_btn_loading")) {
							$wcpb_bb_atc_sm_this.classList.add("th_pb_btn_loading");
						}
						let $wcpb_bb_atc_variant_array = [];
						(this.$wcpb_bb_api_json.wcpb_bb_single_section || []).map(
							($wcpb_bb_variant) => {
								$wcpb_bb_atc_variant_array.push({
									id: $wcpb_bb_variant.v_id,
									quantity: $wcpb_bb_variant.added_qty,
									properties: {
										_th_bundle_box: this.$wcpb_bb_api_json.bundle_key,
										_th_bundle_type: "Build_box",
									},
								});
							});
						const $wcpb_bb_atc_products_formData = {
							items: $wcpb_bb_atc_variant_array,
						};
						const $wcpb_bb_mm_clear_cart = await fetch("/cart/clear.js", {
							method: "POST",
							headers: {
								"Content-Type": "application/json",
							},
						});
						const $wcpb_bb_mm_cart_response = await $wcpb_bb_mm_clear_cart.json();
						if ($wcpb_bb_mm_cart_response.items.length === 0) {
							this.$wcpb_bb_products_atc_cta_event($wcpb_bb_atc_products_formData, $wcpb_bb_atc_sm_this);
						}
					});
				});
			}
		}
		$wcpb_bb_ms_single_addtocart_cta_event() {
			if (document.querySelector(".wcpb_bb_atc_ms_cta_event")) {
				document.querySelectorAll(".wcpb_bb_atc_ms_cta_event").forEach(($wcpb_bb_ms_atc_sm_this, $wcpb_bb_ms_atc_sm_idx) => {
					$wcpb_bb_ms_atc_sm_this[$th_bundle_addEventListener]("click",
						(event) => {
							event.preventDefault(), event.stopImmediatePropagation();
							if (!$wcpb_bb_ms_atc_sm_this.classList.contains("th_pb_btn_loading")) {
								$wcpb_bb_ms_atc_sm_this.classList.add("th_pb_btn_loading");
							}
							let $wcpb_bb_ms_variant_items = [];
							(this.$wcpb_bb_api_json.wcpb_bb_multi_section || []).map(
								($wcpb_bb_ms_section_val) => {
									($wcpb_bb_ms_section_val.added_products || []).map(
										($wcpb_bb_ms_added_val) => {
											$wcpb_bb_ms_variant_items.push($wcpb_bb_ms_added_val);
										});
								});
							const $wcpb_bb_ms_json_data = {
								shop: $th_shop_conveted_url,
								box_id: this.$wcpb_bb_api_json.bundle_key,
								items: $wcpb_bb_ms_variant_items,
								created_product: this.$wcpb_bb_api_json.created_product,
								active_currency: $th_active_currency,
								active_country: $th_active_country,
							};
							this.$wcpb_bb_generate_s_sku_variant($wcpb_bb_ms_atc_sm_this, $wcpb_bb_ms_json_data);
						});
				});
			}
			if (document.querySelector(".wcpb_bb_atc_mm_cta_event")) {
				document.querySelectorAll(".wcpb_bb_atc_mm_cta_event").forEach(($wcpb_bb_mm_atc_mm_this, $wcpb_bb_mm_atc_mm_idx) => {
					$wcpb_bb_mm_atc_mm_this[$th_bundle_addEventListener]("click", async (event) => {
						event.preventDefault(), event.stopImmediatePropagation();
						if (!$wcpb_bb_mm_atc_mm_this.classList.contains("th_pb_btn_loading")) {
							$wcpb_bb_mm_atc_mm_this.classList.add("th_pb_btn_loading");
						}
						let $wcpb_bb_mm_variant_items = [];
						(this.$wcpb_bb_api_json.wcpb_bb_multi_section || []).map(
							($wcpb_bb_mm_section_val) => {
								($wcpb_bb_mm_section_val.added_products || []).map(
									($wcpb_bb_mm_added_val) => {
										let $wcpb_bb_mm_index = $wcpb_bb_mm_variant_items.findIndex(
											(x_val) => x_val.id === $wcpb_bb_mm_added_val.v_id);
										if ($wcpb_bb_mm_index != -1) {
											$wcpb_bb_mm_variant_items[$wcpb_bb_mm_index].quantity = $wcpb_bb_mm_variant_items[$wcpb_bb_mm_index].quantity + $wcpb_bb_mm_added_val.added_qty;
                                            $wcpb_bb_mm_variant_items[$wcpb_bb_mm_index].properties._th_min_quantity = $wcpb_bb_mm_variant_items[$wcpb_bb_mm_index].quantity;
										} else {
											$wcpb_bb_mm_variant_items.push({
												id: $wcpb_bb_mm_added_val.v_id,
												quantity: $wcpb_bb_mm_added_val.added_qty,
												properties: {
													_th_bundle_box: this.$wcpb_bb_api_json.bundle_key,
													_th_bundle_type: "Build_box",
													_th_bundle_id: this.$wcpb_bb_api_json.id,
                                                    _th_min_quantity:$wcpb_bb_mm_added_val.added_qty
												},
											});
										}
									});
							});
						const $wcpb_bb_mm_final_atc_json = {
							items: $wcpb_bb_mm_variant_items,
						};
                  
						this.$wcpb_bb_products_atc_cta_event($wcpb_bb_mm_final_atc_json, $wcpb_bb_mm_atc_mm_this);
						
					});
				});
			}
		}
		async $wcpb_bb_loadmore_fetch_event($wcpb_bb_load_this, $wcpb_bb_section_val, $wcpb_bb_next_section, $wcpb_bb_next_page_number, $wcpb_bb_next_section_index) {
			let $wcpb_bb_loadmore_parameters = {
				shop: $th_shop_conveted_url,
				box_id: this.$wcpb_bb_api_json.bundle_key,
				page: $wcpb_bb_next_page_number,
				section_id: $wcpb_bb_section_val,
				active_currency: $th_active_currency,
				active_country: $th_active_country,
			};
			const rawResponse = await fetch($th_bb_app_ajax_url + "bundle-box-products", {
				method: "POST",
				cache: "no-cache",
				body: JSON.stringify($wcpb_bb_loadmore_parameters),
			});
			const $wcpb_bb_loadmore_result = await rawResponse.json();
			if (!$wcpb_bb_loadmore_result.error) {
				if ($wcpb_bb_loadmore_result.bb_structure_type == "1") {
					let $wcpb_bb_ms_api_json_clone = [...this.$wcpb_bb_api_json.sections];
					for (var secIndex in $wcpb_bb_loadmore_result.data.sections) {
						var section = $wcpb_bb_loadmore_result.data.sections[secIndex];
						var section_id = section.section_id;
						var selected_index = -1;
						var filteredItems2 = section.products.filter(
							(product) => product.is_preselected === 1);
						for (var MultiCloneindex in this.$wcpb_bb_api_json.wcpb_bb_multi_section) {
							var sectionMultiSec = this.$wcpb_bb_api_json.wcpb_bb_multi_section[MultiCloneindex];
							if (sectionMultiSec.section_id == section_id) {
								selected_index = MultiCloneindex;
							}
						}
						for (var item in filteredItems2) {
							var th_object_to_push = {
								added_qty: 1,
								p_handle: filteredItems2[item].handle,
								p_id: filteredItems2[item].id,
								p_title: filteredItems2[item].title,
								v_compare_price: filteredItems2[item].variants[0].compare_at_price,
								v_id: filteredItems2[item].variants[0].id,
								v_original_price: filteredItems2[item].variants[0].original_price,
								v_price: filteredItems2[item].variants[0].price,
								v_title: filteredItems2[item].variants[0].title,
								variant_img: filteredItems2[item].variants[0].image ? filteredItems2[item].variants[0].image.originalSrc : filteredItems2[item].image ? filteredItems2[item].image.src : "https://bundle.thimatic-apps.com/assets/img/no-product-image.svg",
								variant_key: filteredItems2[item].variants[0].variant_key,
							};
							this.$wcpb_bb_api_json.wcpb_bb_multi_section[selected_index].added_products.push(th_object_to_push);
							//$wcpb_bb_mlutisection_clone[selected_index].added_products.push(th_object_to_push);
						}
					}
					if ($wcpb_bb_loadmore_result.data.sections && $wcpb_bb_loadmore_result.data.sections.length) {
						let $wcpb_bb_ms_section_index = $wcpb_bb_ms_api_json_clone.findIndex(
							(val) => val.section_id == $wcpb_bb_section_val);
						let $wcpb_bb_ms_temp_product = [];
						$wcpb_bb_loadmore_result.data.sections[0].products.map(
							($wcpb_bb_ms_product_val) => {
								let $wcpb_bb_ms_loop_break = false;
								let $wcpb_bb_ms_selected_variant_obj = {};
								($wcpb_bb_ms_product_val.variants || []).map(
									($wcpb_bb_ms_variant) => {
										if (!$wcpb_bb_ms_loop_break) {
											if ($wcpb_bb_ms_variant && $wcpb_bb_ms_variant.inventory_management && $wcpb_bb_ms_variant.inventory_management.toLowerCase() == "shopify") {
												if ($wcpb_bb_ms_variant && $wcpb_bb_ms_variant.inventory_policy && $wcpb_bb_ms_variant.inventory_policy.toLowerCase() != "deny") {
													$wcpb_bb_ms_loop_break = true;
													$wcpb_bb_ms_selected_variant_obj = $wcpb_bb_ms_variant;
												} else if ($wcpb_bb_ms_variant && $wcpb_bb_ms_variant.inventory_quantity > 0) {
													$wcpb_bb_ms_loop_break = true;
													$wcpb_bb_ms_selected_variant_obj = $wcpb_bb_ms_variant;
												}
											} else {
												$wcpb_bb_ms_loop_break = true;
												$wcpb_bb_ms_selected_variant_obj = $wcpb_bb_ms_variant;
											}
										}
									});
								let $wcpb_bb_ms_selected_variant_img = $wcpb_bb_ms_product_val.image && $wcpb_bb_ms_product_val.image.src ? $wcpb_bb_ms_product_val.image.src : "https://bundle.thimatic-apps.com/assets/img/no-product-image.svg";
								if ($wcpb_bb_ms_selected_variant_obj.image && $wcpb_bb_ms_selected_variant_obj.image.originalSrc) {
									$wcpb_bb_ms_selected_variant_img = $wcpb_bb_ms_selected_variant_obj.image.originalSrc;
								}
								let $wcpb_bb_ms_obj = {
									...$wcpb_bb_ms_product_val,
									selected_variant: $wcpb_bb_ms_selected_variant_obj.id,
									added_qty: 0,
									selected_variant_title: $wcpb_bb_ms_selected_variant_obj.title,
									v_price: parseFloat($wcpb_bb_ms_selected_variant_obj.price),
									v_orignal_price: parseFloat($wcpb_bb_ms_selected_variant_obj.orignal_price),
									v_compare_price: parseFloat($wcpb_bb_ms_selected_variant_obj.compare_at_price),
									variant_key: $wcpb_bb_ms_selected_variant_obj.variant_key,
									variant_img: $wcpb_bb_ms_selected_variant_img,
								};
								$wcpb_bb_ms_temp_product.push($wcpb_bb_ms_obj);
							});
						let $wcpb_bb_ms_concat_array = $wcpb_bb_ms_api_json_clone[$wcpb_bb_ms_section_index].products.concat($wcpb_bb_ms_temp_product);
						$wcpb_bb_ms_api_json_clone[$wcpb_bb_ms_section_index].products = $wcpb_bb_ms_concat_array;
						$wcpb_bb_ms_api_json_clone[$wcpb_bb_ms_section_index].next_product_page = $wcpb_bb_loadmore_result.data.sections[0].next_product_page;
						$wcpb_bb_ms_api_json_clone[$wcpb_bb_ms_section_index].page_count = $wcpb_bb_next_page_number;
						this.$wcpb_bb_api_json = {
							...this.$wcpb_bb_api_json,
							sections: $wcpb_bb_ms_api_json_clone,
						};
						const $wcpb_bb_bundle_parent_this = $wcpb_bb_load_this.closest(".wc_pb_bb_section_id");
						let $wcpb_bb_build_init_json = new $wcpb_bb_section_class_function(this.$wcpb_bb_api_json, $wcpb_bb_bundle_parent_this, this.$wcpb_bb_layout_htmls);
						$wcpb_bb_build_init_json.$wcpb_bb_ms_build_html_init();
						$th_bb_scroll_event = true;
					}
				} else {
					if ($wcpb_bb_loadmore_result.data[0].products && $wcpb_bb_loadmore_result.data[0].products.length) {
						let $wcpb_bb_api_json_clone = [...this.$wcpb_bb_api_json.products];
						let $wcpb_bb_temp_product = [];
						($wcpb_bb_loadmore_result.data[0].products || []).map(
							($wcpb_bb_p_val) => {
								let $wcpb_bb_loop_break = false,
									$wcpb_bb_selected_variant_obj = {};
								($wcpb_bb_p_val.variants || []).map(($wcpb_bb_variant_val) => {
									if (!$wcpb_bb_loop_break) {
										if ($wcpb_bb_variant_val && $wcpb_bb_variant_val.inventory_management && $wcpb_bb_variant_val.inventory_management.toLowerCase() == "shopify") {
											if ($wcpb_bb_variant_val && $wcpb_bb_variant_val.inventory_policy && $wcpb_bb_variant_val.inventory_policy.toLowerCase() != "deny") {
												$wcpb_bb_loop_break = true;
												$wcpb_bb_selected_variant_obj = $wcpb_bb_variant_val;
											} else if ($wcpb_bb_variant_val && $wcpb_bb_variant_val.inventory_quantity > 0) {
												$wcpb_bb_loop_break = true;
												$wcpb_bb_selected_variant_obj = $wcpb_bb_variant_val;
											}
										} else {
											$wcpb_bb_loop_break = true;
											$wcpb_bb_selected_variant_obj = $wcpb_bb_variant_val;
										}
									}
								});
								let $wcpb_bb_selected_variant_img = $wcpb_bb_p_val.image && $wcpb_bb_p_val.image.src ? $wcpb_bb_p_val.image.src : "https://bundle.thimatic-apps.com/assets/img/no-product-image.svg";
								if ($wcpb_bb_selected_variant_obj.image && $wcpb_bb_selected_variant_obj.image.originalSrc) {
									$wcpb_bb_selected_variant_img = $wcpb_bb_selected_variant_obj.image.originalSrc;
								}
								let $wcpb_bb_temp_p_obj = {
									...$wcpb_bb_p_val,
									selected_variant: $wcpb_bb_selected_variant_obj.id,
									added_qty: 0,
									selected_variant_title: $wcpb_bb_selected_variant_obj.title,
									v_price: parseFloat($wcpb_bb_selected_variant_obj.price),
									v_orignal_price: parseFloat($wcpb_bb_selected_variant_obj.orignal_price),
									v_compare_price: parseFloat($wcpb_bb_selected_variant_obj.compare_at_price),
									variant_key: $wcpb_bb_selected_variant_obj.variant_key,
									variant_img: $wcpb_bb_selected_variant_img,
								};
								$wcpb_bb_temp_product.push($wcpb_bb_temp_p_obj);
							});
						let $wcpb_bb_concat_array = $wcpb_bb_api_json_clone.concat($wcpb_bb_temp_product);
						this.$wcpb_bb_api_json = {
							...this.$wcpb_bb_api_json,
							products: $wcpb_bb_concat_array,
							next_product_page: $wcpb_bb_loadmore_result.data[0].next_product_page,
							page_count: $wcpb_bb_next_page_number,
						};
						const $wcpb_bb_bundle_parent_this = $wcpb_bb_load_this.closest(".wc_pb_bb_section_id");
						let $wcpb_bb_build_init_json = new $wcpb_bb_section_class_function(this.$wcpb_bb_api_json, $wcpb_bb_bundle_parent_this, this.$wcpb_bb_layout_htmls);
						$wcpb_bb_build_init_json.$wcpb_bb_build_html_init();
						$th_bb_scroll_event = true;
					}
				}
				if (typeof $th_loadmore_bundles == "function") {
					$th_loadmore_bundles(this.$wcpb_bb_api_json);
				}
			} else {
				console.error($wcpb_bb_loadmore_result);
				if ($wcpb_bb_load_this.classList.contains("th_pb_btn_loading")) {
					$wcpb_bb_load_this.classList.remove("th_pb_btn_loading");
				}
			}
		}
		$wcpb_bb_loadmore_event() {
			if (document.querySelector(".th_pb_cb_p_grid_loadmore_btn")) {
				document.querySelectorAll(".th_pb_cb_p_grid_loadmore_btn").forEach(($wcpb_bb_load_this, $wcpb_bb_load_idx) => {
					$wcpb_bb_load_this[$th_bundle_addEventListener]("click", async (event) => {
						event.preventDefault(), event.stopImmediatePropagation();
						if (!$wcpb_bb_load_this.classList.contains("th_pb_btn_loading")) {
							$wcpb_bb_load_this.classList.add("th_pb_btn_loading");
						}
						const $wcpb_bb_next_page_number = this.$wcpb_bb_api_json.page_count + 1;
						await this.$wcpb_bb_loadmore_fetch_event($wcpb_bb_load_this, "single_step", false, $wcpb_bb_next_page_number, this.$wcpb_bb_api_json.wcpb_bb_selected_section_count);
					});
				});
				if (document.querySelector(".th_pb_cb_p_grid_loadmore_btn").getAttribute("data-scroll") == "1") {
					window.addEventListener("scroll", function() {
						if (document.querySelector(".th_pb_cb_p_grid_loadmore_btn")) {
							if (document.querySelector(".th_pb_cb_p_grid_loadmore_section").offsetTop - (window.scrollY + window.innerHeight) <= 0 && $th_bb_scroll_event) {
								$th_bb_scroll_event = false;
								document.querySelector(".th_pb_cb_p_grid_loadmore_btn").dispatchEvent(new Event("click"));
							}
						}
					});
				}
			}
		}
		$wcpb_bb_ms_loadmore_event() {
			if (document.querySelector(".th_pb_cb_ms_p_grid_loadmore_btn")) {
				document.querySelectorAll(".th_pb_cb_ms_p_grid_loadmore_btn").forEach(($wcpb_bb_ms_load_this, $wcpb_bb_ms_load_idx) => {
					$wcpb_bb_ms_load_this[$th_bundle_addEventListener]("click", async (event) => {
						event.preventDefault(), event.stopImmediatePropagation();
						if (!$wcpb_bb_ms_load_this.classList.contains("th_pb_btn_loading")) {
							$wcpb_bb_ms_load_this.classList.add("th_pb_btn_loading");
							const $wcpb_bb_ms_next_page_number = this.$wcpb_bb_api_json.sections[this.$wcpb_bb_api_json.wcpb_bb_selected_section_count].page_count + 1;
							await this.$wcpb_bb_loadmore_fetch_event($wcpb_bb_ms_load_this, this.$wcpb_bb_api_json.sections[this.$wcpb_bb_api_json.wcpb_bb_selected_section_count].section_id, false, $wcpb_bb_ms_next_page_number, this.$wcpb_bb_api_json.wcpb_bb_selected_section_count);
						}
					});
				});
				if (document.querySelector(".th_pb_cb_ms_p_grid_loadmore_btn").getAttribute("data-scroll") == "1") {
					window.addEventListener("scroll", function() {
						if (document.querySelector(".th_pb_cb_ms_p_grid_loadmore_btn")) {
							if (document.querySelector(".th_pb_cb_p_grid_loadmore_section").offsetTop - (window.scrollY + window.innerHeight) <= 0 && $th_bb_scroll_event) {
								$th_bb_scroll_event = false;
								document.querySelector(".th_pb_cb_ms_p_grid_loadmore_btn").dispatchEvent(new Event("click"));
							}
						}
					});
				}
			}
		}
		$wcpb_bb_ms_tab_change_event() {
			if (document.querySelector(".th_pb_ms_title_click")) {
				document.querySelectorAll(".th_pb_ms_title_click").forEach(($wcpb_bb_ms_tab_this, $wcpb_bb_ms_tab_idx) => {
					$wcpb_bb_ms_tab_this[$th_bundle_addEventListener]("click", async (event) => {
						event.preventDefault(), event.stopImmediatePropagation();
                        localStorage.setItem('th_remember_last_variant_id','');
						if (!$wcpb_bb_ms_tab_this.closest(".th_pb_cb_ms_steps").classList.contains("th_pb_cb_ms_steps_activated")) {
							if (!$wcpb_bb_ms_tab_this.classList.contains("th_pb_ms_disable_click")) {
								$wcpb_bb_ms_tab_this.classList.add("th_pb_ms_disable_click");
							}
							if ($wcpb_bb_ms_tab_idx > this.$wcpb_bb_api_json.wcpb_bb_selected_section_count) {
								if (this.$wcpb_bb_api_json.sections[$wcpb_bb_ms_tab_idx].products == 0) {
									this.$wcpb_bb_api_json = {
										...this.$wcpb_bb_api_json,
										wcpb_bb_selected_section_count: $wcpb_bb_ms_tab_idx,
									};
									await this.$wcpb_bb_loadmore_fetch_event($wcpb_bb_ms_tab_this, this.$wcpb_bb_api_json.sections[this.$wcpb_bb_api_json.wcpb_bb_selected_section_count].section_id, true, 0, this.$wcpb_bb_api_json.wcpb_bb_selected_section_count);
								} else {
									this.$wcpb_bb_api_json = {
										...this.$wcpb_bb_api_json,
										wcpb_bb_selected_section_count: $wcpb_bb_ms_tab_idx,
									};
									const $wcpb_bb_bundle_parent_this = $wcpb_bb_ms_tab_this.closest(".wc_pb_bb_section_id");
									let $wcpb_bb_build_init_json = new $wcpb_bb_section_class_function(this.$wcpb_bb_api_json, $wcpb_bb_bundle_parent_this, this.$wcpb_bb_layout_htmls);
									$wcpb_bb_build_init_json.$wcpb_bb_ms_build_html_init();
								}
							} else {
								this.$wcpb_bb_api_json = {
									...this.$wcpb_bb_api_json,
									wcpb_bb_selected_section_count: $wcpb_bb_ms_tab_idx,
								};
								const $wcpb_bb_bundle_parent_this = $wcpb_bb_ms_tab_this.closest(".wc_pb_bb_section_id");
								let $wcpb_bb_build_init_json = new $wcpb_bb_section_class_function(this.$wcpb_bb_api_json, $wcpb_bb_bundle_parent_this, this.$wcpb_bb_layout_htmls);
								$wcpb_bb_build_init_json.$wcpb_bb_ms_build_html_init();
							}
						}
						if (typeof $wc_section_change_click == "function") {
							$wc_section_change_click();
						}
					});
				});
			}
		}
		$wcpb_bb_step_previous_btn() {
			let $wcpb_bb_disable_previous_btn = this.$wcpb_bb_api_json.wcpb_bb_selected_section_count === 0 ? "th_pb_bb_disabled_previous_btn" : "";
			let $wcpb_bb_step_previous_btn_html = '<button type="button" aria-label="' + this.$wcpb_bb_api_json.language.buildbox_previous + '" class="btn th_pb_cb_ms_previous_btn ' + $wcpb_bb_disable_previous_btn + '">';
			$wcpb_bb_step_previous_btn_html += '<span class="button_text">' + this.$wcpb_bb_api_json.language.buildbox_previous + "</span>";
			$wcpb_bb_step_previous_btn_html += "</button>";
			return $wcpb_bb_step_previous_btn_html;
		}
		$wcpb_bb_step_next_btn() {
			let $wcpb_bb_disabled_next_btn = "th_pb_bb_disabled_next_btn",
				$wcpb_bb_step_next_btn_html = "";
			let $wcpb_bb_selected_section_id = this.$wcpb_bb_api_json.sections[this.$wcpb_bb_api_json.wcpb_bb_selected_section_count].section_id;
			if (this.$wcpb_bb_api_json.sections[this.$wcpb_bb_api_json.wcpb_bb_selected_section_count].min_product && this.$wcpb_bb_api_json.wcpb_bb_selected_section_count < this.$wcpb_bb_api_json.sections.length - 1) {
				if (this.$wcpb_bb_api_json.wcpb_bb_multi_section.length > 0) {
					let $wcpb_bb_section_added_product = 0;
					(this.$wcpb_bb_api_json.wcpb_bb_multi_section || []).map(
						($wcpb_bb_section_val) => {
							if ($wcpb_bb_section_val.section_id == $wcpb_bb_selected_section_id) {
								$wcpb_bb_section_added_product = ($wcpb_bb_section_val.added_products || []).reduce((a, b) => +a + b.added_qty, 0);
							}
						});
					if ($wcpb_bb_section_added_product >= parseInt(this.$wcpb_bb_api_json.sections[this.$wcpb_bb_api_json.wcpb_bb_selected_section_count].min_product)) {
						$wcpb_bb_disabled_next_btn = "";
					}
				}
				$wcpb_bb_step_next_btn_html += '<button type="button" aria-label="' + this.$wcpb_bb_api_json.language.buildbox_next + '" class="btn button th_pb_cb_ms_next_btn ' + $wcpb_bb_disabled_next_btn + '">';
				$wcpb_bb_step_next_btn_html += '<span class="button_text">' + this.$wcpb_bb_api_json.language.buildbox_next + "</span>";
				$wcpb_bb_step_next_btn_html += '<em class="th_pb_cb_ms_loader_cls"></em>';
				$wcpb_bb_step_next_btn_html += "</button>";
			} else {
				let th_next_buy_btn_need_to_disable = true;
				(this.$wcpb_bb_api_json.wcpb_bb_multi_section || []).map(
					($wcpb_bb_section_val, $wcpb_bb_section_val_index) => {
						if ($wcpb_bb_section_val.section_id == this.$wcpb_bb_api_json.sections[$wcpb_bb_section_val_index].section_id) {
							if (parseFloat($wcpb_bb_section_val.added_products.length) < parseFloat(this.$wcpb_bb_api_json.sections[$wcpb_bb_section_val_index].min_product)) {
								th_next_buy_btn_need_to_disable = false;
							}
						}
					});
				th_next_buy_btn_need_to_disable ? ($wcpb_bb_disabled_next_btn = "") : "";
				$wcpb_bb_step_next_btn_html += '<button type="button" aria-label="' + this.$wcpb_bb_api_json.button_text + '" class="btn button th_pb_cb_ms_next_btn th_pb_cb_ms_next_buy_btn ' + $wcpb_bb_disabled_next_btn + '">';
				$wcpb_bb_step_next_btn_html += '<span class="button_text">' + 'Add To Cart' + "</span>";
				$wcpb_bb_step_next_btn_html += '<em class="th_pb_cb_ms_loader_cls"></em>';
				$wcpb_bb_step_next_btn_html += "</button>";
			}
			return $wcpb_bb_step_next_btn_html;
		}
		$wcpb_bb_ms_step_build($wcpb_bb_ms_main_temp_html) {
			let $wcpb_bb_ms_step_final_html = "";
			(this.$wcpb_bb_api_json.sections || []).map(
				($wcpb_bb_section_val, $wcpb_bb_section_idx) => {
					let $wcpb_bb_step_grid_html = this.$wcpb_bb_layout_htmls.bb_section_step_html;
					for (let i = 1; i <= ($wcpb_bb_step_grid_html.match(/[[wcpb_bb_step_loop_title]]/g) || []).length; i++) {
						$wcpb_bb_step_grid_html = $wcpb_bb_step_grid_html.replace("[[wcpb_bb_step_loop_title]]", $wcpb_bb_section_val.section_title);
					}
					if ($wcpb_bb_section_idx === this.$wcpb_bb_api_json.wcpb_bb_selected_section_count) {
						for (let i = 1; i <= ($wcpb_bb_step_grid_html.match(/[[wcpb_bb_step_loop_activated]]/g) || []).length; i++) {
							$wcpb_bb_step_grid_html = $wcpb_bb_step_grid_html.replace("[[wcpb_bb_step_loop_activated]]", "th_pb_cb_ms_steps_activated");
						}
					} else {
						for (let i = 1; i <= ($wcpb_bb_step_grid_html.match(/[[wcpb_bb_step_loop_activated]]/g) || []).length; i++) {
							$wcpb_bb_step_grid_html = $wcpb_bb_step_grid_html.replace("[[wcpb_bb_step_loop_activated]]", "");
						}
					}
					$wcpb_bb_ms_step_final_html += $wcpb_bb_step_grid_html;
				});
			for (let i = 1; i <= ($wcpb_bb_ms_main_temp_html.match(/[[wcpb_bb_step_loop_html]]/g) || []).length; i++) {
				$wcpb_bb_ms_main_temp_html = $wcpb_bb_ms_main_temp_html.replace("[[wcpb_bb_step_loop_html]]", $wcpb_bb_ms_step_final_html);
			}
			return $wcpb_bb_ms_main_temp_html;
		}
		$wcpb_bb_ms_limit_msg_html() {
			let $wcpb_bb_ms_limit_msg_temp = "";
			if (this.$wcpb_bb_api_json.sections[this.$wcpb_bb_api_json.wcpb_bb_selected_section_count].box_fix_limit_message && this.$wcpb_bb_api_json.sections[this.$wcpb_bb_api_json.wcpb_bb_selected_section_count].min_product && this.$wcpb_bb_api_json.sections[this.$wcpb_bb_api_json.wcpb_bb_selected_section_count].max_product) {
				$wcpb_bb_ms_limit_msg_temp = this.$wcpb_bb_api_json.sections[this.$wcpb_bb_api_json.wcpb_bb_selected_section_count].box_fix_limit_message.replaceAll("[[min]]", this.$wcpb_bb_api_json.sections[this.$wcpb_bb_api_json.wcpb_bb_selected_section_count].min_product).replaceAll("[[max]]", this.$wcpb_bb_api_json.sections[this.$wcpb_bb_api_json.wcpb_bb_selected_section_count].max_product);
			}
			return $wcpb_bb_ms_limit_msg_temp;
		}
		$wcpb_bb_ms_product_grid_price($wcpb_bb_pgrid_customized_temp_html, $wcpb_bb_pro_val) {
			const $wcpb_bb_grid_sale_price = '<span class="th_pb_main_price"><span class="money">' + $th_money_format($wcpb_bb_pro_val.v_price * 100, $th_shop_money) + "</span></span>";
			const $wcpb_bb_grid_compare_price = '<span class="th_pb_old_price"><span class="money th_pb_line_through">' + $th_money_format($wcpb_bb_pro_val.v_compare_price * 100, $th_shop_money) + "</span></span>";
			for (let i = 1; i <= ($wcpb_bb_pgrid_customized_temp_html.match(/[[wcpb_bb_pgrid_psaleprice]]/g) || []).length; i++) {
				$wcpb_bb_pgrid_customized_temp_html = $wcpb_bb_pgrid_customized_temp_html.replace("[[wcpb_bb_pgrid_psaleprice]]", $wcpb_bb_grid_sale_price);
			}
			for (let i = 1; i <= ($wcpb_bb_pgrid_customized_temp_html.match(/[[wcpb_bb_pgrid_pcompareprice]]/g) || []).length; i++) {
				$wcpb_bb_pgrid_customized_temp_html = $wcpb_bb_pgrid_customized_temp_html.replace("[[wcpb_bb_pgrid_pcompareprice]]", $wcpb_bb_pro_val && $wcpb_bb_pro_val.v_compare_price > $wcpb_bb_pro_val.v_price ? $wcpb_bb_grid_compare_price : "");
			}
			return $wcpb_bb_pgrid_customized_temp_html;
		}

     $return_total_added_product_count(pro_id,$wcpb_bb_api_json){
          if($wcpb_bb_api_json.bundle_structure_type==1){
            let current_selected_section_inded=$wcpb_bb_api_json.wcpb_bb_selected_section_count;
            let sections=$wcpb_bb_api_json.wcpb_bb_multi_section;
            let current_section_data=sections[current_selected_section_inded];
            if(sections.length>0 && current_section_data && current_section_data.added_products && current_section_data.added_products.length>0){
              let total_added_product_count=0;
              current_section_data.added_products.forEach((added_product)=>{
                if(added_product.p_id==pro_id && added_product.added_qty>0){
                  total_added_product_count+=added_product.added_qty;
                }
              })
              return total_added_product_count;
            }else{
              return 0;
            }
          }
     }
    $th_return_th_bb_variant_option_qty_selector_structure($wcpb_bb_api_json,current_variant_id){ 
           let qty_selector_structure='';
           let qty_selector_cart_icon_structure=`<div class='th_bb_variant_option_qty_selector_cart_icon' onClick='th_custom_cart_icon_click(this,event)'><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" fill="#000000" height="20px" width="20px" version="1.1" id="Capa_1" viewBox="0 0 303.124 303.124" xml:space="preserve"><g><path d="M312.208,48.613c-1.136-1.47-2.889-2.33-4.746-2.33H70.499L59.631,4.49c-0.01-0.038-0.024-0.073-0.035-0.11   c-0.033-0.119-0.07-0.235-0.11-0.35c-0.026-0.076-0.054-0.152-0.083-0.227c-0.042-0.105-0.086-0.208-0.133-0.31   c-0.038-0.083-0.077-0.165-0.118-0.246c-0.045-0.087-0.093-0.172-0.143-0.257c-0.051-0.088-0.103-0.175-0.158-0.26   c-0.048-0.074-0.099-0.145-0.149-0.216c-0.063-0.088-0.127-0.175-0.194-0.259C58.456,2.19,58.4,2.127,58.344,2.063   c-0.07-0.081-0.141-0.161-0.216-0.238c-0.062-0.064-0.128-0.125-0.192-0.187c-0.073-0.068-0.145-0.136-0.221-0.201   c-0.076-0.065-0.155-0.126-0.234-0.187c-0.07-0.054-0.14-0.108-0.212-0.159c-0.09-0.064-0.183-0.123-0.277-0.181   c-0.067-0.042-0.134-0.085-0.203-0.123c-0.101-0.057-0.204-0.11-0.309-0.162c-0.068-0.034-0.136-0.068-0.205-0.099   c-0.104-0.046-0.21-0.088-0.317-0.129c-0.077-0.03-0.154-0.059-0.232-0.085c-0.099-0.033-0.2-0.063-0.301-0.091   c-0.093-0.025-0.185-0.05-0.279-0.071c-0.089-0.02-0.178-0.037-0.268-0.053c-0.111-0.02-0.224-0.038-0.337-0.052   c-0.077-0.009-0.154-0.016-0.231-0.022c-0.126-0.01-0.252-0.017-0.38-0.019C53.896,0.005,53.86,0,53.824,0H6C2.687,0,0,2.687,0,6   c0,3.313,2.687,6,6,6h43.185l10.867,41.793c0,0.001,0.001,0.002,0.001,0.004l36.107,138.852c0.688,2.644,3.075,4.49,5.807,4.49   h169.383c2.732,0,5.119-1.846,5.807-4.49l36.111-138.855C313.736,51.996,313.345,50.083,312.208,48.613z M290.786,92.566h-62.338   V58.283h71.254L290.786,92.566z M278.748,138.855h-50.3v-34.289h59.217L278.748,138.855z M156.87,138.855v-34.289h59.578v34.289   H156.87z M216.448,150.855v34.283H156.87v-34.283H216.448z M85.655,104.566h59.215v34.289H94.571L85.655,104.566z M156.87,92.566   V58.283h59.578v34.283H156.87z M144.87,58.283v34.283H82.534l-8.915-34.283H144.87z M97.692,150.855h47.178v34.283h-38.263   L97.692,150.855z M266.711,185.139h-38.263v-34.283h47.179L266.711,185.139z"/><path d="M126.419,211.072c-16.791,0-30.451,13.66-30.451,30.451s13.66,30.451,30.451,30.451s30.451-13.66,30.451-30.451   S143.21,211.072,126.419,211.072z M126.419,259.975c-10.174,0-18.451-8.277-18.451-18.451c0-10.174,8.277-18.451,18.451-18.451   s18.451,8.277,18.451,18.451C144.87,251.697,136.593,259.975,126.419,259.975z"/><path d="M246.9,211.072c-16.791,0-30.451,13.66-30.451,30.451s13.66,30.451,30.451,30.451c16.791,0,30.451-13.66,30.451-30.451   S263.69,211.072,246.9,211.072z M246.9,259.975c-10.174,0-18.451-8.277-18.451-18.451c0-10.174,8.277-18.451,18.451-18.451   c10.174,0,18.451,8.277,18.451,18.451C265.351,251.697,257.073,259.975,246.9,259.975z"/></g></svg></div>`;
           if($wcpb_bb_api_json.bundle_structure_type==1){
            let current_selected_section_inded=$wcpb_bb_api_json.wcpb_bb_selected_section_count;
            let sections=$wcpb_bb_api_json.wcpb_bb_multi_section;
            let current_section_data=sections[current_selected_section_inded];
            if(sections.length>0 && current_section_data && current_section_data.added_products && current_section_data.added_products.length>0){
              let variant_is_already_added=false;
              current_section_data.added_products.forEach((added_product)=>{
                if(added_product.v_id==current_variant_id && added_product.added_qty>0){
                  variant_is_already_added=true;
                  qty_selector_structure+=`<div class='th_bb_cusstom_variant_option_main_qty_selector'>`;
                    qty_selector_structure+=`<div class='th_bb_cusstom_variant_option_main_qty_selector_minus minu' onCLick="th_custom_variant_option_qty_sel_event(this)"><svg class="th_trash_icon_prodcuct_grid" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="15px" ><path d="M 10 2 L 9 3 L 3 3 L 3 5 L 21 5 L 21 3 L 15 3 L 14 2 L 10 2 z M 4.3652344 7 L 6.0683594 22 L 17.931641 22 L 19.634766 7 L 4.3652344 7 z"></path></svg></div>`
                    qty_selector_structure+=`<div class='th_bb_cusstom_variant_option_main_qty_selector_count_num'>${added_product.added_qty}</div>`;
                    qty_selector_structure+=`<div class='th_bb_cusstom_variant_option_main_qty_selector_plus plus' onCLick="th_custom_variant_option_qty_sel_event(this)"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" fill="#000000"  width="15px" version="1.1" id="Capa_1" viewBox="0 0 303.124 303.124" xml:space="preserve"><g><path d="M312.208,48.613c-1.136-1.47-2.889-2.33-4.746-2.33H70.499L59.631,4.49c-0.01-0.038-0.024-0.073-0.035-0.11   c-0.033-0.119-0.07-0.235-0.11-0.35c-0.026-0.076-0.054-0.152-0.083-0.227c-0.042-0.105-0.086-0.208-0.133-0.31   c-0.038-0.083-0.077-0.165-0.118-0.246c-0.045-0.087-0.093-0.172-0.143-0.257c-0.051-0.088-0.103-0.175-0.158-0.26   c-0.048-0.074-0.099-0.145-0.149-0.216c-0.063-0.088-0.127-0.175-0.194-0.259C58.456,2.19,58.4,2.127,58.344,2.063   c-0.07-0.081-0.141-0.161-0.216-0.238c-0.062-0.064-0.128-0.125-0.192-0.187c-0.073-0.068-0.145-0.136-0.221-0.201   c-0.076-0.065-0.155-0.126-0.234-0.187c-0.07-0.054-0.14-0.108-0.212-0.159c-0.09-0.064-0.183-0.123-0.277-0.181   c-0.067-0.042-0.134-0.085-0.203-0.123c-0.101-0.057-0.204-0.11-0.309-0.162c-0.068-0.034-0.136-0.068-0.205-0.099   c-0.104-0.046-0.21-0.088-0.317-0.129c-0.077-0.03-0.154-0.059-0.232-0.085c-0.099-0.033-0.2-0.063-0.301-0.091   c-0.093-0.025-0.185-0.05-0.279-0.071c-0.089-0.02-0.178-0.037-0.268-0.053c-0.111-0.02-0.224-0.038-0.337-0.052   c-0.077-0.009-0.154-0.016-0.231-0.022c-0.126-0.01-0.252-0.017-0.38-0.019C53.896,0.005,53.86,0,53.824,0H6C2.687,0,0,2.687,0,6   c0,3.313,2.687,6,6,6h43.185l10.867,41.793c0,0.001,0.001,0.002,0.001,0.004l36.107,138.852c0.688,2.644,3.075,4.49,5.807,4.49   h169.383c2.732,0,5.119-1.846,5.807-4.49l36.111-138.855C313.736,51.996,313.345,50.083,312.208,48.613z M290.786,92.566h-62.338   V58.283h71.254L290.786,92.566z M278.748,138.855h-50.3v-34.289h59.217L278.748,138.855z M156.87,138.855v-34.289h59.578v34.289   H156.87z M216.448,150.855v34.283H156.87v-34.283H216.448z M85.655,104.566h59.215v34.289H94.571L85.655,104.566z M156.87,92.566   V58.283h59.578v34.283H156.87z M144.87,58.283v34.283H82.534l-8.915-34.283H144.87z M97.692,150.855h47.178v34.283h-38.263   L97.692,150.855z M266.711,185.139h-38.263v-34.283h47.179L266.711,185.139z"></path><path d="M126.419,211.072c-16.791,0-30.451,13.66-30.451,30.451s13.66,30.451,30.451,30.451s30.451-13.66,30.451-30.451   S143.21,211.072,126.419,211.072z M126.419,259.975c-10.174,0-18.451-8.277-18.451-18.451c0-10.174,8.277-18.451,18.451-18.451   s18.451,8.277,18.451,18.451C144.87,251.697,136.593,259.975,126.419,259.975z"></path><path d="M246.9,211.072c-16.791,0-30.451,13.66-30.451,30.451s13.66,30.451,30.451,30.451c16.791,0,30.451-13.66,30.451-30.451   S263.69,211.072,246.9,211.072z M246.9,259.975c-10.174,0-18.451-8.277-18.451-18.451c0-10.174,8.277-18.451,18.451-18.451   c10.174,0,18.451,8.277,18.451,18.451C265.351,251.697,257.073,259.975,246.9,259.975z"></path></g></svg></div>`
                  qty_selector_structure+=`</div>`;
                }
              })

              if(!variant_is_already_added){
                qty_selector_structure+=qty_selector_cart_icon_structure;
              }
            }else{
              qty_selector_structure+=qty_selector_cart_icon_structure;
            }
          }

          return qty_selector_structure;
        }

		$wcpb_bb_ms_product_grid_variants_html($wcpb_bb_pgrid_customized_temp_html, $wcpb_bb_pro_val,$wcpb_bb_api_json,$wcpb_bb_pro_idx) {
			const $wcpb_bb_variant_length_cls = $wcpb_bb_pro_val.variants && $wcpb_bb_pro_val.variants.length <= 1 ? "th_pb_cb_p_grid_variant_single" : "";
			let $wcpb_bb_variant_html = '<select class="th_pb_wf th_pb_cb_p_grid_main_variant ' + $wcpb_bb_variant_length_cls + '" aria-label="Select a variant for ' + $wcpb_bb_pro_val.title + '" value="' + $wcpb_bb_pro_val.selected_variant + '">';
            console.log("$wcpb_bb_pro_valvariants",$wcpb_bb_pro_val);
			($wcpb_bb_pro_val.variants || []).map(($wcpb_bb_v_val, $wcpb_bb_v_idx) => {
				const $wcpb_bb_v_selected_true = $wcpb_bb_v_val.id == $wcpb_bb_pro_val.selected_variant ? 'selected="selected"' : "";
				if ($wcpb_bb_v_val && $wcpb_bb_v_val.inventory_management && $wcpb_bb_v_val.inventory_management.toLowerCase() == "shopify") {
					if ($wcpb_bb_v_val && $wcpb_bb_v_val.inventory_policy && $wcpb_bb_v_val.inventory_policy.toLowerCase() != "deny") {
						$wcpb_bb_variant_html += '<option value="' + $wcpb_bb_v_val.id + '" key="' + $wcpb_bb_v_idx + '" ' + $wcpb_bb_v_selected_true + ">" + $wcpb_bb_v_val.title + "</option>";
					} else {
						if ($wcpb_bb_v_val && $wcpb_bb_v_val.inventory_quantity > 0) {
							$wcpb_bb_variant_html += '<option value="' + $wcpb_bb_v_val.id + '" key="' + $wcpb_bb_v_idx + '" ' + $wcpb_bb_v_selected_true + ">" + $wcpb_bb_v_val.title + "</option>";
						}
					}
				} else {
					$wcpb_bb_variant_html += '<option value="' + $wcpb_bb_v_val.id + '" key="' + $wcpb_bb_v_idx + '" ' + $wcpb_bb_v_selected_true + ">" + $wcpb_bb_v_val.title + "</option>";
				}
			});
			$wcpb_bb_variant_html += "</select>";

             //custom variant section starts
            $wcpb_bb_variant_html+=`<div class='th_bb_custom_variant_section_containor ${$wcpb_bb_variant_length_cls}'>`;
               $wcpb_bb_variant_html+=`<div class='th_bb_custom_variant_section_lable' onClick='th_toggle_custom_variant_dropdawn(this)'><span class='th_custom_vaariant_section_total_count' value="${this.$return_total_added_product_count($wcpb_bb_pro_val.id,$wcpb_bb_api_json)}">${this.$return_total_added_product_count($wcpb_bb_pro_val.id,$wcpb_bb_api_json)} Added</span> <div>Select</div> <div><svg xmlns="http://www.w3.org/2000/svg" width="20px" height="20px" viewBox="-2.4 -2.4 28.80 28.80" fill="none" transform="rotate(90)matrix(1, 0, 0, 1, 0, 0)"><g id="SVGRepo_bgCarrier" stroke-width="0" transform="translate(0,0), scale(1)"/><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round" stroke="#CCCCCC" stroke-width="0.4800000000000001"/><g id="SVGRepo_iconCarrier"> <path d="M8.91003 19.9201L15.43 13.4001C16.2 12.6301 16.2 11.3701 15.43 10.6001L8.91003 4.08008" stroke="#292D32" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/></g></svg></div></div>`;
                $wcpb_bb_variant_html+=`<div class='th_bb_variant_option_containor hide_variant_section ${$wcpb_bb_pro_idx%2==0? 'th_bb_variant_option_containor_second_multiply_element':''}' data-prod_id='${$wcpb_bb_pro_val.id}'>`;
            	($wcpb_bb_pro_val.variants || []).map(($wcpb_bb_v_val, $wcpb_bb_v_idx) => {
    				const $wcpb_bb_v_selected_true = $wcpb_bb_v_val.id == $wcpb_bb_pro_val.selected_variant ? true : false;
    				if ($wcpb_bb_v_val && $wcpb_bb_v_val.inventory_management && $wcpb_bb_v_val.inventory_management.toLowerCase() == "shopify") {
    					if ($wcpb_bb_v_val && $wcpb_bb_v_val.inventory_policy && $wcpb_bb_v_val.inventory_policy.toLowerCase() != "deny") {
                           $wcpb_bb_variant_html+=`<div class='th_bb_variant_option ${($wcpb_bb_v_selected_true)?"th_bb_variant_option_active":''}' data-variant_id='${$wcpb_bb_v_val.id}' onClick='th_bb_variant_option_click(this)'>`;
                              $wcpb_bb_variant_html+=`<div class='th_bb_variant_option_title'>${$wcpb_bb_v_val.title}</div>`;
                              $wcpb_bb_variant_html+=`<div class='th_bb_variant_option_qty_selector'>`;
                                    $wcpb_bb_variant_html+=this.$th_return_th_bb_variant_option_qty_selector_structure($wcpb_bb_api_json,$wcpb_bb_v_val.id);
                              $wcpb_bb_variant_html+=`</div>`;
                           $wcpb_bb_variant_html+=`</div>`;
    					} else {
    						if ($wcpb_bb_v_val && $wcpb_bb_v_val.inventory_quantity > 0) {
                                $wcpb_bb_variant_html+=`<div class='th_bb_variant_option ${($wcpb_bb_v_selected_true)?"th_bb_variant_option_active":''}' data-variant_id='${$wcpb_bb_v_val.id}' onClick='th_bb_variant_option_click(this)'>`;
                                $wcpb_bb_variant_html+=`<div class='th_bb_variant_option_title'>${$wcpb_bb_v_val.title}</div>`;
                                $wcpb_bb_variant_html+=`<div class='th_bb_variant_option_qty_selector'>`;
                                      $wcpb_bb_variant_html+=this.$th_return_th_bb_variant_option_qty_selector_structure($wcpb_bb_api_json,$wcpb_bb_v_val.id);
                                $wcpb_bb_variant_html+=`</div>`;
                                $wcpb_bb_variant_html+=`</div>`;
    						}
    					}
    				} else {
                          $wcpb_bb_variant_html+=`<div class='th_bb_variant_option ${($wcpb_bb_v_selected_true)?"th_bb_variant_option_active":''}' data-variant_id='${$wcpb_bb_v_val.id}' onClick='th_bb_variant_option_click(this)'>`;
                              $wcpb_bb_variant_html+=`<div class='th_bb_variant_option_title'>${$wcpb_bb_v_val.title}</div>`;
                              $wcpb_bb_variant_html+=`<div class='th_bb_variant_option_qty_selector'>`;
                                    $wcpb_bb_variant_html+=this.$th_return_th_bb_variant_option_qty_selector_structure($wcpb_bb_api_json,$wcpb_bb_v_val.id);
                              $wcpb_bb_variant_html+=`</div>`;
                           $wcpb_bb_variant_html+=`</div>`;
    				}
    			});
              $wcpb_bb_variant_html+=`</div>`;
            $wcpb_bb_variant_html+=`</div>`;
            //custom variant section ends        
			for (let i = 1; i <= ($wcpb_bb_pgrid_customized_temp_html.match(/[[wcpb_bb_pgrid_pvariants]]/g) || []).length; i++) {
				$wcpb_bb_pgrid_customized_temp_html = $wcpb_bb_pgrid_customized_temp_html.replace("[[wcpb_bb_pgrid_pvariants]]", $wcpb_bb_variant_html);
			}
			return $wcpb_bb_pgrid_customized_temp_html;
		}
		$wcpb_bb_ms_product_grid_add_cta_html($wcpb_bb_pgrid_customized_temp_html, $wcpb_bb_pro_val, $wcpb_bb_variant_disable_btn, $wcpb_bb_ms_disable_add_btn, $wcpb_bb_variant_sum, $wcpb_bb_selected_section_index) {
			const $wcpb_bb_pgrid_added_cls = $wcpb_bb_selected_section_index != -1 && (this.$wcpb_bb_api_json.wcpb_bb_multi_section[$wcpb_bb_selected_section_index].added_products || []).some((y) => y.p_id === $wcpb_bb_pro_val.id) ? "th_pb_cb_added_grid" : "";
			const $wcpb_bb_variant_disable_btn_temp = $wcpb_bb_pro_val.selected_variant ? "" : "th_pb_cb_p_grid_add_disabled";
			let $wcpb_bb_product_grid_add_html = '<div class="th_pb_wf th_pb_cb_p_grid_add ' + $wcpb_bb_pgrid_added_cls + '">';
			$wcpb_bb_product_grid_add_html += '<button type="button" class="th_pb_wf btn  th_pb_cb_ms_p_grid_add_btn ' + $wcpb_bb_ms_disable_add_btn + " " + $wcpb_bb_variant_disable_btn_temp + '">' + this.$wcpb_bb_api_json.grid_add_label + "</button>";
			$wcpb_bb_product_grid_add_html += '<div class="th_pb_wf btn  th_pb_cb_p_grid_add_qty">';
			$wcpb_bb_product_grid_add_html += '<div><button type="button" aria-label="minus" class="th_pb_cb_p_grid_add_qty_btn th_pb_cb_ms_p_grid_add_qty_minus">';
			$wcpb_bb_product_grid_add_html += '<svg  class="th_trash_icon_prodcuct_grid" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20px" height="20px"><path d="M 10 2 L 9 3 L 3 3 L 3 5 L 21 5 L 21 3 L 15 3 L 14 2 L 10 2 z M 4.3652344 7 L 6.0683594 22 L 17.931641 22 L 19.634766 7 L 4.3652344 7 z"/></svg>';
			$wcpb_bb_product_grid_add_html += "</button></div>";
			$wcpb_bb_product_grid_add_html += '<div><span class="th_pb_cb_p_grid_add_qty_text">';
			$wcpb_bb_product_grid_add_html += "<em>" + $wcpb_bb_variant_sum + "</em>";
			$wcpb_bb_product_grid_add_html += "</span></div>";
			$wcpb_bb_product_grid_add_html += '<div><button type="button" aria-label="plus" class="th_pb_cb_p_grid_add_qty_btn th_pb_cb_ms_p_grid_add_qty_plus ' + $wcpb_bb_ms_disable_add_btn + " " + $wcpb_bb_variant_disable_btn_temp + '" >';
			$wcpb_bb_product_grid_add_html += '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" fill="#000000" height="20px" width="20px" version="1.1" id="Capa_1" viewBox="0 0 303.124 303.124" xml:space="preserve"><g><path d="M312.208,48.613c-1.136-1.47-2.889-2.33-4.746-2.33H70.499L59.631,4.49c-0.01-0.038-0.024-0.073-0.035-0.11   c-0.033-0.119-0.07-0.235-0.11-0.35c-0.026-0.076-0.054-0.152-0.083-0.227c-0.042-0.105-0.086-0.208-0.133-0.31   c-0.038-0.083-0.077-0.165-0.118-0.246c-0.045-0.087-0.093-0.172-0.143-0.257c-0.051-0.088-0.103-0.175-0.158-0.26   c-0.048-0.074-0.099-0.145-0.149-0.216c-0.063-0.088-0.127-0.175-0.194-0.259C58.456,2.19,58.4,2.127,58.344,2.063   c-0.07-0.081-0.141-0.161-0.216-0.238c-0.062-0.064-0.128-0.125-0.192-0.187c-0.073-0.068-0.145-0.136-0.221-0.201   c-0.076-0.065-0.155-0.126-0.234-0.187c-0.07-0.054-0.14-0.108-0.212-0.159c-0.09-0.064-0.183-0.123-0.277-0.181   c-0.067-0.042-0.134-0.085-0.203-0.123c-0.101-0.057-0.204-0.11-0.309-0.162c-0.068-0.034-0.136-0.068-0.205-0.099   c-0.104-0.046-0.21-0.088-0.317-0.129c-0.077-0.03-0.154-0.059-0.232-0.085c-0.099-0.033-0.2-0.063-0.301-0.091   c-0.093-0.025-0.185-0.05-0.279-0.071c-0.089-0.02-0.178-0.037-0.268-0.053c-0.111-0.02-0.224-0.038-0.337-0.052   c-0.077-0.009-0.154-0.016-0.231-0.022c-0.126-0.01-0.252-0.017-0.38-0.019C53.896,0.005,53.86,0,53.824,0H6C2.687,0,0,2.687,0,6   c0,3.313,2.687,6,6,6h43.185l10.867,41.793c0,0.001,0.001,0.002,0.001,0.004l36.107,138.852c0.688,2.644,3.075,4.49,5.807,4.49   h169.383c2.732,0,5.119-1.846,5.807-4.49l36.111-138.855C313.736,51.996,313.345,50.083,312.208,48.613z M290.786,92.566h-62.338   V58.283h71.254L290.786,92.566z M278.748,138.855h-50.3v-34.289h59.217L278.748,138.855z M156.87,138.855v-34.289h59.578v34.289   H156.87z M216.448,150.855v34.283H156.87v-34.283H216.448z M85.655,104.566h59.215v34.289H94.571L85.655,104.566z M156.87,92.566   V58.283h59.578v34.283H156.87z M144.87,58.283v34.283H82.534l-8.915-34.283H144.87z M97.692,150.855h47.178v34.283h-38.263   L97.692,150.855z M266.711,185.139h-38.263v-34.283h47.179L266.711,185.139z"></path><path d="M126.419,211.072c-16.791,0-30.451,13.66-30.451,30.451s13.66,30.451,30.451,30.451s30.451-13.66,30.451-30.451   S143.21,211.072,126.419,211.072z M126.419,259.975c-10.174,0-18.451-8.277-18.451-18.451c0-10.174,8.277-18.451,18.451-18.451   s18.451,8.277,18.451,18.451C144.87,251.697,136.593,259.975,126.419,259.975z"></path><path d="M246.9,211.072c-16.791,0-30.451,13.66-30.451,30.451s13.66,30.451,30.451,30.451c16.791,0,30.451-13.66,30.451-30.451   S263.69,211.072,246.9,211.072z M246.9,259.975c-10.174,0-18.451-8.277-18.451-18.451c0-10.174,8.277-18.451,18.451-18.451   c10.174,0,18.451,8.277,18.451,18.451C265.351,251.697,257.073,259.975,246.9,259.975z"></path></g></svg>';
			$wcpb_bb_product_grid_add_html += "</button></div>";
			$wcpb_bb_product_grid_add_html += "</div>";
			$wcpb_bb_product_grid_add_html += "</div>";
			for (let i = 1; i <= ($wcpb_bb_pgrid_customized_temp_html.match(/[[wcpb_bb_pgrid_paddbtn]]/g) || []).length; i++) {
				$wcpb_bb_pgrid_customized_temp_html = $wcpb_bb_pgrid_customized_temp_html.replace("[[wcpb_bb_pgrid_paddbtn]]", $wcpb_bb_product_grid_add_html);
			}
			return $wcpb_bb_pgrid_customized_temp_html;
		}
		$wcpb_bb_ms_build_loadmore_btn($wcpb_bb_sec_temp_val) {
			let $wcpb_bb_ms_build_loadmore_html = "";
			if ($wcpb_bb_sec_temp_val.next_product_page) {
				$wcpb_bb_ms_build_loadmore_html += '<button type="button" aria-label="' + this.$wcpb_bb_api_json.language.buildbox_load_more + '" class="btn button th_pb_cb_ms_p_grid_loadmore_btn" data-scroll="' + this.$wcpb_bb_api_json.btn_load_more + '">';
				$wcpb_bb_ms_build_loadmore_html += '<span class="button_text">' + this.$wcpb_bb_api_json.language.buildbox_load_more + "</span>";
				$wcpb_bb_ms_build_loadmore_html += '<em class="th_pb_add_to_cart_loader"></em>';
				$wcpb_bb_ms_build_loadmore_html += "</button>";
			}
			return $wcpb_bb_ms_build_loadmore_html;
		}
		$wcpb_bb_ms_product_grid_html($wcpb_bb_ms_main_temp_html) {
			(this.$wcpb_bb_api_json.sections || []).map(
				($wcpb_bb_sec_val, $wcpb_bb_sec_idx) => {
					if ($wcpb_bb_sec_idx === this.$wcpb_bb_api_json.wcpb_bb_selected_section_count) {
						let $wcpb_bb_selected_section_index = this.$wcpb_bb_api_json.wcpb_bb_multi_section.findIndex(
							(y) => y.section_id == $wcpb_bb_sec_val.section_id);
						let $wcpb_bb_ms_total_qty = 0;
						if ($wcpb_bb_selected_section_index != -1) {
							$wcpb_bb_ms_total_qty = (this.$wcpb_bb_api_json.wcpb_bb_multi_section[$wcpb_bb_selected_section_index].added_products || []).reduce((a, b) => +a + b.added_qty, 0);
						}
						const $wcpb_bb_ms_disable_add_btn = parseInt($wcpb_bb_sec_val.max_product) === $wcpb_bb_ms_total_qty && parseInt($wcpb_bb_sec_val.max_product) && parseInt($wcpb_bb_sec_val.max_product) > 0 ? "th_pb_cb_p_grid_add_disabled" : "";
						let $wcpb_bb_ms_pgrid_html = "";
                        let product_index_count=0;
						($wcpb_bb_sec_val.products || []).map(
							($wcpb_bb_pro_val, $wcpb_bb_pro_idx) => {
                                product_index_count++;
								let $wcpb_bb_ms_pgrid_customized_html = this.$wcpb_bb_layout_htmls.bb_p_grid_html;
								let $wcpb_bb_variant_disable_btn = true;
								let $wcpb_bb_product_img = "https://bundle.thimatic-apps.com/assets/img/no-product-image.svg";
								if (Object.keys($wcpb_bb_pro_val.image).length) {
									$wcpb_bb_product_img = $th_image_resizer($wcpb_bb_pro_val.image.src, "400x");
								}
								if (Object.keys($wcpb_bb_pro_val.images).length) {
									Object.keys($wcpb_bb_pro_val.images).map(($wcpb_bb_key) => {
										let $wcpb_bb_selected_found = false;
										if (Object.keys($wcpb_bb_pro_val.images[$wcpb_bb_key].variant_ids).length) {
											Object.keys($wcpb_bb_pro_val.images[$wcpb_bb_key].variant_ids).map(($wcpb_bb_v_key) => {
												if ($wcpb_bb_pro_val.images[$wcpb_bb_key].variant_ids[$wcpb_bb_v_key] == $wcpb_bb_pro_val.selected_variant) {
													$wcpb_bb_selected_found = true;
												}
											});
										}
										if ($wcpb_bb_selected_found) {
											$wcpb_bb_product_img = $th_image_resizer($wcpb_bb_pro_val.images[$wcpb_bb_key].src, "400x");
										}
									});
								}
								let $wcpb_bb_variant_sum = 0;
								(this.$wcpb_bb_api_json.wcpb_bb_multi_section || []).map(
									($wcpb_bb_added_section_val) => {
										if ($wcpb_bb_added_section_val.section_id == $wcpb_bb_sec_val.section_id) {
											($wcpb_bb_added_section_val.added_products || []).map(
												($wcpb_bb_added_val) => {
													if ($wcpb_bb_added_val.p_id == $wcpb_bb_pro_val.id) {
														$wcpb_bb_variant_sum = $wcpb_bb_variant_sum + $wcpb_bb_added_val.added_qty;
													}
												});
										}
									});
								if ($wcpb_bb_pro_val.variants && $wcpb_bb_pro_val.variants.length <= 1) {
									if (
										($wcpb_bb_pro_val.status && $wcpb_bb_pro_val.status.toLowerCase() != "draft") || this.$wcpb_bb_api_json.disable_click == false) {
										if ($wcpb_bb_pro_val.variants[0] && $wcpb_bb_pro_val.variants[0].inventory_management && $wcpb_bb_pro_val.variants[0].inventory_management.toLowerCase() == "shopify") {
											if ($wcpb_bb_pro_val.variants[0] && $wcpb_bb_pro_val.variants[0].inventory_policy && $wcpb_bb_pro_val.variants[0].inventory_policy.toLowerCase() != "deny") {
												$wcpb_bb_variant_disable_btn = false;
											} else if ($wcpb_bb_pro_val.variants[0] && $wcpb_bb_pro_val.variants[0].inventory_quantity > 0) {
												$wcpb_bb_variant_disable_btn = false;
											}
										} else {
											$wcpb_bb_variant_disable_btn = false;
										}
									}
								} else {
									$wcpb_bb_variant_disable_btn = false;
								}
								let $wcpb_bb_ms_pro_disabled = "";
								if ($wcpb_bb_pro_val.status == "DRAFT") {
									$wcpb_bb_ms_pro_disabled = 'data-draft="true"';
								}
								for (let i = 1; i <= ($wcpb_bb_ms_pgrid_customized_html.match(/[[wcpb_bb_pgrid_disabled]]/g) || []).length; i++) {
									$wcpb_bb_ms_pgrid_customized_html = $wcpb_bb_ms_pgrid_customized_html.replace("[[wcpb_bb_pgrid_disabled]]", $wcpb_bb_ms_pro_disabled);
								}
								for (let i = 1; i <= ($wcpb_bb_ms_pgrid_customized_html.match(/[[wcpb_bb_pgrid_url]]/g) || []).length; i++) {
									$wcpb_bb_ms_pgrid_customized_html = $wcpb_bb_ms_pgrid_customized_html.replace("[[wcpb_bb_pgrid_url]]", "/products/" + $wcpb_bb_pro_val.handle);
								}
								for (let i = 1; i <= ($wcpb_bb_ms_pgrid_customized_html.match(/[[wcpb_bb_pgrid_img_url]]/g) || []).length; i++) {
									$wcpb_bb_ms_pgrid_customized_html = $wcpb_bb_ms_pgrid_customized_html.replace("[[wcpb_bb_pgrid_img_url]]", '<img src="' + $wcpb_bb_product_img + '" alt="' + $wcpb_bb_pro_val.title + '" />');
								}
								for (let i = 1; i <= ($wcpb_bb_ms_pgrid_customized_html.match(/[[wcpb_bb_pgrid_ptitle]]/g) || []).length; i++) {
									$wcpb_bb_ms_pgrid_customized_html = $wcpb_bb_ms_pgrid_customized_html.replace("[[wcpb_bb_pgrid_ptitle]]", $wcpb_bb_pro_val.title);
								}
								$wcpb_bb_ms_pgrid_customized_html = this.$wcpb_bb_ms_product_grid_price($wcpb_bb_ms_pgrid_customized_html, $wcpb_bb_pro_val);
								$wcpb_bb_ms_pgrid_customized_html = this.$wcpb_bb_ms_product_grid_variants_html($wcpb_bb_ms_pgrid_customized_html, $wcpb_bb_pro_val,this.$wcpb_bb_api_json,product_index_count);
								$wcpb_bb_ms_pgrid_customized_html = this.$wcpb_bb_ms_product_grid_add_cta_html($wcpb_bb_ms_pgrid_customized_html, $wcpb_bb_pro_val, $wcpb_bb_variant_disable_btn, $wcpb_bb_ms_disable_add_btn, $wcpb_bb_variant_sum, $wcpb_bb_selected_section_index);
								$wcpb_bb_ms_pgrid_html += $wcpb_bb_ms_pgrid_customized_html;
							});
						for (let i = 1; i <= ($wcpb_bb_ms_main_temp_html.match(/[[wcpb_bb_box_products_grid_html]]/g) || []).length; i++) {
							$wcpb_bb_ms_main_temp_html = $wcpb_bb_ms_main_temp_html.replace("[[wcpb_bb_box_products_grid_html]]", $wcpb_bb_ms_pgrid_html);
						}
						for (let i = 1; i <= ($wcpb_bb_ms_main_temp_html.match(/[[wcpb_bb_load_more_btn]]/g) || []).length; i++) {
							$wcpb_bb_ms_main_temp_html = $wcpb_bb_ms_main_temp_html.replace("[[wcpb_bb_load_more_btn]]", this.$wcpb_bb_ms_build_loadmore_btn($wcpb_bb_sec_val));
						}
					}
				});
			return $wcpb_bb_ms_main_temp_html;
		}
		$th_return_multitier_html_string() {
			let th_multitier_discount_layout = "";
			if (this.$wcpb_bb_api_json.multi_tiered_discounts.length > 0) {
				th_multitier_discount_layout += `<main class="th_multitier_discount_main_containor_wc">`;
				th_multitier_discount_layout += `<div class="th_multitier_discount_sub_containor_wc">`;
				th_multitier_discount_layout += `<div class="th_multitier_min_max_message_text_wc"></div>`;
				th_multitier_discount_layout += `<div class="th_round_circle_steps_containor_wc">`;
				let tiers = this.$wcpb_bb_api_json.multi_tiered_discounts;
				tiers.forEach((tier) => {
					if (this.$wcpb_bb_api_json.discount_trigger == 0) {
						// discount_after_price
						let th_discount_after_this_price_value = $th_money_format(parseFloat(tier.discount_trigger_value * 100) * parseFloat(Shopify.currency.rate), $th_shop_money,true);
						if (this.$wcpb_bb_api_json.discount_type == "1") {
							//fixed_discount
							var tier_box_discount = $th_money_format(parseFloat(tier.box_discount * 100) * parseFloat(Shopify.currency.rate), $th_shop_money);
						} else {
							var tier_box_discount = `${tier.box_discount}%`;
						}
						th_multitier_discount_layout += `
                            <div class="th_multitier_discount_round_cricle_step_containor_wc">
                                <div class="th_multitier_discount_round_cricle_step_sub_containor_wc">
                                    <div class="th_multitier_straight_line_wc"><span></span></div>
                                    <div class="th_round_circle_multitier_discount_wc discount-step">
                                        <p>${tier_box_discount}<br>${this.$wcpb_bb_api_json.language.tier_save_text}</br></p>
                                    </div>
                                    <div class="th_multitier_straight_line_wc"><span></span></div>
                                </div>
                                <div class="th_multitier_discount_trigger_value_wc">${th_discount_after_this_price_value}</div>
                            </div>`;
					} else {
						// discount_after_quantity
						let tier_discount_after_quantity_value = this.$wcpb_bb_api_json.language.tier_quantity_text;
						tier_discount_after_quantity_value = tier_discount_after_quantity_value.replace("{{qty}}", tier.discount_trigger_value);
						if (this.$wcpb_bb_api_json.discount_type == "1") {
							var tier_box_discount = $th_money_format(parseFloat(tier.box_discount * 100) * parseFloat(Shopify.currency.rate), $th_shop_money);
						} else {
							var tier_box_discount = `${tier.box_discount}%`;
						}
						th_multitier_discount_layout += `
                            <div class="th_multitier_discount_round_cricle_step_containor_wc">
                                <div class="th_multitier_discount_round_cricle_step_sub_containor_wc">
                                    <div class="th_multitier_straight_line_wc"><span></span></div>
                                    <div class="th_round_circle_multitier_discount_wc discount-step">
                                        <p>${tier_box_discount}<br>${this.$wcpb_bb_api_json.language.tier_save_text}</br></p>
                                    </div>
                                    <div class="th_multitier_straight_line_wc"><span></span></div>
                                </div>
                                <div class="th_multitier_discount_trigger_value_wc">${tier_discount_after_quantity_value}</div>
                            </div>`;
					}
				});
				th_multitier_discount_layout += `</div>`;
				th_multitier_discount_layout += `</div>`;
				th_multitier_discount_layout += `</main>`;
			}
			return th_multitier_discount_layout;
		}
		$wcpb_bb_build_html_init() {
			if (this.$wcpb_bb_layout_htmls.bb_section_html != "" && this.$wcpb_bb_layout_htmls.bb_p_grid_html != "" && this.$wcpb_bb_layout_htmls.bb_selected_p_grid_html != "") {
				let $wcpb_bb_main_html = this.$wcpb_bb_layout_htmls.bb_section_html;
				if (this.$wcpb_bb_api_json.use_discount == "1" && this.$wcpb_bb_api_json.use_discount_type == "2") {
					// $wcpb_bb_main_html = $wcpb_bb_main_html.replace(`<div class="th_pb_bb_section">`, `<div class="th_pb_bb_section">` + this.$th_return_multitier_html_string());
                    $wcpb_bb_main_html = $wcpb_bb_main_html.replace("[[th_multitier_layout]]", this.$th_return_multitier_html_string());
				} 
				for (let i = 1; i <= ($wcpb_bb_main_html.match(/[[wcpb_bb_widget_title]]/g) || []).length; i++) {
					$wcpb_bb_main_html = $wcpb_bb_main_html.replace("[[wcpb_bb_widget_title]]", this.$wcpb_bb_api_json.box_widget_title);
				}
				for (let i = 1; i <= ($wcpb_bb_main_html.match(/[[wcpb_bb_widget_desc]]/g) || []).length; i++) {
					$wcpb_bb_main_html = $wcpb_bb_main_html.replace("[[wcpb_bb_widget_desc]]", this.$wcpb_bb_api_json.short_desc ? this.$wcpb_bb_api_json.short_desc : "");
				}
				for (let i = 1; i <= ($wcpb_bb_main_html.match(/[[wcpb_bb_box_products_grid_html]]/g) || []).length; i++) {
					$wcpb_bb_main_html = $wcpb_bb_main_html.replace("[[wcpb_bb_box_products_grid_html]]", this.$wcpb_bb_product_grid_html());
				}
				for (let i = 1; i <= ($wcpb_bb_main_html.match(/[[wcpb_bb_load_more_btn]]/g) || []).length; i++) {
					$wcpb_bb_main_html = $wcpb_bb_main_html.replace("[[wcpb_bb_load_more_btn]]", this.$wcpb_bb_build_loadmore_btn());
				}
				for (let i = 1; i <= ($wcpb_bb_main_html.match(/[[wcpb_bb_box_title]]/g) || []).length; i++) {
					$wcpb_bb_main_html = $wcpb_bb_main_html.replace("[[wcpb_bb_box_title]]", this.$wcpb_bb_api_json.boxname);
				}
				$wcpb_bb_main_html = this.$wcpb_bb_box_final_total_price($wcpb_bb_main_html);
				for (let i = 1; i <= ($wcpb_bb_main_html.match(/[[wcpb_bb_box_limit_msg]]/g) || []).length; i++) {
					$wcpb_bb_main_html = $wcpb_bb_main_html.replace("[[wcpb_bb_box_limit_msg]]", this.$wcpb_bb_limit_msg_html());
				}
				for (let i = 1; i <= ($wcpb_bb_main_html.match(/[[wcpb_bb_box_selected_grid_html]]/g) || []).length; i++) {
					$wcpb_bb_main_html = $wcpb_bb_main_html.replace("[[wcpb_bb_box_selected_grid_html]]", this.$wcpb_bb_box_selected_grid_html());
				}
				for (let i = 1; i <= ($wcpb_bb_main_html.match(/[[wcpb_bb_box_addtocart_cta_btn]]/g) || []).length; i++) {
					$wcpb_bb_main_html = $wcpb_bb_main_html.replace("[[wcpb_bb_box_addtocart_cta_btn]]", this.$wcpb_bb_final_atc_cta_btn());
				}
				for (let i = 1; i <= ($wcpb_bb_main_html.match(/[[wcpb_bb_total_products]]/g) || []).length; i++) {
					$wcpb_bb_main_html = $wcpb_bb_main_html.replace("[[wcpb_bb_total_products]]", this.$wcpb_bb_api_json.total_products);
				}
				this.$wcpb_bb_section_this.innerHTML = $wcpb_bb_main_html;
				if (this.$wcpb_bb_api_json.wc_bd_number == 7) {
					this.$wcpb_bb_section_this.insertAdjacentHTML("beforeend", '<div class="wc_shopify_preview" style="display: flex !important;width: 100% !important;float: left !important;justify-content: center !important;margin-top: 10px !important; opacity: 1 !important; visibility: visible !important; height: 30px !important;"><img src="https://bundle.thimatic-apps.com/rebolt-bundle/public/img/powered_by_rebolt.png" style="display: flex !important;width: 120px !important; opacity: 1 !important; visibility: visible !important; height: 27px !important;"></div>');
				}
				let th_multitier_discount_scrollbar_div_wc = this.$wcpb_bb_section_this.querySelector(".th_round_circle_steps_containor_wc");
				if (th_multitier_discount_scrollbar_div_wc) {
					function th_is_scrollbar_enable_wc(element) {
						return element.scrollWidth > element.clientWidth;
					}
					const th_scrollbar_active_or_not = th_is_scrollbar_enable_wc(th_multitier_discount_scrollbar_div_wc);
					if (th_scrollbar_active_or_not) {
						th_multitier_discount_scrollbar_div_wc.style = "justify-content: start";
					} else {
						th_multitier_discount_scrollbar_div_wc.style = "scrollbar-width: none";
					}
				}
				this.$wcpb_bb_single_variant_change();
				this.$wcpb_bb_single_add_event();
				this.$wcpb_bb_single_addtocart_cta_event();
				this.$wcpb_bb_loadmore_event();
				if (typeof window.$wcpb_bb_custom_callback_event == "function") {
					window.$wcpb_bb_custom_callback_event(this.$wcpb_bb_api_json);
				}
			}
		}
		$wcpb_bb_ms_build_html_init() {
			if (this.$wcpb_bb_layout_htmls.bb_multi_section_html != "" && this.$wcpb_bb_layout_htmls.bb_p_grid_html != "" && this.$wcpb_bb_layout_htmls.bb_section_step_html != "" && this.$wcpb_bb_layout_htmls.bb_selected_p_grid_html != "") {
				let $wcpb_bb_ms_main_html = this.$wcpb_bb_layout_htmls.bb_multi_section_html;
				if (this.$wcpb_bb_api_json.use_discount == "1" && this.$wcpb_bb_api_json.use_discount_type == "2") {
					// $wcpb_bb_ms_main_html = $wcpb_bb_ms_main_html.replace(`<div class="th_pb_bb_section">`, `<div class="th_pb_bb_section">` + this.$th_return_multitier_html_string());
                    $wcpb_bb_ms_main_html = $wcpb_bb_ms_main_html.replace("[[th_multitier_layout]]", this.$th_return_multitier_html_string());
				}
				for (let i = 1; i <= ($wcpb_bb_ms_main_html.match(/[[wcpb_bb_widget_title]]/g) || []).length; i++) {
					$wcpb_bb_ms_main_html = $wcpb_bb_ms_main_html.replace("[[wcpb_bb_widget_title]]", this.$wcpb_bb_api_json.box_widget_title);
				}
				for (let i = 1; i <= ($wcpb_bb_ms_main_html.match(/[[wcpb_bb_widget_desc]]/g) || []).length; i++) {
					$wcpb_bb_ms_main_html = $wcpb_bb_ms_main_html.replace("[[wcpb_bb_widget_desc]]", this.$wcpb_bb_api_json.short_desc ? this.$wcpb_bb_api_json.short_desc : "");
				}
				for (let i = 1; i <= ($wcpb_bb_ms_main_html.match(/[[wcpb_bb_step_previous_btn]]/g) || []).length; i++) {
					$wcpb_bb_ms_main_html = $wcpb_bb_ms_main_html.replace("[[wcpb_bb_step_previous_btn]]", this.$wcpb_bb_step_previous_btn());
				}
				for (let i = 1; i <= ($wcpb_bb_ms_main_html.match(/[[wcpb_bb_step_next_btn]]/g) || []).length; i++) {
					$wcpb_bb_ms_main_html = $wcpb_bb_ms_main_html.replace("[[wcpb_bb_step_next_btn]]", this.$wcpb_bb_step_next_btn());
				}
				$wcpb_bb_ms_main_html = this.$wcpb_bb_ms_step_build($wcpb_bb_ms_main_html);
				for (let i = 1; i <= ($wcpb_bb_ms_main_html.match(/[[wcpb_bb_box_limit_msg]]/g) || []).length; i++) {
					$wcpb_bb_ms_main_html = $wcpb_bb_ms_main_html.replace("[[wcpb_bb_box_limit_msg]]", this.$wcpb_bb_ms_limit_msg_html());
				}
				$wcpb_bb_ms_main_html = this.$wcpb_bb_ms_product_grid_html($wcpb_bb_ms_main_html);
				for (let i = 1; i <= ($wcpb_bb_ms_main_html.match(/[[wcpb_bb_box_title]]/g) || []).length; i++) {
					$wcpb_bb_ms_main_html = $wcpb_bb_ms_main_html.replace("[[wcpb_bb_box_title]]", this.$wcpb_bb_api_json.boxname);
				}
				for (let i = 1; i <= ($wcpb_bb_ms_main_html.match(/[[wcpb_bb_box_active_idx]]/g) || []).length; i++) {
					$wcpb_bb_ms_main_html = $wcpb_bb_ms_main_html.replace("[[wcpb_bb_box_active_idx]]", this.$wcpb_bb_api_json.wcpb_bb_selected_section_count);
				}
				$wcpb_bb_ms_main_html = this.$wcpb_bb_box_final_total_price($wcpb_bb_ms_main_html);
				for (let i = 1; i <= ($wcpb_bb_ms_main_html.match(/[[wcpb_bb_box_selected_grid_html]]/g) || []).length; i++) {
					$wcpb_bb_ms_main_html = $wcpb_bb_ms_main_html.replace("[[wcpb_bb_box_selected_grid_html]]", this.$wcpb_bb_box_selected_grid_html());
				}
				for (let i = 1; i <= ($wcpb_bb_ms_main_html.match(/[[wcpb_bb_box_addtocart_cta_btn]]/g) || []).length; i++) {
					$wcpb_bb_ms_main_html = $wcpb_bb_ms_main_html.replace("[[wcpb_bb_box_addtocart_cta_btn]]", this.$wcpb_bb_final_atc_cta_btn());
				}
				for (let i = 1; i <= ($wcpb_bb_ms_main_html.match(/[[wcpb_bb_total_products]]/g) || []).length; i++) {
					$wcpb_bb_ms_main_html = $wcpb_bb_ms_main_html.replace("[[wcpb_bb_total_products]]", this.$wcpb_bb_api_json.total_products);
				}
				this.$wcpb_bb_section_this.innerHTML = $wcpb_bb_ms_main_html;
				if (this.$wcpb_bb_api_json.wc_bd_number == 7) {
					this.$wcpb_bb_section_this.insertAdjacentHTML("beforeend", '<div class="wc_shopify_preview" style="display: flex !important;width: 100% !important;float: left !important;justify-content: center !important;margin-top: 10px !important; opacity: 1 !important; visibility: visible !important; height: 30px !important;"><img src="https://bundle.thimatic-apps.com/rebolt-bundle/public/img/powered_by_rebolt.png" style="display: flex !important;width: 120px !important; opacity: 1 !important; visibility: visible !important; height: 27px !important;"></div>');
				}
				let th_multitier_discount_scrollbar_div_wc = this.$wcpb_bb_section_this.querySelector(".th_round_circle_steps_containor_wc");
				if (th_multitier_discount_scrollbar_div_wc) {
					function th_is_scrollbar_enable_wc(element) {
						return element.scrollWidth > element.clientWidth;
					}
					const th_scrollbar_active_or_not = th_is_scrollbar_enable_wc(th_multitier_discount_scrollbar_div_wc);
					if (th_scrollbar_active_or_not) {
						th_multitier_discount_scrollbar_div_wc.style = "justify-content: start";
					} else {
						th_multitier_discount_scrollbar_div_wc.style = "scrollbar-width: none";
					}
				}
				this.$wcpb_bb_ms_loadmore_event();
				this.$wcpb_bb_ms_tab_change_event();
				this.$wcpb_bb_ms_single_variant_change();
				this.$wcpb_bb_ms_single_add_event();
				this.$wcpb_bb_ms_single_addtocart_cta_event();
				if (typeof window.$wcpb_bb_custom_callback_event == "function") {
					window.$wcpb_bb_custom_callback_event(this.$wcpb_bb_api_json);
				}
			}
		}
		$wcpb_bb_update_json_val() {
			if (this.$wcpb_bb_api_json.data.bundle_structure_type == "1") {
				let $wcpb_bb_temp_sections = [],
					$wcpb_bb_mlutisection_clone = [];
				(this.$wcpb_bb_api_json.data.sections || []).map(
					($wcpb_bb_section_val) => {
						let $wcpb_bb_temp_product = [];
						$wcpb_bb_section_val.products.map(($wcpb_bb_p_val) => {
							let $wcpb_bb_loop_break = false,
								$wcpb_bb_selected_variant_obj = {};
							($wcpb_bb_p_val.variants || []).map(($wcpb_bb_variant_val) => {
								if (!$wcpb_bb_loop_break) {
									if ($wcpb_bb_variant_val && $wcpb_bb_variant_val.inventory_management && $wcpb_bb_variant_val.inventory_management.toLowerCase() == "shopify") {
										if ($wcpb_bb_variant_val && $wcpb_bb_variant_val.inventory_policy && $wcpb_bb_variant_val.inventory_policy.toLowerCase() != "deny") {
											$wcpb_bb_loop_break = true;
											$wcpb_bb_selected_variant_obj = $wcpb_bb_variant_val;
										} else if ($wcpb_bb_variant_val && $wcpb_bb_variant_val.inventory_quantity > 0) {
											$wcpb_bb_loop_break = true;
											$wcpb_bb_selected_variant_obj = $wcpb_bb_variant_val;
										}
									} else {
										$wcpb_bb_loop_break = true;
										$wcpb_bb_selected_variant_obj = $wcpb_bb_variant_val;
									}
								}
							});
							let $wcpb_bb_selected_variant_img = $wcpb_bb_p_val.image && $wcpb_bb_p_val.image.src ? $wcpb_bb_p_val.image.src : "https://bundle.thimatic-apps.com/assets/img/no-product-image.svg";
							if ($wcpb_bb_selected_variant_obj.image && $wcpb_bb_selected_variant_obj.image.originalSrc) {
								$wcpb_bb_selected_variant_img = $wcpb_bb_selected_variant_obj.image.originalSrc;
							}
							let $wcpb_bb_temp_p_obj = {
								...$wcpb_bb_p_val,
								selected_variant: $wcpb_bb_selected_variant_obj.id,
								added_qty: 0,
								selected_variant_title: $wcpb_bb_selected_variant_obj.title,
								v_price: parseFloat($wcpb_bb_selected_variant_obj.price),
								v_orignal_price: parseFloat($wcpb_bb_selected_variant_obj.orignal_price),
								v_orignal_price: parseFloat($wcpb_bb_selected_variant_obj.orignal_price),
								v_compare_price: parseFloat($wcpb_bb_selected_variant_obj.compare_at_price),
								variant_key: $wcpb_bb_selected_variant_obj.variant_key,
								variant_img: $wcpb_bb_selected_variant_img,
							};
							$wcpb_bb_temp_product.push($wcpb_bb_temp_p_obj);
						});
						let $wcpb_bb_obj_section = {
							...$wcpb_bb_section_val,
							products: $wcpb_bb_temp_product,
							page_count: 0,
						};
						$wcpb_bb_temp_sections.push($wcpb_bb_obj_section);
						let $wcpb_bb_multisection_obj = {
							section_id: $wcpb_bb_section_val.section_id,
							added_products: [],
						};
						$wcpb_bb_mlutisection_clone.push($wcpb_bb_multisection_obj);
					});
				for (var secIndex in $wcpb_bb_temp_sections) {
					var section = $wcpb_bb_temp_sections[secIndex];
					var section_id = section.section_id;
					var selected_index = -1;
					var filteredItems2 = section.products.filter(
						(product) => product.is_preselected === 1);
					for (var MultiCloneindex in $wcpb_bb_mlutisection_clone) {
						var sectionMultiSec = $wcpb_bb_mlutisection_clone[MultiCloneindex];
						if (sectionMultiSec.section_id == section_id) {
							selected_index = MultiCloneindex;
						}
					}
					for (var item in filteredItems2) {
						var th_object_to_push = {
							added_qty: 1,
							p_handle: filteredItems2[item].handle,
							p_id: filteredItems2[item].id,
							p_title: filteredItems2[item].title,
							v_compare_price: filteredItems2[item].variants[0].compare_at_price,
							v_id: filteredItems2[item].variants[0].id,
							v_original_price: filteredItems2[item].variants[0].original_price,
							v_price: filteredItems2[item].variants[0].price,
							v_title: filteredItems2[item].variants[0].title,
							variant_img: filteredItems2[item].variants[0].image ? filteredItems2[item].variants[0].image.originalSrc : filteredItems2[item].image ? filteredItems2[item].image.src : "https://bundle.thimatic-apps.com/assets/img/no-product-image.svg",
							variant_key: filteredItems2[item].variants[0].variant_key,
						};
						$wcpb_bb_mlutisection_clone[selected_index].added_products.push(th_object_to_push);
					}
				}
				this.$wcpb_bb_api_json = {
					...this.$wcpb_bb_api_json.data,
					sections: $wcpb_bb_temp_sections,
					wcpb_bb_multi_section: $wcpb_bb_mlutisection_clone,
					wcpb_bb_selected_section_count: 0,
					wcpb_bb_single_section: [],
					discount_mode: this.$wcpb_bb_api_json.data.discount_mode,
					disable_click: this.$wcpb_bb_api_json.data.disable_click,
				};
				this.$wcpb_bb_ms_build_html_init();
			} else {
				let $wcpb_bb_temp_product = [];
				(this.$wcpb_bb_api_json.data.products || []).map(($wcpb_bb_p_val) => {
					let $wcpb_bb_loop_break = false,
						$wcpb_bb_selected_variant_obj = {};
					($wcpb_bb_p_val.variants || []).map(($wcpb_bb_variant_val) => {
						if (!$wcpb_bb_loop_break) {
							if ($wcpb_bb_variant_val && $wcpb_bb_variant_val.inventory_management && $wcpb_bb_variant_val.inventory_management.toLowerCase() == "shopify") {
								if ($wcpb_bb_variant_val && $wcpb_bb_variant_val.inventory_policy && $wcpb_bb_variant_val.inventory_policy.toLowerCase() != "deny") {
									$wcpb_bb_loop_break = true;
									$wcpb_bb_selected_variant_obj = $wcpb_bb_variant_val;
								} else if ($wcpb_bb_variant_val && $wcpb_bb_variant_val.inventory_quantity > 0) {
									$wcpb_bb_loop_break = true;
									$wcpb_bb_selected_variant_obj = $wcpb_bb_variant_val;
								}
							} else {
								$wcpb_bb_loop_break = true;
								$wcpb_bb_selected_variant_obj = $wcpb_bb_variant_val;
							}
						}
					});
					let $wcpb_bb_selected_variant_img = $wcpb_bb_p_val.image && $wcpb_bb_p_val.image.src ? $wcpb_bb_p_val.image.src : "https://bundle.thimatic-apps.com/assets/img/no-product-image.svg";
					if ($wcpb_bb_selected_variant_obj.image && $wcpb_bb_selected_variant_obj.image.originalSrc) {
						$wcpb_bb_selected_variant_img = $wcpb_bb_selected_variant_obj.image.originalSrc;
					}
					let $wcpb_bb_temp_p_obj = {
						...$wcpb_bb_p_val,
						selected_variant: $wcpb_bb_selected_variant_obj.id,
						added_qty: 0,
						selected_variant_title: $wcpb_bb_selected_variant_obj.title,
						v_price: parseFloat($wcpb_bb_selected_variant_obj.price),
						v_orignal_price: parseFloat($wcpb_bb_selected_variant_obj.orignal_price),
						v_compare_price: parseFloat($wcpb_bb_selected_variant_obj.compare_at_price),
						variant_key: $wcpb_bb_selected_variant_obj.variant_key,
						variant_img: $wcpb_bb_selected_variant_img,
					};
					$wcpb_bb_temp_product.push($wcpb_bb_temp_p_obj);
				});
				const filteredItems = $wcpb_bb_temp_product.filter(
					(product) => product.is_preselected === 1);
				const singleSelection = [];
				for (var item in filteredItems) {
					singleSelection[item] = {};
					singleSelection[item].added_qty = 1;
					singleSelection[item].p_handle = filteredItems[item].handle;
					singleSelection[item].p_id = filteredItems[item].id;
					singleSelection[item].p_title = filteredItems[item].title;
					singleSelection[item].v_compare_price = filteredItems[item].variants[0].compare_at_price;
					singleSelection[item].v_id = filteredItems[item].variants[0].id;
					singleSelection[item].v_original_price = filteredItems[item].variants[0].original_price;
					singleSelection[item].v_price = filteredItems[item].variants[0].price;
					singleSelection[item].v_title = filteredItems[item].variants[0].title;
					singleSelection[item].variant_img = filteredItems[item].variants[0].image.originalSrc;
					singleSelection[item].variant_key = filteredItems[item].variants[0].variant_key;
				}
				this.$wcpb_bb_api_json = {
					...this.$wcpb_bb_api_json.data,
					products: $wcpb_bb_temp_product,
					wcpb_bb_single_section: singleSelection,
					wcpb_bb_multi_section: [],
					discount_mode: this.$wcpb_bb_api_json.data.discount_mode,
					disable_click: this.$wcpb_bb_api_json.data.disable_click,
					page_count: 0,
				};
				this.$wcpb_bb_build_html_init();
			}
		}
	}
	const $wcpb_bb_new_ajax_request = async function($wcpb_bb_ajax_data, $wcpb_bb_bundle_this) {
		fetch($th_bb_app_ajax_url + 'bundle-box', {
			method: 'POST',
			body: JSON.stringify($wcpb_bb_ajax_data),
			cache: 'no-cache'
		}).then(response => response.json()).then($wcpb_bb_result => {
			if (!$wcpb_bb_result.error) {
				if ($wcpb_bb_result.data.bundle_key) {
					let $wcpb_bb_build_init_json = new $wcpb_bb_section_class_function($wcpb_bb_result, $wcpb_bb_bundle_this, $wcpb_bb_result.bb_layout);
					$wcpb_bb_build_init_json.$wcpb_bb_update_json_val();
                    let mobile_search=document.querySelector('.mobile-search');
                    if(mobile_search){
                      mobile_search.classList.add("th_yes_this_page_contains_buildbox");
                    }
					if (typeof $th_bundle_success_callback === 'function') {
						$th_bundle_success_callback($wcpb_bb_result.data.id);
					}
				}
			}
		}).catch(($wcpb_bb_result) => {
			console.error($wcpb_bb_result);
			$wcpb_bb_bundle_this.innerHTML = '';
		});
	}
	if (document.querySelector('.wc_pb_bb_section_id[data-bbid]')) {
		document.querySelectorAll('.wc_pb_bb_section_id[data-bbid]').forEach(function($wcpb_bb_bundle, $wcpb_bb_idx) {
			$wcpb_bb_bundle.innerHTML = $th_loader_code;
			const $wcpb_bb_id = $wcpb_bb_bundle.getAttribute('data-bbid');
			const $wcpb_bb_ajax_data = {
				shop: $th_shop_conveted_url,
				box_id: $wcpb_bb_id,
				active_currency: $th_active_currency,
				active_country: $th_active_country,
				page: []
			};
			$wcpb_bb_new_ajax_request($wcpb_bb_ajax_data, $wcpb_bb_bundle);
		});
	}
	const $wcpb_pr_bundle_change_event = () => {
		document.querySelectorAll('.wc_bundle_pr_single_variant').forEach(($wcpb_pr_select_this) => {
			$wcpb_pr_select_this[$th_bundle_addEventListener]('change', async (event) => {
				event.preventDefault(), event.stopImmediatePropagation();
				const $wcpb_pr_this_parent = $wcpb_pr_select_this.closest('[data-pgrid="wcpb_grid_start"]');
				$wcpb_pr_this_parent.querySelector('.wcpb_pr_p_grid_img_cls').setAttribute('src', $wcpb_pr_select_this.options[$wcpb_pr_select_this.selectedIndex].getAttribute('data-image'));
				const $wcpb_pr_price = parseFloat($wcpb_pr_select_this.options[$wcpb_pr_select_this.selectedIndex].getAttribute('data-price'));
				const $wcpb_pr_compare_price = parseFloat($wcpb_pr_select_this.options[$wcpb_pr_select_this.selectedIndex].getAttribute('data-compare_price'));
				$wcpb_pr_this_parent.querySelector('.wcpb_pr_p_main_price').innerHTML = '<span class="money">' + $th_money_format($wcpb_pr_price, $th_shop_money) + '</span>';
				if ($wcpb_pr_compare_price > $wcpb_pr_price) {
					$wcpb_pr_this_parent.querySelector('.wcpb_pr_p_compare_price').innerHTML = '<span class="money th_pb_line_through">' + $th_money_format($wcpb_pr_compare_price, $th_shop_money) + '</span>';
				} else {
					$wcpb_pr_this_parent.querySelector('.wcpb_pr_p_compare_price').innerHTML = '';
				}
				if ($wcpb_pr_select_this.options[$wcpb_pr_select_this.selectedIndex].getAttribute('data-available') == 'true') {
					$wcpb_pr_this_parent.querySelector('.wc_bundle_pr_cta_cls').setAttribute('style', 'pointer-events:auto !important;');
					$wcpb_pr_this_parent.querySelector('.wc_bundle_pr_cta_cls').classList.remove('wc_bundle_pr_cta_disabled');
				} else {
					$wcpb_pr_this_parent.querySelector('.wc_bundle_pr_cta_cls').setAttribute('style', 'pointer-events:none !important;');
					$wcpb_pr_this_parent.querySelector('.wc_bundle_pr_cta_cls').classList.add('wc_bundle_pr_cta_disabled');
				}
			});
		});
		const $wcpb_pr_bundle_normal_enable_cta_btn = ($wcpb_pr_option_parents, $wcpb_pr_option_val_array) => {
			const $wcpb_pr_final_option_selected = $wcpb_pr_option_val_array.join(" / ");
			$wcpb_pr_option_parents.querySelector('.wc_bundle_pr_single_variant').selectedIndex = -1;
			if ($wcpb_pr_option_parents.querySelectorAll('.wc_bundle_pr_single_variant option[data-title="' + $wcpb_pr_final_option_selected + '"]').length > 0) {
				$wcpb_pr_option_parents.querySelector('.wc_bundle_pr_single_variant option[data-title="' + $wcpb_pr_final_option_selected + '"]').selected = true;
				$wcpb_pr_option_parents.querySelector('.wc_bundle_pr_single_variant').dispatchEvent(new Event('change'));
			} else {
				$wcpb_pr_option_parents.closest('[data-pgrid="wcpb_grid_start"]').querySelector('.wc_bundle_pr_cta_cls').setAttribute('style', 'pointer-events:none !important;');
				$wcpb_pr_option_parents.closest('[data-pgrid="wcpb_grid_start"]').querySelector('.wc_bundle_pr_cta_cls').classList.add('wc_bundle_pr_cta_disabled');
			}
		}
		const $wcpb_pr_update_radio_button = ($wcpb_pr_select_index, $wcpb_pr_option_pro_id, $wcpb_pr_option_parents) => {
			switch ($wcpb_pr_select_index) {
				case 1:
					var $wcpb_pr_key = 'root';
					break;
				case 2:
					var $wcpb_pr_key = $wcpb_pr_option_parents.querySelector('.wc_bundle_pr_variant_select_div_cls[data-index="0"] .wc_bundle_pr_variant_swatch_btn:checked').value;
					break;
				case 3:
					var $wcpb_pr_key = $wcpb_pr_option_parents.querySelector('.wc_bundle_pr_variant_select_div_cls[data-index="0"] .wc_bundle_pr_variant_swatch_btn:checked').value;
					$wcpb_pr_key += ' / ' + $wcpb_pr_option_parents.querySelector('.wc_bundle_pr_variant_select_div_cls[data-index="1"] .wc_bundle_pr_variant_swatch_btn:checked').value;
			}
			let $wcpb_pr_vari_availableOptions = ($th_products_json.th_bundle_variantmap[$wcpb_pr_option_pro_id + '_' + $wcpb_pr_key]) ? $th_products_json.th_bundle_variantmap[$wcpb_pr_option_pro_id + '_' + $wcpb_pr_key] : [];
			$wcpb_pr_option_parents.closest('[data-pgrid="wcpb_grid_start"]').querySelectorAll('.wc_bundle_pr_variant_select_div_cls[data-index="' + ($wcpb_pr_select_index - 1) + '"] .wc_bundle_pr_variant_swatch_field').forEach(function($wcpb_pr_variants_swatches_div_cls) {
				if ($wcpb_pr_vari_availableOptions.includes($wcpb_pr_variants_swatches_div_cls.querySelector('.wc_bundle_pr_variant_swatch_btn').value)) {
					$wcpb_pr_variants_swatches_div_cls.classList.remove('th_vari_soldout');
					$wcpb_pr_variants_swatches_div_cls.style.display = 'inline-block';
					$wcpb_pr_variants_swatches_div_cls.querySelector('.wc_bundle_pr_variant_swatch_btn').removeAttribute('disabled');
				} else {
					$wcpb_pr_variants_swatches_div_cls.classList.add('th_vari_soldout');
					$wcpb_pr_variants_swatches_div_cls.style.display = 'none';
					$wcpb_pr_variants_swatches_div_cls.querySelector('.wc_bundle_pr_variant_swatch_btn').setAttribute('disabled', 'disabled');
					if ($wcpb_pr_variants_swatches_div_cls.querySelectorAll('.wc_bundle_pr_variant_swatch_btn:checked').length) {
						$wcpb_pr_variants_swatches_div_cls.querySelector('.wc_bundle_pr_variant_swatch_btn').removeAttribute('checked');
						if ($wcpb_pr_variants_swatches_div_cls.nextSibling) {
							$wcpb_pr_variants_swatches_div_cls.nextSibling.querySelector('.wc_bundle_pr_variant_swatch_btn').setAttribute('checked', 'checked');
						}
					}
				}
			});
		}
		if (document.querySelector('.wc_bundle_pr_variant_swatch_btn')) {
			document.querySelectorAll('.wc_bundle_pr_variant_swatch_btn').forEach(($wcpb_pr_option_this) => {
				const $wcpb_pr_option_parents = $wcpb_pr_option_this.closest('.wc_bundle_pr_variant_section_cls');
				$wcpb_pr_option_this[$th_bundle_addEventListener]('change', async (event) => {
					event.preventDefault(), event.stopImmediatePropagation();
					const $wcpb_pr_option_val_array = new Array();
					$wcpb_pr_option_parents.querySelectorAll('.wc_bundle_pr_variant_select_div_cls').forEach(($wcpb_pr_variants_swatches_div_cls) => {
						if ($wcpb_pr_variants_swatches_div_cls.querySelector('.wc_bundle_pr_variant_swatch_btn:checked')) {
							let $wcpb_pr_temp_val = $wcpb_pr_variants_swatches_div_cls.querySelector('.wc_bundle_pr_variant_swatch_btn:checked').value;
							$wcpb_pr_option_val_array.push($wcpb_pr_temp_val);
						}
					});
					const $wcpb_pr_option_pro_id = $wcpb_pr_option_parents.closest('[data-pgrid="wcpb_grid_start"]').getAttribute('data-pid');
					$wcpb_pr_update_radio_button(parseInt($th_products_json.th_bundle_products[$wcpb_pr_option_pro_id][0].options.length), $wcpb_pr_option_pro_id, $wcpb_pr_option_parents);
					$wcpb_pr_bundle_normal_enable_cta_btn($wcpb_pr_option_parents, $wcpb_pr_option_val_array);
				});
				$wcpb_pr_option_this.dispatchEvent(new Event('change'));
			});
		}
		if (document.querySelector('.wc_bundle_pr_option_select_cls')) {
			document.querySelectorAll('.wc_bundle_pr_option_select_cls').forEach(($wcpb_pr_option_this) => {
				const $wcpb_pr_option_parents = $wcpb_pr_option_this.closest('.wc_bundle_pr_variant_section_cls');
				$wcpb_pr_option_this[$th_bundle_addEventListener]('change', async (event) => {
					event.preventDefault(), event.stopImmediatePropagation();
					const $wcpb_pr_option_val_array = new Array();
					$wcpb_pr_option_parents.querySelectorAll('.wc_bundle_pr_option_select_cls').forEach(($wcpb_pr_option_select) => {
						$wcpb_pr_option_val_array.push($wcpb_pr_option_select.options[$wcpb_pr_option_select.selectedIndex].value);
					});
					$wcpb_pr_bundle_normal_enable_cta_btn($wcpb_pr_option_parents, $wcpb_pr_option_val_array);
				});
				$wcpb_pr_option_parents.querySelector('.wc_bundle_pr_single_variant').dispatchEvent(new Event('change'));
			});
		}
	}
	const $wcpb_pr_bundle_cta_atc_event = () => {
		if (document.querySelector('.wc_bundle_pr_cta_cls')) {
			document.querySelectorAll('.wc_bundle_pr_cta_cls').forEach(($wcpb_pr_cta_this) => {
				$wcpb_pr_cta_this[$th_bundle_addEventListener]('click', async (event) => {
					event.preventDefault(), event.stopImmediatePropagation();
					$th_bundle_cta_loader_class($wcpb_pr_cta_this, 'add_loader', 'th_pb_btn_loading');
					const $wcpb_pr_bundle_id = $wcpb_pr_cta_this.getAttribute('data-bid');
					let $wcpb_pr_id_array = new Array();
					$wcpb_pr_id_array.push({
						id: $wcpb_pr_cta_this.closest('[data-pgrid="wcpb_grid_start"]').querySelector('.wc_bundle_pr_single_variant').options[$wcpb_pr_cta_this.closest('[data-pgrid="wcpb_grid_start"]').querySelector('.wc_bundle_pr_single_variant').selectedIndex].value,
						quantity: 1,
						properties: {
							_th_bundle_product: $wcpb_pr_bundle_id,
							_th_bundle_type: 'recommended'
						}
					});
					const $wcpb_pr_bundle_formData = {
						items: $wcpb_pr_id_array
					};
					const $wcpb_pr_addtocart_result = await $th_bundle_cta_ajax_event($wcpb_pr_bundle_formData).then($wcpb_pr_addtocart_response => {
						return $wcpb_pr_addtocart_response
					});
					if ($wcpb_pr_addtocart_result.items) {
						if ($wcpb_pr_cta_this.getAttribute('data-checkout') == '2') {
							if (typeof $wcpb_pr_addtocart_callback === 'function') {
								$wcpb_pr_addtocart_callback($wcpb_pr_cta_this, $wcpb_pr_addtocart_result);
							}
						} else if ($wcpb_pr_cta_this.getAttribute('data-checkout') == '1') {
							window.location.href = '/checkout';
						} else {
							var route_url = window.Shopify.routes.root;
							if (!route_url) {
								route_url = window.Shopify.routes.root_url;
							}
							const $th_bundle_cta_root_url = (Shopify && Shopify.routes && route_url) ? route_url : '/';
							window.location.href = window.location.origin + $th_bundle_cta_root_url + 'cart';
						}
						$th_bundle_cta_loader_class($wcpb_pr_cta_this, 'remove_loader', 'th_pb_btn_loading');
					}
				});
			});
		}
	}
	const $wcpb_pr_bundle_title = function($wcpb_pr_bundle_value) {
		let $wcpb_pr_title_html = '<div class="wc_bundle_pr_title wc_df_cls">';
		$wcpb_pr_title_html += '<h4>' + $wcpb_pr_bundle_value.bundle_detail.bundle_title + '</h4>';
		if ($wcpb_pr_bundle_value.bundle_detail.short_desc) {
			$wcpb_pr_title_html += '<div class="wc_bundle_pr_description">' + $wcpb_pr_bundle_value.bundle_detail.short_desc + '</div>';
		}
		$wcpb_pr_title_html += '</div>';
		return $wcpb_pr_title_html;
	}
	const $wcpb_pr_product_price_html = ($wcpb_pr_pro_value, $wcpb_pr_bundle_p_html) => {
		const $wcpb_pr_grid_sale_price = '<span class="wcpb_pr_p_main_price"><span class="money">' + $th_money_format($wcpb_pr_pro_value.variants[0].price * 100, $th_shop_money) + '</span></span>';
		const $wcpb_pr_grid_compare_temp_price = ($wcpb_pr_pro_value.variants[0].compare_at_price > $wcpb_pr_pro_value.variants[0].price) ? $th_money_format($wcpb_pr_pro_value.variants[0].compare_at_price * 100, $th_shop_money) : '';
		const $wcpb_pr_grid_compare_price = '<span class="wcpb_pr_p_compare_price"><span class="money th_pb_line_through">' + $wcpb_pr_grid_compare_temp_price + '</span></span>';
		for (let i = 1; i <= ($wcpb_pr_bundle_p_html.match(/[[wcpb_pr_pgrid_price]]/g) || []).length; i++) {
			$wcpb_pr_bundle_p_html = $wcpb_pr_bundle_p_html.replace('[[wcpb_pr_pgrid_price]]', $wcpb_pr_grid_sale_price);
		}
		for (let i = 1; i <= ($wcpb_pr_bundle_p_html.match(/[[wcpb_pr_pgrid_compare_price]]/g) || []).length; i++) {
			$wcpb_pr_bundle_p_html = $wcpb_pr_bundle_p_html.replace('[[wcpb_pr_pgrid_compare_price]]', $wcpb_pr_grid_compare_price);
		}
		return $wcpb_pr_bundle_p_html;
	}
	const $wcpb_pr_product_variants_html = ($wcpb_pr_pro_value, $wcpb_pr_bundle_p_html, $wcpb_pr_p_img, $wcpb_pr_bundle_value, $wcpb_pr_json_lay_settings) => {
		let $wcpb_pr_v_default_image = $wcpb_pr_p_img;
		let $wcpb_pr_variant_html = '<div class="wc_df_cls wc_bundle_pr_variant_section_cls">';
		$wcpb_pr_variant_html += '<select class="wc_bundle_pr_single_variant wc_bundle_pr_single_variant_hide">';
		($wcpb_pr_pro_value.variants || []).map(($wcpb_pr_v_val, $wcpb_pr_v_idx) => {
			if ($wcpb_pr_v_val.image !== undefined && $wcpb_pr_v_val.image !== null) {
				$wcpb_pr_v_default_image = $th_image_resizer($wcpb_pr_v_val.image.originalSrc, '600x');
			}
			const $wcpb_pr_available_status = $th_variant_instock_status($wcpb_pr_pro_value, $wcpb_pr_v_val);
			$wcpb_pr_variant_html += '<option value="' + $wcpb_pr_v_val.id + '" data-title="' + $wcpb_pr_v_val.title + '" data-ptitle="' + $wcpb_pr_pro_value.title + '" data-compare_price="' + ($wcpb_pr_v_val.compare_at_price * 100) + '" data-price="' + ($wcpb_pr_v_val.price * 100) + '" data-image="' + $wcpb_pr_v_default_image + '?v=123" data-available="' + $wcpb_pr_available_status + '">' + $wcpb_pr_v_val.title + '</option>';
		});
		$wcpb_pr_variant_html += '</select>';
		if ($wcpb_pr_pro_value.variants.length <= 1) {
			if ($wcpb_pr_pro_value.variants[0].title != 'Default Title') {
				$wcpb_pr_variant_html += '<div class="wc_df_cls wc_bundle_pr_single_variant_section"><span class="wc_df_cls wc_bundle_pr_single_variant_title">' + $wcpb_pr_pro_value.variants[0].title + '</span></div>';
			}
		} else {
			$wcpb_pr_variant_html += '<div class="wc_df_cls wc_bundle_pr_variant_options">';
			if ($wcpb_pr_json_lay_settings.variant_picker == '1') {
				const $wcpb_pr_current_time = Date.now();
				($wcpb_pr_pro_value.options || []).map(($wcpb_pr_option_list, $wcpb_pr_option_l_idx) => {
					$wcpb_pr_variant_html += '<div class="wc_df_cls wc_bundle_pr_variant_select_div_cls" data-index="' + $wcpb_pr_option_l_idx + '" data-option="' + $wcpb_pr_option_list.name.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '') + '">';
					$wcpb_pr_variant_html += '<span class="wc_df_cls wc_bundle_pr_option_label_cls">' + $wcpb_pr_option_list.name + '</span>';
					($wcpb_pr_option_list.values || []).map(($wcpb_pr_option_val, $wcpb_pr_option_val_idx) => {
						const $wcpb_pr_option_checked = $wcpb_pr_option_val_idx === 0 ? 'checked="checked"' : '';
						if ($wcpb_pr_option_list.name.toLowerCase().indexOf('color') != -1 || $wcpb_pr_option_list.name.toLowerCase().indexOf('colour') != -1 || $wcpb_pr_option_list.name.toLowerCase().indexOf('shade') != -1) {
							$wcpb_pr_variant_html += '<div class="wc_bundle_pr_variant_swatch_field wc_bundle_pr_variant_swatch_field_color">';
							$wcpb_pr_variant_html += '<input type="radio" name="wcpb_pr_qty_' + $wcpb_pr_bundle_value.bundle_detail.id + '_' + $wcpb_pr_pro_value.handle + '_' + $wcpb_pr_option_l_idx + '_' + $wcpb_pr_current_time + '" id="wcpb_pr_variant_swatch_' + $wcpb_pr_bundle_value.bundle_detail.id + '_' + $wcpb_pr_pro_value.handle + '_' + $wcpb_pr_option_l_idx + '_' + $wcpb_pr_option_val_idx + '_' + $wcpb_pr_current_time + '" class="wc_bundle_pr_variant_swatch_btn" value="' + $wcpb_pr_option_val.replace(/"/g, "'") + '" ' + $wcpb_pr_option_checked + ' />';
							$wcpb_pr_variant_html += '<label class="wc_bundle_pr_variant_swatch_label wc_bundle_pr_variant_swatch_color ' + $wcpb_pr_option_val.toLowerCase().replace(/[^\w ]+/g, '').replace(/ +/g, '-') + '" for="wcpb_pr_variant_swatch_' + $wcpb_pr_bundle_value.bundle_detail.id + '_' + $wcpb_pr_pro_value.handle + '_' + $wcpb_pr_option_l_idx + '_' + $wcpb_pr_option_val_idx + '_' + $wcpb_pr_current_time + '" style="background-color:' + $wcpb_pr_option_val.toLowerCase().replace(/[^\w ]+/g, '').replace(/ +/g, '-') + '" title="' + $wcpb_pr_option_val + '"></label>';
							$wcpb_pr_variant_html += '</div>';
						} else {
							$wcpb_pr_variant_html += '<div class="wc_bundle_pr_variant_swatch_field">';
							$wcpb_pr_variant_html += '<input type="radio" name="th_pb_qty_' + $wcpb_pr_bundle_value.bundle_detail.id + '_' + $wcpb_pr_pro_value.handle + '_' + $wcpb_pr_option_l_idx + '_' + $wcpb_pr_current_time + '" id="wcpb_pr_variant_swatch_' + $wcpb_pr_bundle_value.bundle_detail.id + '_' + $wcpb_pr_pro_value.handle + '_' + $wcpb_pr_option_l_idx + '_' + $wcpb_pr_option_val_idx + '_' + $wcpb_pr_current_time + '" class="wc_bundle_pr_variant_swatch_btn" value="' + $wcpb_pr_option_val.replace(/"/g, "'") + '" ' + $wcpb_pr_option_checked + ' />';
							$wcpb_pr_variant_html += '<label class="wc_bundle_pr_variant_swatch_label ' + $wcpb_pr_option_val.toLowerCase().replace(/[^\w ]+/g, '').replace(/ +/g, '-') + '" for="wcpb_pr_variant_swatch_' + $wcpb_pr_bundle_value.bundle_detail.id + '_' + $wcpb_pr_pro_value.handle + '_' + $wcpb_pr_option_l_idx + '_' + $wcpb_pr_option_val_idx + '_' + $wcpb_pr_current_time + '" title="' + $wcpb_pr_option_val + '">' + $wcpb_pr_option_val + '</label>';
							$wcpb_pr_variant_html += '</div>';
						}
					});
					$wcpb_pr_variant_html += '</div>';
				});
			} else {
				($wcpb_pr_pro_value.options || []).map(($wcpb_pr_option_list, $wcpb_pr_option_l_idx) => {
					$wcpb_pr_variant_html += '<div class="wc_df_cls wc_bundle_pr_variant_select_div_cls" data-option="' + $wcpb_pr_option_list.name.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '') + '">';
					$wcpb_pr_variant_html += '<label class="wc_df_cls wc_bundle_pr_option_label_cls" data-name="' + $wcpb_pr_option_list.name + '">' + $wcpb_pr_option_list.name + '</label>';
					$wcpb_pr_variant_html += '<select class="wc_df_cls wc_bundle_pr_option_select_cls" data-name="' + $wcpb_pr_option_list.name + '">';
					($wcpb_pr_option_list.values || []).map(($wcpb_pr_option_val, $wcpb_pr_option_val_idx) => {
						$wcpb_pr_variant_html += '<option value="' + $wcpb_pr_option_val.replace(/"/g, "'") + '">' + $wcpb_pr_option_val + '</option>';
					});
					$wcpb_pr_variant_html += '</select></div>';
				});
			}
			$wcpb_pr_variant_html += '</div>';
		}
		$wcpb_pr_variant_html += '</div>';
		$th_pb_generate_variantmap($wcpb_pr_pro_value);
		for (let i = 1; i <= ($wcpb_pr_bundle_p_html.match(/[[wcpb_pr_pgrid_variants]]/g) || []).length; i++) {
			$wcpb_pr_bundle_p_html = $wcpb_pr_bundle_p_html.replace('[[wcpb_pr_pgrid_variants]]', $wcpb_pr_variant_html);
		}
		return $wcpb_pr_bundle_p_html;
	}
	const $wcpb_pr_product_cta_btn_html = ($wcpb_pr_json_lay_settings, $wcpb_pr_bundle_p_html, $wcpb_pr_bundle_value) => {
		let $wcpb_pr_cta_btn_main_html = '<button type="button" class="btn button wc_bundle_pr_cta_cls" title="Add to Cart" data-bid="' + $wcpb_pr_bundle_value.bundle_detail.id + '" data-checkout="' + $wcpb_pr_json_lay_settings.direct_checkout + '">';
		$wcpb_pr_cta_btn_main_html += '<span class="button_text">Add to cart</span><em class="th_pb_add_to_cart_loader"></em>';
		$wcpb_pr_cta_btn_main_html += '</button>';
		for (let i = 1; i <= ($wcpb_pr_bundle_p_html.match(/[[wcpb_pr_pgrid_cta_btn]]/g) || []).length; i++) {
			$wcpb_pr_bundle_p_html = $wcpb_pr_bundle_p_html.replace('[[wcpb_pr_pgrid_cta_btn]]', ($wcpb_pr_json_lay_settings.show_addtocart_btn == '1') ? $wcpb_pr_cta_btn_main_html : '');
		}
		return $wcpb_pr_bundle_p_html;
	}
	const $wcpb_pr_bundle_p_grid = ($wcpb_pr_bundle_value, $wcpb_pr_json_lay_settings) => {
		let $wcpb_pr_bundle_p_main_html = '';
		($wcpb_pr_bundle_value.product_detail || []).map(($wcpb_pr_pro_value, $wcpb_pr_pro_idx) => {
			let $wcpb_pr_bundle_p_html = $wcpb_pr_json_lay_settings.html_grid;
			for (let i = 1; i <= ($wcpb_pr_bundle_p_html.match(/[[wcpb_pr_pgrid_parent]]/g) || []).length; i++) {
				$wcpb_pr_bundle_p_html = $wcpb_pr_bundle_p_html.replace('[[wcpb_pr_pgrid_parent]]', 'data-pgrid="wcpb_grid_start" data-pid="' + $wcpb_pr_pro_value.id + '"');
			}
			for (let i = 1; i <= ($wcpb_pr_bundle_p_html.match(/[[wcpb_pr_pgrid_url]]/g) || []).length; i++) {
				$wcpb_pr_bundle_p_html = $wcpb_pr_bundle_p_html.replace('[[wcpb_pr_pgrid_url]]', '/products/' + $wcpb_pr_pro_value.handle);
			}
			let $wcpb_pr_p_img = $th_pb_p_grid_image($wcpb_pr_pro_value);
			for (let i = 1; i <= ($wcpb_pr_bundle_p_html.match(/[[wcpb_pr_pgrid_img_url]]/g) || []).length; i++) {
				$wcpb_pr_bundle_p_html = $wcpb_pr_bundle_p_html.replace('[[wcpb_pr_pgrid_img_url]]', '<img class="wcpb_pr_p_grid_img_cls" src="' + $wcpb_pr_p_img + '?v=123" alt="' + $wcpb_pr_pro_value.p_title + '" />');
			}
			for (let i = 1; i <= ($wcpb_pr_bundle_p_html.match(/[[wcpb_pr_pgrid_title]]/g) || []).length; i++) {
				$wcpb_pr_bundle_p_html = $wcpb_pr_bundle_p_html.replace('[[wcpb_pr_pgrid_title]]', $wcpb_pr_pro_value.title);
			}
			$wcpb_pr_bundle_p_html = $wcpb_pr_product_price_html($wcpb_pr_pro_value, $wcpb_pr_bundle_p_html);
			$wcpb_pr_bundle_p_html = $wcpb_pr_product_variants_html($wcpb_pr_pro_value, $wcpb_pr_bundle_p_html, $wcpb_pr_p_img, $wcpb_pr_bundle_value, $wcpb_pr_json_lay_settings);
			$wcpb_pr_bundle_p_html = $wcpb_pr_product_cta_btn_html($wcpb_pr_json_lay_settings, $wcpb_pr_bundle_p_html, $wcpb_pr_bundle_value);
			$wcpb_pr_bundle_p_main_html += $wcpb_pr_bundle_p_html;
		});
		return $wcpb_pr_bundle_p_main_html;
	}
	const $wcpb_pr_enable_slider_event = ($wcpb_pr_slider_class) => {
		if (typeof Flickity === 'function') {
			var flkty = new Flickity($wcpb_pr_slider_class, {
				freeScroll: true,
				contain: true,
				wrapAround: true,
				groupCells: true,
				cellAlign: 'left'
			});
		}
	}
	const $wcpb_pr_main_html = ($wcpb_pr_json, $wcpb_pr_section) => {
		($wcpb_pr_json.bundle_list || []).map(($wcpb_pr_bundle_value, $wcpb_pr_bundle_idx) => {
			if ($wcpb_pr_bundle_value.product_detail && $wcpb_pr_bundle_value.product_detail.length > 0) {
				let $wcpb_pr_section_html = '<div class="wc_bundle_pr_outer wc_df_cls">';
				$wcpb_pr_section_html += $wcpb_pr_bundle_title($wcpb_pr_bundle_value);
				$wcpb_pr_section_html += '<div class="wc_bundle_pr_inner wc_df_cls"><div class="wc_bundle_pr_column wc_bundle_pr_column_index_' + $wcpb_pr_bundle_idx + '_' + $wcpb_pr_bundle_value.bundle_detail.id + ' wc_bundle_pr_column_slider_' + wc_external_script_layout.slider + ' wc_bundle_pr_column_idx_' + wc_external_script_layout.grid_number_as_per_row + '">';
				$wcpb_pr_section_html += $wcpb_pr_bundle_p_grid($wcpb_pr_bundle_value, $wcpb_pr_json.layout_setting);
				$wcpb_pr_section_html += '</div></div>';
				$wcpb_pr_section_html += '</div>';
				$wcpb_pr_section.insertAdjacentHTML('beforeend', $wcpb_pr_section_html);
				if (wc_external_script_layout.slider == '1') {
					const $wcpb_pr_slider_class = '.wc_bundle_pr_column_index_' + $wcpb_pr_bundle_idx + '_' + $wcpb_pr_bundle_value.bundle_detail.id;
					setTimeout(() => {
						$wcpb_pr_enable_slider_event($wcpb_pr_slider_class);
					}, 200);
				}
				$wcpb_pr_bundle_change_event();
				$wcpb_pr_bundle_cta_atc_event();
			}
		});
	}
	const $wcpb_pr_new_ajax_request = async function($wcpb_pr_ajax_data, $wcpb_pr_bundle, $wcpb_pr_carousel) {
		const $wcpb_pr_ajax_data_string = new URLSearchParams($wcpb_pr_ajax_data).toString();
		fetch($th_app_ajax_new_url + 'recommended-products?' + $wcpb_pr_ajax_data_string, {
			method: 'GET'
		}).then(response => response.json()).then($wcpb_pr_result => {
			if (!$wcpb_pr_result.error) {
				$wcpb_pr_main_html($wcpb_pr_result, $wcpb_pr_bundle);
			}
		}).catch(($wcpb_pr_result) => {
			console.error($wcpb_pr_result);
			$wcpb_pr_bundle.innerHTML = '';
		});
	}
	if (document.querySelector('.wc_bundle_product_recommended[data-thpid]')) {
		document.querySelectorAll('.wc_bundle_product_recommended[data-thpid]').forEach(function($wcpb_pr_bundle, $wcpb_pr_idx) {
			const $wcpb_pr_id = $wcpb_pr_bundle.getAttribute('data-thpid');
			const $wcpb_pr_ajax_data = {
				shop: $th_shop_conveted_url,
				product_id: $wcpb_pr_id,
				active_currency: $th_active_currency,
				active_country: $th_active_country,
				type: 'recommended'
			};
			$wcpb_pr_new_ajax_request($wcpb_pr_ajax_data, $wcpb_pr_bundle);
		});
	}
	if (document.querySelector('.wc_bundle_product_recently_viewed')) {
		document.querySelectorAll('.wc_bundle_product_recently_viewed').forEach(function($wcpb_rv_bundle, $wcpb_rv_idx) {
			const $wcpb_rv_b_id = $wcpb_rv_bundle.getAttribute('data-thbid');
			const $wcpb_rv_customer_id = __st.cid != undefined ? __st.cid : null;
			const $wcpb_rv_product_id = __st.rid != undefined ? __st.rid : null;
			const $wcpb_rv_ajax_data = {
				shop: $th_shop_conveted_url,
				product_id: $wcpb_rv_product_id,
				active_currency: $th_active_currency,
				active_country: $th_active_country,
				type: 'recently_viewed',
				customer_id: $wcpb_rv_customer_id,
				bundle_id: $wcpb_rv_b_id
			};
			$wcpb_pr_new_ajax_request($wcpb_rv_ajax_data, $wcpb_rv_bundle);
		});
	}
	const $wcpb_rv_save_product_ajax = async () => {
		const $wcpb_rv_customer_id = __st.cid != undefined ? __st.cid : null;
		const $wcpb_rv_post_data = {
			shop: $th_shop_conveted_url,
			product_id: __st.rid,
			customer_id: $wcpb_rv_customer_id
		};
		fetch($th_app_ajax_new_url + 'view-product', {
			method: 'POST',
			cache: 'no-cache',
			keepalive: true,
			body: JSON.stringify($wcpb_rv_post_data)
		}).then(response => response.json()).then($wcpb_pr_result => {
			if ($wcpb_pr_result.error) {
				localStorage.setItem('$wcpb_rv_disable', 'true');
			}
		}).catch(($wcpb_pr_result) => {
			console.error($wcpb_pr_result);
		});
	}
	if ($th_shop_conveted_url == 'ethan-watch-house.myshopify.com' || $th_shop_conveted_url == 'payful-paradise.myshopify.com' || $th_shop_conveted_url == 'xn-eckaa1e8bi5cx826gbpoc.myshopify.com') {
		if (__st && __st.p != undefined && __st.p == 'product' && localStorage.getItem('$wcpb_rv_disable') != 'true' && wc_external_script_layout && wc_external_script_layout.wc_ch_status) {
			$wcpb_rv_save_product_ajax();
		}
	}
	var clickEventAddOn = 0;
	const $wcpb_ao_variant_change_event = () => {
		const $wcpb_ao_addtocart_event = async ($wcpb_ao_id_array, argumentValue) => {
			const $wcpb_ao_formData = {
				items: $wcpb_ao_id_array
			};
			const $wcpb_ao_addtocart_result = await $th_bundle_cta_ajax_event($wcpb_ao_formData).then($wcpb_ao_addtocart_response => {
				return $wcpb_ao_addtocart_response
			});
			if ($wcpb_ao_addtocart_result.items) {
				var route_url = window.Shopify.routes.root;
				if (!route_url) {
					route_url = window.Shopify.routes.root_url;
				}
				const $wcpb_ao_cta_root_url = (Shopify && Shopify.routes && route_url) ? route_url : '/';
				if (argumentValue) {
					if (argumentValue == 'specific event') {
						if (typeof addonItemsAddedToCart == 'function') {
							addonItemsAddedToCart('addon_success');
						}
					} else {
						argumentValue.dispatchEvent(new Event('click'));
						argumentValue.closest('form').dispatchEvent(new Event('submit'));
						clickEventAddOn = 0;
					}
				} else {
					window.location.href = window.location.origin + $wcpb_ao_cta_root_url + 'cart';
				}
			}
		}
		if (document.querySelector('.wcpb_temp_addtocart_btn')) {
			document.querySelector('.wcpb_ao_section .wcpb_temp_addtocart_btn').style.display = 'none';
			document.querySelectorAll('.wcpb_temp_addtocart_btn').forEach(($wcpb_temp_addtocart_btn) => {
				$wcpb_temp_addtocart_btn[$th_bundle_addEventListener]('click', (event) => {
					event.preventDefault(), event.stopImmediatePropagation();
					const argumentValue = event.detail.argumentName;
					let $wcpb_ao_id_array = new Array();
					const $wcpb_ao_uid = $th_bundle_addtocart_uniqueid();
					const $wcpb_ao_bundle_id = $wcpb_temp_addtocart_btn.closest('.wcpb_ao_inner').getAttribute('data-bundle');
					$wcpb_temp_addtocart_btn.closest('.wcpb_ao_inner').querySelectorAll('.wcpb_ao_p_single_grid').forEach(($wcpb_ao_grid_val, $wcpb_ao_grid_idx) => {
						if ($wcpb_ao_grid_val.querySelector('.wcpb_ao_p_grid_checkbox_input').checked) {
                            let wc_ao_single_variant_pro_qty_input=$wcpb_ao_grid_val.querySelector('.wc_ao_single_variant_pro_qty_input');
                            if(wc_ao_single_variant_pro_qty_input){
    							$wcpb_ao_id_array.push({
    								id: $wcpb_ao_grid_val.querySelector('.wcpb_ao_pro_variants').options[$wcpb_ao_grid_val.querySelector('.wcpb_ao_pro_variants').selectedIndex].value,
    								quantity: wc_ao_single_variant_pro_qty_input.querySelector('em').innerText,
    								properties: {
    									_th_bundle_addon: $wcpb_ao_bundle_id,
    									_th_bundle_type: 'addon',
    									_th_bundle_uid: $wcpb_ao_uid
    								}
    							});
                             }else{
                              let th_bb_variant_options=$wcpb_ao_grid_val.querySelectorAll('.th_bb_variant_option');
                              th_bb_variant_options.forEach((th_bb_variant_option)=>{
                                let wc_variant_qty=parseFloat(th_bb_variant_option.querySelector('.th_bb_cusstom_variant_option_main_qty_selector_count_num').innerText);
                                if(wc_variant_qty>0){
                                  	$wcpb_ao_id_array.push({
    								id: th_bb_variant_option.dataset.variant_id,
    								quantity: wc_variant_qty,
    								properties: {
    									_th_bundle_addon: $wcpb_ao_bundle_id,
    									_th_bundle_type: 'addon',
    									_th_bundle_uid: $wcpb_ao_uid
    								}
    							});
                                }
                              })
                             }
                            
						}
					});
					if ($wcpb_ao_id_array.length > 0) {
						$wcpb_ao_addtocart_event($wcpb_ao_id_array, argumentValue);
					} else {
						if (argumentValue) {
							if (argumentValue == 'specific event') {
								if (typeof addonItemsAddedToCart == 'function') {
									addonItemsAddedToCart($wcpb_ao_id_array);
								}
							} else {
								argumentValue.closest('form').querySelector('.wc_bundle_addon').remove();
								argumentValue.closest('form').querySelector('.wc_bundle_addon_type').remove();
								argumentValue.closest('form').querySelector('.wc_bundle_addon_uid').remove();
							    argumentValue.dispatchEvent(new Event('click'));
							    argumentValue.closest('form').dispatchEvent(new Event('submit'));
								clickEventAddOn = 0;
							}
						}
					}
				});
			});
			if (typeof addonBundleDisplayed == 'function') {
				addonBundleDisplayed();
			} else {
				var route_url = window.Shopify.routes.root;
				if (!route_url) {
					route_url = window.Shopify.routes.root_url;
				}
				document.querySelectorAll('form[action="' + route_url + 'cart/add"] button[type="submit"], form[action="' + route_url + 'cart/add"]  input[type="submit"], form[action="' + route_url + 'cart/add"]  input[type="button"][value="submit"], form[action="' + route_url + 'cart/add"]  button[type="button"][value="submit"]').forEach(function(self) {
					if (!self.closest('form').querySelector('.wc_bundle_addon')) {
						self.closest('form').insertAdjacentHTML("afterbegin", '<input type="hidden" class="wc_bundle_addon" name="properties[_th_bundle_addon]" value="' + document.querySelector('.wcpb_ao_section .wcpb_ao_inner').getAttribute('data-bundle') + '">');
					}
					if (!self.closest('form').querySelector('.wc_bundle_addon_type')) {
						self.closest('form').insertAdjacentHTML("afterbegin", '<input type="hidden" class="wc_bundle_addon_type" name="properties[_th_bundle_type]" value="addon">');
					}
					if (!self.closest('form').querySelector('.wc_bundle_addon_uid')) {
						self.closest('form').insertAdjacentHTML("afterbegin", '<input type="hidden" class="wc_bundle_addon_uid" name="properties[_th_bundle_uid]" value="' + $th_bundle_addtocart_uniqueid() + '">');
					}
					if (!self.closest('form').querySelector('.wc_bundle_normal_product')) {
						self.closest('form').insertAdjacentHTML("afterbegin", '<input type="hidden" class="wc_bundle_normal_product" name="properties[_th_bundle_normal_item]" value="true">');
					}
					self.addEventListener('click', function(event) {
						var shopify_product_id = ShopifyAnalytics.meta.product.id;
						if (self.closest('form').innerHTML.includes(shopify_product_id)) {
							if (clickEventAddOn == 0) {
								clickEventAddOn++;
								event.preventDefault();
								const customEvent = new CustomEvent('click', {
									detail: {
										argumentName: self
									}
								});
								document.querySelector('.wcpb_temp_addtocart_btn').dispatchEvent(customEvent);
							} else {
								return;
							}
						}
					});
				});
			}
		}
		const $wcpb_ao_show_error_msg = ($wcpb_ao_error_this, $wcpb_ao_final_option_selected) => {
			document.querySelectorAll('.wcpb_ao_inner .wcpb_ao_error_msg').forEach(function(self) {
				self.innerHTML = '';
			})
			document.querySelectorAll('.wcpb_ao_inner .wcpb_ao_p_grid_checkbox_input').forEach(function(self) {
				self.removeAttribute('disabled');
			})
			$wcpb_ao_error_this.closest('.wcpb_ao_inner').querySelectorAll('.wcpb_ao_p_single_grid').forEach(($wcpb_ao_p_single_grid, $wcpb_ao_p_single_grid_idx) => {
				const $wcpb_ao_oos_status = ($wcpb_ao_p_single_grid.querySelector('.wcpb_ao_pro_variants').options[$wcpb_ao_p_single_grid.querySelector('.wcpb_ao_pro_variants').selectedIndex]) ? $wcpb_ao_p_single_grid.querySelector('.wcpb_ao_pro_variants').options[$wcpb_ao_p_single_grid.querySelector('.wcpb_ao_pro_variants').selectedIndex].getAttribute('data-available') : 'false';
				if ($wcpb_ao_oos_status == 'false') {
					let $wcpb_ao_oos_p_title = $wcpb_ao_p_single_grid.querySelector('.wcpb_ao_pinfo_detail_title').innerText;
					if ($wcpb_ao_p_single_grid.querySelector('.wcpb_ao_pro_variants').options[$wcpb_ao_p_single_grid.querySelector('.wcpb_ao_pro_variants').selectedIndex]) {
						if ($wcpb_ao_p_single_grid.querySelector('.wcpb_ao_pro_variants').options[$wcpb_ao_p_single_grid.querySelector('.wcpb_ao_pro_variants').selectedIndex].getAttribute('data-title') == 'Default Title') {
							$wcpb_ao_oos_p_title = $wcpb_ao_p_single_grid.querySelector('.wcpb_ao_pinfo_detail_title').innerText;
						} else {
							$wcpb_ao_oos_p_title = $wcpb_ao_p_single_grid.querySelector('.wcpb_ao_pinfo_detail_title').innerText + ' (' + $wcpb_ao_p_single_grid.querySelector('.wcpb_ao_pro_variants').options[$wcpb_ao_p_single_grid.querySelector('.wcpb_ao_pro_variants').selectedIndex].getAttribute('data-title') + ')';
						}
					}
					const $wcpb_ao_error_msg = $wcpb_ao_error_this.getAttribute('data-msg');
					const $wcpb_ao_error_msg_text = $wcpb_ao_error_msg.replace('{{title}}', $wcpb_ao_oos_p_title);
					$wcpb_ao_p_single_grid.querySelector('.wcpb_ao_error_msg').innerHTML = '<p class="wcpb_ao_ajax_error_cls">' + $wcpb_ao_error_msg_text + '</p>';
					const checkbox = $wcpb_ao_p_single_grid.querySelector('.wcpb_ao_p_grid_checkbox_input');
					if (checkbox.checked) {
						checkbox.checked = false;
					}
					$wcpb_ao_p_single_grid.querySelector('.wcpb_ao_p_grid_checkbox_input').setAttribute('disabled', 'disabled');
				}
			});
		}
		document.querySelectorAll('.wcpb_ao_p_grid_checkbox_input').forEach(($wcpb_ao_p_grid_checkbox) => {
			$wcpb_ao_p_grid_checkbox[$th_bundle_addEventListener]('change', (event) => {
				event.preventDefault(), event.stopImmediatePropagation();
				$wcpb_ao_show_error_msg($wcpb_ao_p_grid_checkbox.closest('.wcpb_ao_inner').querySelector('.wcpb_ao_error_msg'));
			});
			$wcpb_ao_show_error_msg($wcpb_ao_p_grid_checkbox.closest('.wcpb_ao_inner').querySelector('.wcpb_ao_error_msg'));
		});
		document.querySelectorAll('.wcpb_ao_pro_variants').forEach(($wcpb_ao_pro_variants) => {
			$wcpb_ao_pro_variants[$th_bundle_addEventListener]('change', (event) => {
				event.preventDefault(), event.stopImmediatePropagation();
				$wcpb_ao_pro_variants.closest('.wcpb_ao_p_grid_pinfo_inner').querySelector('.wcpb_ao_pinfo_image_figure img').setAttribute('src', $wcpb_ao_pro_variants.options[$wcpb_ao_pro_variants.selectedIndex].getAttribute('data-image'));
				const $wcpb_ao_price = parseFloat($wcpb_ao_pro_variants.options[$wcpb_ao_pro_variants.selectedIndex].getAttribute('data-price'));
				const $wcpb_ao_compare_price = parseFloat($wcpb_ao_pro_variants.options[$wcpb_ao_pro_variants.selectedIndex].getAttribute('data-compare_price'));
				$wcpb_ao_pro_variants.closest('.wcpb_ao_p_grid_pinfo_inner').querySelector('.wcpb_ao_main_price').innerHTML = '<span class="money transcy-money">' + $th_money_format($wcpb_ao_price, $th_shop_money) + '</span>';
				if ($wcpb_ao_compare_price > $wcpb_ao_price) {
					$wcpb_ao_pro_variants.closest('.wcpb_ao_p_grid_pinfo_inner').querySelector('.wcpb_ao_old_price').innerHTML = '<span class="money transcy-money wcpb_ao_line_through">' + $th_money_format($wcpb_ao_compare_price, $th_shop_money) + '</span>';
				} else {
					$wcpb_ao_pro_variants.closest('.wcpb_ao_p_grid_pinfo_inner').querySelector('.wcpb_ao_old_price').innerHTML = '';
				}
				$wcpb_ao_show_error_msg($wcpb_ao_pro_variants.closest('.wcpb_ao_inner').querySelector('.wcpb_ao_error_msg'));
			});
			$wcpb_ao_pro_variants.dispatchEvent(new Event('change'));
		});
		const $wcpb_ao_show_hide_error_msg = ($wcpb_ao_option_parents, $wcpb_ao_option_val_array) => {
			const $wcpb_ao_final_option_selected = $wcpb_ao_option_val_array.join(' / ');
			$wcpb_ao_option_parents.querySelector('.wcpb_ao_pro_variants').selectedIndex = -1;
			$wcpb_ao_option_parents.closest('.wcpb_ao_inner').querySelector('.wcpb_ao_error_msg').innerHTML = '';
			if ($wcpb_ao_option_parents.querySelectorAll('.wcpb_ao_pro_variants option[data-title="' + $wcpb_ao_final_option_selected + '"]').length > 0) {
				$wcpb_ao_option_parents.querySelector('.wcpb_ao_pro_variants option[data-title="' + $wcpb_ao_final_option_selected + '"]').selected = true;
				$wcpb_ao_option_parents.querySelector('.wcpb_ao_pro_variants').dispatchEvent(new Event('change'));
			}
		}
		const $wcpb_ao_update_radio_button = ($wcpb_ao_select_index, $wcpb_ao_select_pid, $wcpb_ao_option_parents) => {
			switch ($wcpb_ao_select_index) {
				case 1:
					var $th_key = 'root';
					break;
				case 2:
					var $th_key = $wcpb_ao_option_parents.querySelector('.wcpb_ao_select_swatch_cls[data-index="0"] .wcpb_ao_variant_swatch_btn:checked').value;
					break;
				case 3:
					var $th_key = $wcpb_ao_option_parents.querySelector('.wcpb_ao_select_swatch_cls[data-index="0"] .wcpb_ao_variant_swatch_btn:checked').value;
					$th_key += ' / ' + $wcpb_ao_option_parents.querySelector('.wcpb_ao_select_swatch_cls[data-index="1"] .wcpb_ao_variant_swatch_btn:checked').value;
			}
			let $wcpb_ao_vari_availableOptions = ($th_products_json.th_bundle_variantmap[$wcpb_ao_select_pid + '_' + $th_key]) ? $th_products_json.th_bundle_variantmap[$wcpb_ao_select_pid + '_' + $th_key] : [];
			$wcpb_ao_option_parents.querySelectorAll('.wcpb_ao_select_swatch_cls[data-index="' + ($wcpb_ao_select_index - 1) + '"] .wcpb_ao_variant_swatch_field').forEach(($wcpb_ao_variant_swatch_field) => {
				if ($wcpb_ao_vari_availableOptions.includes($wcpb_ao_variant_swatch_field.querySelector('.wcpb_ao_variant_swatch_btn').value)) {
					$wcpb_ao_variant_swatch_field.classList.remove('th_vari_soldout');
					$wcpb_ao_variant_swatch_field.style.display = 'inline-block';
					$wcpb_ao_variant_swatch_field.querySelector('.wcpb_ao_variant_swatch_btn').removeAttribute('disabled');
				} else {
					$wcpb_ao_variant_swatch_field.classList.add('th_vari_soldout');
					$wcpb_ao_variant_swatch_field.style.display = 'none';
					$wcpb_ao_variant_swatch_field.querySelector('.wcpb_ao_variant_swatch_btn').setAttribute('disabled', 'disabled');
					if ($wcpb_ao_variant_swatch_field.querySelectorAll('.wcpb_ao_variant_swatch_btn:checked').length) {
						$wcpb_ao_variant_swatch_field.querySelector('.wcpb_ao_variant_swatch_btn').removeAttribute('checked');
						if ($wcpb_ao_variant_swatch_field.nextSibling) {
							$wcpb_ao_variant_swatch_field.nextSibling.querySelector('.wcpb_ao_variant_swatch_btn').setAttribute('checked', 'checked');
						}
					}
				}
			});
		}
		if (document.querySelector('.wcpb_ao_variant_swatch_btn')) {
			document.querySelectorAll('.wcpb_ao_variant_swatch_btn').forEach(($wcpb_ao_variant_swatch_btn) => {
				$wcpb_ao_variant_swatch_btn[$th_bundle_addEventListener]('change', (event) => {
					event.preventDefault(), event.stopImmediatePropagation();
					const $wcpb_ao_option_parents = $wcpb_ao_variant_swatch_btn.closest('.wcpb_ao_pinfo_variant_selector');
					const $wcpb_ao_option_val_array = new Array();
					$wcpb_ao_option_parents.querySelectorAll('.wcpb_ao_variant_swatches_grid').forEach(($wcpb_ao_variant_swatches_grid) => {
						if ($wcpb_ao_variant_swatches_grid.querySelector('.wcpb_ao_variant_swatch_btn:checked')) {
							$wcpb_ao_option_val_array.push($wcpb_ao_variant_swatches_grid.querySelector('.wcpb_ao_variant_swatch_btn:checked').value);
						}
					});
					const $wcpb_ao_pro_id = $wcpb_ao_variant_swatch_btn.closest('.wcpb_ao_p_single_grid').getAttribute('data-pid');
					$wcpb_ao_update_radio_button(parseInt($th_products_json.th_bundle_products[$wcpb_ao_pro_id][0].options.length), $wcpb_ao_pro_id, $wcpb_ao_option_parents);
					$wcpb_ao_show_hide_error_msg($wcpb_ao_option_parents, $wcpb_ao_option_val_array);
					$wcpb_ao_show_error_msg($wcpb_ao_variant_swatch_btn.closest('.wcpb_ao_inner').querySelector('.wcpb_ao_error_msg'));
				});
				$wcpb_ao_variant_swatch_btn.dispatchEvent(new Event('change'));
			});
		}
		if (document.querySelector('.wcpb_ao_option_select_cls')) {
			document.querySelectorAll('.wcpb_ao_option_select_cls').forEach(($wcpb_ao_option_select_cls) => {
				$wcpb_ao_option_select_cls[$th_bundle_addEventListener]('change', (event) => {
					event.preventDefault(), event.stopImmediatePropagation();
					const $wcpb_ao_option_parents = $wcpb_ao_option_select_cls.closest('.wcpb_ao_pinfo_variant_selector');
					const $wcpb_ao_option_val_array = new Array();
					$wcpb_ao_option_parents.querySelectorAll('.wcpb_ao_option_select_cls').forEach(($wcpb_ao_option_select) => {
						$wcpb_ao_option_val_array.push($wcpb_ao_option_select.options[$wcpb_ao_option_select.selectedIndex].value);
					});
					$wcpb_ao_show_hide_error_msg($wcpb_ao_option_parents, $wcpb_ao_option_val_array);
					$wcpb_ao_show_error_msg($wcpb_ao_option_select_cls.closest('.wcpb_ao_inner').querySelector('.wcpb_ao_error_msg'));
				});
				$wcpb_ao_option_select_cls.dispatchEvent(new Event('change'));
			});
		}
	}
	const $wcpb_ao_bundle_title = ($wcpb_ao_bundle_title, $wcpb_ao_bundle_desc) => {
		let $wcpb_ao_bundle_title_html = '<div class="wcpb_wf wcpb_ao_title">';
		$wcpb_ao_bundle_title_html += '<h4 class="wcpb_wf">' + $wcpb_ao_bundle_title + '</h4>';
		if ($wcpb_ao_bundle_desc) {
			$wcpb_ao_bundle_title_html += '<div class="wcpb_wf wcpb_ao_description">' + $wcpb_ao_bundle_desc + '</div>';
		}
		$wcpb_ao_bundle_title_html += '</div>';
		return $wcpb_ao_bundle_title_html;
	}
	const $wcpb_ao_single_variant = ($wcpb_ao_bundle_val, $wcpb_ao_pro_val, $wcpb_ao_product_default_image, $wcpb_ao_discount, $wcpb_ao_show_hide_select) => {
		let $wcpb_ao_single_variant_html = '',
			$wcpb_ao_product_image = $wcpb_ao_product_default_image;
		let $wcpb_ao_dc_price = $th_pb_product_bundle_price($wcpb_ao_bundle_val, $wcpb_ao_pro_val.variants[0].price, $wcpb_ao_discount);
		let $wcpb_ao_dc_cp_price = $th_pb_product_bundle_original_price($wcpb_ao_bundle_val, $wcpb_ao_pro_val.variants[0].price, $wcpb_ao_pro_val.variants[0].compare_at_price, $wcpb_ao_discount);
		if (($wcpb_ao_pro_val.variants[0].image !== undefined && $wcpb_ao_pro_val.variants[0].image !== null) || ($wcpb_ao_pro_val.variants[0].featured_image !== undefined && $wcpb_ao_pro_val.variants[0].featured_image !== null)) {
			if ($wcpb_ao_pro_val.variants[0].featured_image !== undefined && $wcpb_ao_pro_val.variants[0].featured_image !== null) {
				$wcpb_ao_product_image = $th_image_resizer($wcpb_ao_pro_val.variants[0].featured_image.src, '300x');
			} else {
				$wcpb_ao_product_image = $th_image_resizer($wcpb_ao_pro_val.variants[0].image.originalSrc, '300x')
			}
		}
		$wcpb_ao_single_variant_html += '<div class="wcpb_wf wcpb_ao_pinfo_variant_selector">';
		$wcpb_ao_single_variant_html += '<select class="wcpb_wf wcpb_ao_pro_variants ' + $wcpb_ao_show_hide_select + '">';
		const $wcpb_ao_variant_available_status = $th_variant_instock_status($wcpb_ao_pro_val, $wcpb_ao_pro_val.variants[0]);
		$wcpb_ao_single_variant_html += '<option value="' + $wcpb_ao_pro_val.variants[0].id + '" data-title="' + $wcpb_ao_pro_val.variants[0].title.replace(/"/g, "'") + '" data-ptitle="' + $wcpb_ao_pro_val.title + '" data-compare_price="' + $wcpb_ao_dc_cp_price + '" data-price="' + $wcpb_ao_dc_price + '" data-image="' + $wcpb_ao_product_image + '?v=123" data-available="' + $wcpb_ao_variant_available_status + '">' + $wcpb_ao_pro_val.variants[0].title + '</option>';
		$wcpb_ao_single_variant_html += '</select>';
        $wcpb_ao_single_variant_html+=`<div class='th_bb_custom_variant_section_containor '><div class="th_pb_wf btn  th_pb_cb_p_grid_add_qty">
              <div> 
                  <button type="button" aria-label="minus" class="th_pb_cb_p_grid_add_qty_btn th_pb_cb_ms_p_grid_add_qty_minus minus"  onClick='th_handle_qty_for_single_var_pro_ao(this)'>
                      <svg class="th_trash_icon_prodcuct_grid" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20px" height="20px">
                          <path d="M 10 2 L 9 3 L 3 3 L 3 5 L 21 5 L 21 3 L 15 3 L 14 2 L 10 2 z M 4.3652344 7 L 6.0683594 22 L 17.931641 22 L 19.634766 7 L 4.3652344 7 z"></path>
                      </svg>
                  </button>
              </div>
              <div><span class="th_pb_cb_p_grid_add_qty_text wc_ao_single_variant_pro_qty_input"><em>1</em></span></div>
              <div>
                  <button type="button" aria-label="plus" class="th_pb_cb_p_grid_add_qty_btn th_pb_cb_ms_p_grid_add_qty_plus  plus" onClick='th_handle_qty_for_single_var_pro_ao(this)'>
                      <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" fill="#000000" height="20px" width="20px" version="1.1" id="Capa_1" viewBox="0 0 303.124 303.124" xml:space="preserve">
                          <g>
                              <path d="M312.208,48.613c-1.136-1.47-2.889-2.33-4.746-2.33H70.499L59.631,4.49c-0.01-0.038-0.024-0.073-0.035-0.11   c-0.033-0.119-0.07-0.235-0.11-0.35c-0.026-0.076-0.054-0.152-0.083-0.227c-0.042-0.105-0.086-0.208-0.133-0.31   c-0.038-0.083-0.077-0.165-0.118-0.246c-0.045-0.087-0.093-0.172-0.143-0.257c-0.051-0.088-0.103-0.175-0.158-0.26   c-0.048-0.074-0.099-0.145-0.149-0.216c-0.063-0.088-0.127-0.175-0.194-0.259C58.456,2.19,58.4,2.127,58.344,2.063   c-0.07-0.081-0.141-0.161-0.216-0.238c-0.062-0.064-0.128-0.125-0.192-0.187c-0.073-0.068-0.145-0.136-0.221-0.201   c-0.076-0.065-0.155-0.126-0.234-0.187c-0.07-0.054-0.14-0.108-0.212-0.159c-0.09-0.064-0.183-0.123-0.277-0.181   c-0.067-0.042-0.134-0.085-0.203-0.123c-0.101-0.057-0.204-0.11-0.309-0.162c-0.068-0.034-0.136-0.068-0.205-0.099   c-0.104-0.046-0.21-0.088-0.317-0.129c-0.077-0.03-0.154-0.059-0.232-0.085c-0.099-0.033-0.2-0.063-0.301-0.091   c-0.093-0.025-0.185-0.05-0.279-0.071c-0.089-0.02-0.178-0.037-0.268-0.053c-0.111-0.02-0.224-0.038-0.337-0.052   c-0.077-0.009-0.154-0.016-0.231-0.022c-0.126-0.01-0.252-0.017-0.38-0.019C53.896,0.005,53.86,0,53.824,0H6C2.687,0,0,2.687,0,6   c0,3.313,2.687,6,6,6h43.185l10.867,41.793c0,0.001,0.001,0.002,0.001,0.004l36.107,138.852c0.688,2.644,3.075,4.49,5.807,4.49   h169.383c2.732,0,5.119-1.846,5.807-4.49l36.111-138.855C313.736,51.996,313.345,50.083,312.208,48.613z M290.786,92.566h-62.338   V58.283h71.254L290.786,92.566z M278.748,138.855h-50.3v-34.289h59.217L278.748,138.855z M156.87,138.855v-34.289h59.578v34.289   H156.87z M216.448,150.855v34.283H156.87v-34.283H216.448z M85.655,104.566h59.215v34.289H94.571L85.655,104.566z M156.87,92.566   V58.283h59.578v34.283H156.87z M144.87,58.283v34.283H82.534l-8.915-34.283H144.87z M97.692,150.855h47.178v34.283h-38.263   L97.692,150.855z M266.711,185.139h-38.263v-34.283h47.179L266.711,185.139z"></path>
                              <path d="M126.419,211.072c-16.791,0-30.451,13.66-30.451,30.451s13.66,30.451,30.451,30.451s30.451-13.66,30.451-30.451   S143.21,211.072,126.419,211.072z M126.419,259.975c-10.174,0-18.451-8.277-18.451-18.451c0-10.174,8.277-18.451,18.451-18.451   s18.451,8.277,18.451,18.451C144.87,251.697,136.593,259.975,126.419,259.975z"></path>
                              <path d="M246.9,211.072c-16.791,0-30.451,13.66-30.451,30.451s13.66,30.451,30.451,30.451c16.791,0,30.451-13.66,30.451-30.451   S263.69,211.072,246.9,211.072z M246.9,259.975c-10.174,0-18.451-8.277-18.451-18.451c0-10.174,8.277-18.451,18.451-18.451   c10.174,0,18.451,8.277,18.451,18.451C265.351,251.697,257.073,259.975,246.9,259.975z"></path>
                          </g>
                      </svg>
                  </button>
              </div>
          </div></div>`;
		if ($wcpb_ao_pro_val.variants[0].title != 'Default Title') {
			$wcpb_ao_single_variant_html += '<div class="wcpb_wf wcpb_ao_single_select_div_cls"><span class="wcpb_wf wcpb_ao_single_variant_title">' + $wcpb_ao_pro_val.variants[0].title + '</span></div>';
		}
		$wcpb_ao_single_variant_html += '</div>';
		return $wcpb_ao_single_variant_html;
	}
	const $wcpb_ao_multi_variant = ($wcpb_ao_bundle_val, $wcpb_ao_pro_val, $wcpb_ao_product_default_image, $wcpb_ao_discount, $wcpb_ao_show_hide_select, $wcpb_ao_bundle_lay_set) => {
		let $wcpb_ao_product_image = $wcpb_ao_product_default_image;
		let $wcpb_ao_multi_variant_html = '<div class="wcpb_wf wcpb_ao_pinfo_variant_selector">';
		$wcpb_ao_multi_variant_html += '<select class="wcpb_wf wcpb_ao_pro_variants ' + $wcpb_ao_show_hide_select + '">';
		$wcpb_ao_pro_val.variants.forEach(($wcpb_ao_variant_val, $wcpb_ao_variant_idx) => {
			const $wcpb_ao_price = $th_pb_product_bundle_price($wcpb_ao_bundle_val, $wcpb_ao_variant_val.price, $wcpb_ao_discount);
			const $wcpb_ao_cp_price = $th_pb_product_bundle_original_price($wcpb_ao_bundle_val, $wcpb_ao_variant_val.price, $wcpb_ao_variant_val.compare_at_price, $wcpb_ao_discount);
			if (($wcpb_ao_variant_val.featured_image !== undefined && $wcpb_ao_variant_val.featured_image !== null) || ($wcpb_ao_variant_val.image !== undefined && $wcpb_ao_variant_val.image !== null)) {
				if ($wcpb_ao_variant_val.featured_image !== undefined && $wcpb_ao_variant_val.featured_image !== null) {
					$wcpb_ao_product_image = $th_image_resizer($wcpb_ao_variant_val.featured_image.src, '600x');
				} else {
					$wcpb_ao_product_image = $th_image_resizer($wcpb_ao_variant_val.image.originalSrc, '600x');
				}
			}
			const $wcpb_ao_variant_available_status = $th_variant_instock_status($wcpb_ao_pro_val, $wcpb_ao_variant_val);
			$wcpb_ao_multi_variant_html += '<option value="' + $wcpb_ao_variant_val.id + '" data-title="' + $wcpb_ao_variant_val.title.replace(/"/g, "'") + '" data-ptitle="' + $wcpb_ao_pro_val.title + '" data-compare_price="' + $wcpb_ao_cp_price + '" data-price="' + $wcpb_ao_price + '" data-image="' + $wcpb_ao_product_image + '?v=123" data-available="' + $wcpb_ao_variant_available_status + '">' + $wcpb_ao_variant_val.title + '</option>';
		});
		$wcpb_ao_multi_variant_html += '</select>';
        $wcpb_ao_multi_variant_html +=`<div class='th_bb_custom_variant_section_containor '>`
        if($wcpb_ao_pro_val.variants.length>=1){
          $wcpb_ao_multi_variant_html+=`<div class="th_bb_custom_variant_section_lable" onclick="th_ao_toggle_custom_variant_dropdawn(this)">
                                          <span class="th_custom_vaariant_section_total_count th_hide_ao_total_count_label" data-value="0"><span>0</span> Added</span>
                                          <div class="th-custom-variant-title">Select</div>
                                          <div class="th-custom-variant-icon">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="-2.4 -2.4 28.80 28.80" fill="none">
                                              <path d="M8.91 19.92L15.43 13.4C16.2 12.63 16.2 11.37 15.43 10.6L8.91 4.08" stroke="#292D32" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                            </svg>
                                          </div>
                                        </div>`;

          $wcpb_ao_multi_variant_html+=`<div class="th_bb_variant_option_containor hide_variant_section">`;
          	$wcpb_ao_pro_val.variants.forEach(($wcpb_ao_variant_val, $wcpb_ao_variant_idx) => {
                $wcpb_ao_multi_variant_html+=`<div class='th_bb_variant_option ${$wcpb_ao_variant_idx==0 ? 'th_bb_variant_option_active' :'' } ' onClick='th_bb_variant_option_click_ao(this)' data-variant_id='${$wcpb_ao_variant_val.id}'>`
    			$wcpb_ao_multi_variant_html += `<div class='th_bb_variant_option_title'>${$wcpb_ao_variant_val.title}</div>`;
                $wcpb_ao_multi_variant_html+=`<div class="th_bb_variant_option_qty_selector_ao">
                    <div class="th_bb_variant_option_qty_selector_cart_icon" >
                      <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" fill="#000000" height="20px" width="20px" version="1.1" id="Capa_1" viewBox="0 0 303.124 303.124" xml:space="preserve"><g><path d="M312.208,48.613c-1.136-1.47-2.889-2.33-4.746-2.33H70.499L59.631,4.49c-0.01-0.038-0.024-0.073-0.035-0.11   c-0.033-0.119-0.07-0.235-0.11-0.35c-0.026-0.076-0.054-0.152-0.083-0.227c-0.042-0.105-0.086-0.208-0.133-0.31   c-0.038-0.083-0.077-0.165-0.118-0.246c-0.045-0.087-0.093-0.172-0.143-0.257c-0.051-0.088-0.103-0.175-0.158-0.26   c-0.048-0.074-0.099-0.145-0.149-0.216c-0.063-0.088-0.127-0.175-0.194-0.259C58.456,2.19,58.4,2.127,58.344,2.063   c-0.07-0.081-0.141-0.161-0.216-0.238c-0.062-0.064-0.128-0.125-0.192-0.187c-0.073-0.068-0.145-0.136-0.221-0.201   c-0.076-0.065-0.155-0.126-0.234-0.187c-0.07-0.054-0.14-0.108-0.212-0.159c-0.09-0.064-0.183-0.123-0.277-0.181   c-0.067-0.042-0.134-0.085-0.203-0.123c-0.101-0.057-0.204-0.11-0.309-0.162c-0.068-0.034-0.136-0.068-0.205-0.099   c-0.104-0.046-0.21-0.088-0.317-0.129c-0.077-0.03-0.154-0.059-0.232-0.085c-0.099-0.033-0.2-0.063-0.301-0.091   c-0.093-0.025-0.185-0.05-0.279-0.071c-0.089-0.02-0.178-0.037-0.268-0.053c-0.111-0.02-0.224-0.038-0.337-0.052   c-0.077-0.009-0.154-0.016-0.231-0.022c-0.126-0.01-0.252-0.017-0.38-0.019C53.896,0.005,53.86,0,53.824,0H6C2.687,0,0,2.687,0,6   c0,3.313,2.687,6,6,6h43.185l10.867,41.793c0,0.001,0.001,0.002,0.001,0.004l36.107,138.852c0.688,2.644,3.075,4.49,5.807,4.49   h169.383c2.732,0,5.119-1.846,5.807-4.49l36.111-138.855C313.736,51.996,313.345,50.083,312.208,48.613z M290.786,92.566h-62.338   V58.283h71.254L290.786,92.566z M278.748,138.855h-50.3v-34.289h59.217L278.748,138.855z M156.87,138.855v-34.289h59.578v34.289   H156.87z M216.448,150.855v34.283H156.87v-34.283H216.448z M85.655,104.566h59.215v34.289H94.571L85.655,104.566z M156.87,92.566   V58.283h59.578v34.283H156.87z M144.87,58.283v34.283H82.534l-8.915-34.283H144.87z M97.692,150.855h47.178v34.283h-38.263   L97.692,150.855z M266.711,185.139h-38.263v-34.283h47.179L266.711,185.139z"></path><path d="M126.419,211.072c-16.791,0-30.451,13.66-30.451,30.451s13.66,30.451,30.451,30.451s30.451-13.66,30.451-30.451   S143.21,211.072,126.419,211.072z M126.419,259.975c-10.174,0-18.451-8.277-18.451-18.451c0-10.174,8.277-18.451,18.451-18.451   s18.451,8.277,18.451,18.451C144.87,251.697,136.593,259.975,126.419,259.975z"></path><path d="M246.9,211.072c-16.791,0-30.451,13.66-30.451,30.451s13.66,30.451,30.451,30.451c16.791,0,30.451-13.66,30.451-30.451   S263.69,211.072,246.9,211.072z M246.9,259.975c-10.174,0-18.451-8.277-18.451-18.451c0-10.174,8.277-18.451,18.451-18.451   c10.174,0,18.451,8.277,18.451,18.451C265.351,251.697,257.073,259.975,246.9,259.975z"></path></g></svg>
                    </div>
                 </div>
                 <div class="th_bb_cusstom_variant_option_main_qty_selector th_hide_qty_selector_ao_custom_option">
                   <div class="th_bb_cusstom_variant_option_main_qty_selector_minus minus" onclick="th_custom_variant_option_qty_sel_event_ao(this)">
                      <svg class="th_trash_icon_prodcuct_grid" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="15px">
                         <path d="M 10 2 L 9 3 L 3 3 L 3 5 L 21 5 L 21 3 L 15 3 L 14 2 L 10 2 z M 4.3652344 7 L 6.0683594 22 L 17.931641 22 L 19.634766 7 L 4.3652344 7 z"></path>
                      </svg>
                   </div>
                   <div class="th_bb_cusstom_variant_option_main_qty_selector_count_num">0</div>
                   <div class="th_bb_cusstom_variant_option_main_qty_selector_plus plus" onclick="th_custom_variant_option_qty_sel_event_ao(this)">
                      <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" fill="#000000" width="15px" version="1.1" id="Capa_1" viewBox="0 0 303.124 303.124" xml:space="preserve">
                         <g>
                            <path d="M312.208,48.613c-1.136-1.47-2.889-2.33-4.746-2.33H70.499L59.631,4.49c-0.01-0.038-0.024-0.073-0.035-0.11   c-0.033-0.119-0.07-0.235-0.11-0.35c-0.026-0.076-0.054-0.152-0.083-0.227c-0.042-0.105-0.086-0.208-0.133-0.31   c-0.038-0.083-0.077-0.165-0.118-0.246c-0.045-0.087-0.093-0.172-0.143-0.257c-0.051-0.088-0.103-0.175-0.158-0.26   c-0.048-0.074-0.099-0.145-0.149-0.216c-0.063-0.088-0.127-0.175-0.194-0.259C58.456,2.19,58.4,2.127,58.344,2.063   c-0.07-0.081-0.141-0.161-0.216-0.238c-0.062-0.064-0.128-0.125-0.192-0.187c-0.073-0.068-0.145-0.136-0.221-0.201   c-0.076-0.065-0.155-0.126-0.234-0.187c-0.07-0.054-0.14-0.108-0.212-0.159c-0.09-0.064-0.183-0.123-0.277-0.181   c-0.067-0.042-0.134-0.085-0.203-0.123c-0.101-0.057-0.204-0.11-0.309-0.162c-0.068-0.034-0.136-0.068-0.205-0.099   c-0.104-0.046-0.21-0.088-0.317-0.129c-0.077-0.03-0.154-0.059-0.232-0.085c-0.099-0.033-0.2-0.063-0.301-0.091   c-0.093-0.025-0.185-0.05-0.279-0.071c-0.089-0.02-0.178-0.037-0.268-0.053c-0.111-0.02-0.224-0.038-0.337-0.052   c-0.077-0.009-0.154-0.016-0.231-0.022c-0.126-0.01-0.252-0.017-0.38-0.019C53.896,0.005,53.86,0,53.824,0H6C2.687,0,0,2.687,0,6   c0,3.313,2.687,6,6,6h43.185l10.867,41.793c0,0.001,0.001,0.002,0.001,0.004l36.107,138.852c0.688,2.644,3.075,4.49,5.807,4.49   h169.383c2.732,0,5.119-1.846,5.807-4.49l36.111-138.855C313.736,51.996,313.345,50.083,312.208,48.613z M290.786,92.566h-62.338   V58.283h71.254L290.786,92.566z M278.748,138.855h-50.3v-34.289h59.217L278.748,138.855z M156.87,138.855v-34.289h59.578v34.289   H156.87z M216.448,150.855v34.283H156.87v-34.283H216.448z M85.655,104.566h59.215v34.289H94.571L85.655,104.566z M156.87,92.566   V58.283h59.578v34.283H156.87z M144.87,58.283v34.283H82.534l-8.915-34.283H144.87z M97.692,150.855h47.178v34.283h-38.263   L97.692,150.855z M266.711,185.139h-38.263v-34.283h47.179L266.711,185.139z"></path>
                            <path d="M126.419,211.072c-16.791,0-30.451,13.66-30.451,30.451s13.66,30.451,30.451,30.451s30.451-13.66,30.451-30.451   S143.21,211.072,126.419,211.072z M126.419,259.975c-10.174,0-18.451-8.277-18.451-18.451c0-10.174,8.277-18.451,18.451-18.451   s18.451,8.277,18.451,18.451C144.87,251.697,136.593,259.975,126.419,259.975z"></path>
                            <path d="M246.9,211.072c-16.791,0-30.451,13.66-30.451,30.451s13.66,30.451,30.451,30.451c16.791,0,30.451-13.66,30.451-30.451   S263.69,211.072,246.9,211.072z M246.9,259.975c-10.174,0-18.451-8.277-18.451-18.451c0-10.174,8.277-18.451,18.451-18.451   c10.174,0,18.451,8.277,18.451,18.451C265.351,251.697,257.073,259.975,246.9,259.975z"></path>
                         </g>
                      </svg>
                   </div> 
                 </div>
                 `;
              
                $wcpb_ao_multi_variant_html+=`</div>`;
		   });
          $wcpb_ao_multi_variant_html+=`</div>`
        }
        $wcpb_ao_multi_variant_html+=`</div>`
		$wcpb_ao_multi_variant_html += '<div class="wcpb_wf wcpb_ao_variants_select_div_cls">';
		if ($wcpb_ao_pro_val.is_all_variants == '1') {
			if (parseInt($wcpb_ao_bundle_lay_set.variant_layout) === 1) {
				const $wcpb_ao_current_time = Date.now();
				$wcpb_ao_pro_val.options.forEach(($wcpb_ao_option_val, $wcpb_ao_option_idx) => {
					$wcpb_ao_multi_variant_html += '<div class="wcpb_wf wcpb_ao_select_swatch_cls" data-index="' + $wcpb_ao_option_idx + '" data-option="' + $wcpb_ao_option_val.name.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '') + '">';
					$wcpb_ao_multi_variant_html += '<span class="wcpb_wf wcpb_ao_option_label_cls">' + $wcpb_ao_option_val.name + '</span>';
					$wcpb_ao_multi_variant_html += '<div class="wcpb_ao_variant_swatches_grid">';
					$wcpb_ao_option_val.values.forEach(($wcpb_ao_option_title_val, $wcpb_ao_option_title_idx) => {
						const $wcpb_ao_option_checked = $wcpb_ao_option_title_idx === 0 ? 'checked="checked"' : '';
						if ($wcpb_ao_option_val.name.toLowerCase().indexOf('color') != -1 || $wcpb_ao_option_val.name.toLowerCase().indexOf('colour') != -1) {
							$wcpb_ao_multi_variant_html += '<div class="wcpb_ao_variant_swatch_field wcpb_ao_variant_swatch_field_color">';
							$wcpb_ao_multi_variant_html += '<input type="radio" name="wcpb_ao_' + $wcpb_ao_bundle_val.bundle_detail.id + '_' + $wcpb_ao_pro_val.handle + '_' + $wcpb_ao_option_idx + '_' + $wcpb_ao_current_time + '" id="wcpb_ao_variant_swatch_' + $wcpb_ao_bundle_val.bundle_detail.id + '_' + $wcpb_ao_pro_val.handle + '_' + $wcpb_ao_option_idx + '_' + $wcpb_ao_option_title_idx + '_' + $wcpb_ao_current_time + '" class="wcpb_ao_variant_swatch_btn" value="' + $wcpb_ao_option_title_val.replace(/"/g, "'") + '" ' + $wcpb_ao_option_checked + ' />';
							$wcpb_ao_multi_variant_html += '<label for="wcpb_ao_variant_swatch_' + $wcpb_ao_bundle_val.bundle_detail.id + '_' + $wcpb_ao_pro_val.handle + '_' + $wcpb_ao_option_idx + '_' + $wcpb_ao_option_title_idx + '_' + $wcpb_ao_current_time + '" class="wcpb_ao_variant_swatch_label wcpb_ao_variant_swatch_color ' + $wcpb_ao_option_title_val.toLowerCase().replace(/[^\w ]+/g, '').replace(/ +/g, '-') + '" style="background-color:' + $wcpb_ao_option_title_val.toLowerCase().replace(/[^\w ]+/g, '').replace(/ +/g, '-') + '"></label>';
							$wcpb_ao_multi_variant_html += '</div>';
						} else {
							$wcpb_ao_multi_variant_html += '<div class="wcpb_ao_variant_swatch_field">';
							$wcpb_ao_multi_variant_html += '<input type="radio" name="wcpb_ao_' + $wcpb_ao_bundle_val.bundle_detail.id + '_' + $wcpb_ao_pro_val.handle + '_' + $wcpb_ao_option_idx + '_' + $wcpb_ao_current_time + '" id="wcpb_ao_variant_swatch_' + $wcpb_ao_bundle_val.bundle_detail.id + '_' + $wcpb_ao_pro_val.handle + '_' + $wcpb_ao_option_idx + '_' + $wcpb_ao_option_title_idx + '_' + $wcpb_ao_current_time + '" class="wcpb_ao_variant_swatch_btn" value="' + $wcpb_ao_option_title_val.replace(/"/g, "'") + '" ' + $wcpb_ao_option_checked + ' />';
							$wcpb_ao_multi_variant_html += '<label for="wcpb_ao_variant_swatch_' + $wcpb_ao_bundle_val.bundle_detail.id + '_' + $wcpb_ao_pro_val.handle + '_' + $wcpb_ao_option_idx + '_' + $wcpb_ao_option_title_idx + '_' + $wcpb_ao_current_time + '" class="wcpb_ao_variant_swatch_label ' + $wcpb_ao_option_title_val.toLowerCase().replace(/[^\w ]+/g, '').replace(/ +/g, '-') + '">' + $wcpb_ao_option_title_val + '</label>';
							$wcpb_ao_multi_variant_html += '</div>';
						}
					});
					$wcpb_ao_multi_variant_html += '</div></div>';
				});
			} else {
				$wcpb_ao_pro_val.options.forEach(($wcpb_ao_option_val, $wcpb_ao_option_idx) => {
					$wcpb_ao_multi_variant_html += '<div class="wcpb_wf wcpb_ao_select_dp_cls" data-option="' + $wcpb_ao_option_val.name.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '') + '">';
					$wcpb_ao_multi_variant_html += '<label class="wcpb_wf wcpb_ao_option_label_cls" data-name="' + $wcpb_ao_option_val.name + '">' + $wcpb_ao_option_val.name + '</label>';
					$wcpb_ao_multi_variant_html += '<select class="wcpb_wf wcpb_ao_option_select_cls" data-name="' + $wcpb_ao_option_val.name + '">';
					$wcpb_ao_option_val.values.forEach(($wcpb_ao_option_title_val, $wcpb_ao_option_title_idx) => {
						$wcpb_ao_multi_variant_html += '<option value="' + $wcpb_ao_option_title_val.replace(/"/g, "'") + '">' + $wcpb_ao_option_title_val + '</option>';
					});
					$wcpb_ao_multi_variant_html += '</select>';
					$wcpb_ao_multi_variant_html += '</div>';
				});
			}
		}
		$wcpb_ao_multi_variant_html += '</div>';
		$wcpb_ao_multi_variant_html += '</div>';
		return $wcpb_ao_multi_variant_html;
	}
	const $wcpb_ao_product_grid_event = ($wcpb_ao_bundle_val, $wcpb_ao_bundle_lay_set) => {
		if ($wcpb_ao_bundle_val.product_list) {
			let $wcpb_ao_discount = 100 - parseFloat($wcpb_ao_bundle_val.bundle_detail.discount);
			let $wcpb_ao_product_html = '<div class="wcpb_wf wcpb_ao_outer">';
			$wcpb_ao_product_html += '<div class="wcpb_wf wcpb_ao_inner mySwiper" data-bundle="' + $wcpb_ao_bundle_val.bundle_detail.id + '">';
			$wcpb_ao_product_html += $wcpb_ao_bundle_title($wcpb_ao_bundle_val.bundle_detail.bundle_title, $wcpb_ao_bundle_val.bundle_detail.short_desc);
			$wcpb_ao_product_html += '<div class="wcpb_wf wcpb_ao_p_grids swiper-wrapper" data-bundle="' + $wcpb_ao_bundle_val.bundle_detail.id + '" data-discount="' + $wcpb_ao_discount + '" data-fixedprice="' + ($wcpb_ao_bundle_val.bundle_detail.fixed_discount) * $th_active_currency_rate + '" data-bundletype="' + $wcpb_ao_bundle_val.bundle_detail.discount_type + '">';
			$wcpb_ao_bundle_val.product_list.forEach(($wcpb_ao_pro_val, $wcpb_ao_pro_idx) => {
				if ($wcpb_ao_pro_val.status !== 'draft') {
					let $wcpb_ao_product_image = $th_pb_p_grid_image($wcpb_ao_pro_val);
					$wcpb_ao_product_html += '<div class="wcpb_ao_p_single_grid swiper-slide" data-pid="' + $wcpb_ao_pro_val.id + '">';
					$wcpb_ao_product_html += '<div class="wcpb_ao_p_grid_checkbox">';
					$wcpb_ao_product_html += '<label class="wcpb_ao_p_grid_checkbox_label" for="wcpb_ao_p_check_' + $wcpb_ao_bundle_val.bundle_detail.id + '_' + $wcpb_ao_pro_val.id + '">';
					$wcpb_ao_product_html += '<input type="checkbox" id="wcpb_ao_p_check_' + $wcpb_ao_bundle_val.bundle_detail.id + '_' + $wcpb_ao_pro_val.id + '" class="wcpb_ao_p_grid_checkbox_input" value="' + $wcpb_ao_pro_val.id + '" />';
					$wcpb_ao_product_html += '</label>';
					$wcpb_ao_product_html += '</div>';
					$wcpb_ao_product_html += '<div class="wcpb_ao_p_grid_pinfo"><div class="wcpb_ao_p_grid_pinfo_inner">';
					$wcpb_ao_product_html += '<div class="wcpb_ao_pinfo_image"><figure class="wcpb_wf wcpb_ao_pinfo_image_figure">';
					$wcpb_ao_product_html += '<a href="/products/' + $wcpb_ao_pro_val.handle + '" class="wcpb_wf"><img src="' + $wcpb_ao_product_image + '?v=123" class="wcpb_wf" alt="' + $wcpb_ao_pro_val.handle + '" /></a>';
					$wcpb_ao_product_html += '</figure></div>';
					$wcpb_ao_product_html += '<div class="wcpb_ao_pinfo_details">';
					$wcpb_ao_product_html += '<h6 class="wcpb_wf wcpb_ao_pinfo_detail_title"><a href="/products/' + $wcpb_ao_pro_val.handle + '" class="wcpb_wf">' + $wcpb_ao_pro_val.title + '</a></h6>';
					$wcpb_ao_product_html += '<p class="wcpb_wf wcpb_ao_pinfo_detail_price">';
					let $wcpb_ao_dc_price = $th_pb_product_bundle_price($wcpb_ao_bundle_val, $wcpb_ao_pro_val.variants[0].price, $wcpb_ao_discount);
					let $wcpb_ao_dc_cp_price = $th_pb_product_bundle_original_price($wcpb_ao_bundle_val, $wcpb_ao_pro_val.variants[0].price, $wcpb_ao_pro_val.variants[0].compare_at_price, $wcpb_ao_discount);
					$wcpb_ao_product_html += '<span class="wcpb_ao_main_price"><span class="money transcy-money">' + $th_money_format($wcpb_ao_dc_price, $th_shop_money) + '</span></span>';
					if ($wcpb_ao_dc_cp_price > $wcpb_ao_dc_price) {
						$wcpb_ao_product_html += '<span class="wcpb_ao_old_price"><span class="money transcy-money wcpb_ao_line_through">' + $th_money_format($wcpb_ao_dc_cp_price, $th_shop_money) + '</span></span>';
					} else {
						$wcpb_ao_product_html += '<span class="wcpb_ao_old_price"></span>';
					}
					$wcpb_ao_product_html += '</p>';
					$wcpb_ao_product_html += '<div class="wcpb_wf wcpb_ao_pinfo_variant_selector">';
					const $wcpb_ao_show_hide_select = $wcpb_ao_pro_val.is_all_variants == '1' ? 'wcpb_ao_main_select_hide_cls' : '';
					if ($wcpb_ao_pro_val.variants.length <= 1) {
						$wcpb_ao_product_html += $wcpb_ao_single_variant($wcpb_ao_bundle_val, $wcpb_ao_pro_val, $wcpb_ao_product_image, $wcpb_ao_discount, $wcpb_ao_show_hide_select);
					} else {
						$wcpb_ao_product_html += $wcpb_ao_multi_variant($wcpb_ao_bundle_val, $wcpb_ao_pro_val, $wcpb_ao_product_image, $wcpb_ao_discount, $wcpb_ao_show_hide_select, $wcpb_ao_bundle_lay_set);
					}
					$wcpb_ao_product_html += '</div>';
					$wcpb_ao_product_html += '<div class="wcpb_ao_error_msg" data-msg="' + $wcpb_ao_bundle_lay_set.language.not_available + '"></div>';
					$wcpb_ao_product_html += '</div>';
					$wcpb_ao_product_html += '</div></div>';
					$wcpb_ao_product_html += '</div>';
 
					$th_pb_generate_variantmap($wcpb_ao_pro_val);
				} else {
					console.log('Rebolt Bundle: This product is in Draft', $wcpb_ao_pro_val);
				}
			});
			$wcpb_ao_product_html += '</div>';
            $wcpb_ao_product_html+=`<div class="swiper-pagination"></div>`;
			$wcpb_ao_product_html += '<div class="wcpb_ao_error_msg" data-msg="' + $wcpb_ao_bundle_lay_set.language.not_available + '"></div>';
			$wcpb_ao_product_html += '<div class="wcpb_wf wcpb_temp_button_div">';
			$wcpb_ao_product_html += '<div value="add_to_cart" class="wcpb_temp_addtocart_btn btn button"><span class="button_text">Add To Cart</span></div>';
			$wcpb_ao_product_html += '</div>';
			$wcpb_ao_product_html += '</div>';
			if ($wcpb_ao_bundle_val.wc_bd_number == 7) {
				$wcpb_ao_product_html += '<div class="wc_shopify_preview" style="display: flex !important;width: 100% !important;float: left !important;justify-content: center !important;margin-top: 10px !important; opacity: 1 !important; visibility: visible !important; height: 30px !important;"><img src="https://rebolt.webcontrive.com/rebolt-bundle/public/img/powered_by_rebolt.png" style="display: flex !important;width: 120px !important; opacity: 1 !important; visibility: visible !important; height: 27px !important;"></div>';
			}
			$wcpb_ao_product_html += '</div>';
			return $wcpb_ao_product_html;
		}
	}
	const $wcpb_ao_design_layout = ($wcpb_ao_bundle_result, $wcpb_ao_bundle_this) => {
		let $wcpb_ao_main_html = '';
		$wcpb_ao_bundle_result?.addon_bundle_list?.forEach(($wcpb_ao_bundle_val, $wcpb_ao_bundle_idx) => {
			$wcpb_ao_bundle_val.wc_bd_number = $wcpb_ao_bundle_result.wc_bd_number;
			$wcpb_ao_main_html += $wcpb_ao_product_grid_event($wcpb_ao_bundle_val, wc_external_script_layout);
			$wcpb_ao_bundle_this.innerHTML = $wcpb_ao_main_html;
			if (typeof $th_bundle_success_callback === 'function') {
				// $th_bundle_success_callback($wcpb_ao_bundle_val.bundle_detail.id, $wcpb_ao_bundle_result);
			}
		});
		$wcpb_ao_variant_change_event();

     const swiper = new Swiper('.mySwiper', {
      slidesPerView: 3,
      slidesPerGroup: 3, // <--- this controls dot count
      spaceBetween: 20,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      breakpoints: {
        0: { slidesPerView: 2, slidesPerGroup: 2},
        768: { slidesPerView: 2, slidesPerGroup: 2 },
        1024: { slidesPerView: 3, slidesPerGroup: 3 },
      },
    });

	}
	/* ========== Cart Page JS ========== */
	let $th_cart_fixed_price_json = {},
		$th_cart_free_shipping_json = {};
	const $th_bundle_check_array = function($th_source, $th_target) {
		let $th_array_result = $th_source.filter(function($th_item) {
			return $th_target.indexOf($th_item) > -1
		});
		if ($th_array_result.length >= $th_target.length) {
			return true
		} else {
			return false;
		}
	}
	const $th_bundle_cart_set_discount_price = function($th_loop_this, $th_bundle_price, $th_bundle_line_price, $th_cart_price, $th_cart_line_price) {
		for (let i = 0; i < $th_loop_this.querySelectorAll('.th_item_price').length; i++) {
			$th_loop_this.querySelectorAll('.th_item_price')[i].innerHTML = '<span class="money">' + $th_money_format($th_bundle_price, $th_shop_money) + '</span>';
			if ($th_cart_price > $th_bundle_price) {
				$th_loop_this.querySelectorAll('.th_item_price')[i].insertAdjacentHTML('beforeend', '<span class="money th_pb_line_through">' + $th_money_format($th_cart_price, $th_shop_money) + '</span>');
			}
		}
		for (let i = 0; i < $th_loop_this.querySelectorAll('.th_item_line_price').length; i++) {
			$th_loop_this.querySelectorAll('.th_item_line_price')[i].innerHTML = '<span class="money">' + $th_money_format($th_bundle_line_price, $th_shop_money) + '</span>';
			if ($th_cart_line_price > $th_bundle_line_price) {
				$th_loop_this.querySelectorAll('.th_item_line_price')[i].insertAdjacentHTML('beforeend', '<span class="money th_pb_line_through">' + $th_money_format($th_cart_line_price, $th_shop_money) + '</span>');
			}
		}
		$th_loop_this.setAttribute('data-thprice', $th_bundle_line_price);
		$th_loop_this.setAttribute('data-thpriceoriginal', $th_cart_line_price);
	}
	const $th_bundle_disable_class = function($th_this, $th_cart_value, $th_bundle_value, $th_bundle_language, $th_bundle_type) {
		let $th_cart_disabled_clsses = [];
		if ($th_bundle_type == '$th_normal_bundle' || $th_bundle_type == '$th_combo_bundle' || $th_bundle_type == '$th_quantity_bundle' || $th_bundle_type == '$th_fbt_bundle') {
			$th_cart_disabled_clsses = ['input[name="updates[]"]', '.js-qty .js-qty__adjust', 'select[aria-label="Quantity"]', '.increaseVal', '.decreaseVal', '.qtyBtn', '.th_pb_remove_item', '.plus', '.minus', '.QuantitySelector__Button', '.cart-item-increase', '.cart-item-decrease', '.quantity__button', '.quantity-selector__button', '.quantity-selector__value', '.js-qty__adjust.js-qty__adjust--minus', '.js-qty__adjust.js-qty__adjust--plus'];
		}
		if ($th_cart_disabled_clsses) {
			$th_cart_disabled_clsses.forEach(function($th_single_class) {
				const $th_single_code = $th_this.querySelectorAll($th_single_class);
				if (typeof $th_single_code == 'object' && $th_single_code) {
					for (let i = 0; i < $th_single_code.length; i++) {
						$th_single_code[i].classList.add('th_pb_disabled_qty_btn_cls');
					}
				}
			});
		}
		$th_this.setAttribute('data-thkey', $th_cart_value.key);
		$th_this.setAttribute('data-thpbid', $th_bundle_value.bundle_id);
		if ($th_this.querySelector('.th_pb_remove_cart_item')) {
			$th_this.querySelectorAll('.th_pb_remove_cart_item').forEach(function($th_remove_cart_item) {
				$th_remove_cart_item.classList.add('th_pb_remove_all_products');
				$th_remove_cart_item.setAttribute('href', 'javascript:void(0)');
				$th_remove_cart_item.setAttribute('data-thromdesc', $th_bundle_language.cart_remove_confi);
			});
		}
	}
	const $th_bundle_cart_checkout_event = async function() {
		let $th_bundle_array = [],
			$th_quick_array = [],
			$th_combo_array = [],
			$th_quantity_array = [];
		window.$th_bundle_cart_active_bundles_value.forEach(function($th_bundle_grid, $th_loop_idx) {
			if ($th_bundle_grid.type == 'custom') {
				$th_quick_array.push($th_bundle_grid);
			}
			if ($th_bundle_grid.type == 'combo') {
				$th_combo_array.push($th_bundle_grid);
			} else {
				$th_bundle_array.push($th_bundle_grid);
			}
		});
		$th_create_bundle_draft_order($th_shop_conveted_url, window.$th_bundle_cart_object_value.items, null, $th_bundle_array, $th_quick_array, null, null, $th_active_currency, $th_combo_array, null);
	}
	const $th_bundle_checkout_section = function($th_cart_active_bundles_value, $th_cart_main_json) {
		window.$th_bundle_cart_active_bundles_value = $th_cart_active_bundles_value;
		window.$th_bundle_cart_object_value = $th_cart_main_json;
		const $th_cart_checkout_cls = ['.th_pb_ajax_cart_checkout_cta_btn', 'input[name=\'checkout\']', 'button[name=\'checkout\']', '[href$=\'checkout\']', 'input[name=\'goto_pp\']', 'button[name=\'goto_pp\']', 'input[name=\'goto_gc\']', 'button[name=\'goto_gc\']', '.additional-checkout-button', '.google-wallet-button-holder', '.amazon-payments-pay-button'];
		$th_cart_checkout_cls.forEach(function($th_selector) {
			const $th_cart_btn_code = document.querySelectorAll($th_selector);
			if (typeof $th_cart_btn_code == 'object' && $th_cart_btn_code) {
				for (let i = 0; i < $th_cart_btn_code.length; i++) {
					const $th_cart_btn_code_click = $th_cart_btn_code[i];
					$th_cart_btn_code_click[$th_bundle_addEventListener]('click', function(event) {
						event.preventDefault(), event.stopImmediatePropagation();
						$th_bundle_cart_checkout_event();
					}, false);
					$th_cart_btn_code_click.dataset.thpbCheckout = true;
				}
			}
		});
	}
	const $th_bundle_remove_products = async function() {
		if (document.querySelector('.th_pb_remove_all_products')) {
			document.querySelectorAll('.th_pb_remove_all_products').forEach(function($th_pb_remove_all_products) {
				$th_pb_remove_all_products[$th_bundle_addEventListener]('click', function(event) {
					event.preventDefault(), event.stopImmediatePropagation();
					let $th_remove_msg = $th_pb_remove_all_products.getAttribute('data-thromdesc');
					if ($th_remove_msg == '' || $th_remove_msg == null || $th_remove_msg == undefined) {
						$th_remove_msg = 'If you delete any product from the bundle then it will remove all the products associated with that bundle.';
					}
					const $th_remove_confirmation = confirm($th_remove_msg);
					if ($th_remove_confirmation) {
						let $th_remove_array = {};
						const $th_remove_bundle_id = $th_pb_remove_all_products.closest('.th_pb_cart_line').getAttribute('data-thpbid');
						document.querySelectorAll('.th_pb_cart_line[data-thpbid="' + $th_remove_bundle_id + '"]').forEach(function($th_line_this, $th_line_idx) {
							$th_remove_array[$th_line_this.getAttribute('data-thkey')] = 0;
							if ($th_line_idx === (document.querySelectorAll('.th_pb_cart_line[data-thpbid="' + $th_remove_bundle_id + '"]').length - 1)) {
								fetch('/cart/update.json', {
									method: 'POST',
									headers: {
										'Content-Type': 'application/json'
									},
									body: JSON.stringify({
										updates: $th_remove_array
									})
								}).then(response => response.json()).then($th_update_result => {
									location.reload();
								}).catch(($th_update_error) => {
									console.error($th_update_error);
								});
							}
						});
					} else {
						return false;
					}
				});
			});
		}
	}
	const $th_cart_final_total = function($th_total_cart_active_bundle, $th_cart_original_total, $th_total_cart_fixed_price_json, $th_total_cart_free_shipping_json, $th_bundle_language) {
		let $th_total_price = 0,
			$th_cart_total_price = $th_cart_original_total;
		document.querySelectorAll('.th_pb_cart_line').forEach(function($th_cart_line, $th_cart_idx) {
			const $th_line_price = parseFloat($th_cart_line.getAttribute('data-thprice'));
			if ($th_cart_line.getAttribute('data-thprice') != null) {
				$th_total_price = $th_total_price + $th_line_price;
			}
			if ($th_cart_idx === (document.querySelectorAll('.th_pb_cart_line').length - 1)) {
				if (Object.keys($th_total_cart_fixed_price_json).length > 0) {
					let $th_cart_fixed_price_total = 0,
						$th_custom_each_index = 0;
					for (let $th_fixed_idx in $th_total_cart_fixed_price_json) {
						var $th_min_module_val = 0;
						if ($th_total_cart_fixed_price_json[$th_fixed_idx].bundle_type == '9') {
							$th_min_module_val = 1;
						} else {
							$th_min_module_val = ((($th_total_cart_fixed_price_json[$th_fixed_idx].qty_module || []).reduce((a, b) => +parseInt(a) + parseInt(b), 0)) / parseInt($th_total_cart_fixed_price_json[$th_fixed_idx].bundle_products));
						}
						let fixed_value = '';
						if ($th_total_cart_fixed_price_json[$th_fixed_idx].fixed_value == null) {
							fixed_value = 0;
						} else {
							fixed_value = $th_total_cart_fixed_price_json[$th_fixed_idx].fixed_value;
						}
						$th_cart_fixed_price_total = parseFloat($th_cart_fixed_price_total) + ((parseFloat(fixed_value) * Number($th_min_module_val) * 100) * $th_active_currency_rate);
						$th_custom_each_index++;
						if ($th_custom_each_index === Object.keys($th_total_cart_fixed_price_json).length) {
							$th_cart_total_price = parseFloat($th_total_price);
							$th_total_price = parseFloat($th_total_price) - parseFloat($th_cart_fixed_price_total);
							for (let i = 0; i < document.querySelectorAll('.th_cart_total_price').length; i++) {
								document.querySelectorAll('.th_cart_total_price')[i].innerHTML = '<span class="th_cart_total_sale_price"><span class="money">' + $th_money_format($th_total_price, $th_shop_money) + '</span></span>';
								if ($th_cart_total_price > $th_total_price) {
									document.querySelectorAll('.th_cart_total_price')[i].insertAdjacentHTML('beforeend', '<span class="th_cart_total_original_price"><span class="money th_pb_line_through">' + $th_money_format($th_cart_total_price, $th_shop_money) + '</span></span>');
								}
							}
							if (document.querySelector('.th_cart_fixed_discount_msg')) {
								document.querySelector('.th_cart_fixed_discount_msg').innerHTML = '<em>' + $th_bundle_language.fixed_price + ' <span class="money">' + $th_money_format($th_cart_fixed_price_total, $th_shop_money) + '</span></em>';
							} else {
								for (let i = 0; i < document.querySelectorAll('.th_cart_total_price').length; i++) {
									document.querySelectorAll('.th_cart_total_price')[i].insertAdjacentHTML('beforeend', '<div class="th_cart_fixed_discount_msg"><em>' + ($th_bundle_language.fixed_price) + ' <span class="money">' + $th_money_format($th_cart_fixed_price_total, $th_shop_money) + '</span></em></div>');
								}
							}
						}
					}
				} else {
					for (let i = 0; i < document.querySelectorAll('.th_cart_total_price').length; i++) {
						document.querySelectorAll('.th_cart_total_price')[i].innerHTML = '<span class="th_cart_total_sale_price"><span class="money">' + $th_money_format($th_total_price, $th_shop_money) + '</span></span>';
						if ($th_cart_total_price > $th_total_price) {
							document.querySelectorAll('.th_cart_total_price')[i].insertAdjacentHTML('beforeend', '<span class="th_cart_total_original_price"><span class="money th_pb_line_through">' + $th_money_format($th_cart_total_price, $th_shop_money) + '</span></span>');
						}
					}
				}
				if (Object.keys($th_total_cart_free_shipping_json).length > 0) {
					for (let i = 0; i < document.querySelectorAll('.th_cart_total_price').length; i++) {
						document.querySelectorAll('.th_cart_total_price')[i].innerHTML = '<span class="th_cart_total_sale_price"><span class="money">' + $th_money_format($th_total_price, $th_shop_money) + '</span></span>';
						if ($th_cart_total_price > $th_total_price) {
							document.querySelectorAll('.th_cart_total_price')[i].insertAdjacentHTML('beforeend', '<span class="th_cart_total_original_price"><span class="money th_pb_line_through">' + $th_money_format($th_cart_total_price, $th_shop_money) + '</span></span>');
						}
					}
					if (document.querySelector('.th_cart_free_shipping_msg')) {
						document.querySelector('.th_cart_free_shipping_msg').innerHTML = '<em>' + $th_bundle_language.save + '</em><span class="th_cart_free_shipping_msg_text">' + $th_bundle_language.free_shipping + '</span>';
					} else {
						for (let i = 0; i < document.querySelectorAll('.th_cart_total_price').length; i++) {
							document.querySelectorAll('.th_cart_total_price')[i].insertAdjacentHTML('beforeend', '<div class="th_cart_free_shipping_msg"><em>' + $th_bundle_language.save + '</em><span class="th_cart_free_shipping_msg_text">' + $th_bundle_language.free_shipping + '</span></div>');
						}
					}
				}
			}
		});
	}
	const $th_cart_apply_bundle_discount = function($th_cart_active_bundles_value, $th_cart_bundle_result, $th_cart_main_json) {
		if (document.querySelectorAll('.th_pb_cart_line').length > 0) {
			$th_cart_active_bundles_value.forEach(function($th_bundle_value, $th_bundle_idx) {
				let $th_line_temp = 0,
					$th_line_count = 0,
					$th_bundle_module = [],
					$th_qty_sum_time = {},
					$th_fbt_sum_time = {};
				$th_cart_main_json.items.forEach(function($th_cart_value, $th_cart_idx) {
					$th_line_count++;
					const $th_this = document.querySelector('.th_pb_cart_line[data-indexth="' + $th_line_count + '"]');
					const $th_line_id = $th_this.getAttribute('data-idth');
					if ($th_cart_value.properties) {
						for (let $th_pro_idx in $th_cart_value.properties) {
							if ($th_pro_idx.indexOf('th_bundle_product') >= 0) {
								if ($th_cart_value.properties[$th_pro_idx] == $th_bundle_value.bundle_id) {
									if ($th_bundle_value.discount_type == '0') {
										if ($th_bundle_value.discount > 0 && $th_this.querySelector('.th_bundle_discount_text')) {
											$th_this.querySelector('.th_bundle_discount_text').innerHTML = $th_cart_bundle_result.language.bundle_discount + ' ' + $th_bundle_value.discount + '%';
										}
									}
									const $th_temp_dis = 100 - parseFloat($th_bundle_value.discount);
									const $th_b_price = parseFloat($th_cart_value.price) * parseFloat($th_temp_dis) / 100;
									let $th_b_line_price = 0;
									if ($th_this.querySelector('.th_bundle_discount_text')) {
										if ($th_bundle_value.discount_type == '0') {
											if ($th_bundle_value.discount > 0) {
												$th_b_line_price = parseFloat($th_b_price) * parseFloat($th_cart_value.quantity);
												$th_bundle_cart_set_discount_price($th_this, $th_b_price, $th_b_line_price, $th_cart_value.price, $th_cart_value.line_price);
											}
										} else if ($th_bundle_value.discount_type == '2') {
											$th_cart_free_shipping_json[$th_bundle_value.bundle_id] = {
												bundle_id: $th_bundle_value.bundle_id,
												free_shipping: true
											};
										} else {
											let $th_temp_added_array = [];
											$th_bundle_value.products.forEach(function($th_temp_value, $th_temp_idx) {
												if (($th_temp_value.product_id == $th_cart_value.product_id) && (!$th_temp_added_array.includes($th_cart_value.product_id))) {
													$th_bundle_module.push($th_cart_value.quantity);
													$th_temp_added_array.push($th_cart_value.product_id);
												}
											});
											const $th_bundle_product_final_qty = ($th_bundle_value.products || []).reduce((a, b) => +parseInt(a) + parseInt(b.quantity), 0);
											$th_cart_fixed_price_json[$th_bundle_value.bundle_id] = {
												bundle_id: $th_bundle_value.bundle_id,
												bundle_type: $th_bundle_value.bundle_type,
												fixed_value: $th_bundle_value.fixed_discount,
												qty_module: $th_bundle_module,
												bundle_products: $th_bundle_product_final_qty
											};
										}
										$th_line_temp = $th_line_temp + $th_b_line_price;
										$th_bundle_disable_class($th_this, $th_cart_value, $th_bundle_value, $th_cart_bundle_result.language, '$th_normal_bundle');
									}
								}
							} else if ($th_pro_idx.indexOf('th_bundle_combo') >= 0) {
								if ($th_cart_value.properties[$th_pro_idx] == $th_bundle_value.bundle_id) {
									if ($th_bundle_value.discount_type == '0') {
										if ($th_bundle_value.discount > 0) {
											$th_this.querySelector('.th_bundle_discount_text').innerHTML = $th_cart_bundle_result.language.bundle_discount + ' ' + $th_bundle_value.discount + '%';
										}
									}
									const $th_temp_dis = 100 - parseFloat($th_bundle_value.discount);
									const $th_b_price = parseFloat($th_cart_value.price) * parseFloat($th_temp_dis) / 100;
									let $th_b_line_price = 0;
									if ($th_this.querySelector('.th_bundle_discount_text')) {
										if ($th_bundle_value.discount_type == '0') {
											if ($th_bundle_value.discount > 0) {
												$th_b_line_price = parseFloat($th_b_price) * parseFloat($th_cart_value.quantity);
												$th_bundle_cart_set_discount_price($th_this, $th_b_price, $th_b_line_price, $th_cart_value.price, $th_cart_value.line_price);
											}
										} else if ($th_bundle_value.discount_type == '2') {
											$th_cart_free_shipping_json[$th_bundle_value.bundle_id] = {
												bundle_id: $th_bundle_value.bundle_id,
												free_shipping: true
											};
										} else {
											let $th_temp_added_array = [];
											$th_bundle_value.products.forEach(function($th_temp_value, $th_temp_idx) {
												if (($th_temp_value.product_id == $th_cart_value.product_id) && (!$th_temp_added_array.includes($th_cart_value.product_id))) {
													$th_bundle_module.push($th_cart_value.quantity);
													$th_temp_added_array.push($th_cart_value.product_id);
												}
											});
											const $th_bundle_product_final_qty = ($th_bundle_value.products || []).reduce((a, b) => +parseInt(a) + parseInt(b.quantity), 0);
											$th_cart_fixed_price_json[$th_bundle_value.bundle_id] = {
												bundle_id: $th_bundle_value.bundle_id,
												bundle_type: $th_bundle_value.bundle_type,
												fixed_value: $th_bundle_value.fixed_discount,
												qty_module: $th_bundle_module,
												bundle_products: $th_bundle_product_final_qty
											};
										}
										$th_line_temp = $th_line_temp + $th_b_line_price;
										$th_bundle_disable_class($th_this, $th_cart_value, $th_bundle_value, $th_cart_bundle_result.language, '$th_combo_bundle');
									}
								}
							} else if ($th_pro_idx.indexOf('_th_bundle_addon') >= 0) {
								if (!$th_cart_value.properties['_th_bundle_normal_item']) {
									if ($th_cart_value.properties[$th_pro_idx] == $th_bundle_value.bundle_id) {
										if ($th_bundle_value.discount_type == '0') {
											if ($th_bundle_value.discount > 0) {
												$th_this.querySelector('.th_bundle_discount_text').innerHTML = $th_cart_bundle_result.language.bundle_discount + ' ' + $th_bundle_value.discount + '%';
											}
										}
										const $th_temp_dis = 100 - parseFloat($th_bundle_value.discount);
										const $th_b_price = parseFloat($th_cart_value.price) * parseFloat($th_temp_dis) / 100;
										let $th_b_line_price = 0;
										if ($th_this.querySelector('.th_bundle_discount_text')) {
											if ($th_bundle_value.discount_type == '0') {
												if ($th_bundle_value.discount > 0) {
													$th_b_line_price = parseFloat($th_b_price) * parseFloat($th_cart_value.quantity);
													$th_bundle_cart_set_discount_price($th_this, $th_b_price, $th_b_line_price, $th_cart_value.price, $th_cart_value.line_price);
												}
											} else if ($th_bundle_value.discount_type == '2') {
												$th_cart_free_shipping_json[$th_bundle_value.bundle_id] = {
													bundle_id: $th_bundle_value.bundle_id,
													free_shipping: true
												};
											} else {
												let $th_temp_added_array = [];
												$th_bundle_value.products.forEach(function($th_temp_value, $th_temp_idx) {
													if (($th_temp_value.product_id == $th_cart_value.product_id) && (!$th_temp_added_array.includes($th_cart_value.product_id))) {
														$th_bundle_module.push($th_cart_value.quantity);
														$th_temp_added_array.push($th_cart_value.product_id);
													}
												});
												const $th_bundle_product_final_qty = ($th_bundle_value.products || []).reduce((a, b) => +parseInt(a) + parseInt(b.quantity), 0);
												$th_cart_fixed_price_json[$th_bundle_value.bundle_id] = {
													bundle_id: $th_bundle_value.bundle_id,
													bundle_type: $th_bundle_value.bundle_type,
													fixed_value: $th_bundle_value.fixed_discount,
													qty_module: $th_bundle_module,
													bundle_products: $th_bundle_product_final_qty
												};
											}
											$th_line_temp = $th_line_temp + $th_b_line_price;
											$th_bundle_disable_class($th_this, $th_cart_value, $th_bundle_value, $th_cart_bundle_result.language, '$th_normal_bundle');
										}
									}
								} else {
									if ($th_cart_value.properties[$th_pro_idx] == $th_bundle_value.bundle_id) {
										$th_bundle_disable_class($th_this, $th_cart_value, $th_bundle_value, $th_cart_bundle_result.language, '$th_normal_bundle');
									}
								}
							} else if ($th_pro_idx.indexOf('th_bundle_custom') >= 0) {
								if ($th_cart_value.properties[$th_pro_idx] == $th_bundle_value.bundle_id) {
									if (parseFloat($th_bundle_value.discount) > 0) {
										$th_this.querySelector('.th_bundle_discount_text').innerHTML = $th_cart_bundle_result.language.custom_discount + ' ' + $th_bundle_value.discount + '%';
									}
									const $th_temp_dis = 100 - parseFloat($th_bundle_value.discount);
									const $th_b_price = parseFloat($th_cart_value.price) * parseFloat($th_temp_dis) / 100;
									let $th_b_line_price = 0;
									if ($th_this.querySelector('.th_bundle_discount_text')) {
										$th_b_line_price = parseFloat($th_b_price) * parseFloat($th_cart_value.quantity);
										$th_bundle_cart_set_discount_price($th_this, $th_b_price, $th_b_line_price, $th_cart_value.price, $th_cart_value.line_price);
										$th_bundle_disable_class($th_this, $th_cart_value, $th_bundle_value, $th_cart_bundle_result.language, '$th_quick_bundle');
									}
								}
							} else if ($th_pro_idx.indexOf('th_bundle_quantity') >= 0) {
								if ($th_cart_value.properties[$th_pro_idx] == $th_bundle_value.bundle_id) {
									if ($th_qty_sum_time.hasOwnProperty($th_cart_value.properties._th_bundle_uid)) {
										$th_qty_sum_time[$th_cart_value.properties._th_bundle_uid] = parseInt($th_cart_value.quantity) + parseInt($th_qty_sum_time[$th_cart_value.properties._th_bundle_uid]);
									} else {
										$th_qty_sum_time[$th_cart_value.properties._th_bundle_uid] = parseInt($th_cart_value.quantity);
									}
									$th_this.setAttribute('data-thqty', $th_cart_value.quantity);
								}
							} else if ($th_pro_idx.indexOf('th_bundle_fbt') >= 0) {
								if ($th_cart_value.properties[$th_pro_idx] == $th_bundle_value.bundle_id) {
									if ($th_fbt_sum_time.hasOwnProperty($th_cart_value.properties._th_bundle_uid)) {
										$th_fbt_sum_time[$th_cart_value.properties._th_bundle_uid] = parseInt($th_cart_value.quantity) + parseInt($th_fbt_sum_time[$th_cart_value.properties._th_bundle_uid]);
									} else {
										$th_fbt_sum_time[$th_cart_value.properties._th_bundle_uid] = parseInt($th_cart_value.quantity);
									}
								}
							}
						}
					}
					if (!$th_this.hasAttribute('data-thprice')) {
						$th_this.setAttribute('data-thprice', $th_cart_value.line_price);
						$th_this.setAttribute('data-thpriceoriginal', $th_cart_value.line_price);
					}
					if ($th_cart_idx === ($th_cart_main_json.items.length - 1)) {
						for (let $th_single_sum_time in $th_qty_sum_time) {
							let $th_qty_discount_val, $th_bundle_product_length;
							if ($th_bundle_value.quantity_break) {
								for (let $th_qty_idx in $th_bundle_value.quantity_break) {
									if (parseInt($th_bundle_value.quantity_break[$th_qty_idx].quantity) <= parseInt($th_qty_sum_time[$th_single_sum_time])) {
										$th_qty_discount_val = parseFloat($th_bundle_value.quantity_break[$th_qty_idx].discount);
										$th_bundle_product_length = parseInt($th_bundle_value.quantity_break[$th_qty_idx].quantity);
									}
								}
							}
							let $th_qty_line_temp = 0,
								$th_qty_temp_line_price = 0,
								$th_qty_bundle_module = [];
							$th_cart_main_json.items.forEach(function($th_qty_cart_value, $th_qty_cart_idx) {
								$th_qty_line_temp = $th_qty_cart_idx + 1;
								const $th_qty_this = document.querySelector('.th_pb_cart_line[data-indexth="' + $th_qty_line_temp + '"]');
								const $th_qty_line_id = $th_qty_this.getAttribute('data-idth');
								if ($th_qty_cart_value.properties) {
									for (let $th_qty_pro_idx in $th_qty_cart_value.properties) {
										if ($th_qty_pro_idx.indexOf('th_bundle_quantity') >= 0) {
											if ($th_qty_cart_value.properties[$th_qty_pro_idx] == $th_bundle_value.bundle_id) {
												if ($th_qty_cart_value.properties._th_bundle_uid == $th_single_sum_time) {
													if ($th_bundle_value.discount_type == '0') {
														if ($th_qty_discount_val > 0) {
															$th_qty_this.querySelector('.th_bundle_discount_text').innerHTML = $th_cart_bundle_result.language.bundle_discount + ' ' + $th_qty_discount_val + '%';
														}
													}
													const $th_qty_temp_dis = 100 - parseFloat($th_qty_discount_val);
													const $th_qty_b_price = parseFloat($th_qty_cart_value.price) * parseFloat($th_qty_temp_dis) / 100;
													let $th_qty_b_line_price = 0;
													if ($th_qty_this.querySelector('.th_bundle_discount_text')) {
														if ($th_bundle_value.discount_type == '0') {
															if ($th_qty_discount_val > 0) {
																$th_qty_b_line_price = parseFloat($th_qty_cart_value.line_price) * parseFloat($th_qty_temp_dis) / 100;
																$th_bundle_cart_set_discount_price($th_qty_this, $th_qty_b_price, $th_qty_b_line_price, $th_qty_cart_value.price, $th_qty_cart_value.line_price);
															}
														} else {
															$th_bundle_value.products.forEach(function($th_temp_value, $th_temp_idx) {
																if ($th_temp_value.product_id == $th_qty_cart_value.product_id) {
																	if ($th_qty_cart_value.properties._th_bundle_uid == $th_single_sum_time) {
																		$th_qty_bundle_module.push($th_qty_cart_value.quantity);
																	}
																}
															});
															$th_cart_fixed_price_json[$th_bundle_value.bundle_id + '_' + $th_single_sum_time] = {
																bundle_id: $th_bundle_value.bundle_id,
																bundle_type: $th_bundle_value.bundle_type,
																fixed_value: $th_qty_discount_val,
																qty_module: $th_qty_bundle_module,
																bundle_products: $th_bundle_product_length
															};
														}
														$th_qty_temp_line_price = $th_qty_temp_line_price + $th_qty_b_line_price;
														$th_bundle_disable_class($th_qty_this, $th_qty_cart_value, $th_bundle_value, $th_cart_bundle_result.language, '$th_quantity_bundle');
													}
												}
											}
										}
									}
								}
								if ($th_qty_temp_line_price == 0) {
									if (!$th_qty_this.hasAttribute('data-thprice')) {
										$th_qty_this.setAttribute('data-thprice', $th_qty_cart_value.line_price);
										$th_qty_this.setAttribute('data-thpriceoriginal', $th_qty_cart_value.line_price);
									}
								}
							});
						}
						for (let $th_fbt_single_sum_time in $th_fbt_sum_time) {
							if (parseInt($th_bundle_value.min_product) <= parseInt($th_fbt_sum_time[$th_fbt_single_sum_time])) {
								let $th_fbt_line_temp = 0,
									$th_fbt_temp_line_price = 0,
									$th_fbt_bundle_module = [];
								$th_cart_main_json.items.forEach(function($th_fbt_cart_value, $th_fbt_cart_idx) {
									$th_fbt_line_temp = $th_fbt_cart_idx + 1;
									const $th_fbt_this = document.querySelector('.th_pb_cart_line[data-indexth="' + $th_fbt_line_temp + '"]');
									if ($th_fbt_cart_value.properties) {
										for (let $th_fbt_pro_idx in $th_fbt_cart_value.properties) {
											if ($th_fbt_pro_idx.indexOf('th_bundle_fbt') >= 0) {
												if ($th_fbt_cart_value.properties[$th_fbt_pro_idx] == $th_bundle_value.bundle_id) {
													if ($th_fbt_cart_value.properties._th_bundle_uid == $th_fbt_single_sum_time) {
														if ($th_bundle_value.fbt_apply_discount == '1') {
															if ($th_bundle_value.discount_type == '0') {
																if (parseFloat($th_bundle_value.discount) > 0) {
																	$th_fbt_this.querySelector('.th_bundle_discount_text').innerHTML = $th_cart_bundle_result.language.bundle_discount + ' ' + $th_bundle_value.discount + '%';
																}
															}
															const $th_fbt_temp_dis = 100 - parseFloat($th_bundle_value.discount);
															const $th_fbt_b_price = parseFloat($th_fbt_cart_value.price) * parseFloat($th_fbt_temp_dis) / 100;
															let $th_fbt_b_line_price = 0;
															if ($th_fbt_this.querySelector('.th_bundle_discount_text')) {
																if ($th_bundle_value.discount_type == '0') {
																	if ($th_bundle_value.discount > 0) {
																		$th_fbt_b_line_price = parseFloat($th_fbt_cart_value.line_price) * parseFloat($th_fbt_temp_dis) / 100;
																		$th_bundle_cart_set_discount_price($th_fbt_this, $th_fbt_b_price, $th_fbt_b_line_price, $th_fbt_cart_value.price, $th_fbt_cart_value.line_price);
																	}
																} else {
																	if (parseFloat($th_bundle_value.fixed_discount) > 0) {
																		$th_bundle_value.products.forEach(function($th_temp_value, $th_temp_idx) {
																			if ($th_temp_value.product_id == $th_fbt_cart_value.product_id) {
																				if ($th_fbt_cart_value.properties._th_bundle_uid == $th_fbt_single_sum_time) {
																					$th_fbt_bundle_module.push($th_fbt_cart_value.quantity);
																				}
																			}
																		});
																		$th_cart_fixed_price_json[$th_bundle_value.bundle_id + '_' + $th_fbt_single_sum_time] = {
																			bundle_id: $th_bundle_value.bundle_id,
																			bundle_type: $th_bundle_value.bundle_type,
																			fixed_value: $th_bundle_value.fixed_discount,
																			qty_module: $th_fbt_bundle_module,
																			bundle_products: parseInt($th_fbt_sum_time[$th_fbt_single_sum_time])
																		};
																	}
																}
																$th_fbt_temp_line_price = $th_fbt_temp_line_price + $th_fbt_b_line_price;
																$th_bundle_disable_class($th_fbt_this, $th_fbt_cart_value, $th_bundle_value, $th_cart_bundle_result.language, '$th_fbt_bundle');
															}
														}
													}
												}
											}
										}
									}
									if ($th_fbt_temp_line_price == 0) {
										if (!$th_fbt_this.hasAttribute('data-thprice')) {
											$th_fbt_this.setAttribute('data-thprice', $th_fbt_cart_value.line_price);
											$th_fbt_this.setAttribute('data-thpriceoriginal', $th_fbt_cart_value.line_price);
										}
									}
								});
							}
						}
					}
				});
				if ($th_bundle_idx === ($th_cart_active_bundles_value.length - 1)) {
					setTimeout(function() {
						$th_cart_final_total($th_cart_active_bundles_value, $th_cart_main_json.total_price, $th_cart_fixed_price_json, $th_cart_free_shipping_json, $th_cart_bundle_result.language,$th_cart_main_json);
					}, 500);
					$th_bundle_checkout_section($th_cart_active_bundles_value, $th_cart_main_json);
					$th_bundle_remove_products();
				}
			});
		}
	}
	const $th_cart_format = function($th_cart_bundle_result, $th_cart_main_json) {
		let $th_cart_active_bundles_value = [],
			$th_fbt_array_ids = [];
		$th_cart_bundle_result.bundle_detail.forEach(function($th_cb_value, $th_cb_idx) {
			let $th_pb_ids = [],
				$th_pb_bundle_ids = '',
				$th_cart_custom_ids = [],
				$th_cart_ids = [],
				$th_combo_array_ids = [],
				$th_cart_quantity_ids = [],
				$th_cart_fbt_ids = [],
				$th_cart_ao_ids = [];
			$th_cb_value.products.forEach(function($th_pro_value, $th_pro_idx) {
				$th_pb_ids.push(parseFloat($th_pro_value.product_id));
			});
			$th_cart_main_json.items.forEach(function($th_item_value, $th_item_idx) {
				if ($th_item_value.properties) {
					for (let $th_properties_idx in $th_item_value.properties) {
						if ($th_item_value.properties[$th_properties_idx] == 'bundle') {
							$th_cart_ids.push($th_item_value.product_id);
						}
						if ($th_item_value.properties[$th_properties_idx] == 'custom') {
							$th_cart_custom_ids.push($th_item_value.product_id);
						}
						if ($th_item_value.properties[$th_properties_idx] == 'combo') {
							$th_combo_array_ids.push($th_item_value.product_id);
						}
						if ($th_item_value.properties[$th_properties_idx] == 'quantity') {
							$th_cart_quantity_ids.push($th_item_value.product_id);
						}
						if ($th_item_value.properties[$th_properties_idx] == 'fbt') {
							$th_cart_fbt_ids.push($th_item_value.product_id);
						}
						if ($th_item_value.properties[$th_properties_idx] == 'addon') {
							$th_cart_ao_ids.push($th_item_value.product_id);
						}
						if ($th_item_value.properties._th_bundle_product == $th_cb_value.bundle_id) {
							$th_pb_bundle_ids = $th_cb_value.bundle_id;
						}
						if ($th_item_value.properties._th_bundle_custom == $th_cb_value.bundle_id) {
							$th_pb_bundle_ids = $th_cb_value.bundle_id;
						}
						if ($th_item_value.properties._th_bundle_combo == $th_cb_value.bundle_id) {
							$th_pb_bundle_ids = $th_cb_value.bundle_id;
						}
						if ($th_item_value.properties._th_bundle_fbt == $th_cb_value.bundle_id) {
							$th_pb_bundle_ids = $th_cb_value.bundle_id;
						}
						if ($th_item_value.properties._th_bundle_quantity == $th_cb_value.bundle_id) {
							$th_pb_bundle_ids = $th_cb_value.bundle_id;
						}
						if ($th_item_value.properties._th_bundle_addon == $th_cb_value.bundle_id) {
							$th_pb_bundle_ids = $th_cb_value.bundle_id;
						}
					}
				}
				if ($th_item_idx === ($th_cart_main_json.items.length - 1)) {
					if ($th_bundle_check_array($th_cart_ids, $th_pb_ids)) {
						if ($th_cb_value.type == 'bundle') {
							if ($th_pb_bundle_ids == $th_cb_value.bundle_id) {
								$th_cart_active_bundles_value.push($th_cb_value);
							}
						}
					}
					if ($th_bundle_check_array($th_cart_custom_ids, $th_pb_ids)) {
						if ($th_cb_value.type == 'custom') {
							if ($th_pb_bundle_ids == $th_cb_value.bundle_id) {
								$th_cart_active_bundles_value.push($th_cb_value);
							}
						}
					}
					if ($th_bundle_check_array($th_combo_array_ids, $th_pb_ids)) {
						if ($th_cb_value.type == 'combo') {
							if ($th_pb_bundle_ids == $th_cb_value.bundle_id) {
								$th_cart_active_bundles_value.push($th_cb_value);
							}
						}
					}
					if ($th_cb_value.bundle_type == '9') {
						if ($th_pb_bundle_ids == $th_cb_value.bundle_id) {
							$th_cart_active_bundles_value.push($th_cb_value);
						}
					}
					if ($th_cb_value.bundle_type == '3') {
						if ($th_pb_bundle_ids == $th_cb_value.bundle_id) {
							$th_cart_active_bundles_value.push($th_cb_value);
						}
					}
					if ($th_cb_value.bundle_type == '2') {
						if ($th_pb_bundle_ids == $th_cb_value.bundle_id) {
							$th_cart_active_bundles_value.push($th_cb_value);
						}
					}
				}
			});
			if ($th_cb_idx === ($th_cart_bundle_result.bundle_detail.length - 1)) {
				$th_cart_apply_bundle_discount($th_cart_active_bundles_value, $th_cart_bundle_result, $th_cart_main_json);
			}
		});
	}
	const $th_ajax_cart_set_class = function($th_cart_bundle_result, $th_cart_main_json) {
		if ($th_cart_bundle_result.cart_settings.cart_item_class && $th_cart_bundle_result.cart_settings.cart_item_class != null) {
			if (document.querySelectorAll($th_cart_bundle_result.cart_settings.cart_item_class).length > 0) {
				var $th_index = 1;
				document.querySelectorAll($th_cart_bundle_result.cart_settings.cart_item_class).forEach(function($th_cart_item_class, $th_idx) {
					if (!$th_cart_item_class.classList.contains('th_pb_cart_line')) {
						$th_cart_item_class.classList.add('th_pb_cart_line');
					}
					if (!$th_cart_item_class.getAttribute('data-idth')) {
						$th_cart_item_class.setAttribute('data-idth', $th_cart_main_json.items[$th_idx].id);
					}
					$th_cart_item_class.setAttribute('data-indexth', $th_idx + 1);
					if ($th_cart_bundle_result.cart_settings.cart_item_property_class && $th_cart_bundle_result.cart_settings.cart_item_property_class != null) {
						if ($th_cart_item_class.querySelectorAll('.th_bundle_discount_text').length === 0) {
							$th_cart_item_class.querySelector($th_cart_bundle_result.cart_settings.cart_item_property_class).insertAdjacentHTML('afterend', '<span class="th_bundle_discount_text"></span>');
						}
					}
					if ($th_cart_bundle_result.cart_settings.cart_item_price_class && $th_cart_bundle_result.cart_settings.cart_item_price_class != null) {
						if ($th_cart_item_class.querySelectorAll('.th_item_price').length === 0) {
							$th_cart_item_class.querySelectorAll($th_cart_bundle_result.cart_settings.cart_item_price_class).forEach(function(self) {
								self.classList.add('th_item_price');
							});
						}
					}
					if ($th_cart_bundle_result.cart_settings.cart_item_line_price_class && $th_cart_bundle_result.cart_settings.cart_item_line_price_class != null) {
						if ($th_cart_item_class.querySelectorAll('.th_item_line_price').length === 0) {
							$th_cart_item_class.querySelectorAll($th_cart_bundle_result.cart_settings.cart_item_line_price_class).forEach(function(self) {
								self.classList.add('th_item_line_price');
							})
						}
					}
					if ($th_cart_bundle_result.cart_settings.cart_remove_btn && $th_cart_bundle_result.cart_settings.cart_remove_btn != null) {
						if ($th_cart_item_class.querySelectorAll('.th_pb_remove_cart_item').length === 0) {
							$th_cart_item_class.querySelectorAll($th_cart_bundle_result.cart_settings.cart_remove_btn).forEach(function(self) {
								self.classList.add('th_pb_remove_cart_item');
							});
						}
					}
				});
				if ($th_cart_bundle_result.cart_settings.cart_item_total_price_class && $th_cart_bundle_result.cart_settings.cart_item_total_price_class != null) {
					if (document.querySelectorAll('.th_cart_total_price').length === 0) {
						document.querySelectorAll($th_cart_bundle_result.cart_settings.cart_item_total_price_class).forEach(function(self) {
							self.classList.add('th_cart_total_price');
						});
					}
				}
				if ($th_cart_bundle_result.cart_settings.cart_checkout_btn_class && $th_cart_bundle_result.cart_settings.cart_checkout_btn_class != null) {
					if (document.querySelectorAll('.th_pb_ajax_cart_checkout_cta_btn').length === 0) {
						document.querySelector($th_cart_bundle_result.cart_settings.cart_checkout_btn_class).classList.add('th_pb_ajax_cart_checkout_cta_btn');
					}
				}
			}
		}
	}
	const $th_cart_get_bundle_details = async function($th_cart_main_json, $th_cart_bundle_ids, $th_cart_product_ids, $th_cart_all_product_ids, $th_cart_event_type) {
		let $th_cart_type = 'cart_page';
		if ($th_cart_event_type == '$th_ajax_cart_event') {
			$th_cart_type = 'ajax_cart_drawer';
		}
		let $th_cart_bundle_request = {
			shop: $th_shop_conveted_url,
			cart_bundle_ids: $th_cart_bundle_ids,
			product_ids: $th_cart_product_ids,
			all_product_ids: $th_cart_all_product_ids,
			active_currency: $th_active_currency,
			active_country: $th_active_country,
			cart_type: $th_cart_type,
			shopify_theme_id: $th_shop_theme_id
		};
		$th_cart_bundle_request = new URLSearchParams($th_cart_bundle_request).toString();
		fetch($th_app_ajax_url + 'cart_bundle.php?' + $th_cart_bundle_request, {
			method: 'GET',
			cache: 'no-cache'
		}).then(response => response.json()).then($th_cart_bundle_result => {
			if ($th_cart_bundle_result && $th_cart_bundle_result.bundle_detail) {
				if (Object.keys($th_cart_bundle_result.cart_settings).length > 0 && $th_cart_bundle_result.cart_settings && $th_cart_event_type == '$th_ajax_cart_event') {
					$th_ajax_cart_set_class($th_cart_bundle_result, $th_cart_main_json);
				} else {
					window.th_bundle_cart_ajax = false;
				}
				if ($th_cart_event_type == '$th_page_cart_event') {
					window.th_bundle_cart_ajax = true;
				}
				if (document.querySelectorAll('.th_pb_cart_line').length > 0) {
					$th_cart_format($th_cart_bundle_result, $th_cart_main_json);
				} else {
					if ($th_cart_bundle_result.cart_settings && cart_settings) {
						window.th_bundle_cart_ajax = true;
						$th_cart_bundle_result.cart_settings = cart_settings;
					}
					$th_ajax_cart_set_class($th_cart_bundle_result, $th_cart_main_json);
					$th_cart_format($th_cart_bundle_result, $th_cart_main_json);
				}
			} else {
				window.th_bundle_cart_ajax = false;
			}
		}).catch(($th_bundle_error) => {
			console.error($th_bundle_error);
		});
	}
	const $th_cart_apply_discount_code = function($th_cart_main_json, $th_cart_event_type) {
		let $th_cart_bundle_ids = [],
			$th_cart_product_ids = [],
			$th_cart_all_product_ids = [];
		$th_cart_main_json.items.forEach(function($th_cart_value, $th_cart_idx) {
			$th_cart_all_product_ids.push($th_cart_value.product_id);
			if ($th_cart_value.properties != null) {
				for (let $th_properties_idx in $th_cart_value.properties) {
					if ($th_properties_idx == '_th_bundle_product' || $th_properties_idx == '_th_bundle_custom' || $th_properties_idx == '_th_bundle_quantity' || $th_properties_idx == '_th_bundle_fbt' || $th_properties_idx == '_th_bundle_combo' || $th_properties_idx == '_th_bundle_addon') {
						$th_cart_bundle_ids.push($th_cart_value.properties[$th_properties_idx]);
						$th_cart_product_ids.push($th_cart_value.product_id);
					}
				}
			}
			if ($th_cart_idx === ($th_cart_main_json.items.length - 1)) {
				$th_cart_bundle_ids = [...new Set($th_cart_bundle_ids)];
				$th_cart_product_ids = [...new Set($th_cart_product_ids)];
				$th_cart_all_product_ids = [...new Set($th_cart_all_product_ids)];
				if ($th_cart_bundle_ids.length > 0) {
					$th_cart_get_bundle_details($th_cart_main_json, $th_cart_bundle_ids, $th_cart_product_ids, $th_cart_all_product_ids, $th_cart_event_type);
				}
			}
		});
	}
	const $th_get_cart_value_event = async function($th_active_currency, $th_cart_event_type) {
		const $th_cart_fetch_url = '/cart.js?currency=' + $th_active_currency;
		const $th_cart_main_json = await $th_bundle_get_cart_json($th_cart_fetch_url).then($th_cart_response => {
			return $th_cart_response
		});
		const $th_bundle_class = '.th_pb_cart_bundles',
			$th_bundle_code_place = '$th_bundle_append_code',
			$th_specific_bundle = null;
		if ($th_cart_main_json.item_count > 0) {
			await $th_cart_apply_discount_code($th_cart_main_json, $th_cart_event_type);
			if ($th_cart_event_type != '$th_ajax_cart_event' && document.querySelector('.th_pb_cart_bundles')) {
				let $th_cart_item_data = [];
				$th_cart_main_json.items.forEach(function($th_cart_value, $th_cart_idx) {
					$th_cart_item_data.push({
						variant_id: $th_cart_value.id,
						product_id: $th_cart_value.product_id,
						quantity: $th_cart_value.quantity,
						price: $th_cart_value.price
					});
					if ($th_cart_idx === ($th_cart_main_json.items.length - 1)) {
						const $th_cart_post_data = {
							items: $th_cart_item_data,
							total_price: $th_cart_main_json.total_price
						};
						const $th_get_bundle_ajax_data = {
							shop: $th_shop_conveted_url,
							product_id: null,
							active_currency: $th_active_currency,
							active_country: $th_active_country,
							page_id: null,
							page_type: 'cart',
							cart: $th_cart_post_data
						};
						$th_bundle_new_ajax_request($th_get_bundle_ajax_data, $th_bundle_response_status, $th_bundle_class, $th_bundle_code_place, $th_specific_bundle, null, null);
					}
				});
			}
		} else {
			if ($th_cart_event_type != '$th_ajax_cart_event' && document.querySelector('.th_pb_cart_bundles')) {
				const $th_cart_post_data = {
					items: null
				};
				const $th_get_bundle_ajax_data = {
					shop: $th_shop_conveted_url,
					product_id: null,
					active_currency: $th_active_currency,
					active_country: $th_active_country,
					page_id: null,
					page_type: 'cart',
					cart: $th_cart_post_data
				};
				$th_bundle_new_ajax_request($th_get_bundle_ajax_data, $th_bundle_response_status, $th_bundle_class, $th_bundle_code_place, $th_specific_bundle, null, null);
			}
		}
	}
	window.wc_cart_callback_function = () => {
		$th_get_cart_value_event($th_active_currency, '$th_page_cart_event');
	}
	if (window.location.href.indexOf('/cart') > -1) {
		$th_get_cart_value_event($th_active_currency, '$th_page_cart_event');
	}
	window.fetch = new Proxy(window.fetch, {
		apply($wcpb_fetch, $wcpb_that, $wcpb_args) {
			var $wcpb_result = $wcpb_fetch.apply($wcpb_that, $wcpb_args);
			return $wcpb_result.then(async (response) => {
				if ($wcpb_args[0].search(/cart.*js|cart\/change|cart\/add/) >= 0 && $wcpb_args[0].indexOf('/cart.js?currency=') == -1 && $wcpb_args[0].indexOf('/cart.js?bundle') == -1 && $wcpb_args[0].indexOf('/cart.js?src=ss') == -1 && $wcpb_args[0].indexOf('/cart.json?icu=1') == -1) {
					if (window.th_bundle_cart_ajax) {
						setTimeout(function() {
							$th_get_cart_value_event($th_active_currency, '$th_ajax_cart_event');
						}, 1000);
					}
				}
			}), $wcpb_result
		}
	});
	let oldXHROpen = window.XMLHttpRequest.prototype.open;
	window.XMLHttpRequest.prototype.open = function(method, url, async, user, password) {
		if (url.search(/cart.*js|cart\/change|cart\/add/) >= 0 && url.indexOf('/cart.js?currency=') == -1 && url.indexOf('/cart.js?bundle') == -1 && url.indexOf('/cart.js?src=ss') == -1 && url.indexOf('/cart.json?icu=1') == -1) {
			if (window.th_bundle_cart_ajax) {
				setTimeout(function() {
					$th_get_cart_value_event($th_active_currency, '$th_ajax_cart_event');
				}, 1000);
			}
		}
		return oldXHROpen.apply(this, arguments);
	}
	if (document.querySelector('.th_open_cart_drawer_cls')) {
		document.querySelectorAll('.th_open_cart_drawer_cls').forEach(function($th_cd_button) {
			$th_cd_button[$th_bundle_addEventListener]('click', function(event) {
				setTimeout(function() {
					$th_get_cart_value_event($th_active_currency, '$th_ajax_cart_event');
				}, 1000);
			});
		});
	}
}
// addon code starts 

  let th_handle_qty_for_single_var_pro_ao=(click_btn)=>{
    let th_bb_custom_variant_section_containor =click_btn.closest('.th_bb_custom_variant_section_containor');
    let wc_ao_single_variant_pro_qty_input=th_bb_custom_variant_section_containor.querySelector('.wc_ao_single_variant_pro_qty_input');
    let th_current_qty=parseFloat(wc_ao_single_variant_pro_qty_input.querySelector('em').innerText);
    let wcpb_ao_p_grid_checkbox_input=click_btn.closest('.wcpb_ao_p_single_grid').querySelector('.wcpb_ao_p_grid_checkbox_input');
    wcpb_ao_p_grid_checkbox_input.checked=true;
    if(click_btn.classList.contains('plus')){
      th_current_qty++;
      wc_ao_single_variant_pro_qty_input.querySelector('em').innerText=th_current_qty;
    }else{
      if(th_current_qty!=1){
        th_current_qty--;
        wc_ao_single_variant_pro_qty_input.querySelector('em').innerText=th_current_qty;
      }
    }
  }
  let th_handle_ao_option_label_count=(th_bb_variant_option_containor)=>{
    let wc_total_pro_added_count=0;
    let ao_custom_option_qty_inputs=th_bb_variant_option_containor.querySelectorAll('.th_bb_cusstom_variant_option_main_qty_selector_count_num');
    let th_custom_vaariant_section_total_count=th_bb_variant_option_containor.querySelector('.th_custom_vaariant_section_total_count');
    ao_custom_option_qty_inputs.forEach((ao_custom_option_qty_input)=>{
      wc_total_pro_added_count+=parseFloat(ao_custom_option_qty_input.innerText);
    })
    if(wc_total_pro_added_count>0){
      th_custom_vaariant_section_total_count.classList.remove('th_hide_ao_total_count_label');
      th_custom_vaariant_section_total_count.querySelector('span').innerText=wc_total_pro_added_count;
    }else{
      th_custom_vaariant_section_total_count.classList.add('th_hide_ao_total_count_label');
    }
  }
  let th_custom_variant_option_qty_sel_event_ao=(click_btn)=>{
    event.stopImmediatePropagation();
    event.stopPropagation();
    let th_bb_variant_option=click_btn.closest('.th_bb_variant_option');
    let th_bb_custom_variant_section_containor = click_btn.closest('.th_bb_custom_variant_section_containor');
    let wc_option_quanitity_element=th_bb_variant_option.querySelector('.th_bb_cusstom_variant_option_main_qty_selector_count_num');
    let th_bb_variant_option_qty_selector=th_bb_variant_option.querySelector('.th_bb_variant_option_qty_selector_ao');
    let th_bb_cusstom_variant_option_main_qty_selector=th_bb_variant_option.querySelector('.th_bb_cusstom_variant_option_main_qty_selector');
    let wc_option_qty=parseFloat(wc_option_quanitity_element.innerText);
    if(click_btn.classList.contains('plus')){
      wc_option_qty++;
      wc_option_quanitity_element.innerText=wc_option_qty;
    }else{
      if(wc_option_qty==1){
        th_bb_variant_option_qty_selector.classList.remove('wc_hide_custom_variant_option_cart_icon');
        th_bb_cusstom_variant_option_main_qty_selector.classList.add('th_hide_qty_selector_ao_custom_option');
      }
      wc_option_qty--;
      wc_option_quanitity_element.innerText=wc_option_qty;
    }
    th_handle_ao_option_label_count(th_bb_custom_variant_section_containor);
  }

let th_bb_variant_option_click_ao=(click_element)=>{
  event.stopImmediatePropagation();
  event.stopPropagation();	
  let th_bb_variant_option_containor=click_element.closest('.th_bb_variant_option_containor');
  let th_bb_custom_variant_section_containor = click_element.closest('.th_bb_custom_variant_section_containor');
  th_bb_variant_option_containor.closest('.wcpb_ao_p_single_grid').querySelector('.wcpb_ao_p_grid_checkbox_input').checked=true;
  let th_bb_variant_options=th_bb_variant_option_containor.querySelectorAll('.th_bb_variant_option');
  th_bb_variant_options.forEach((th_bb_variant_option)=>th_bb_variant_option.classList.remove('th_bb_variant_option_active'));
  click_element.classList.add('th_bb_variant_option_active');
  let th_bb_cusstom_variant_option_main_qty_selector_count_num=click_element.querySelector('.th_bb_cusstom_variant_option_main_qty_selector_count_num');
  let th_bb_variant_option_qty_selector=click_element.querySelector('.th_bb_variant_option_qty_selector_ao');
  let th_bb_cusstom_variant_option_main_qty_selector=click_element.querySelector('.th_bb_cusstom_variant_option_main_qty_selector');
  let wc_current_selected_option_count=parseFloat(th_bb_cusstom_variant_option_main_qty_selector.innerText);
  let wc_main_select_element=th_bb_variant_option_containor.closest('.wcpb_ao_pinfo_variant_selector').querySelector('.wcpb_ao_pro_variants')
  if(th_bb_cusstom_variant_option_main_qty_selector_count_num.innerText=='0'){
    wc_current_selected_option_count++;
    th_bb_cusstom_variant_option_main_qty_selector.classList.remove('th_hide_qty_selector_ao_custom_option');
    th_bb_variant_option_qty_selector.classList.add('wc_hide_custom_variant_option_cart_icon');
    th_bb_cusstom_variant_option_main_qty_selector_count_num.innerText=wc_current_selected_option_count;
  }
    wc_main_select_element.value=click_element.dataset.variant_id;
    wc_main_select_element.dispatchEvent(new Event('change'));
    let current_selected_variant_title=click_element.querySelector('.th_bb_variant_option_title').innerText;
    th_bb_custom_variant_section_containor.querySelector('.th-custom-variant-title').innerText=current_selected_variant_title;
    th_handle_ao_option_label_count(th_bb_custom_variant_section_containor);
}
let th_ao_toggle_custom_variant_dropdawn=(click_element)=>{
  event.stopImmediatePropagation();
  event.stopPropagation()	
  let th_bb_variant_option_containors=document.querySelectorAll('.th_bb_variant_option_containor');
  let th_bb_custom_variant_section_containor = click_element.closest('.th_bb_custom_variant_section_containor');
  let th_bb_variant_option_containor = th_bb_custom_variant_section_containor.querySelector('.th_bb_variant_option_containor ');
  let is_box_already_open=th_bb_variant_option_containor.classList.contains('hide_variant_section');
  let th_bb_custom_variant_section_containors=document.querySelectorAll('.wcpb_ao_section .th_bb_custom_variant_section_containor');
  th_bb_custom_variant_section_containors.forEach((th_bb_custom_variant_section_containor)=>th_bb_custom_variant_section_containor.classList.remove('th_rotate_variant_option_svg_ao'))
  th_bb_variant_option_containors.forEach((th_bb_variant_option_containor)=>th_bb_variant_option_containor.classList.add('hide_variant_section'));
  if(is_box_already_open){
    th_bb_variant_option_containor.classList.remove('hide_variant_section');
    th_bb_custom_variant_section_containor.classList.add('th_rotate_variant_option_svg_ao');
  }else{
     th_bb_variant_option_containor.classList.add('hide_variant_section');
     th_bb_custom_variant_section_containor.classList.remove('th_rotate_variant_option_svg_ao')
  }
}
// addon code ends

const changeEvent = new Event('change', {
  bubbles: true,
  cancelable: true
});

const clickEvent = new Event('click', {
  bubbles: true,
  cancelable: true
});
let th_toggle_custom_variant_dropdawn=(th_bb_custom_variant_section_lable)=>{
   let already_hide=false;
   let th_bb_variant_option_containors=document.querySelectorAll('.th_bb_variant_option_containor');
   let current_variant_option_containor=th_bb_custom_variant_section_lable.closest('.th_bb_custom_variant_section_containor').querySelector('.th_bb_variant_option_containor');
   if(current_variant_option_containor.classList.contains('hide_variant_section')){already_hide=true}
   th_bb_variant_option_containors.forEach((options_containor)=>{options_containor.classList.add('hide_variant_section')})
   if(current_variant_option_containor && already_hide){current_variant_option_containor.classList.remove('hide_variant_section')}
}

let th_bb_variant_option_click=(th_bb_variant_option)=>{
  let th_pb_cb_p_grid_column=th_bb_variant_option.closest('.th_pb_cb_p_grid_column');
  let th_pb_cb_p_grid_main_variant=th_pb_cb_p_grid_column.querySelector('.th_pb_cb_p_grid_main_variant');
  let th_bb_variant_option_variant_id=th_bb_variant_option.dataset.variant_id;
  let click_event_for_cart_icon_on_variant_change=th_bb_variant_option.querySelector('.th_bb_variant_option_qty_selector_cart_icon');
  
  if(th_bb_variant_option_variant_id && th_pb_cb_p_grid_main_variant){
    th_pb_cb_p_grid_main_variant.value=th_bb_variant_option_variant_id;
    th_pb_cb_p_grid_main_variant.dispatchEvent(changeEvent);
    // click_event_for_cart_icon_on_variant_change.click();
  }
}

let th_custom_cart_icon_click=(cart_icon,event)=>{
 event.stopImmediatePropagation();
 event.stopPropagation();
 let th_pb_cb_p_grid_column=cart_icon.closest(".th_pb_cb_p_grid_column");
 let th_pb_cb_p_grid_add =th_pb_cb_p_grid_column.querySelector('.th_pb_cb_p_grid_add');
 let th_pb_cb_ms_p_grid_add_btn=th_pb_cb_p_grid_column.querySelector('.th_pb_cb_ms_p_grid_add_btn')
 let th_pb_cb_ms_p_grid_add_qty_plus =th_pb_cb_p_grid_column.querySelector('.th_pb_cb_ms_p_grid_add_qty_plus');
 if(th_pb_cb_p_grid_add){
   if(!th_pb_cb_p_grid_add.classList.contains('th_pb_cb_added_grid')){
    th_pb_cb_ms_p_grid_add_btn.dispatchEvent(clickEvent); 
   }else{
     th_pb_cb_ms_p_grid_add_qty_plus.dispatchEvent(clickEvent);
   }
 }
}

let th_custom_variant_option_qty_sel_event=(qty_selector_btn)=>{
  let th_pb_cb_p_grid_column=qty_selector_btn.closest('.th_pb_cb_p_grid_column');
  let th_pb_cb_ms_p_grid_add_qty_minus=th_pb_cb_p_grid_column.querySelector('.th_pb_cb_ms_p_grid_add_qty_minus');
  let th_pb_cb_ms_p_grid_add_qty_plus=th_pb_cb_p_grid_column.querySelector('.th_pb_cb_ms_p_grid_add_qty_plus');

  if(qty_selector_btn.classList.contains('plus')){
    th_pb_cb_ms_p_grid_add_qty_plus.dispatchEvent(clickEvent);
  }else{
    th_pb_cb_ms_p_grid_add_qty_minus.dispatchEvent(clickEvent);
  }
}